import React, { useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { DragControls } from 'three/examples/jsm/controls/DragControls';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { acceleratedRaycast, computeBoundsTree, disposeBoundsTree } from 'three-mesh-bvh';
import './Viewer3D.css';
import { ViewportGizmo } from "three-viewport-gizmo";
import { AtomiControls } from "./AtomiControls.js";
import { Text } from 'troika-three-text';
import { CustomGridHelper } from './GridHelper';
import { fitCameraToSceneObjects, prepareGeometry, createSelectedVerticesAttribute, calculateBoundingBoxOfAllMeshes, removeExistingGridHelpers, lineSubdivide, cloneMesh, applySubdivision, DisposeMesh, setColorBufferBySelection, GetInsoleBox, isBoxInside, fitInside, clearDuplicateVertices } from '../../Utils/ViewerUtils'
import { useDesignStore } from 'context/DesignContext';
import { useViewerStore, ViewerTabsMode } from 'context/ViewerContext';
import { CV_8U, GaussianBlur, imread, INTER_LINEAR, Mat, Rect, resize, Size } from '@techstark/opencv-js';
import { AdditionImode, BONES_ALL_NAME_PREFIX, DEFAULT_ADDITON_MESH_MATERIAL, DEFAULT_CILICKED_ADDITION_COLOR, DEFAULT_FOOTSHOE_COLOR, DEFAULT_LIFTEDMESH_COLOR, DEFAULT_BOTTOM_MESH_COLOR, DEFAULT_TOP_MESH_COLOR, DEFAULT_MESH_MATERIAL, Hardness, MeasurementSystem, SHOEMARKERS_INSIDE_NAME_PREFIX, SHOEMARKERS_OUTSIDE_NAME_PREFIX, } from './consts';
import { InsoleHighLevelParams } from 'models/InsoleHighLevelParams';
import { Addition, AdditionNewStatus, AutomaticAdditions } from 'models/Addition';
import { Insole, INSOLE_LENGTH_MM, INSOLE_WIDTH_MM } from 'models/Insole';
import { applyTemplate, scheduleAutosave } from './SaveManager';
import { VOICE_FIT_CAMERA_EVENT } from 'Voice/voiceCommands';
import { isExhibitionNarrationDesign } from 'Exhibition/exhibitionCapabilities';
import { PressureImage } from 'models/Insole';
import { addNewAddition, getTemplate, saveDesignPressureAlignment } from '../../services/designService';
import { AlignedFoot, deleteFootScans, loadFootScans, saveFootScans } from '../../services/footScanService';
import { useApi } from 'context/ApiProvider';
import FrameProcessorPressure from 'components/Modals/PatientModal/utils/FrameProcessorPressure';
import { applyColorMap2, convertMatToImageData, reverseImageData } from 'Scan/RondonPressureViewerComponent';
import config from 'Scan/ConfigPath';
import PressureData from 'Scan/PressureData';
import { resetStackWithDesign, undoLastAutosave } from './UndoStack';
import { ArchWallMedial, heelWallJoints, HeelMedialToLateral4, archHeelWallJoints, archWallJoints } from 'data/wallJoints';
import { DesignPressureAlignmentRequestDto, PressureAlignment } from 'models/DesignPressureAlignment';
import { useSelectedDesignStore } from 'context/SelectedDesignContext';
import { AdditionTransformControlMode } from 'types/additionTransformControlMode';
import { RONDOM_getColorByHardness, RONDOM_PRESSURE_INSOLE_LENGTH_GAP } from './RondomConsts';
import { useAuth } from '../../context/AuthContext';
import { canEditDesign, canUseDevelopmentExports } from 'auth/permissions';
import { DesignCategory, DesignType, InsoleDesign } from 'models/InsoleDesign';
import * as wbctUtils from 'Utils/WbctUtils';
import { BONES_X_SHIFT, TranslateBonesToMainMesh } from 'models/Bones';
import toast from 'react-hot-toast';
import { useLoadingComponentStore } from 'context/LoadingContext';
import { convertMmToViewerUnit, convertUnitToDefault, LengthUnit } from 'Utils/MeasurementUtils';
import { isDesktop, isMobile, isTablet } from 'Utils/MediaQueryUtils';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { CSS3DObject, CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
import AdditionSpinner from 'components/Spinners/AdditionSpinner';
import ImageGallerySpinner from 'components/Spinners/NewAdditionSpinner';
import SurfaceJointSpinner from '../Spinners/SurfaceJointSpinner';
import ToolboxButton from '../Spinners/ToolBox';
import DimensionSpinner from '../Spinners/DimensionSpinner';
import { createRoot } from 'react-dom/client';
import {
  Link as LinkIcon,
  UTurnLeft,
  UTurnRight,
} from '@mui/icons-material';
import ReplyIcon from '@mui/icons-material/Reply';
import { mirrorToLeft, mirrorToRight } from 'components/Viewer3d/Mirror';
import { Brush, Evaluator, SUBTRACTION } from 'three-bvh-csg';
import { findInAutoAdditions } from 'Utils/DesignUtils';
import SurfaceJointDualSpinner from 'components/Spinners/SurfaceJointDualSpinner';
import { HighLevelJoint, MeshConfig, meshConfigs, MeshJoints } from 'types/stl';
import { HIGH_HEEL_JOINT_TYPE, HighHeelController } from 'Utils/HighHeelUtils';
import { useFootMeshStore } from 'context/FootMeshContext';
import { alignFootToInsole, getInsoleLengthForFoot, mirrorFoot, seatFootOnInsole } from 'Utils/FootMeshUtils';
import { HighHeelHeight } from 'data/highHeelJoints';
import {
  frameCameraToObjects,
  isSnappedDiagonalDirection,
} from 'Utils/CameraFramingUtils';
import {
  emitParamStepEnd,
  emitParamStepStart,
  VOICE_CAMERA_MAX_MS,
  VOICE_CAMERA_MIN_MS,
  VOICE_CAMERA_SPEED_UNITS_PER_SEC,
  VOICE_FOLLOWUP_WAIT_MS,
  VOICE_PARAM_APPLY_MS,
  VOICE_PARAM_GAP_MS,
  VOICE_PARAM_HOLD_MS,
  VOICE_SPEAK_START_TIMEOUT_MS,
  VOICE_STEP_SPEAK_START_TIMEOUT_MS,
  VOICE_TAIL_WAIT_MS,
  waitForQueueItems,
  waitMs,
  waitUntilAgentAudible,
  waitUntilAgentQuiet,
  waitUntilAgentSpeaking,
} from 'Voice/voiceSpeechSync';

THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;

interface Viewer3DProps {
  modelUrl?: string;
  toolbarRef?: React.RefObject<HTMLDivElement>;
  isBackdropOpen?: boolean;
}

enum JointType {
  PRESSURE_ALIGNMENT = "pressureAlignment",
  EDIT_SURFACE = "surface",
  EDIT_PROFILE = "profile",
  ADDITION = 'addition'
}

interface TextureOffsets {
  rotationAngle: number;
  uOffset: number;
  vOffset: number;
}

// Pressure alignment expressed relative to a model's default alignment points
interface PressureAlignmentOffset {
  dx: number;
  dz: number;
  dAngle: number;
}

const Viewer3D: React.FC<Viewer3DProps> = ({ toolbarRef, isBackdropOpen }): JSX.Element => {
  //context states
  const designLoaded = useDesignStore((state) => state.designLoaded);
  const insoleDesign = useDesignStore((state) => state.insoleDesign);
  const selectedFoot = useViewerStore((state) => state.selectedAdditionFromViewer.foot);
  const selectedAdditonOut = useViewerStore((state) => state.selectedAdditionFromViewer.additionIndex);
  const newAddition = useDesignStore((state) => state.newAddition);
  const additionHeightUpdated = useDesignStore((state) => state.additionHeightUpdated);
  const additionMoved = useDesignStore((state) => state.additionMoved);
  const setAdditionHeightUpdated = useDesignStore((state) => state.setAdditionHeightUpdated);
  const additionHardnessUpdated = useDesignStore((state) => state.additionHardnessUpdated);
  const setAdditionHardnessUpdated = useDesignStore((state) => state.setAdditionHardnessUpdated);
  const advanceMode = useViewerStore((state) => state.advanceMode);
  const finalize = useDesignStore((state) => state.GcodeReady);
  const pressureImageData = useDesignStore((state) => state.pressureImageData);
  const feetView = useViewerStore((state) => state.feetView);
  const footMeshVisible = useViewerStore((state) => state.footMeshVisible);
  const alignFoot = useViewerStore((state) => state.alignFoot);
  const wireframe = useViewerStore((state) => state.wireframe);
  const coloringState = useViewerStore((state) => state.coloring);
  const topInsoleDefaultColor = useViewerStore((state) => state.topInsoleDefaultColor);
  const bottomInsoleDefaultColor = useViewerStore((state) => state.bottomInsoleDefaultColor);
  const liftedMeshColor = useViewerStore((state) => state.liftedInsoleDefaultColor);
  const liftedMeshTransparency = useViewerStore((state) => state.liftedInsoleTransparency);
  const shoeDataMeshColor = useViewerStore((state) => state.shoeDataDefaultColor);
  const shoeDataMeshTransparency = useViewerStore((state) => state.shoeDataTransparency);
  const bonesTransparency = useViewerStore((state) => state.bonesTransparency);
  const surfaceUpdated = useViewerStore((state) => state.surfaceUpdated);
  let rightToolboxMode = useViewerStore((state) => state.mode);
  const additionRemoved = useDesignStore((state) => state.additionRemoved);
  const gcodesVisibility = useViewerStore((state) => state.gcodeVisible);
  const insolesVisibility = useViewerStore((state) => state.insolesVisible);
  const additionsVisibility = useViewerStore((state) => state.additionsViewMeshVisible);
  const bonesVisibility = useViewerStore((state) => state.bonesMeshVisible);
  const liftedInsoleVisibility = useViewerStore((state) => state.liftedInsoleMeshVisible);
  const shoeDataVisibility = useViewerStore((state) => state.shoeDataMeshVisible);
  const highHeelVisibility = useViewerStore((state) => state.highHeelMeshVisible);
  let alignPressureToggle = useViewerStore((state) => state.alignPressure);
  const liveMode = useViewerStore((state) => state.liveMode);
  const animatePressure = useViewerStore((state) => state.animatePressure);
  const clipping = useViewerStore((state) => state.clipping);
  const bandHeightClipping = useViewerStore((state) => state.bandHeightClipping);
  const perspectiveCameraEnabled = useViewerStore((state) => state.perspectiveCamera);

  const gcodeStatus = useViewerStore((state) => state.gcodeStatus);
  const engraving = useDesignStore((state) => state.engraving);
  const updateFromPanel = useViewerStore(state => state.updateFromPanel);
  const updateFromViewer = useViewerStore(state => state.updateFromViewer);
  const { setUpdateFromPanel, setUpdateFromViewer } = useViewerStore();
  const api = useApi();
  const editJointSelected = useRef<boolean>(false);

  //locals 
  const currentMode = useRef<AdditionTransformControlMode>(AdditionTransformControlMode.No);
  const selectedAdditionIndexRef = useRef<number>(-1);
  const selectedFootIndexRef = useRef<number>(-1);
  const [leftClickedPosition, setLeftClickedPosition] = useState<THREE.Vector2>(new THREE.Vector2());
  const [rightClickedPosition, setRightClickedPosition] = useState<THREE.Vector2>(new THREE.Vector2());

  const containerRef = useRef<HTMLDivElement>(null);
  const sceneRef = useRef<THREE.Scene | null>(null);
  const cameraRef = useRef<THREE.Camera | null>(null);
  const initialCameraViewRef = useRef<{
    position: THREE.Vector3;
    target: THREE.Vector3;
    up: THREE.Vector3;
    distance: number;
    ortho?: { left: number; right: number; top: number; bottom: number };
  } | null>(null);
  const perspectiveCameraRef = useRef<THREE.PerspectiveCamera | null>(null);
  const orthographicCameraRef = useRef<THREE.OrthographicCamera | null>(null);
  const skipNextCameraFitRef = useRef(false);
  /**
   * Where each camera was last left, so switching away and back puts the model
   * exactly where it was.
   *
   * Without this, every switch re-fitted the whole scene. Going perspective →
   * orthographic → perspective therefore did not return the user to the view
   * they started from, but to a generic fit of everything visible — which sat
   * much further off than where they had the insoles.
   */
  const cameraModeStateRef = useRef<Partial<Record<'perspective' | 'orthographic', {
    position: THREE.Vector3;
    target: THREE.Vector3;
    up: THREE.Vector3;
    zoom: number;
  }>>>({});
  const cameraFrameTimeoutRef = useRef<number | null>(null);
  const rendererRef = useRef<THREE.WebGLRenderer | null>(null);
  const bandClipPlaneRef = useRef<THREE.Plane | null>(null);
  const controlsRef = useRef<OrbitControls | null>(null);
  const gizmoRef = useRef<ViewportGizmo | null>(null);
  const ORTHO_FIXED_ZOOM = 1.2;
  const atomiControlsRef = useRef<AtomiControls | null>(null);
  const additionGizmoPivotRef = useRef<THREE.Group | null>(null);
  const gizmoStartRotationYRef = useRef<number>(0);
  const gizmoStartForwardRef = useRef<THREE.Vector3 | null>(null);
  const gizmoStartScaleXRef = useRef<number>(1);
  const gizmoStartScaleYRef = useRef<number>(1);
  const gizmoStartScaleZRef = useRef<number>(1);
  const originalGeometryRef = useRef<THREE.BufferGeometry[] | null>(null);
  const isInitializedRef = useRef<boolean>(false);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  const vertexSpheresRef = useRef<THREE.Mesh[][]>([]);
  const vertexSpheresGroupRef = useRef<THREE.Group[] | null>(null);
  const highHeelRef = useRef<HighHeelController>(new HighHeelController());
  const jointControlsRef = useRef<[DragControls, string][]>([]);
  const sectionControlsRef = useRef<[DragControls, string][]>([]);
  const pressureControlsRef = useRef<[DragControls, string][]>([]);
  const engravingControlsRef = useRef<[DragControls, string][]>([]);
  const raycasterRef = useRef<THREE.Raycaster | null>(null);
  const realtimeMousePos = new THREE.Vector2();
  const vertexMarkers = new Map<THREE.Mesh, THREE.Mesh>();
  let timeoutId: NodeJS.Timeout | null = null;
  let lastFoundPosition: { x: string; y: string; z: string } | null = null;

  const designCategory = useRef<DesignCategory>(DesignCategory.Insole);
  const meshconfig = useRef<MeshConfig>();
  const thirdQuarter = useRef<boolean>(false);
  const thirdQuarterValue = useDesignStore(state => state.thirdQuarter);

  const profileJoints = useRef<HighLevelJoint[]>([]);
  const surfaceJoints = useRef<MeshJoints["surface"]>();
  const profileJointsArray = useRef<MeshJoints["profile"][]>([]);
  const surfaceJointsArray = useRef<MeshJoints["surface"][]>([]);

  const isSandal = useRef<boolean>(false);

  const highlightedFaceRef = useRef<THREE.Mesh[]>([]);

  const outputMeshRef = useRef<THREE.Mesh[]>([]);
  const footMeshesRef = useRef<(THREE.Mesh | null)[]>([null, null]);
  const footAlignmentRef = useRef<{ spheres: THREE.Mesh[]; lines: (THREE.Line | null)[]; dragControls: DragControls | null }>({ spheres: [], lines: [], dragControls: null });
  const handledFootSaveRequestRef = useRef(useFootMeshStore.getState().saveRequest);
  const footScansDesignIdRef = useRef<number | null>(null);
  const profileJointSpheresRef = useRef<THREE.Mesh[][]>([]);
  const surfaceJointSpheresRef = useRef<THREE.Mesh[][]>([]);
  const archLinePointsRef = useRef<THREE.Vector3[][]>([]);
  const pressureAlignmentSphereRef = useRef<THREE.Mesh[][]>([]);
  // Per-foot alignment offsets from the model's default points, carried across a category switch
  const pressureAlignmentTransferRef = useRef<PressureAlignmentOffset[] | null>(null);
  const profileCurveRef = useRef<THREE.Line[]>([]);
  const pressureAlignmentLine = useRef<THREE.Line[]>([]);
  const archEditLine = useRef<THREE.Line[]>([]);
  const instepLine = useRef<THREE.Line[]>([]);
  const insoleHighLevelParamRef = useRef<InsoleHighLevelParams[]>([]);
  // Add isLoading state before the return statement
  const [isLoading, setIsLoading] = useState(false);
  const pressureImageDataRef = useRef<(PressureImage | undefined)[]>([]);
  const textureOffsetsRef = useRef<TextureOffsets[]>([]);
  const fp = new FrameProcessorPressure();

  const heelDepthRealY = useRef<number[]>([19.065, 19.065]);
  const isAdditionUpdatedByGizmo = useRef(false);

  const hasBones = useRef<boolean[]>([false, false]);
  const LiftedMeshRef = useRef<THREE.Mesh[]>([]);
  const shoeInsideMarkerGroup = useRef<THREE.Group[]>([]);
  const shoeOutsideMarkerGroup = useRef<THREE.Group[]>([]);
  const labelRenderer = new CSS2DRenderer();
  const standRenderer = new CSS3DRenderer();
  const [lastUpdatedParams, setLastUpdatedParams] = useState<{
    foot: number;
    fieldKey: string;
    value: any;
  }[]>([]);
  const sphereLabelsRef = useRef<Map<string, CSS2DObject>>(new Map());
  const sphereLinesRef = useRef<Map<string, THREE.Line>>(new Map());
  const guideLines = useRef<Map<string, THREE.Line>>(new Map());
  const additionLabelsRef = useRef<Map<string, CSS2DObject>>(new Map());
  const additionLinesRef = useRef<Map<string, THREE.Line>>(new Map());
  const dimensionLabelsRef = useRef<Map<string, CSS2DObject>>(new Map());
  const newAdditionLabelsRef = useRef<Map<string, CSS2DObject>>(new Map());
  const dimensionLinesRef = useRef<Map<string, THREE.Line>>(new Map());
  const boundingBoxGroupsRef = useRef<{ [key: number]: THREE.Group | null }>({});
  const dimensionSpheresRef = useRef<{ [key: number]: THREE.Mesh }>({});
  const archGuideSpheresRef = useRef<{ [key: number]: THREE.Mesh }>({});
  const heelGuideSpheresRef = useRef<{ [key: number]: THREE.Mesh }>({});
  const toolboxPanelRef = useRef<Array<CSS2DObject | null>>([]);

  const engravingProxyMapRef = useRef<Map<THREE.Mesh, THREE.Mesh>>(new Map());
  const additionsRef = React.useRef<Addition[]>([]);
  const InitialShiftBones = useRef<THREE.Vector3[]>([]);
  const changesToApply = useRef<InsoleHighLevelParams[] | null>(null);
  const insoleOldCenter = useRef<THREE.Vector3[] | null[]>([null, null]);

  const activeLabelInnerDivRef = useRef<HTMLElement | null>(null);
  /** Key/type of the expanded label, kept so exclusivity survives label rebuilds. */
  const activeLabelKeyRef = useRef<string | null>(null);
  const activeLabelTypeRef = useRef<'dimension' | 'sphere' | 'addition' | 'newAddition' | null>(null);
  /** Label the voice tour currently holds open, so it can close exactly that one. */
  const voiceLabelKeyRef = useRef<string | null>(null);
  const voiceFocusQueueRef = useRef<{
    fieldKey: string;
    feet: number[];
    updates: { fieldKey: string; foot: number; value: number; single?: boolean }[];
    camera: { single: string; both?: string; fill?: number; zoom?: number };
    line: string;
    silent?: boolean;
    /** Planned move durations from the pre-call timeline. */
    focusMs: number;
    returnMs: number;
    /** Estimated spoken length of this step's line; the step is sized to it. */
    speechMs: number;
    /** First step of an agent turn, so it waits for that turn to become audible. */
    startsTurn?: boolean;
    /** Another step was announced, so keep the camera out instead of going home. */
    expectFollowUp?: boolean;
    done?: () => void;
  }[]>([]);
  const voiceFocusProcessingRef = useRef(false);
  /** True while an addition is being framed, so overlapping requests are dropped. */
  const additionFocusBusyRef = useRef(false);
  /** Identifies the circle currently running, so it can be stopped from outside. */
  const orbitTokenRef = useRef(0);
  /**
   * Identifies the camera move currently running, so an older one stands down.
   *
   * Every move runs its own requestAnimationFrame loop and nothing used to stop
   * the previous one: both then wrote position, target and frustum on the same
   * frames, and the older loop ended by snapping the camera onto its own end
   * pose — in the middle of the newer move. Two camera commands inside one
   * move's length jumped for that reason, which is what a limb length change
   * sent as two tool calls does.
   */
  const cameraTransitionTokenRef = useRef(0);
  /**
   * An explicit claim on the camera, held across several steps.
   *
   * Separate from the orbit's own claim so the two cannot clear one another: a
   * circle that ends inside a held section would otherwise hand the camera back
   * while the narration still wants it.
   */
  const voiceCameraHeldRef = useRef(false);
  /**
   * True while the narration is driving the camera.
   *
   * The viewer re-frames itself whenever the feet view changes, on the next
   * frame and without animating. That is right when the visitor flips the view
   * themselves, and wrong during a narrated move: hiding a foot as part of a
   * shot made the viewer snap the camera a frame later, which the narration's
   * own move then continued from. That fight is what the jump out of the
   * pressure view was.
   */
  const voiceCameraBusyRef = useRef(false);
  /**
   * Where the camera was before it went to an addition.
   *
   * Held across steps rather than inside one trip, because the narration talks
   * about the pad over more than one sentence — its controls first, then sliding
   * it — and the camera has to stay on it throughout, going home only when the
   * subject changes.
   */
  const additionFocusHomeRef = useRef<CameraViewSnapshot | null>(null);
  const voiceFocusSnapshotRef = useRef<{
    position: THREE.Vector3;
    target: THREE.Vector3;
    up: THREE.Vector3;
    distance: number;
    ortho?: { left: number; right: number; top: number; bottom: number; zoom?: number };
  } | null>(null);

  const { user } = useAuth();

  const archEditorConst = useRef<number>(20);
  const colorPalleteRef = useRef<[number, number, number][]>([]);
  const animateIntervalIDRef = useRef<NodeJS.Timer | null>(null);

  const [deactivationFlag, setDeactivationFlag] = useState(false);

  const propertyStep = useRef<number>(1);
  const thicknessPropertyStep = useRef<number>(0.5);
  const measurementExclude = ['Wedge', 'Fill', 'Sagital'];

  const originDistance = 15;
  const archCutMargin = 5;

  const toggleDeactivation = () => {
    setDeactivationFlag(prev => !prev);
  };

  const defaultLengthUnits: Record<MeasurementSystem, LengthUnit> = {
    [MeasurementSystem.metric]: 'mm',
    [MeasurementSystem.imperial]: 'inch',
  };

  const getDefaultLengthUnit = () => {
    return defaultLengthUnits[useViewerStore.getState().measurementSystem];
  }

  const getVisibleDesignObjectsForFraming = (): THREE.Object3D[] => {
    const viewerState = useViewerStore.getState();
    const view = viewerState.feetView;
    const feet = view === 'right' ? [0] : view === 'left' ? [1] : [0, 1];
    const design = useDesignStore.getState().insoleDesign;
    const objects: THREE.Object3D[] = [];

    feet.forEach((foot) => {
      const insoleMesh = outputMeshRef.current?.[foot];
      if (insoleMesh) objects.push(insoleMesh);

      if (viewerState.bonesMeshVisible) {
        const bones = design?.insoles?.[foot]?.bonesGroup;
        if (bones) objects.push(bones);
      }

      if (design?.category === DesignCategory.HighHeel) {
        if (viewerState.liftedInsoleMeshVisible) {
          const liftedMesh = LiftedMeshRef.current?.[foot];
          if (liftedMesh) objects.push(liftedMesh);
        }

        if (viewerState.highHeelMeshVisible) {
          const highHeelMesh = highHeelRef.current.getMeshes()?.[foot];
          if (highHeelMesh) objects.push(highHeelMesh);
        }
      }
    });

    return objects;
  };

  const frameVisibleDesignObjects = (applyDiagonalComposition = false) => {
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    const container = containerRef.current;
    if (!camera || !controls || !container) return;

    const objects = getVisibleDesignObjectsForFraming();
    if (objects.length === 0) return;

    const viewDirection = camera.position.clone().sub(controls.target);
    const upwardScreenShiftRatio = applyDiagonalComposition && isSnappedDiagonalDirection(viewDirection)
      ? 0.04
      : 0;

    frameCameraToObjects(
      camera,
      controls,
      { width: container.clientWidth, height: container.clientHeight },
      objects,
      {
        padding: 1.15,
        upwardScreenShiftRatio,
        zoomOutSteps: 2,
      }
    );

    if ((gizmoRef.current as any)?.cameraUpdate) {
      (gizmoRef.current as any).cameraUpdate();
    } else {
      gizmoRef.current?.update();
    }
  };

  const scheduleVisibleDesignFrame = (delay = 120, applyDiagonalComposition = false) => {
    if (cameraFrameTimeoutRef.current !== null) {
      window.clearTimeout(cameraFrameTimeoutRef.current);
    }
    cameraFrameTimeoutRef.current = window.setTimeout(() => {
      cameraFrameTimeoutRef.current = null;
      frameVisibleDesignObjects(applyDiagonalComposition);
    }, delay);
  };

  useEffect(() => {
    if (!useDesignStore.getState().insoleDesign) return;

    isSandal.current = insoleDesign?.isSandal ?? false;
    designCategory.current = insoleDesign?.category!;

    // Initialize the joints indices
    meshconfig.current = meshConfigs[designCategory.current];

    profileJoints.current = meshconfig.current?.joints.profile ?? [];
    surfaceJoints.current = meshconfig.current!.joints.surface;

    profileJointsArray.current = [profileJoints.current.map(j => ({ ...j, center: j.center.clone() })),
    profileJoints.current.map(j => ({ ...j, center: j.center.clone() }))];

    const cloneSurfaceJoints = (joints: typeof surfaceJoints.current) =>
      Object.fromEntries(
        Object.entries(joints).map(([key, joint]) => [
          key,
          joint ? { ...joint, center: joint.center.clone() } : null,
        ])
      ) as MeshJoints["surface"];

    surfaceJointsArray.current = [
      cloneSurfaceJoints(surfaceJoints.current!),
      cloneSurfaceJoints(surfaceJoints.current!),
    ];
  }, [useDesignStore().insoleDesign?.category]);

  useEffect(() => {
    useDesignStore.getState().setGCode([]);
  }, [insoleDesign?.name]);

  const getColorFromCSSVariable = (variableName: string): THREE.Color => {
    const colorValue = getComputedStyle(document.documentElement)
      .getPropertyValue(variableName)
      .trim();

    return new THREE.Color(colorValue);
  };

  const updateAdditionsRef = (): void => {
    const localInsoleDesign = insoleDesign ?? useDesignStore.getState().insoleDesign;
    if (!localInsoleDesign?.insoles) {
      additionsRef.current = [];
      return;
    }

    const rightAdditions = localInsoleDesign.insoles[0]?.additions ?? [];
    const leftAdditions = localInsoleDesign.insoles[1]?.additions ?? [];

    additionsRef.current = [...rightAdditions, ...leftAdditions];
  };

  useEffect(() => {
    if (animatePressure) {
      const pData = useDesignStore.getState().insoleDesign?.pressureData;
      if (!pData) return;
      var rightCurrentFrame = 0;
      var leftCurrentFrame = 0;

      animateIntervalIDRef.current = setInterval(() => {
        if (rightCurrentFrame >= pData.CalibFrames_Right.length) rightCurrentFrame = 0;
        if (leftCurrentFrame >= pData.CalibFrames_Left.length) leftCurrentFrame = 0;

        const rightImageData = CreateImageData(colorPalleteRef.current, pData.CalibFrames_Right[rightCurrentFrame], pData.ROI_Right, (pData.ExamType != 'static'), true, pData.CalibFrames_Right);
        const leftImageData = CreateImageData(colorPalleteRef.current, pData.CalibFrames_Left[leftCurrentFrame], pData.ROI_Left, (pData.ExamType != 'static'), false, pData.CalibFrames_Left);

        const rightPressureImage: PressureImage = {
          image: rightImageData,
          realHeight: pData.PressureSensorHeight * rightImageData.height / 5.0,
          realWidth: pData.PressureSensorWidth * rightImageData.width / 5.0
        };

        const leftPressureImage: PressureImage = {
          image: leftImageData,
          realHeight: pData.PressureSensorHeight * leftImageData.height / 5.0,
          realWidth: pData.PressureSensorWidth * leftImageData.width / 5.0
        };

        if (pressureImageDataRef.current[0]) {
          updateInsoleTexture(0, rightPressureImage, outputMeshRef.current[0]);
          updateInsoleTexture(0, rightPressureImage, LiftedMeshRef.current[0]);
        }
        if (pressureImageDataRef.current[1]) {
          updateInsoleTexture(1, leftPressureImage, outputMeshRef.current[1]);
          updateInsoleTexture(1, leftPressureImage, LiftedMeshRef.current[1]);
        }
        rightCurrentFrame++;
        leftCurrentFrame++;
      }, 100);
    }
    else {
      if (animateIntervalIDRef.current) {
        clearInterval(animateIntervalIDRef.current);
        animateIntervalIDRef.current = null;
      }

      if (pressureImageDataRef.current[0]) {
        updateInsoleTexture(0, pressureImageDataRef.current[0], outputMeshRef.current[0]);
        updateInsoleTexture(0, pressureImageDataRef.current[0], LiftedMeshRef.current[0]);
      }
      if (pressureImageDataRef.current[1]) {
        updateInsoleTexture(1, pressureImageDataRef.current[1], outputMeshRef.current[1]);
        updateInsoleTexture(1, pressureImageDataRef.current[1], LiftedMeshRef.current[1]);
      }
    }
  }, [animatePressure])

  const UpdateLiftedMesh = (side: number) => {
    const localInsoleDesign = insoleDesign ?? useDesignStore.getState().insoleDesign;
    if (localInsoleDesign == null) return;
    if ((localInsoleDesign.category !== DesignCategory.HighHeel && !hasBones.current[side]) 
      || localInsoleDesign.category== DesignCategory.Sandal) return;
    const insole = localInsoleDesign.insoles[side];
    const curvePoints = insole?.curvePoints;
    const liftedMesh = LiftedMeshRef.current[side];
    const sourceMesh =
      thirdQuarter.current && !isSandal.current ?
        outputMeshRef.current[side].children[0] as THREE.Mesh :
        outputMeshRef.current[side] ?? insole?.mainMesh;

    if (!(curvePoints instanceof THREE.Group) || curvePoints.children.length <= 0) return;
    if (!liftedMesh || !sourceMesh?.geometry) return;

    liftedMesh.geometry.dispose();
    liftedMesh.geometry = sourceMesh.geometry.clone();
    wbctUtils.LiftMesh(liftedMesh, curvePoints, insole.bonesMarkers);
    liftedMesh.geometry.computeBoundingBox();
    liftedMesh.geometry.computeBoundingSphere();
    liftedMesh.geometry.attributes.position.needsUpdate = true;
    insole.liftedMesh = liftedMesh;
  }

  const UpdateBonesPosition = () => {
    const localInsoleDesign = insoleDesign ?? useDesignStore.getState().insoleDesign;
    if (localInsoleDesign == null) return null;

    const sides = [0, 1];
    const shifts: THREE.Vector3[] = [];

    for (let side = 0; side < sides.length; side++) {
      const bones = localInsoleDesign?.insoles[side].bonesGroup;
      const bonesMarker = localInsoleDesign?.insoles[side].bonesFPIMarkers;
      const footshoe = localInsoleDesign.insoles[side].footShoeMesh;
      const curvesPointGroup = localInsoleDesign.insoles[side].curvePoints;

      if (bones && bonesMarker) hasBones.current[side] = true;
      else { hasBones.current[side] = false; continue; }

      const group = new THREE.Group();
      group.name = `${BONES_ALL_NAME_PREFIX}${side}`;
      group.add(footshoe);
      group.add(bonesMarker);
      group.add(bones);
      group.add(curvesPointGroup);

      const shift = TranslateBonesToMainMesh(outputMeshRef.current[side], bones, side);
      if (!shift) return null;

      shifts.push(shift.clone());

      group.position.copy(shift);
      group.updateMatrixWorld(true);

      if (group instanceof THREE.Group) {
        sceneRef.current?.add(group);
      }
    }

    return shifts;
  };

  const AddClonedInsole = () => {
    const localInsoleDesign = insoleDesign ?? useDesignStore.getState().insoleDesign;
    if (localInsoleDesign == null) return;
    const noBones = hasBones.current.every(value => value === false);
    const isHighHeel = localInsoleDesign.category == DesignCategory.HighHeel;
    if ((noBones && !isHighHeel)) return;

    localInsoleDesign.insoles.forEach((insole, index) => {
      insole.liftedMesh = cloneMesh(insole.mainMesh);
      insole.liftedMesh.castShadow = true;
      insole.liftedMesh.receiveShadow = true;
      // Read from the store, not from this render's captured value. These
      // meshes are built while the design loads, and the captured value belongs
      // to whichever render created the closure — so a design that switched the
      // lifted insole off before the mesh existed still got a visible one, and
      // nothing re-applied it afterwards because the value had already changed.
      insole.liftedMesh.visible = useViewerStore.getState().liftedInsoleMeshVisible;

      if (!pressureImageDataRef.current[index]) {
        const currentLiftedColor = useViewerStore.getState().liftedInsoleDefaultColor;
        const currentLiftedTransparency = useViewerStore.getState().liftedInsoleTransparency;
        const liftedMeshOpacity = currentLiftedTransparency / 255;
        const clonedMaterials = Array.isArray(insole.liftedMesh.material)
          ? insole.liftedMesh.material
          : [insole.liftedMesh.material];

        clonedMaterials.forEach(material => {
          const liftedMaterial = material as THREE.MeshStandardMaterial;
          liftedMaterial.vertexColors = false;
          liftedMaterial.color?.set(`#${currentLiftedColor}`);
          liftedMaterial.transparent = currentLiftedTransparency < 255;
          liftedMaterial.opacity = liftedMeshOpacity;
          liftedMaterial.needsUpdate = true;
        });
      }

      const liftInsoleShift = Math.pow(-1, index + 1) * BONES_X_SHIFT;
      insole.liftedMesh?.translateX(liftInsoleShift);
      sceneRef.current?.add(insole.liftedMesh);
      LiftedMeshRef.current[index] = insole.liftedMesh;
    });
  }

  const addShoeMarkersToScene = () => {
    const localInsoleDesign = insoleDesign ?? useDesignStore.getState().insoleDesign;
    if (localInsoleDesign == null) return;
    const noBones = hasBones.current.every(value => value === false);
    if (noBones) return;

    const sides = [0, 1];
    const sideNames = ['right', 'left'];

    for (let side = 0; side < sides.length; side++) {
      const insideMarkers = localInsoleDesign.insoles[side].shoeInsideMarkers;
      const outsideMarkers = localInsoleDesign.insoles[side].shoeOutsideMarkers;

      if (insideMarkers && insideMarkers.length > 0) {
        if (!shoeInsideMarkerGroup.current[side]) {
          shoeInsideMarkerGroup.current[side] = new THREE.Group();
          shoeInsideMarkerGroup.current[side].name = `${SHOEMARKERS_INSIDE_NAME_PREFIX}${sideNames[side]}`;
          // From the store for the same reason as the lifted mesh above: this
          // group is built once, and these are the outline lines around the shoe.
          shoeInsideMarkerGroup.current[side].visible = useViewerStore.getState().shoeDataMeshVisible;
          sceneRef.current?.add(shoeInsideMarkerGroup.current[side]);
        }

        wbctUtils.drawLinesBetweenPoints(insideMarkers, shoeInsideMarkerGroup.current[side], 0x2a82da, sideNames[side], side);
      }

      if (outsideMarkers && outsideMarkers.length > 0) {
        if (!shoeOutsideMarkerGroup.current[side]) {
          shoeOutsideMarkerGroup.current[side] = new THREE.Group();
          shoeOutsideMarkerGroup.current[side].name = `${SHOEMARKERS_OUTSIDE_NAME_PREFIX}${sideNames[side]}`;
          shoeOutsideMarkerGroup.current[side].visible = useViewerStore.getState().shoeDataMeshVisible;
          sceneRef.current?.add(shoeOutsideMarkerGroup.current[side]);
        }

        wbctUtils.drawLinesBetweenPoints(outsideMarkers, shoeOutsideMarkerGroup.current[side], 0x3dd49f, sideNames[side], side);
      }

      if (shoeInsideMarkerGroup.current[side] && shoeInsideMarkerGroup.current.length > 0) {
        shoeInsideMarkerGroup.current[side].position.copy(InitialShiftBones.current[side]);
      }

      if (shoeOutsideMarkerGroup.current[side] && shoeOutsideMarkerGroup.current.length > 0) {
        shoeOutsideMarkerGroup.current[side].position.copy(InitialShiftBones.current[side]);
      }
    }
  };

  useEffect(() => {
    if (insoleDesign === null) return;

    toggleAdvanceMode();
    rightToolboxMode = useViewerStore.getState().mode;
    handleDragControlConnections(rightToolboxMode);
    if (rightToolboxMode != ViewerTabsMode.Edit) {
      resetAllSpheresToDefaultColor();
    }

    const gizmo = gizmoRef.current;
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    const leftEngraving = lastToolboxModeRef.current === ViewerTabsMode.Engraving
      && rightToolboxMode !== ViewerTabsMode.Engraving;
    lastToolboxModeRef.current = rightToolboxMode;

    if (gizmo && camera && controls) {
      if (rightToolboxMode === ViewerTabsMode.Engraving) {
        setCameraViewWithAnimation(camera, controls, containerRef.current!, sceneRef, 'engraving');
      } else if (leftEngraving) {
        setCameraViewWithAnimation(camera, controls, containerRef.current!, sceneRef, 'default');
      }
    }

    if (rightToolboxMode !== ViewerTabsMode.Additions) {
      changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, false);
      if (insoleDesign && selectedAdditionIndexRef.current >= 0) {
        const selectedAddition = insoleDesign.insoles[selectedFootIndexRef.current].additions[selectedAdditionIndexRef.current];
        if (selectedAddition == undefined || selectedAddition === null || selectedAddition.jointGeometry === null) return;
        if (additionGizmoPivotRef.current && sceneRef.current) {
          additionGizmoPivotRef.current.remove(selectedAddition.jointGeometry);
          sceneRef.current.remove(additionGizmoPivotRef.current);
        }
        if (sceneRef.current && sceneRef.current.children.includes(selectedAddition.jointGeometry)) {
          sceneRef.current.remove(selectedAddition.jointGeometry);
        }
      }
      selectedAdditionIndexRef.current = -1;
      currentMode.current = AdditionTransformControlMode.No;
      useViewerStore.setState({
        selectedAdditionFromViewer: { foot: -1, additionIndex: -1 }
      });
    }

    RenderManualEdit();
  }, [rightToolboxMode]);

  const handleDragControlConnections = (mode?: ViewerTabsMode) => {
    const renderer = rendererRef.current;
    if (!renderer) return;
    if (mode === ViewerTabsMode.Edit) {
      if (alignPressureToggle) {
        //Align Pressure in Edit Mode
        engravingControlsRef.current.forEach(control => { control[0].disconnect(); });
        jointControlsRef.current.forEach(control => { control[0].disconnect(); });
        sectionControlsRef.current.forEach(control => { control[0].disconnect(); });
        pressureControlsRef.current.forEach(control => { control[0].connect(renderer.domElement); });
      }
      else {
        if (advanceMode) {
          //Advanced Mode in Edit Mode
          engravingControlsRef.current.forEach(control => { control[0].disconnect(); });
          jointControlsRef.current.forEach(control => { control[0].disconnect(); });
          pressureControlsRef.current.forEach(control => { control[0].disconnect(); });
          sectionControlsRef.current.forEach(control => { control[0].connect(renderer.domElement); });
        }
        else {
          //Normal Mode in Edit Mode
          engravingControlsRef.current.forEach(control => { control[0].disconnect(); });
          sectionControlsRef.current.forEach(control => { control[0].disconnect(); });
          pressureControlsRef.current.forEach(control => { control[0].disconnect(); });
          jointControlsRef.current.forEach(control => { control[0].connect(renderer.domElement); });
        }
      }
    }
    else if (mode === ViewerTabsMode.Engraving) {
      if (alignPressureToggle) {
        //Align Pressure in Engraving Mode
        engravingControlsRef.current.forEach(control => { control[0].disconnect(); });
        jointControlsRef.current.forEach(control => { control[0].disconnect(); });
        sectionControlsRef.current.forEach(control => { control[0].disconnect(); });
        pressureControlsRef.current.forEach(control => { control[0].connect(renderer.domElement); });
      }
      else {
        //Engraving Mode
        pressureControlsRef.current.forEach(control => { control[0].disconnect(); });
        jointControlsRef.current.forEach(control => { control[0].disconnect(); });
        sectionControlsRef.current.forEach(control => { control[0].disconnect(); });
        engravingControlsRef.current.forEach(control => { control[0].connect(renderer.domElement); });
      }
    }
    else {
      if (alignPressureToggle) {
        //Align Pressure in Engraving Mode
        engravingControlsRef.current.forEach(control => { control[0].disconnect(); });
        jointControlsRef.current.forEach(control => { control[0].disconnect(); });
        sectionControlsRef.current.forEach(control => { control[0].disconnect(); });
        pressureControlsRef.current.forEach(control => { control[0].connect(renderer.domElement); });
      }
      else {
        engravingControlsRef.current.forEach(control => { control[0].disconnect(); });
        jointControlsRef.current.forEach(control => { control[0].disconnect(); });
        sectionControlsRef.current.forEach(control => { control[0].disconnect(); });
        pressureControlsRef.current.forEach(control => { control[0].disconnect(); });
      }
    }
    renderer.domElement.style.touchAction = 'none';
  }

  useEffect(() => {
    if (!insoleDesign) { return; }
    const footIndex = selectedFoot;
    if (footIndex == -1) return;
    let isAdditionClicked = false;
    const additionsNoRemove = insoleDesign?.insoles[footIndex]?.additions?.filter(a => a.status != AdditionNewStatus.removed);
    const addition = additionsNoRemove ? additionsNoRemove[selectedAdditonOut] : undefined;
    const originalAdditionIndex = addition ? insoleDesign.insoles[footIndex].additions.findIndex(a => a === addition) : -1;
    if (originalAdditionIndex != selectedAdditionIndexRef.current || footIndex != selectedFootIndexRef.current) {
      if (selectedAdditionIndexRef.current >= 0 && selectedFootIndexRef.current >= 0) {
        changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, false);
      }
      changeAdditionColor(originalAdditionIndex, footIndex, true);
      selectedAdditionIndexRef.current = originalAdditionIndex;
      selectedFootIndexRef.current = footIndex;
      if (rightToolboxMode === ViewerTabsMode.Additions) SetMode(AdditionTransformControlMode.EnableTransformControl);
      isAdditionClicked = true;
    };
    if (!isAdditionClicked) {
      // changeAdditionColor(selectedAdditonOut, footIndex, false);
      selectedAdditionIndexRef.current = -1;
    }
  }, [selectedAdditonOut, selectedFoot])

  // Sync local ref with store when store value changes from outside
  useEffect(() => {
    if (selectedAdditonOut !== selectedAdditionIndexRef.current) {
      //console.log('Syncing local ref with store: ', selectedAdditonOut);
      selectedAdditionIndexRef.current = selectedAdditonOut;
    }
  }, [selectedAdditonOut]);

  useEffect(() => {
    selectedFootIndexRef.current = selectedFoot;
  }, [selectedFoot]);

  useEffect(() => {
    if (pressureImageData.length === 0 || pressureImageDataRef.current.length === 0) return;
    pressureImageDataRef.current = [];
    textureOffsetsRef.current = [];

    const defaultOffsets: TextureOffsets = {
      rotationAngle: 0,
      uOffset: 0,
      vOffset: 0
    };

    pressureImageDataRef.current.push(pressureImageData[0]);
    textureOffsetsRef.current.push(defaultOffsets);

    pressureImageDataRef.current.push(pressureImageData[1]);
    textureOffsetsRef.current.push(defaultOffsets);

    resetTextureAlignmentPoints();
    createPressureLine(0);
    createPressureLine(1);
    if (pressureImageData[0]?.image && pressureImageDataRef.current[0]) {
      updateInsoleTexture(0, pressureImageDataRef.current[0], outputMeshRef.current[0]);
      updateInsoleTexture(0, pressureImageDataRef.current[0], LiftedMeshRef.current[0]);
    }
    if (pressureImageData[1]?.image && pressureImageDataRef.current[1]) {
      updateInsoleTexture(1, pressureImageDataRef.current[1], outputMeshRef.current[1]);
      updateInsoleTexture(1, pressureImageDataRef.current[1], LiftedMeshRef.current[1]);
    }
  }, [pressureImageData]);

  function resetTextureAlignmentPoints() {
    const freshInsoleDesign = useDesignStore.getState().insoleDesign;

    //if (!insolesCount) return;
    if (freshInsoleDesign == null) return;
    for (let i = 0; i < 2; i++) {
      if (!originalGeometryRef.current || !originalGeometryRef.current[i]) continue;
      const geometry = originalGeometryRef.current[i];
      if (geometry == null) return;
      const insoleVertices = geometry.attributes.position.array;

      for (let j = 0; j < meshconfig.current!.pressureAlignmentDefault.length; j++) {
        const index = meshconfig.current!.pressureAlignmentDefault[j];
        const x = insoleVertices[index * 3];
        const y = 0;
        const z = insoleVertices[index * 3 + 2];

        const elements = pressureAlignmentSphereRef.current[i];
        if (!elements || elements.length < 1) continue;
        elements.forEach((el) => {
          if (j === 0 && el.userData.jointName === 'translation') {
            el.userData.originalPosition = new THREE.Vector3(x, y, z);
            el.userData.initialPosition = new THREE.Vector3(x, y, z);
            el.position.set(x, y, z);
          }
          else if (j === 1 && el.userData.jointName === 'rotation') {
            el.userData.originalPosition = new THREE.Vector3(x, y, z);
            el.userData.initialPosition = new THREE.Vector3(x, y, z);
            el.position.set(x, y, z);
          }
        });

        // Force a render update
        if (rendererRef.current && sceneRef.current && cameraRef.current) {
          rendererRef.current.render(sceneRef.current, cameraRef.current);
        }
      }
    }
  }

  function updateInsoleTexture(foot: number, pressureImageData: PressureImage, mesh: THREE.Mesh) {
    if (!mesh) return;

    let offset = textureOffsetsRef.current[foot];
    let textureCenter = pressureAlignmentSphereRef.current[foot][0].position;
    generatePlanarUVs(mesh,
      foot,
      pressureImageData.realWidth,
      pressureImageData.realHeight,
      offset.rotationAngle,
      textureCenter,
      { u: offset.uOffset, v: offset.vOffset }
    );

    mesh = thirdQuarter.current && !isSandal.current && mesh.children.length > 0
      ? mesh.children[0] as THREE.Mesh : mesh;

    const texture = imageDataToTexture(pressureImageData.image)

    createPressureLine(foot);

    texture.colorSpace = THREE.SRGBColorSpace;

    const ratioy = 1;
    const ratiox = 1;

    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;

    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;

    texture.repeat.set(ratiox, ratioy);

    mesh.material = new THREE.MeshStandardMaterial({
      map: texture,
      // color: 0xffffff,
      side: THREE.DoubleSide
    });
    mesh.material.needsUpdate = true;
  }

  function imageDataToTexture(imgData: ImageData): THREE.DataTexture {
    const texture = new THREE.DataTexture(
      new Uint8Array(imgData.data.buffer),
      imgData.width,
      imgData.height,
      THREE.RGBAFormat
    );
    texture.needsUpdate = true;
    return texture;
  }

  useEffect(() => {
    const mode = useViewerStore.getState().mode;
    handleDragControlConnections(mode);
    if (!sceneRef.current) return;
    // Remove old engraving meshes
    const oldMeshes = sceneRef.current.getObjectsByProperty('name', 'engraving');
    sceneRef.current.remove(...oldMeshes);

    // Remove old DragControls if exist
    engravingControlsRef.current.forEach(([dragControl, _]) => {
      try {
        if (dragControl.removeEventListener) {
          dragControl.removeEventListener('dragstart', onDragStart);
          dragControl.removeEventListener('drag', engravingOnDrag);
          dragControl.removeEventListener('dragend', engravingOnDragEnd);
        }
      } catch (e) {
        console.log('Error removing event listeners from engraving drag control:', e);
      }
      dragControl.dispose();
    });
    engravingControlsRef.current = [];

    const oldProxyMeshes = sceneRef.current.getObjectsByProperty('name', 'engravingProxy');
    oldProxyMeshes.forEach((proxy) => {
      if (proxy instanceof THREE.Mesh) {
        proxy.geometry.dispose();
        if (Array.isArray((proxy.material as THREE.Material | THREE.Material[]))) {
          (proxy.material as THREE.Material[]).forEach((material) => material.dispose());
        } else if (proxy.material) {
          (proxy.material as THREE.Material).dispose();
        }
      }
    });
    sceneRef.current.remove(...oldProxyMeshes);
    engravingProxyMapRef.current.clear();

    if (mode === ViewerTabsMode.Engraving || updateFromPanel) {
      var engraving = useDesignStore.getState().engraving;
      // Add all new meshes
      const allMeshes: THREE.Mesh[] = [
        ...(engraving.textMesh || []),
        ...(engraving.UIDMesh || []),
        ...(engraving.CEMesh || []),
      ];
      sceneRef.current.add(...allMeshes);

      // Only RIGHT foot meshes (x < 0) are draggable
      const rightMeshes = allMeshes.filter(mesh => mesh.position.x < 0);

      if (cameraRef.current && rendererRef.current && rightMeshes.length > 0) {
        const proxyMeshes: THREE.Mesh[] = [];
        rightMeshes.forEach((mesh) => {
          const proxyMesh = createEngravingDragProxy(mesh);
          sceneRef.current?.add(proxyMesh);
          proxyMeshes.push(proxyMesh);
        });

        const engravingDragControls = new DragControls(proxyMeshes, cameraRef.current, rendererRef.current.domElement);
        engravingControlsRef.current.push([engravingDragControls, 'engraving']);
        engravingDragControls.addEventListener('dragstart', onDragStart);
        engravingDragControls.addEventListener('drag', engravingOnDrag);
        engravingDragControls.addEventListener('dragend', engravingOnDragEnd);
        rendererRef.current?.render(sceneRef.current, cameraRef.current);
      }
      setUpdateFromPanel(false);
    }
  }, [
    updateFromPanel,
    engraving.textMesh,
    engraving.UIDMesh,
    engraving.CEMesh,
    rightToolboxMode
  ]);

  const createEngravingDragProxy = (sourceMesh: THREE.Mesh): THREE.Mesh => {
    const proxy = new THREE.Mesh(
      new THREE.BoxGeometry(1, 1, 1),
      new THREE.MeshBasicMaterial({
        color: 0x000000,
        transparent: true,
        opacity: 0,
        depthWrite: false,
        depthTest: false,
      })
    );

    proxy.name = 'engravingProxy';
    proxy.userData.sourceMesh = sourceMesh;
    proxy.position.copy(sourceMesh.position);
    proxy.quaternion.copy(sourceMesh.quaternion);

    const box = new THREE.Box3().setFromObject(sourceMesh);
    if (!box.isEmpty()) {
      const size = new THREE.Vector3();
      box.getSize(size);
      proxy.geometry.dispose();
      proxy.geometry = new THREE.BoxGeometry(Math.max(size.x, 0.001), Math.max(size.y, 0.001), Math.max(size.z, 0.001));
      proxy.position.copy(sourceMesh.position);
    }

    engravingProxyMapRef.current.set(proxy, sourceMesh);
    return proxy;
  };

  const engravingOnDrag = (event: THREE.Event & { object: THREE.Object3D }) => {
    const proxy = event.object as THREE.Mesh;
    const targetMesh = engravingProxyMapRef.current.get(proxy) ?? proxy;
    const pos = proxy.position.clone();
    pos.y = -0.05;
    targetMesh.position.copy(pos);
  };

  const engravingOnDragEnd = (event: THREE.Event & { object: THREE.Object3D }) => {
    const proxy = event.object as THREE.Mesh;
    const targetMesh = engravingProxyMapRef.current.get(proxy) ?? proxy;
    const pos = targetMesh.position.clone();
    if (!sceneRef.current) return;

    if (engraving.textMesh?.includes(targetMesh as Brush)) {
      engraving.textPosition = pos.clone();
    }
    else if (engraving.UIDMesh?.includes(targetMesh as Brush)) {
      engraving.UIDPosition = pos.clone();
    }
    else if (engraving.CEMesh?.includes(targetMesh as Brush)) {
      engraving.CEPosition = pos.clone();
    }
    else if (engraving.logoMesh?.includes(targetMesh as Brush)) {
      engraving.logoPosition = pos.clone();
    }
    setUpdateFromViewer(true);

    if (controlsRef?.current) controlsRef.current.enabled = true;
  };

  useEffect(() => {
    if (!outputMeshRef.current) return;

    const { side, index, value } = additionHardnessUpdated;
    if (side < 0 || index < 0 || !insoleDesign) return;
    selectedAdditionIndexRef.current = index;
    selectedFootIndexRef.current = side;
    const addition = insoleDesign.insoles[side].additions[index];
    addition.isUpdated = true;
    addition.hardness = value;

    addition.SetColor();
    // // Use local ref instead of getting from store
    if (selectedAdditionIndexRef.current < 0) return;
    changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, true);
    if (liveMode) {
      deactivateLabel();
      setTimeout(() => {
        const updatedAddition = insoleDesign?.insoles[side]?.additions[index];
        if (updatedAddition && updatedAddition.status !== AdditionNewStatus.removed) {
          createOrUpdateAdditionLabel(updatedAddition, side, index);
        }
      }, 0);
    }
    scheduleAutosave(`Addition hardness (${value} )`, { updateAddition: true });
  }, [additionHardnessUpdated]);

  useEffect(() => {
    if (!outputMeshRef.current) return;

    const { side, index, value } = additionHeightUpdated;
    if (side < 0 || index < 0 || value < 0 || !insoleDesign) return;
    selectedAdditionIndexRef.current = index;
    selectedFootIndexRef.current = side;
    const addition = insoleDesign.insoles[side].additions[index];
    addition.isUpdated = true;
    addition.SetHeight(value);
    addition.UpdateAddition(
      outputMeshRef.current[selectedFootIndexRef.current], value, false);

    updateOutputMesh(selectedFootIndexRef.current);

    // Use local ref instead of getting from store
    if (selectedAdditionIndexRef.current < 0) return;
    changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, true);

    // Sync gizmo Y scale when height changes so future drags are relative to the new height
    if (additionGizmoPivotRef.current) {
      gizmoStartScaleYRef.current = additionGizmoPivotRef.current.scale.y;
    }

    if (liveMode) {
      deactivateLabel();
      setTimeout(() => {
        const updatedAddition = insoleDesign?.insoles[side]?.additions[index];
        if (updatedAddition && updatedAddition.status !== AdditionNewStatus.removed) {
          createOrUpdateAdditionLabel(updatedAddition, side, index);
        }
      }, 0);
    }
    scheduleAutosave(`Addition height (${value} mm)`, { updateAddition: true });
  }, [additionHeightUpdated]);

  // Re-frame on what is visible. Changing which meshes are shown leaves the
  // subject off-centre, because the framing still belongs to what was on screen
  // before — the named camera views only change direction, not framing.
  useEffect(() => {
    const onFit = (event: Event) => {
      if (!cameraRef.current || !controlsRef.current || !containerRef.current) return;
      const detail = (event as CustomEvent<{
        durationMs?: number;
        fill?: number;
        view?: string;
        done?: () => void;
      }>).detail;
      // Asked for as a move: used mid narration, where a snap reads as the page
      // jumping. Without a duration this stays the instant fit every other
      // caller expects after a visibility toggle.
      if (detail?.durationMs) {
        void frameVisibleMeshes(detail.fill ?? 0.6, detail.durationMs / 1000, false, detail.view)
          .then(() => detail.done?.());
        return;
      }
      fitCameraToSceneObjects(
        cameraRef.current,
        controlsRef.current,
        containerRef.current,
        sceneRef,
        'toggle'
      );
      detail?.done?.();
    };
    document.addEventListener(VOICE_FIT_CAMERA_EVENT, onFit);
    return () => document.removeEventListener(VOICE_FIT_CAMERA_EVENT, onFit);
  }, []);

  /**
   * Slide an addition across the insole.
   *
   * Uses the same primitive the drag gizmo uses: TryTranslateXZ reads the
   * displacement from the joint sphere's world position against its recorded
   * original, so the sphere is re-baselined, nudged, and re-baselined again.
   * That keeps a voice-driven move and a dragged one on exactly one code path.
   */
  useEffect(() => {
    if (!outputMeshRef.current) return;

    const { side, index, dx, dz } = additionMoved;
    if (side < 0 || index < 0 || (dx === 0 && dz === 0) || !insoleDesign) return;

    const addition = insoleDesign.insoles[side]?.additions[index];
    if (!addition || !addition.jointGeometry) return;

    selectedAdditionIndexRef.current = index;
    selectedFootIndexRef.current = side;

    // Baseline, nudge, translate, re-baseline.
    addition.UpdateJointGeometry();
    addition.jointGeometry.position.x += dx;
    addition.jointGeometry.position.z += dz;
    addition.jointGeometry.updateMatrixWorld(true);

    const moved = addition.TryTranslateXZ(outputMeshRef.current[side], true);
    addition.UpdateJointGeometry();

    if (!moved) {
      // Refused: either under the one-millimetre threshold, or the addition
      // would have left the insole. Put the sphere back where it was.
      addition.jointGeometry.position.x -= dx;
      addition.jointGeometry.position.z -= dz;
      addition.jointGeometry.updateMatrixWorld(true);
      addition.UpdateJointGeometry();
      return;
    }

    addition.isUpdated = true;
    updateOutputMesh(side);
    changeAdditionColor(index, side, true);

    if (liveMode) {
      deactivateLabel();
      setTimeout(() => {
        const updated = insoleDesign?.insoles[side]?.additions[index];
        if (updated && updated.status !== AdditionNewStatus.removed) {
          createOrUpdateAdditionLabel(updated, side, index);
        }
      }, 0);
    }
    scheduleAutosave("Addition moved", { updateAddition: true });
  }, [additionMoved]);

  useEffect(() => {
    const newAdditionAdded = () => {
      if (!newAddition || !outputMeshRef.current || !originalGeometryRef.current) return false;
      if (newAddition.status === AdditionNewStatus.isNew) {
        selectedFootIndexRef.current = newAddition.foot == 'right' ? 0 : 1;
        const foot = selectedFootIndexRef.current;
        newAddition.thickness = insoleHighLevelParamRef.current[foot].thickness;
        newAddition.ScaleX(newAddition.viewMesh, insoleHighLevelParamRef.current[foot].width / INSOLE_WIDTH_MM, false);
        newAddition.ScaleZ(newAddition.viewMesh, insoleHighLevelParamRef.current[foot].length / INSOLE_LENGTH_MM, false);
        newAddition.TranslateAdditionFromLowpolyToMainMesh(originalGeometryRef.current[foot], outputMeshRef.current[foot]);
        newAddition.UpdateAddition(outputMeshRef.current[foot], null, true);

        updateOutputMesh(foot);

        //for touch panel
        if (liveMode) {
          const index = insoleDesign?.insoles[foot].additions.length;
          if (index && index != 0) createOrUpdateAdditionLabel(newAddition, foot, index - 1);
        }
        return true;
      }
    }
    const handleNewAddition = () => {
      if (insoleDesign == null) return;
      const res = newAdditionAdded();
      if (!res) return;
      const isNewAutoParamAddition = (newAddition?.automaticAddition !== AutomaticAdditions.None) && newAddition?.status === AdditionNewStatus.isNew;
      if (isNewAutoParamAddition)
        scheduleAutosave("New additions", { newAddition: true, updateAutoProperties: isNewAutoParamAddition, now: isNewAutoParamAddition })
      else
        scheduleAutosave("New additions", { newAddition: true, updateAutoProperties: isNewAutoParamAddition, now: isNewAutoParamAddition })
    }
    handleNewAddition();

  }, [newAddition]);

  useEffect(() => {
    // const { side, index } = additionRemoved;

    if (!additionRemoved) return;
    // if (side < 0 || index < 0 || !insoleDesign) return;
    if (!additionRemoved.length || !insoleDesign) return;

    // let additionRemovedCopy = JSON.parse(JSON.stringify(additionRemoved));
    let isRemoveAutoParamAddition = false;
    let needRightInsoleUpdate = false;
    let needLeftInsoleUpdate = false;
    let needSaveRemoveAddition = false;

    for (let i = 0; i < additionRemoved.length; i++) {

      let { side, index, isAdditionID } = additionRemoved[i];
      const allAdditions = insoleDesign.insoles[side].additions;

      const additionsNoRemove = allAdditions.filter(a => a.status !== AdditionNewStatus.removed);

      let finalIndex = index;
      if (isAdditionID) finalIndex = useDesignStore.getState().insoleDesign?.insoles[side].additions.findIndex(add => add.designAdditionId === index);

      if (allAdditions.length !== additionsNoRemove.length) {
        const additionInFiltered = (!isAdditionID) ? additionsNoRemove[index] : additionsNoRemove.find(add => add.designAdditionId === index);
        finalIndex = additionInFiltered
          ? allAdditions.findIndex(a => a === additionInFiltered)
          : -1;
      }

      if (finalIndex < 0 || finalIndex >= allAdditions.length) {
        console.warn("Invalid finalIndex in removal:", finalIndex);
        // useDesignStore.setState({ additionRemoved: [] });
        needSaveRemoveAddition = needSaveRemoveAddition || false;
        continue;
      }
      needSaveRemoveAddition = needSaveRemoveAddition || true;
      const selectedAddition = allAdditions[finalIndex];

      changeAdditionColor(finalIndex, side, false);

      if (selectedAddition && selectedAddition.jointGeometry) {
        if (additionGizmoPivotRef.current && sceneRef.current) {
          if (selectedAddition.jointGeometry.parent === additionGizmoPivotRef.current) {
            additionGizmoPivotRef.current.remove(selectedAddition.jointGeometry);
          }
          sceneRef.current.remove(additionGizmoPivotRef.current);
        }
        if (sceneRef.current?.children.includes(selectedAddition.jointGeometry)) {
          sceneRef.current.remove(selectedAddition.jointGeometry);
        }
        if (sceneRef.current?.children.includes(selectedAddition.viewMesh)) {
          sceneRef.current.remove(selectedAddition.viewMesh);
        }
        selectedAddition.status = AdditionNewStatus.removed;
        if (liveMode) removeAdditionLabel(side, index);
        deactivateLabel();
        rendererRef.current?.render(sceneRef.current!, cameraRef.current!);
        selectedAdditionIndexRef.current = -1;
        selectedFootIndexRef.current = -1;

        currentMode.current = AdditionTransformControlMode.No;

        useViewerStore.setState({
          selectedAdditionFromViewer: { foot: -1, additionIndex: -1 }
        });
      }
      isRemoveAutoParamAddition = isRemoveAutoParamAddition || (selectedAddition?.automaticAddition !== AutomaticAdditions.None) && selectedAddition?.status === AdditionNewStatus.removed;
      needLeftInsoleUpdate = needLeftInsoleUpdate || (side == 1);
      needRightInsoleUpdate = needRightInsoleUpdate || (side == 0);
      findInAutoAdditions(selectedAddition.designAdditionId, side, null);
    }
    // console.log('The insole after removing additions', useDesignStore.getState().insoleDesign?.insoles);
    if (needSaveRemoveAddition) scheduleAutosave('', { removeAddition: true, updateAutoProperties: isRemoveAutoParamAddition });
    if (needRightInsoleUpdate) updateOutputMesh(0);
    if (needLeftInsoleUpdate) updateOutputMesh(1);
    if (isRemoveAutoParamAddition) {
      const event = new CustomEvent('refreshAutomaticComponents');
      document.dispatchEvent(event);
    }

    useDesignStore.setState({ additionRemoved: [] });
    if (liveMode) addLabelstoAllAdditions();
  }, [additionRemoved]);

  const loadAllAdditions = (foot: number, dif: THREE.Vector3 | null) => {
    if (outputMeshRef.current === null || !outputMeshRef.current[foot]) {
      console.log("Missing addition refs, returning early");
      return;
    }
    const localInsoleDesign = useDesignStore.getState().insoleDesign;
    if (localInsoleDesign === null || localInsoleDesign.insoles.length === 0 || localInsoleDesign.insoles[foot].additions.length === 0) return;

    if (insoleHighLevelParamRef.current[foot].thickness == undefined) {
      getInsoleThickness(foot);
    }

    const currectAdditons = localInsoleDesign?.insoles[foot].additions.filter(a => a.status != AdditionNewStatus.removed);

    currectAdditons.forEach(addition => {
      if (addition.mode === AdditionImode.Bottom) {
        addition.thickness = surfaceJointsArray.current[foot]['thickness'].center.y; //insoleHighLevelParamRef.current[foot].thickness;
        addition.UpdateAddition(outputMeshRef.current[foot], null, false, dif);
      }
    });

    currectAdditons.forEach(addition => {
      if (addition.mode === AdditionImode.Top) {
        addition.thickness = surfaceJointsArray.current[foot]['thickness'].center.y;//insoleHighLevelParamRef.current[foot].thickness;
        addition.UpdateAddition(outputMeshRef.current[foot], null, false, dif);
      }
    });

    updateNormalsMesh();

    for (let i = 0; i < currectAdditons.length; i++) {
      if (sceneRef.current && currectAdditons[i].viewMesh && sceneRef.current.children.includes(currectAdditons[i].viewMesh)) {
        sceneRef.current.remove(currectAdditons[i].viewMesh);
      }

      currectAdditons[i].ApplyViewMeshOnOutputMeshNEW(
        getProfilePoints(foot),
        currectAdditons[i].mesh.clone(),
        outputMeshRef.current[foot]
      );

      // currectAdditons[i].ApplyViewMeshOnOutputMesh(
      //   outputMeshRef.current[foot],
      //   currectAdditons[i].mesh.clone(),
      //   i / 10
      // );

      sceneRef.current?.add(currectAdditons[i].viewMesh);
    }
    selectedFootIndexRef.current = foot;
  }

  const getProfilePoints = (foot: number) => {
    let threeVectorPoints: THREE.Vector3[] = [];
    const insoleVertices = originalGeometryRef.current![foot].attributes.position.array;

    threeVectorPoints = profileJoints.current.map(joint => {
      const centerVertexId = joint.centerId;
      const x = insoleVertices[centerVertexId * 3];
      const y = insoleVertices[centerVertexId * 3 + 1];
      const z = insoleVertices[centerVertexId * 3 + 2];
      return new THREE.Vector3(x, y, z);
    });

    let curvePoints: THREE.Vector3[] = [...threeVectorPoints, threeVectorPoints[0]];
    curvePoints = lineSubdivide(curvePoints);

    return curvePoints;
  }

  const addLabelstoAllAdditions = (createMode: boolean = true) => {
    insoleDesign?.insoles.forEach((insole: Insole, foot: number) => {
      let additionIndex = 0;
      insole?.additions.forEach((additionItem: Addition, i: number) => {
        if (additionItem.status != AdditionNewStatus.removed) {
          if (createMode) {
            createOrUpdateAdditionLabel(additionItem, foot, additionIndex, 'create');
            createMode = false;
          }
          else {
            createOrUpdateAdditionLabel(additionItem, foot, additionIndex, 'update');
          }
          additionIndex += 1;
        }
      });
    });
  }

  const getInsoleThickness = (foot: number) => {
    if (outputMeshRef.current[foot]) {
      let thicknessjoint = surfaceJointsArray.current[foot]['thickness'];
      thicknessjoint.value = Math.round(thicknessjoint.center.y * 10) / 10; // round to 1 decimal place
      insoleHighLevelParamRef.current[foot].thickness = thicknessjoint.value;
    }
  }

  const updateNormalsMesh = () => {
    if (!outputMeshRef.current) {
      return;
    }
    const selectedFoot = selectedFootIndexRef.current;

    if (outputMeshRef.current[selectedFoot]?.geometry) {
      outputMeshRef.current[selectedFoot].geometry.computeVertexNormals();
      const meshNormalAttribute = outputMeshRef.current[selectedFoot].geometry.getAttribute('normal');
      if (meshNormalAttribute) {
        meshNormalAttribute.needsUpdate = true;
      }
    }
  }

  const InitAdditionTransformControl = () => {
    if (cameraRef.current === null || rendererRef.current == null || sceneRef.current == null || controlsRef.current == null) return;

    // Initialize AtomiControls once
    if (!atomiControlsRef.current) {
      const radius = 15;
      atomiControlsRef.current = new AtomiControls(cameraRef.current, rendererRef.current, radius);
      atomiControlsRef.current.layers.set(1);
      atomiControlsRef.current.addEventListener("onpointer", ({ onChange }: any) => {
        if (!controlsRef.current) return;
        if (onChange) {
          controlsRef.current.enabled = false;
        } else {
          controlsRef.current.enabled = true;
        }
        // capture start state
        if (onChange) {

          if (insoleDesign && selectedAdditionIndexRef.current >= 0) {

            const selectedAddition =
              insoleDesign.insoles[selectedFootIndexRef.current]
                .additions[selectedAdditionIndexRef.current];

            if (!selectedAddition || !selectedAddition.UpdateJointGeometry) return;

            selectedAddition.UpdateJointGeometry();

            if (additionGizmoPivotRef.current) {

              gizmoStartRotationYRef.current =
                additionGizmoPivotRef.current.rotation.y;

              const startForward = new THREE.Vector3(0, 0, 1)
                .applyQuaternion(additionGizmoPivotRef.current.quaternion);

              startForward.y = 0;

              if (startForward.lengthSq() > 0) {
                startForward.normalize();
              }

              gizmoStartForwardRef.current = startForward;

              gizmoStartScaleXRef.current = additionGizmoPivotRef.current.scale.x;
              gizmoStartScaleYRef.current = additionGizmoPivotRef.current.scale.y;
              gizmoStartScaleZRef.current = additionGizmoPivotRef.current.scale.z;
            }
          }
        } else {
          SetMode(AdditionTransformControlMode.TransformControlDragged);
        }
      });
    }
  }

  const IsAdditionClicked = (clickedPos: THREE.Vector2) => {
    if (!insoleDesign) { return; }
    if (!cameraRef.current) { console.log('Missing required refs addition selection'); return; }
    if (rightToolboxMode === ViewerTabsMode.Engraving || alignPressureToggle) return;
    if (editJointSelected.current) {
      editJointSelected.current = false;
      return;
    }

    if (
      currentMode.current == AdditionTransformControlMode.TransformControlDragged ||
      currentMode.current == AdditionTransformControlMode.AdditionWithTransformControl
    ) return;

    let raycaster = new THREE.Raycaster();
    raycaster.layers.set(0);
    raycaster.params.Mesh = { threshold: 0.001 };
    cameraRef.current.updateMatrixWorld(true);
    raycaster.setFromCamera(clickedPos, cameraRef.current);

    let isAdditionClicked = false;
    let bestHit: { foot: number, index: number, distance: number } | null = null;

    insoleDesign.insoles.forEach((insole: Insole, foot: number) => {
      insole?.additions.forEach((additionItem: Addition, i: number) => {
        if (!additionItem?.viewMesh || additionItem.status === AdditionNewStatus.removed) {
          return;
        }
        additionItem.viewMesh.layers.set(0);
        const intersects = raycaster.intersectObject(additionItem.viewMesh, false);
        if (intersects.length > 0) {
          intersects.sort((a, b) => a.distance - b.distance);
          const hit = intersects[0];
          if (!hit || hit.faceIndex === null || hit.faceIndex === undefined) return;
          if (!bestHit || hit.distance < bestHit.distance) {
            bestHit = {
              foot,
              index: i,
              distance: hit.distance
            };
          }
        }
      });
    });

    if (bestHit) {
      const { foot, index } = bestHit;

      if (index != selectedAdditionIndexRef.current || foot != selectedFootIndexRef.current) {
        if (selectedAdditionIndexRef.current != -1) {
          changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, false);
        }

        selectedAdditionIndexRef.current = index;
        selectedFootIndexRef.current = foot;

        changeAdditionColor(index, foot, true);

        useViewerStore.setState({
          selectedAdditionFromViewer: { foot, additionIndex: index }
        });

        if (rightToolboxMode === ViewerTabsMode.Additions)
          SetMode(AdditionTransformControlMode.EnableTransformControl);
        else if (
          rightToolboxMode === ViewerTabsMode.Edit ||
          rightToolboxMode === ViewerTabsMode.View
        ) SetMode(AdditionTransformControlMode.EnableLimitedTransformControl);

        isAdditionClicked = true;

      }
    }
    if (!isAdditionClicked) {
      changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, false);
      selectedAdditionIndexRef.current = -1;

      useViewerStore.setState({
        selectedAdditionFromViewer: { foot: -1, additionIndex: -1 }
      });
    }
  }

  useEffect(() => {
    if (!liveMode) IsAdditionClicked(leftClickedPosition);
  }, [leftClickedPosition]);

  useEffect(() => {
    if (currentMode.current === AdditionTransformControlMode.AdditionWithTransformControl) {
      SetMode(AdditionTransformControlMode.DisableTransformControl);
    }
    if (alignPressureToggle) {
      useViewerStore.getState().setLiveMode(useViewerStore.getState().oldLiveMode);
      useViewerStore.getState().toggleAlignPressure();
    }
    if (useViewerStore.getState().alignFoot) applyFootTransforms();
  }, [rightClickedPosition]);

  const SetMode = (mode: AdditionTransformControlMode) => {
    if (insoleDesign == null) return;
    // Use the local ref value instead of getting from store
    if (selectedAdditionIndexRef.current < 0) return;

    if (!outputMeshRef.current || outputMeshRef.current === null) return;
    if (sceneRef === null || !sceneRef.current) return;
    currentMode.current = mode;
    let isAdditionTransformedByGizmo = isAdditionUpdatedByGizmo.current;
    const rightToolboxMode = useViewerStore.getState().mode;
    const liveMode = useViewerStore.getState().liveMode;
    if (
      currentMode.current === AdditionTransformControlMode.EnableTransformControl ||
      currentMode.current === AdditionTransformControlMode.EnableLimitedTransformControl
    ) {
      if (
        rightToolboxMode !== ViewerTabsMode.Additions &&
        rightToolboxMode !== ViewerTabsMode.View &&
        rightToolboxMode !== ViewerTabsMode.Edit &&
        !liveMode
      ) return;
      const selectedAddition = insoleDesign.insoles[selectedFootIndexRef.current].additions[selectedAdditionIndexRef.current];
      if (!selectedAddition || !selectedAddition.jointGeometry) return;

      // Create a pivot that holds the joint sphere (visible) and the gizmo as siblings
      if (!additionGizmoPivotRef.current) {
        additionGizmoPivotRef.current = new THREE.Group();
        additionGizmoPivotRef.current.layers.set(1);
      }
      // Position pivot at the addition's world-space bounding box center and reset its rotation
      const box = new THREE.Box3().setFromObject(selectedAddition.viewMesh ?? selectedAddition.mesh);
      const center = new THREE.Vector3();
      box.getCenter(center);
      center.y = (box.max.y + box.min.y) / 2;
      additionGizmoPivotRef.current.position.copy(center);
      additionGizmoPivotRef.current.rotation.set(0, 0, 0);

      // Ensure only one joint sphere is attached (remove any previous joint sphere children)
      additionGizmoPivotRef.current.children
        .filter((c: any) => c?.userData?.jointType === 'addition')
        .forEach((c) => additionGizmoPivotRef.current && additionGizmoPivotRef.current.remove(c));

      // Parent the jointGeometry under pivot at local origin to avoid double-offset
      selectedAddition.jointGeometry.position.set(0, 0, 0);
      selectedAddition.jointGeometry.layers.set(1);
      additionGizmoPivotRef.current.add(selectedAddition.jointGeometry);

      // Attach gizmo to scene
      if (atomiControlsRef.current) {
        if (currentMode.current === AdditionTransformControlMode.EnableLimitedTransformControl) {
          atomiControlsRef.current.limit();
        }
        // else if (selectedAddition.groupName.toLowerCase() === 'rondom' && selectedAddition.paintType === AdditionPaintType.ByConstant) {
        //   atomiControlsRef.current.limitScale('y');
        // } 
        else {
          atomiControlsRef.current.removeLimit();
        }
        additionGizmoPivotRef.current.add(atomiControlsRef.current);
        gizmoStartScaleYRef.current = additionGizmoPivotRef.current.scale.y;
        // match the rotation of transform controls to the addition
        atomiControlsRef.current.ensureRotationMatch(selectedAddition.angle);
      }

      sceneRef.current.add(additionGizmoPivotRef.current);
      currentMode.current = AdditionTransformControlMode.AdditionWithTransformControl;

    } else if (currentMode.current == AdditionTransformControlMode.TransformControlDragged) {
      const curentInsole = insoleDesign.insoles[selectedFootIndexRef.current];
      const selectedAddition = curentInsole.additions[selectedAdditionIndexRef.current];
      if (!selectedAddition) return;

      selectedAddition.thickness = insoleHighLevelParamRef.current[selectedFootIndexRef.current].thickness;
      // Apply XZ translation based on joint world movement (sphere is child of pivot)
      isAdditionTransformedByGizmo = selectedAddition.TryTranslateXZ(outputMeshRef.current[selectedFootIndexRef.current], true) || isAdditionTransformedByGizmo;
      // Apply Y rotation delta using signed angle around world Y between start and current forward vectors
      if (additionGizmoPivotRef.current && gizmoStartForwardRef.current) {
        const currentForward = new THREE.Vector3(0, 0, 1).applyQuaternion(additionGizmoPivotRef.current.quaternion);
        currentForward.y = 0;
        if (currentForward.lengthSq() > 0) currentForward.normalize();
        const start = gizmoStartForwardRef.current.clone();
        const cur = currentForward;
        const crossY = start.x * cur.z - start.z * cur.x; // y-component of cross(start, cur)
        const dot = start.x * cur.x + start.z * cur.z;
        const deltaY = -1 * Math.atan2(crossY, dot);
        isAdditionTransformedByGizmo = selectedAddition.TryRotateY(outputMeshRef.current[selectedFootIndexRef.current], deltaY, true) || isAdditionTransformedByGizmo;
      }

      // Apply scale from gizmo pivot to the addition
      if (additionGizmoPivotRef.current) {
        const relX = additionGizmoPivotRef.current.scale.x / gizmoStartScaleXRef.current;
        const relY = additionGizmoPivotRef.current.scale.y / gizmoStartScaleYRef.current;
        const relZ = additionGizmoPivotRef.current.scale.z / gizmoStartScaleZRef.current;
        isAdditionTransformedByGizmo = selectedAddition.ScaleX(outputMeshRef.current[selectedFootIndexRef.current], relX) || isAdditionTransformedByGizmo;
        isAdditionTransformedByGizmo = selectedAddition.ScaleZ(outputMeshRef.current[selectedFootIndexRef.current], relZ) || isAdditionTransformedByGizmo;
        isAdditionTransformedByGizmo = selectedAddition.ScaleY(outputMeshRef.current[selectedFootIndexRef.current], relY, true) || isAdditionTransformedByGizmo;
        // Reset captured start scales to current so gizmo visual size remains consistent
        gizmoStartScaleXRef.current = additionGizmoPivotRef.current.scale.x;
        gizmoStartScaleYRef.current = additionGizmoPivotRef.current.scale.y;
        gizmoStartScaleZRef.current = additionGizmoPivotRef.current.scale.z;
        if (gizmoStartScaleYRef.current !== 1) {
          setTimeout(() => {
            deactivateLabel();
          }, 300);
        }
        // Reset gizmos scale pointers position and scale
        atomiControlsRef.current?.resetScales();
        isAdditionUpdatedByGizmo.current = isAdditionTransformedByGizmo;
        updateOutputMesh(selectedFootIndexRef.current);

        // Position pivot at the addition's world-space bounding box center and reset its rotation
        const box = new THREE.Box3().setFromObject(selectedAddition.viewMesh ?? selectedAddition.mesh);
        const center = new THREE.Vector3();
        box.getCenter(center);
        center.y = (box.max.y + box.min.y) / 2;
        additionGizmoPivotRef.current.position.copy(center);

      }
      currentMode.current = AdditionTransformControlMode.AdditionWithTransformControl;
    }
    else if (currentMode.current === AdditionTransformControlMode.DisableTransformControl) {
      changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, false);
      //console.log('changeAdditionColor4');
      const selectedAddition = insoleDesign.insoles[selectedFootIndexRef.current].additions[selectedAdditionIndexRef.current];
      if (!selectedAddition || !selectedAddition.jointGeometry) return;
      if (additionGizmoPivotRef.current && sceneRef.current) {
        // Detach gizmo and sphere from pivot, then remove pivot
        additionGizmoPivotRef.current.remove(selectedAddition.jointGeometry);
        sceneRef.current.remove(additionGizmoPivotRef.current);
      }
      // Ensure jointGeometry is removed from scene if still present
      if (sceneRef.current && sceneRef.current.children.includes(selectedAddition.jointGeometry)) {
        sceneRef.current.remove(selectedAddition.jointGeometry);
      }
      selectedAdditionIndexRef.current = -1;
      currentMode.current = AdditionTransformControlMode.No;
      useViewerStore.setState({
        selectedAdditionFromViewer: { foot: -1, additionIndex: -1 }
      });
      atomiControlsRef.current?.resetScales();
      gizmoStartScaleXRef.current = 1;
      gizmoStartScaleYRef.current = 1;
      gizmoStartScaleZRef.current = 1;
      additionGizmoPivotRef.current?.scale.set(1, 1, 1);
      additionGizmoPivotRef.current?.children.forEach((child) => {
        if (child !== selectedAddition.jointGeometry) {
          child.scale.set(1, 1, 1);
        }
      });

      if (liveMode) {
        addLabelstoAllAdditions();
      }
    }
    if (isAdditionUpdatedByGizmo.current) {
      scheduleAutosave("New addition position", { updateAddition: true })
      isAdditionUpdatedByGizmo.current = false;
    }
  };

  const changeAdditionColor = (additonIndex: number, footIndex: number, selected: boolean) => {
    if (!insoleDesign) return;
    const insole = insoleDesign.insoles[footIndex];
    if (!insole || additonIndex < 0) return;

    const ad = insole.additions[additonIndex];
    if (!ad || !ad.viewMesh) return;

    const color = selected ? DEFAULT_CILICKED_ADDITION_COLOR : ad.color;
    const additionMaterial = ad.viewMesh.material;

    const applyHexColorToAdditionMaterial = (mat: THREE.Material) => {
      mat.transparent = true;
      if ('color' in mat) {
        (mat as THREE.MeshStandardMaterial).color.setHex(color);
      }
    };
    Array.isArray(additionMaterial) ? additionMaterial.forEach(applyHexColorToAdditionMaterial) : applyHexColorToAdditionMaterial(additionMaterial);

    ad.viewMesh.material = additionMaterial;
  };

  const setAdditionsOpacity = (opacity: number) => {
    if (!insoleDesign || !insoleDesign.insoles) return;

    insoleDesign.insoles.forEach((insole, foot) => {
      insole.additions?.forEach((addition, idx) => {
        const mat = addition.viewMesh?.material;
        if (!mat) return;
        const apply = (m: THREE.Material) => {
          const mm = m as any;
          if (typeof mm.opacity === 'number') {
            mm.transparent = true;
            mm.opacity = opacity;
            m.needsUpdate = true;
          }
        };
        Array.isArray(mat) ? mat.forEach(apply) : apply(mat);
      });
    });

    // Optional: force a render so you see the change instantly
    if (rendererRef.current && sceneRef.current && cameraRef.current) {
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    }
  };

  const selectRoofPointsBothFoot = (joint: HighLevelJoint) => {
    clearSelection(false);
    if (!originalGeometryRef.current) return;
    originalGeometryRef.current.forEach((foot) => {
      const selectedAttribute = foot.getAttribute('selected');
      if (!selectedAttribute) return;
      const selectedArray = selectedAttribute.array;

      joint.vertices.forEach((vertices: { ids: number[], weight: number }) => {
        vertices.ids.forEach((vertexId: number) => {
          selectedArray[vertexId] = vertices.weight;
        });
      });

      selectedAttribute.needsUpdate = true;
    });
  }

  // Add clearSelection function
  const clearSelection = (callUpdate: boolean = true) => {
    // Remove all highlighted faces
    removeAllHighlightedFaces();

    // Reset 'selected' attribute in the original geometry if it exists
    if (originalGeometryRef.current) {
      const selectedAttribute = originalGeometryRef.current[selectedFootIndexRef.current]?.getAttribute('selected');
      if (selectedAttribute) {
        for (let i = 0; i < selectedAttribute.array.length; i++) {
          selectedAttribute.array[i] = 0;
        }
        selectedAttribute.needsUpdate = true;
      }
    }

    // Update the output mesh to reflect the cleared selection
    if (callUpdate) updateOutputMesh();
  };

  // Function to update renderer size
  const updateRendererSize = () => {
    if (!containerRef.current || !cameraRef.current || !rendererRef.current) return;

    const width = containerRef.current.clientWidth;
    let height = containerRef.current.clientHeight;

    // Prevent unreasonably large heights (likely measurement errors)
    const MAX_HEIGHT = 2000; // Set a reasonable maximum height
    if (height > MAX_HEIGHT) {
      console.warn(`Height value too large (${height}px), capping at ${MAX_HEIGHT}px`);
      height = MAX_HEIGHT;
    }

    // Only update if size has changed significantly (prevent micro-adjustments)
    const significantChange =
      Math.abs(width - containerSize.width) > 5 ||
      Math.abs(height - containerSize.height) > 5;

    if (significantChange) {

      // Update camera
      if (cameraRef.current instanceof THREE.PerspectiveCamera) {
        cameraRef.current.aspect = width / height;
      } else if (cameraRef.current instanceof THREE.OrthographicCamera) {
        const aspect = width / height;
        const d = 20;
        cameraRef.current.left = -d * aspect;
        cameraRef.current.right = d * aspect;
        cameraRef.current.top = d;
        cameraRef.current.bottom = -d;
      }

      if (
        cameraRef.current instanceof THREE.PerspectiveCamera ||
        cameraRef.current instanceof THREE.OrthographicCamera
      ) {
        cameraRef.current.updateProjectionMatrix();
      }

      // Update renderer size
      rendererRef.current.setSize(width, height);

      // Use theme color for background
      const color = getThemeBackgroundColor();
      const threeColor = new THREE.Color(color);
      if (sceneRef.current) {
        sceneRef.current.background = threeColor;
      }
      rendererRef.current.setClearColor(threeColor);

      // Force a render to prevent black flash
      rendererRef.current.render(sceneRef.current!, cameraRef.current!);

      // Update container size state
      setContainerSize({ width, height });
    }
  };

  // Function to add vertex spheres
  const addRoofVertexSpheres = (geometry: THREE.BufferGeometry, scene: THREE.Scene | null, foot: number) => {
    if (!scene || isSandal.current) return;

    const stateViewer = useViewerStore.getState().mode;
    // Get vertex positions
    const positions = geometry.attributes.position.array;

    // Create a group to hold all vertex spheres
    const spheresGroup = new THREE.Group();
    scene.add(spheresGroup);

    // Clear previous spheres
    vertexSpheresRef.current[foot] = [];

    // Create a material for the spheres
    const sphereMaterial = new THREE.MeshBasicMaterial({
      color: 0x0000FF, // Blue color
      transparent: true,
      opacity: 0.8, // Increase opacity for better visibility
      depthTest: false
    });

    // Create a small sphere geometry - make it smaller to better fit on vertices
    let radius = isMobile() || isTablet() ? 1.7 : 1.2;
    const sphereGeometry = new THREE.SphereGeometry(radius, 8, 8);

    // let aa = '';
    // // console.log('________________________');
    // // Add a sphere for each vertex
    // for (let i = 0; i < positions.length; i += 3) {
    //   const vertexId = i / 3;
    //   const x = positions[i];
    //   const y = positions[i + 1];
    //   const z = positions[i + 2];

    //   if (y > 1.5)
    //     aa += ' ' + vertexId + ','
    //   // Create a sphere for the vertex
    //   const sphere = new THREE.Mesh(sphereGeometry, new THREE.MeshStandardMaterial({
    //     color: 'green', // Green color
    //     transparent: true,
    //     opacity: 0.8, // Increase opacity for better visibility
    //     depthTest: false
    //   }));
    //   sphere.position.set(x, y, z);
    //   sphere.userData.vertexId = vertexId;
    //   sphere.userData.foot = foot;

    //   // Add the sphere to the group
    //   // if (y > 1.5) spheresGroup.add(sphere);
    //   // vertexSpheresRef.current[foot].push(sphere);
    //   sceneRef.current?.add(sphere);
    // }

    // // console.log('_________________',aa);


    // Add a sphere for each vertex   
    meshconfig.current!.roofVertices.vertices[0].ids.forEach(vertexId => {
      const x = positions[vertexId * 3];
      const y = positions[vertexId * 3 + 1];
      const z = positions[vertexId * 3 + 2];

      // Create a sphere for the vertex
      const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial.clone());
      sphere.position.set(x, y, z);
      sphere.userData.vertexId = vertexId;
      sphere.userData.foot = foot;
      sphere.renderOrder = 1;
      makeSphereEasierToTouch(sphere, 2.2);
      sphere.visible = advanceMode && stateViewer == ViewerTabsMode.Edit;

      // Add the sphere to the group
      spheresGroup.add(sphere);
      vertexSpheresRef.current[foot].push(sphere);
    });

    // Store the spheres group reference for cleanup
    vertexSpheresGroupRef.current?.push(spheresGroup);
  };

  // Function to update the output mesh
  const updateOutputMesh = (foot?: number) => {
    if (!originalGeometryRef.current || !sceneRef.current) return;

    // Use the ref value instead of the state value for immediate updates
    const feetToUpdate = foot === undefined ? [0, 1] : [foot];

    //select roof points for apply addition
    selectRoofPointsBothFoot(meshconfig.current!.roofJoints);

    feetToUpdate.forEach(index => {
      if (!originalGeometryRef.current || !originalGeometryRef.current[index]) return;
      const geometryref = originalGeometryRef.current[index];

      // Apply subdivision to the original geometry
      const subdividedGeometry = applySubdivision(geometryref.clone(), 2);
      // Merge vertices to ensure proper normal sharing
      const mergedGeometry = BufferGeometryUtils.mergeVertices(subdividedGeometry);
      outputMeshRef.current[index].geometry.dispose();
      outputMeshRef.current[index].geometry.copy(mergedGeometry);
      // Ensure proper normal calculation for smooth shading
      outputMeshRef.current[index].geometry.computeVertexNormals();
      outputMeshRef.current[index].geometry.computeBoundingBox();
      // Set needsUpdate flag for normal attribute
      const outputNormalAttribute = outputMeshRef.current[index].geometry.getAttribute('normal');
      if (outputNormalAttribute) {
        outputNormalAttribute.needsUpdate = true;
      }

      var dif = updateObjectsLocation(outputMeshRef.current[index], index);
      loadAllAdditions(index, dif);

      const subdividedGeometry2 = applySubdivision(outputMeshRef.current[index].geometry.clone(), 1);
      // Merge vertices to ensure proper normal sharing
      const mergedGeometry2 = BufferGeometryUtils.mergeVertices(subdividedGeometry2);
      outputMeshRef.current[index].geometry.dispose();
      outputMeshRef.current[index].geometry.copy(mergedGeometry2);
      // Ensure proper normal calculation for smooth shading
      outputMeshRef.current[index].geometry.computeVertexNormals();
      outputMeshRef.current[index].geometry.computeBoundingBox();
      // Set needsUpdate flag for normal attribute
      const outputNormalAttribute2 = outputMeshRef.current[index].geometry.getAttribute('normal');
      if (outputNormalAttribute2) {
        outputNormalAttribute2.needsUpdate = true;
      }

      createSpline(index);
      createArchEditorLine(index);
      createPressureLine(index);
      addShaderToMaterial(index);
      UpdateLiftedMesh(index);
      if (useViewerStore.getState().grids) enableGrids(true);

      if (isSandal.current) {
        insoleHighLevelParamRef.current[index].instepArea = createInStepLine(index, undefined);
      }
      useDesignStore.getState().setGCode([]);
      useDesignStore.getState().setUpdatedMesh(outputMeshRef.current[index]);

      outputMeshRef.current[index].material.vertexColors = true;
      outputMeshRef.current[index].material.needsUpdate = true;
    });

    setColorandTransparency();
    if (!useViewerStore.getState().coloring) {
      if (pressureImageDataRef.current[0]) {
        updateInsoleTexture(0, pressureImageDataRef.current[0], outputMeshRef.current[0]);
        updateInsoleTexture(0, pressureImageDataRef.current[0], LiftedMeshRef.current[0]);
      }
      if (pressureImageDataRef.current[1]) {
        updateInsoleTexture(1, pressureImageDataRef.current[1], outputMeshRef.current[1]);
        updateInsoleTexture(1, pressureImageDataRef.current[1], LiftedMeshRef.current[1]);
      }
    }

    // Force a render to update the scene
    if (rendererRef.current && cameraRef.current) {
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    }
    useViewerStore.getState().toggleSurfaceUpdated();
  };

  const generatePlanarUVs = (
    mesh: THREE.Mesh,
    foot: number,
    imageDataWidth: number,
    imageDataHeight: number,
    radAngle: number = 0,
    center: THREE.Vector3,
    uvOffset: { u: number, v: number }
  ) => {
    if (!mesh || !mesh.geometry || !mesh.geometry.isBufferGeometry) return;

    const mBox = GetInsoleBox(mesh);
    const mCenter = mBox.getCenter(new THREE.Vector3());

    mesh = thirdQuarter.current && !isSandal.current && mesh.children.length > 0
      ? mesh.children[0] as THREE.Mesh : mesh;

    if (thirdQuarter.current && !isSandal.current && mesh.children.length == 0) {
      const mBox = GetInsoleBox(outputMeshRef.current[foot]);
      mBox.getCenter(mCenter);
    }

    const geometry = mesh.geometry;
    const positionAttr = geometry.attributes.position;
    const selectAttr = geometry.getAttribute('selected').array;

    geometry.computeBoundingBox();

    // if (geometry.boundingBox)
    // geometry.boundingBox.getCenter(mCenter);

    let minX = mCenter.x - 0.5 * imageDataWidth;
    let minZ = mCenter.z - 0.5 * imageDataHeight;

    // let minX = Infinity;
    // let minZ = Infinity;

    // for (let i = 0; i < positionAttr.count; i++) {
    //   const x = positionAttr.getX(i);
    //   const z = positionAttr.getZ(i);
    //   if (x < minX) minX = x;
    //   if (z < minZ) minZ = z;
    // }

    const uvArray: number[] = [];

    const cos = Math.cos(radAngle);
    const sin = Math.sin(radAngle);

    for (let i = 0; i < positionAttr.count; i++) {
      // map texture only on insole part for sandal
      if (isSandal.current && selectAttr[i] < 0.9) {
        uvArray.push(0, 0);
        continue;
      }

      let x = positionAttr.getX(i) - center.x;
      let z = positionAttr.getZ(i) - center.z;

      const xr = x * cos - z * sin;
      const zr = x * sin + z * cos;

      x = xr + center.x;
      z = zr + center.z;

      let u = (x - minX) / imageDataWidth;
      let v = (z - minZ) / imageDataHeight;

      u += uvOffset.u;
      v += uvOffset.v;

      uvArray.push(u, v);
    }

    geometry.setAttribute("uv", new THREE.Float32BufferAttribute(uvArray, 2));
    geometry.attributes.uv.needsUpdate = true;
  }

  // Function to handle drag start
  const onDragStart = () => {
    // Disable orbit controls during dragging
    if (controlsRef.current) {
      controlsRef.current.enabled = false;
    }
  };

  // Function to handle drag
  const onDrag = (event: THREE.Event & { object: THREE.Object3D }) => {
    if (!originalGeometryRef.current || !sceneRef.current) return;

    const sphere = event.object as THREE.Mesh;
    const jointType = sphere.userData.jointType;

    if (jointType === HIGH_HEEL_JOINT_TYPE) {
      highHeelRef.current.applyHandleDrag(sphere);
      return;
    }

    // Get the dragged sphere
    const jointIndex = sphere.userData.jointIndex;
    const jointName = sphere.userData.jointName;

    if (jointType === JointType.ADDITION || jointType === JointType.PRESSURE_ALIGNMENT) return;

    const foot = sphere.userData.foot;
    const geometry = originalGeometryRef.current[foot];
    const insoleVertices = geometry.getAttribute('position');
    const originalPositions = new Float32Array(insoleVertices.array);

    let joint;
    if (jointType === 'surface') {
      joint = surfaceJointsArray.current[foot][labelToProperty(jointName)];
    } else if (jointType === 'profile') {
      joint = profileJointsArray.current[foot][jointIndex];
    } else {
      const vertexId = sphere.userData.vertexId;
      const distance = sphere.position.y - insoleVertices.getY(vertexId);

      // Update the original geometry vertex position
      // insoleVertices.setX(vertexId, sphere.position.x);
      insoleVertices.setY(vertexId, sphere.position.y);
      // insoleVertices.setZ(vertexId, sphere.position.z);

      sphere.position.x = insoleVertices.getX(vertexId);
      sphere.position.z = insoleVertices.getZ(vertexId);

      meshconfig.current!.roofVertices.vertices.slice(1).forEach(vertexGroup => {
        if (vertexGroup.ids.includes(sphere.userData.vertexId))
          vertexGroup.ids.forEach(vertexId => {
            // Calculate new position based on weight and displacement
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, originalPositions[vertexId * 3 + 1] + distance * weight);
          });
      });
    }

    let displacement = new THREE.Vector3();
    if (jointType)
      displacement = new THREE.Vector3(
        sphere.position.x - sphere.userData.originalPosition.x,
        sphere.position.y - sphere.userData.originalPosition.y,
        sphere.position.z - sphere.userData.originalPosition.z
      );

    // update thickness with 0.5mm steps and skip 3mm thickness because of print bugs
    if (jointName == 'Thickness' && joint) {
      var thStep = 0.5;
      let nowVal = sphere.position.y;
      let oldValY = sphere.userData.originalPosition.y;
      const outsoleOffset = isSandal.current
        ? (surfaceJointsArray.current[foot]['outsoleThickness']?.center.y ?? 0) + 2.55
        : 0;
      nowVal -= outsoleOffset;
      oldValY -= outsoleOffset;

      var realVal = nowVal * joint.bval + joint.cval;
      var snappedVal = Math.round(realVal / thStep) * thStep;
      if (snappedVal == 3) snappedVal = 3.5;
      var currentVal = (snappedVal - joint.cval) / joint.bval;

      var thicknessDisplacement = currentVal - oldValY;
      displacement.y = thicknessDisplacement;

      sphere.position.y = currentVal + outsoleOffset;
    }

    // Constrain movement based on joint type
    if (jointType === 'surface' && jointName !== 'Arch Sagital Position') {
      sphere.position.x = sphere.userData.originalPosition.x;
      sphere.position.z = sphere.userData.originalPosition.z;
      sphere.userData.originalPosition.y = sphere.position.y;
    } else if (jointType === 'surface' && jointName === 'Arch Sagital Position') {
      sphere.position.x = sphere.userData.originalPosition.x;
      sphere.position.y = sphere.userData.originalPosition.y;
      sphere.userData.originalPosition.z = sphere.position.z;
    } else if (jointType === 'profile') {
      sphere.position.y = sphere.userData.originalPosition.y;
      sphere.userData.originalPosition.x = sphere.position.x;
      sphere.userData.originalPosition.z = sphere.position.z;
    }

    let editFlag = false;
    if (joint) {
      editFlag = true;
      if (jointType === 'surface') {
        if (jointName === 'Heel Lateral Wedge' && insoleHighLevelParamRef.current[foot].heelWedgeType == 'Medial') {
          editFlag = false;
        }
        else if (jointName === 'Heel Medial Wedge' && insoleHighLevelParamRef.current[foot].heelWedgeType == 'Lateral') {
          editFlag = false;
        }
        else if (jointName === 'Forefoot Lateral Wedge' && insoleHighLevelParamRef.current[foot].forefootWedgeType == 'Medial') {
          editFlag = false;
        }
        else if (jointName === 'Forefoot Medial Wedge' && insoleHighLevelParamRef.current[foot].forefootWedgeType == 'Lateral') {
          editFlag = false
        }
      }
    }

    // Update vertices for each vertex group
    if (joint && editFlag) {
      joint.center = sphere.position;
      if (jointName !== 'Arch Sagital Position') {
        if (jointName === 'Heel Height' || jointName === 'Thickness' || jointName === 'Outsole Thickness') heelDepthRealY.current[foot] += displacement.y;
        joint.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: any) => {
            // Calculate new position based on weight and displacement
            const weight = vertexGroup.weight;
            const newX = originalPositions[vertexId * 3] + displacement.x * weight;
            const newY = originalPositions[vertexId * 3 + 1] + displacement.y * weight;
            const newZ = originalPositions[vertexId * 3 + 2] + displacement.z * weight;

            // Update the vertex position in the geometry
            if (jointType === 'surface') {
              insoleVertices.setY(vertexId, newY);
            } else if (jointType === 'profile') {
              insoleVertices.setX(vertexId, newX);
              insoleVertices.setZ(vertexId, newZ);
            }

            // Update the corresponding roof vertex sphere position if it exists
            if (vertexSpheresRef.current && vertexSpheresRef.current[foot]) {
              const vertexSphere = vertexSpheresRef.current[foot].filter((item) => item.userData.vertexId === vertexId)[0];
              if (vertexSphere == undefined) return;

              if (jointType === 'surface') {
                vertexSphere.position.set(vertexSphere.position.x, newY, vertexSphere.position.z);
              } else if (jointType === 'profile') {
                vertexSphere.position.set(newX, vertexSphere.position.y, newZ);
              }
            }
          });
        });

        let anotherWedgeJoint;;
        if (jointType === 'surface') {
          if (jointName === 'Heel Lateral Wedge' && insoleHighLevelParamRef.current[foot].heelWedgeType == 'Lateral') {
            anotherWedgeJoint = surfaceJointsArray.current[foot]['heelMedialWedge'];
            anotherWedgeJoint.vertices.forEach((vertexGroup) => {
              vertexGroup.ids.forEach((vertexId) => {
                const weight = vertexGroup.weight * -1;
                const newY = originalPositions[vertexId * 3 + 1] + displacement.y * weight;
                insoleVertices.setY(vertexId, newY);
              });
            });
          }
          else if (jointName === 'Heel Medial Wedge' && insoleHighLevelParamRef.current[foot].heelWedgeType == 'Medial') {
            anotherWedgeJoint = surfaceJointsArray.current[foot]['heelLateralWedge'];
            anotherWedgeJoint.vertices.forEach((vertexGroup) => {
              vertexGroup.ids.forEach((vertexId) => {
                const weight = vertexGroup.weight * -1;
                const newY = originalPositions[vertexId * 3 + 1] + displacement.y * weight;
                insoleVertices.setY(vertexId, newY);
              });
            });
          }
          else if (jointName === 'Forefoot Medial Wedge' && insoleHighLevelParamRef.current[foot].forefootWedgeType == 'Medial') {
            anotherWedgeJoint = surfaceJointsArray.current[foot]['forefootLateralWedge'];
            anotherWedgeJoint.vertices.forEach((vertexGroup) => {
              vertexGroup.ids.forEach((vertexId) => {
                const weight = vertexGroup.weight * -1;
                const newY = originalPositions[vertexId * 3 + 1] + displacement.y * weight;
                insoleVertices.setY(vertexId, newY);
              });
            });
          }
          else if (jointName === 'Forefoot Lateral Wedge' && insoleHighLevelParamRef.current[foot].forefootWedgeType == 'Lateral') {
            anotherWedgeJoint = surfaceJointsArray.current[foot]['forefootMedialWedge'];
            anotherWedgeJoint.vertices.forEach((vertexGroup) => {
              vertexGroup.ids.forEach((vertexId) => {
                const weight = vertexGroup.weight * -1;
                const newY = originalPositions[vertexId * 3 + 1] + displacement.y * weight;
                insoleVertices.setY(vertexId, newY);
              });
            });
          }
        }
      }
      else {
        archLinePointsRef.current[foot][0] = new THREE.Vector3(sphere.position.x, 0, sphere.position.z);
        correctArchEditor(sphere.position.z, foot, insoleVertices, joint);
      }
    }

    // Mark the position attribute as needing update
    geometry.attributes.position.needsUpdate = true;
    geometry.computeVertexNormals();

    // Force a render to update the scene
    if (rendererRef.current && cameraRef.current) {
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    }

    if (sphere.userData.jointType === 'surface' || sphere.userData.jointName === 'Arch Sagital Position') {
      const fieldKey = joint!.name;
      const data = getValueFromFieldKey(foot, fieldKey);
      const value = Math.round(data?.value);
      setLastUpdatedParams([{ foot, fieldKey, value }]);
    }
  };

  // Function to handle drag end
  const onDragEnd = (event: THREE.Event & { object: THREE.Object3D }) => {
    editJointSelected.current = true;   //prevent addition update when dragging a joint

    // Get the dragged sphere
    const sphere = event.object as THREE.Mesh;
    if (sphere.userData.jointType === HIGH_HEEL_JOINT_TYPE) {
      if (controlsRef.current) controlsRef.current.enabled = true;
      const result = highHeelRef.current.finishHandleDrag(sphere);
      if (result) {
        const { foot, height } = result;
        if (insoleHighLevelParamRef.current[foot]) {
          insoleHighLevelParamRef.current[foot].highHeelHeight = height;
        }
        UpdateLiftedMesh(foot);
        updateSurfaceJointValuesTable();
        // scheduleAutosave('High heel height', { updateInsoleMesh: true });
      }
      return;
    }

    const foot = sphere.userData.foot;
    const joint = sphere.userData.jointType == 'surface' ?
      surfaceJointsArray.current[foot][labelToProperty(sphere.userData.jointName)] : null;

    let needUpdateAutoProperties: boolean = false;
    let needSaveAdditionUpdate: boolean = false;

    if (joint && sphere.userData.jointType === 'surface') {
      checkHighLevelsValuesAfterEditing(joint, foot);
      if (!isSandal.current) {
        handleArchFill(foot, insoleHighLevelParamRef.current[foot].archFill);
        handleHeelFill(foot, insoleHighLevelParamRef.current[foot].heelFill);
        handleArchHeelFill(foot, insoleHighLevelParamRef.current[foot].archFill, insoleHighLevelParamRef.current[foot].heelFill);
      }
    }

    // recalculate addition location if arch position edited
    if (joint && sphere.userData.jointType === 'surface' && sphere.userData.jointName === 'Arch Sagital Position') {
      insoleDesign?.insoles[foot].additions.forEach(ad => {
        if (ad.relativeIndexMesh != null) {
          ad.TranslateAdditionFromLowpolyToMainMesh(originalGeometryRef.current![foot], outputMeshRef.current[foot]);
          ad.isUpdated = true;
          needSaveAdditionUpdate = true;
        }
      });
    }

    // Re-enable orbit controls after dragging
    if (controlsRef.current) {
      controlsRef.current.enabled = true;
    }

    // Update the original mesh after drag ends
    if (originalGeometryRef.current && sceneRef.current) {

      //Update values and tables
      if (sphere.userData.jointType === 'surface') {
        let heelDepthMouseChanging = sphere.userData.jointName == 'Heel Height' || sphere.userData.jointName == 'Thickness' || sphere.userData.jointName == 'Outsole Thickness';
        handleSurfaceJointValues(foot, heelDepthMouseChanging);
      }

      //Update profile and surface spheres
      if (originalGeometryRef.current) {
        updateJointSpheres(originalGeometryRef.current[foot], foot);
      }

      if (sphere.userData.jointType === 'surface' &&
        (sphere.userData.jointName == 'Heel Depth' ||
          sphere.userData.jointName == 'Heel Height' ||
          sphere.userData.jointName == 'Thickness' ||
          sphere.userData.jointName == 'Outsole Thickness'
        )) {
        handleSurfaceJointValues(foot);
        updateHeelDepthAutoProps();
        needUpdateAutoProperties = true;
      }


      // Update the output mesh
      updateOutputMesh(foot);

      if (sphere.userData.jointType === 'profile') {
        updateInsoleLengthAndWidth(foot, true);
        // Update the dimension spheres and labels for length and width
        setLastUpdatedParams([{ foot: foot, fieldKey: 'Profile Curve', value: 0 }]);
      }

      scheduleAutosave("Changes to the design mesh", {
        updateInsoleMesh: true,
        updateAutoProperties: needUpdateAutoProperties,
        updateAddition: needSaveAdditionUpdate
      });

      // Force a render to update the scene
      if (rendererRef.current && cameraRef.current) {
        rendererRef.current.render(sceneRef.current, cameraRef.current);
      }
    }

    if (sphere.userData.jointType === 'surface' || sphere.userData.jointName === 'Arch Sagital Position') {
      const fieldKey = joint!.name;
      const data = getValueFromFieldKey(foot, fieldKey);
      const value = Math.round(data?.value);
      setLastUpdatedParams([{ foot, fieldKey, value }]);
    }
  };

  const savePressureAlignment = async () => {
    if (!pressureAlignmentSphereRef.current?.length) return;
    const rightTranslationMesh: THREE.Mesh = pressureAlignmentSphereRef.current[0].filter(sphere => sphere.userData.jointName === 'translation')[0];
    const rightRotationMesh: THREE.Mesh = pressureAlignmentSphereRef.current[0].filter(sphere => sphere.userData.jointName === 'rotation')[0];
    const leftTranslationMesh: THREE.Mesh = pressureAlignmentSphereRef.current[1].filter(sphere => sphere.userData.jointName === 'translation')[0];
    const leftRotationMesh: THREE.Mesh = pressureAlignmentSphereRef.current[1].filter(sphere => sphere.userData.jointName === 'rotation')[0];
    const alignPressureDto = new DesignPressureAlignmentRequestDto({
      rightCenterPointX: rightTranslationMesh.position.x,
      rightCenterPointZ: rightTranslationMesh.position.z,
      rightRotationPointX: rightRotationMesh.position.x,
      rightRotationPointZ: rightRotationMesh.position.z,
      leftCenterPointX: leftTranslationMesh.position.x,
      leftCenterPointZ: leftTranslationMesh.position.z,
      leftRotationPointX: leftRotationMesh.position.x,
      leftRotationPointZ: leftRotationMesh.position.z,
    });
    await saveDesignPressureAlignment(api, useSelectedDesignStore.getState().designId, alignPressureDto);
  }

  const getAlignmentSpheres = (foot: number) => {
    const spheres = pressureAlignmentSphereRef.current[foot];
    const translation = spheres?.find(sphere => sphere.userData.jointName === 'translation');
    const rotation = spheres?.find(sphere => sphere.userData.jointName === 'rotation');
    if (!translation?.userData.initialPosition || !rotation?.userData.initialPosition) return null;
    return { translation, rotation };
  }

  // Stored alignment points are absolute coordinates on the current model's mesh. Before switching
  // model type, express them relative to the model's default points so they can be re-applied.
  const capturePressureAlignmentOffsets = (): PressureAlignmentOffset[] | null => {
    const alignment = useDesignStore.getState().pressureAlignment;
    if (!alignment) return null;

    const offsets: PressureAlignmentOffset[] = [];
    for (let foot = 0; foot < 2; foot++) {
      const spheres = getAlignmentSpheres(foot);
      if (!spheres) return null;
      const defaultCenter: THREE.Vector3 = spheres.translation.userData.initialPosition;
      const defaultRotation: THREE.Vector3 = spheres.rotation.userData.initialPosition;

      const centerX = (foot === 0 ? alignment.rightCenterPointX : alignment.leftCenterPointX) ?? defaultCenter.x;
      const centerZ = (foot === 0 ? alignment.rightCenterPointZ : alignment.leftCenterPointZ) ?? defaultCenter.z;
      const rotationX = (foot === 0 ? alignment.rightRotationPointX : alignment.leftRotationPointX) ?? defaultRotation.x;
      const rotationZ = (foot === 0 ? alignment.rightRotationPointZ : alignment.leftRotationPointZ) ?? defaultRotation.z;

      const defaultAngle = Math.atan2(defaultRotation.x - defaultCenter.x, defaultRotation.z - defaultCenter.z);
      const angle = Math.atan2(rotationX - centerX, rotationZ - centerZ);

      offsets.push({ dx: centerX - defaultCenter.x, dz: centerZ - defaultCenter.z, dAngle: angle - defaultAngle });
    }
    return offsets;
  }

  // Re-apply captured offsets on the new model's default points, then store and save the result.
  const applyPressureAlignmentOffsets = async (offsets: PressureAlignmentOffset[]) => {
    const points: number[][] = [];
    for (let foot = 0; foot < 2; foot++) {
      const spheres = getAlignmentSpheres(foot);
      if (!spheres) return;
      const defaultCenter: THREE.Vector3 = spheres.translation.userData.initialPosition;
      const defaultRotation: THREE.Vector3 = spheres.rotation.userData.initialPosition;
      const { dx, dz, dAngle } = offsets[foot];

      // Keep the new model's distance between the points, only carry over the angle change
      const length = Math.hypot(defaultRotation.x - defaultCenter.x, defaultRotation.z - defaultCenter.z);
      const angle = Math.atan2(defaultRotation.x - defaultCenter.x, defaultRotation.z - defaultCenter.z) + dAngle;
      const centerX = defaultCenter.x + dx;
      const centerZ = defaultCenter.z + dz;
      points.push([centerX, centerZ, centerX + length * Math.sin(angle), centerZ + length * Math.cos(angle)]);
    }

    const values = {
      rightCenterPointX: points[0][0], rightCenterPointZ: points[0][1], rightRotationPointX: points[0][2], rightRotationPointZ: points[0][3],
      leftCenterPointX: points[1][0], leftCenterPointZ: points[1][1], leftRotationPointX: points[1][2], leftRotationPointZ: points[1][3],
    };
    useDesignStore.getState().setPressureAlignment(new PressureAlignment({ ...useDesignStore.getState().pressureAlignment, ...values }));
    await saveDesignPressureAlignment(api, useSelectedDesignStore.getState().designId, new DesignPressureAlignmentRequestDto(values));
  }

  const loadStoredPressureAlignment = () => {
    if (pressureAlignmentSphereRef.current.length < 1) return;
    // Read the store directly; the hook value can be stale inside async load flows
    const pressureAlignmentStore = useDesignStore.getState().pressureAlignment;
    const rightTranslationMesh: THREE.Mesh = Object.assign({},
      pressureAlignmentSphereRef.current[0].filter(
        sphere => sphere.userData.jointName === 'translation')[0]
    );
    const rightRotationMesh: THREE.Mesh = Object.assign({},
      pressureAlignmentSphereRef.current[0].filter(
        sphere => sphere.userData.jointName === 'rotation')[0]
    );
    const leftTranslationMesh: THREE.Mesh = Object.assign({},
      pressureAlignmentSphereRef.current[1].filter(
        sphere => sphere.userData.jointName === 'translation')[0]
    );
    const leftRotationMesh: THREE.Mesh = Object.assign({},
      pressureAlignmentSphereRef.current[1].filter(
        sphere => sphere.userData.jointName === 'rotation')[0]
    );

    if (pressureAlignmentStore?.rightCenterPointX)
      rightTranslationMesh.position.x = pressureAlignmentStore?.rightCenterPointX;
    if (pressureAlignmentStore?.rightCenterPointZ)
      rightTranslationMesh.position.z = pressureAlignmentStore?.rightCenterPointZ;
    if (pressureAlignmentStore?.rightRotationPointX)
      rightRotationMesh.position.x = pressureAlignmentStore?.rightRotationPointX;
    if (pressureAlignmentStore?.rightRotationPointZ)
      rightRotationMesh.position.z = pressureAlignmentStore?.rightRotationPointZ;

    if (pressureAlignmentStore?.leftCenterPointX)
      leftTranslationMesh.position.x = pressureAlignmentStore?.leftCenterPointX;
    if (pressureAlignmentStore?.leftCenterPointZ)
      leftTranslationMesh.position.z = pressureAlignmentStore?.leftCenterPointZ;
    if (pressureAlignmentStore?.leftRotationPointX)
      leftRotationMesh.position.x = pressureAlignmentStore?.leftRotationPointX;
    if (pressureAlignmentStore?.leftRotationPointZ)
      leftRotationMesh.position.z = pressureAlignmentStore?.leftRotationPointZ;

    const rightTranslationFix = new THREE.Vector3(
      rightTranslationMesh.position.x - rightTranslationMesh.userData.originalPosition.x,
      rightTranslationMesh.position.y - rightTranslationMesh.userData.originalPosition.y,
      rightTranslationMesh.position.z - rightTranslationMesh.userData.originalPosition.z
    );
    rightRotationMesh.position.x = rightRotationMesh.position.x - rightTranslationFix.x;
    rightRotationMesh.position.y = rightRotationMesh.position.y - rightTranslationFix.y;
    rightRotationMesh.position.z = rightRotationMesh.position.z - rightTranslationFix.z;

    const leftTranslationFix = new THREE.Vector3(
      leftTranslationMesh.position.x - leftTranslationMesh.userData.originalPosition.x,
      leftTranslationMesh.position.y - leftTranslationMesh.userData.originalPosition.y,
      leftTranslationMesh.position.z - leftTranslationMesh.userData.originalPosition.z
    );
    leftRotationMesh.position.x = leftRotationMesh.position.x - leftTranslationFix.x;
    leftRotationMesh.position.y = leftRotationMesh.position.y - leftTranslationFix.y;
    leftRotationMesh.position.z = leftRotationMesh.position.z - leftTranslationFix.z;

    textureAlignment(rightTranslationMesh, 0);
    textureAlignment(rightRotationMesh, 0);
    textureAlignment(leftTranslationMesh, 1);
    textureAlignment(leftRotationMesh, 1);
  }

  const storePressureAlignment = (foot: number) => {
    const pressureAlignment = useDesignStore.getState().pressureAlignment;
    const translationMesh: THREE.Mesh = pressureAlignmentSphereRef.current[foot].filter(sphere => sphere.userData.jointName === 'translation')[0];
    const translationX = translationMesh.position.x;
    const translationZ = translationMesh.position.z;
    const rotationMesh: THREE.Mesh = pressureAlignmentSphereRef.current[foot].filter(sphere => sphere.userData.jointName === 'rotation')[0];
    const rotationX = rotationMesh.position.x;
    const rotationZ = rotationMesh.position.z;

    if (foot == 0)
      useDesignStore.setState({
        pressureAlignment: {
          ...pressureAlignment,
          rightCenterPointX: translationX, rightCenterPointZ: translationZ, rightRotationPointX: rotationX, rightRotationPointZ: rotationZ
        }
      });
    else
      useDesignStore.setState({
        pressureAlignment: {
          ...pressureAlignment,
          leftCenterPointX: translationX, leftCenterPointZ: translationZ, leftRotationPointX: rotationX, leftRotationPointZ: rotationZ
        }
      });
  }

  const onDragPressureAlignment = (event: THREE.Event & { object: THREE.Object3D }) => {
    if (!originalGeometryRef.current || !sceneRef.current) return;
    // Get the dragged sphere
    const sphere = event.object as THREE.Mesh;
    const jointType = sphere.userData.jointType;

    if (jointType !== JointType.PRESSURE_ALIGNMENT) return;

    const foot = sphere.userData.foot;

    textureAlignment(sphere, foot);
  }

  const onDragEndPressureAlignment = (event: THREE.Event & { object: THREE.Object3D }) => {
    if (!originalGeometryRef.current || !sceneRef.current) return;
    // Get the dragged sphere
    const sphere = event.object as THREE.Mesh;
    const foot = sphere.userData.foot;
    const jointType = sphere.userData.jointType;

    if (jointType === JointType.PRESSURE_ALIGNMENT) {
      textureAlignment(sphere, foot);
      storePressureAlignment(foot);

      if (controlsRef.current) {
        controlsRef.current.enabled = true;
      }

      if (pressureImageDataRef.current[foot]) {
        updateInsoleTexture(foot, pressureImageDataRef.current[foot], outputMeshRef.current[foot]);
        updateInsoleTexture(foot, pressureImageDataRef.current[foot], LiftedMeshRef.current[foot]);
      }
    }
  }

  const getValueFromFieldKey = (foot: number, fieldKey: string): any => {
    const params = insoleHighLevelParamRef.current[foot];
    if (!params) return null;

    let value: number | null = null;
    let min: number | null = null;
    let max: number | null = null;

    switch (fieldKey) {
      case 'Length':
        value = convertMmToViewerUnit(params.length);
        min = convertMmToViewerUnit(150);
        max = convertMmToViewerUnit(450);
        break;
      case 'Width':
        value = convertMmToViewerUnit(params.width);
        min = convertMmToViewerUnit(50);
        max = convertMmToViewerUnit(150);
        break;
      case 'Thickness':
        value = convertMmToViewerUnit(params.thickness);
        min = convertMmToViewerUnit(surfaceJoints.current!.thickness.min);
        max = convertMmToViewerUnit(surfaceJoints.current!.thickness.max);
        break;
      case 'Heel Fill':
        value = params.heelFill;
        min = 0;
        max = 100;
        break;
      case 'Arch Fill':
        value = params.archFill;
        min = 0;
        max = 100;
        break;
      case 'Bottom Smoothness':
        value = params.bottomSmoothness;
        break;
      case 'Heel Height':
        value = convertMmToViewerUnit(params.heelHeight);
        min = convertMmToViewerUnit(surfaceJoints.current!.heelHeight.min);
        max = convertMmToViewerUnit(surfaceJoints.current!.heelHeight.max);
        break;
      case 'Heel Depth':
        value = convertMmToViewerUnit(params.heelDepth);
        min = convertMmToViewerUnit(surfaceJoints.current!.heelDepth.min);
        max = convertMmToViewerUnit(surfaceJoints.current!.heelDepth.max);
        break;
      case 'Heel Lateral Wedge':
        value = params.heelLateralWedge;
        min = surfaceJoints.current!.heelLateralWedge.min;
        max = surfaceJoints.current!.heelLateralWedge.max;
        break;
      case 'Heel Medial Wedge':
        value = params.heelMedialWedge;
        min = surfaceJoints.current!.heelMedialWedge.min;
        max = surfaceJoints.current!.heelMedialWedge.max;
        break;
      case 'Arch Center Height':
        value = convertMmToViewerUnit(params.archCenterHeight);
        min = convertMmToViewerUnit(surfaceJoints.current!.archCenterHeight.min);
        max = convertMmToViewerUnit(surfaceJoints.current!.archCenterHeight.max);
        break;
      case 'Arch Lateral Height':
        value = convertMmToViewerUnit(params.archLateralHeight);
        min = convertMmToViewerUnit(surfaceJoints.current!.archLateralHeight.min);
        max = convertMmToViewerUnit(surfaceJoints.current!.archLateralHeight.max);
        break;
      case 'Arch Medial Height':
        value = convertMmToViewerUnit(params.archMedialHeight);
        min = convertMmToViewerUnit(surfaceJoints.current!.archMedialHeight.min);
        max = convertMmToViewerUnit(surfaceJoints.current!.archMedialHeight.max);
        break;
      case 'Forefoot Lateral Wedge':
        value = params.forefootLateralWedge;
        min = surfaceJoints.current!.forefootLateralWedge.min;
        max = surfaceJoints.current!.forefootLateralWedge.max;
        break;
      case 'Forefoot Medial Wedge':
        value = params.forefootMedialWedge;
        min = surfaceJoints.current!.forefootMedialWedge.min;
        max = surfaceJoints.current!.forefootMedialWedge.max;
        break;
      case 'Arch Sagital Position':
        value = params.archSagitalPosition;
        min = surfaceJoints.current!.archSagitalPosition.min;
        max = surfaceJoints.current!.archSagitalPosition.max;
        break;
      case 'Band Height': {
        // min/max on this joint are fractions of the insole length (0.2, 0.3),
        // not millimetres — which is why the property panel multiplies them by
        // the length. Reading them raw reported an allowed range of 0.2 to
        // 0.3 mm, so every real value looked out of range.
        const bandJoint = surfaceJoints.current?.bandHeight;
        if (!bandJoint) return null;
        value = convertMmToViewerUnit(params.bandHeight);
        min = bandJoint.min * convertMmToViewerUnit(params.length);
        max = bandJoint.max * convertMmToViewerUnit(params.length);
        break;
      }
      case 'Outsole Thickness': {
        // Sandal only; the joint is null in the other models.
        const outsoleJoint = surfaceJoints.current?.outsoleThickness;
        if (!outsoleJoint) return null;
        value = convertMmToViewerUnit(params.outsoleThickness);
        min = convertMmToViewerUnit(outsoleJoint.min);
        max = convertMmToViewerUnit(outsoleJoint.max);
        break;
      }
      case 'High Heel Height':
        value = convertMmToViewerUnit(params.highHeelHeight);
        min = convertMmToViewerUnit(HighHeelHeight.min);
        max = convertMmToViewerUnit(HighHeelHeight.max);
        break;
      default:
        console.warn(`Unknown fieldKey: ${fieldKey}`);
        return null;
    }

    return { value, min, max };
  };

  const textureAlignment = (sphere: THREE.Mesh, foot: number) => {
    if (pressureImageDataRef.current == null || pressureImageDataRef.current.length == 0) return;
    if (pressureImageDataRef.current[foot] == null) return;

    const pressureOffset = findTextureOffsets(foot);
    if (sphere.userData.jointName === 'translation') {

      const translate = new THREE.Vector3(
        sphere.position.x - sphere.userData.originalPosition.x,
        sphere.position.y - sphere.userData.originalPosition.y,
        sphere.position.z - sphere.userData.originalPosition.z
      );
      const anchorPos = sphere.position.clone();
      const initPos = sphere.userData.initialPosition.clone();

      if (pressureOffset) {
        textureOffsetsRef.current[foot].uOffset = ((initPos.x + pressureOffset.xPressureOffset - (anchorPos.x))) / (pressureImageDataRef.current[foot].realWidth);
        textureOffsetsRef.current[foot].vOffset = ((initPos.z + pressureOffset.zPressureOffset - (anchorPos.z))) / (pressureImageDataRef.current[foot].realHeight);
      }
      else {
        textureOffsetsRef.current[foot].uOffset = ((initPos.x - (anchorPos.x))) / (pressureImageDataRef.current[foot].realWidth);
        textureOffsetsRef.current[foot].vOffset = ((initPos.z - (anchorPos.z))) / (pressureImageDataRef.current[foot].realHeight);
      }

      generatePlanarUVs(outputMeshRef.current[foot],
        foot,
        pressureImageDataRef.current[foot].realWidth,
        pressureImageDataRef.current[foot].realHeight,
        textureOffsetsRef.current[foot].rotationAngle,
        sphere.position,
        { u: textureOffsetsRef.current[foot].uOffset, v: textureOffsetsRef.current[foot].vOffset }
      );

      pressureAlignmentSphereRef.current[foot].forEach(s => {
        if (s.userData.jointName === 'rotation') {
          s.userData.originalPosition.x = s.position.x + translate.x;
          s.userData.originalPosition.y = s.position.y;
          s.userData.originalPosition.z = s.position.z + translate.z;
          s.position.x = s.position.x + translate.x;
          s.position.y = s.position.y;
          s.position.z = s.position.z + translate.z;
        }
      });

      const linePos = pressureAlignmentLine.current[foot].position;
      pressureAlignmentLine.current[foot].position.set(linePos.x + translate.x, linePos.y, linePos.z + translate.z);

      sphere.userData.originalPosition.x = sphere.position.x;
      sphere.position.y = sphere.userData.originalPosition.y;
      sphere.userData.originalPosition.z = sphere.position.z;
    }
    else if (sphere.userData.jointName === 'rotation') {
      const centerMarker: THREE.Mesh = pressureAlignmentSphereRef.current[foot].filter(sphere => sphere.userData.jointName === 'translation')[0];
      const v0 = new THREE.Vector3().subVectors(sphere.userData.originalPosition, centerMarker.position);
      const v1 = new THREE.Vector3().subVectors(sphere.position, centerMarker.position);
      const axis = new THREE.Vector3(0, 1, 0);

      const angleRad = signedAngle2(v0, v1, axis);

      // textureOffsetsRef.current[foot].rotationAngle = signedAngle2(v1, pressureOffset.pressureVector, axis);
      if (pressureOffset) {
        let pAngle = Math.atan2(pressureOffset.pressureVector.x, pressureOffset.pressureVector.z) * -1;
        let mAngle = Math.atan2(v1.x, v1.z);
        textureOffsetsRef.current[foot].rotationAngle = mAngle - pAngle;
      }
      else {
        textureOffsetsRef.current[foot].rotationAngle = signedAngle(centerMarker.position, sphere.userData.initialPosition, sphere.position, axis);
      }
      // textureOffsetsRef.current[0].rotationAngle = signedAngle2(rmeshVector, rightPressure.pressureVector, rotationAxis);

      generatePlanarUVs(outputMeshRef.current[foot],
        foot,
        pressureImageDataRef.current[foot].realWidth,
        pressureImageDataRef.current[foot].realHeight,
        textureOffsetsRef.current[foot].rotationAngle,
        centerMarker.position,
        { u: textureOffsetsRef.current[foot].uOffset, v: textureOffsetsRef.current[foot].vOffset }
      );
      // outputMeshRef.current[foot].material.map.rotation = angleRad;
      // rotateUVs(outputMeshRef.current[foot].geometry, foot);

      pressureAlignmentSphereRef.current[foot].forEach(s => {
        if (s.userData.jointName === 'pressureLine') {
          const angle = Math.atan2(sphere.position.z - centerMarker.position.z, sphere.position.x - centerMarker.position.x);
          s.geometry.rotateY(angleRad);
        }
      });

      // createPressureLine(foot);

      sphere.userData.originalPosition.x = sphere.position.x;
      sphere.position.y = sphere.userData.originalPosition.y;
      sphere.userData.originalPosition.z = sphere.position.z;
    }
  }

  function signedAngle(center: THREE.Vector3, base: THREE.Vector3, rPoint: THREE.Vector3, axis: THREE.Vector3): number {
    const helperPoint = new THREE.Vector3(center.x + 50, center.y, center.z);

    const v0 = new THREE.Vector3().subVectors(base, center);
    const v1 = new THREE.Vector3().subVectors(rPoint, center);
    const vHelper = new THREE.Vector3().subVectors(helperPoint, center);

    const baseAngle = signedAngle2(v0, vHelper, axis);
    const rotationAngle = signedAngle2(v1, vHelper, axis);

    return baseAngle - rotationAngle;
  }

  function signedAngle2(v0: THREE.Vector3, v1: THREE.Vector3, rotationAxis: THREE.Vector3): number {
    const a = v0.clone().normalize();
    const b = v1.clone().normalize();
    const cross = new THREE.Vector3().crossVectors(a, b);
    const dot = a.dot(b);
    const det = rotationAxis.dot(cross);
    return Math.atan2(det, dot);
  }

  const setHighLevelHeelPoints = (foot: number, medialAngle: number, lateralAngle: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current === null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');
    const jointList = surfaceJointsArray.current[foot];
    const lateralJoint = jointList['heelLateralWedge'];
    const medialJoint = jointList['heelMedialWedge'];

    if (!lateralJoint || !medialJoint) return;

    const dx = Math.abs(lateralJoint.center.x - medialJoint.center.x);

    const medialNextYChange = (insoleHighLevelParamRef.current[foot].heelWedgeType != 'Lateral') ?
      (Math.tan(medialAngle * Math.PI / 180.0) * dx / 2) :
      (Math.tan(lateralAngle * Math.PI / 180.0) * dx / 2) * -1;

    const lateralNextYChange = (insoleHighLevelParamRef.current[foot].heelWedgeType != 'Medial') ?
      (Math.tan(lateralAngle * Math.PI / 180.0) * dx / 2) :
      (Math.tan(medialAngle * Math.PI / 180.0) * dx / 2) * -1;

    medialJoint.center.y = heelDepthRealY.current[foot] + medialNextYChange;
    lateralJoint.center.y = heelDepthRealY.current[foot] + lateralNextYChange;

    const displacementM = medialJoint.center.y - insoleVertices.getY(medialJoint.centerId);
    const displacementL = lateralJoint.center.y - insoleVertices.getY(lateralJoint.centerId);

    lateralJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementL * weight);
      });
    });
    medialJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementM * weight);
      });
    });
  };

  const setHighLevelForefootPoints = (foot: number, medialAngle: number, lateralAngle: number, thickness: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current === null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');
    const jointList = surfaceJointsArray.current[foot];
    const lateralJoint = jointList['forefootLateralWedge'];
    const medialJoint = jointList['forefootMedialWedge'];
    const thicknessJoint = jointList['thickness'];

    if (!lateralJoint || !medialJoint || !thicknessJoint) return;

    const dxm = Math.abs(thicknessJoint.center.x - medialJoint.center.x);
    const dxl = Math.abs(lateralJoint.center.x - thicknessJoint.center.x);

    const medialNextY = (insoleHighLevelParamRef.current[foot].forefootWedgeType != 'Lateral') ?
      thickness + (Math.tan(medialAngle * Math.PI / 180.0) * dxm) :
      thickness - (Math.tan(lateralAngle * Math.PI / 180.0) * dxm);

    const lateralNextY = (insoleHighLevelParamRef.current[foot].forefootWedgeType != 'Medial') ?
      thickness + (Math.tan(lateralAngle * Math.PI / 180.0) * dxl) :
      thickness - (Math.tan(medialAngle * Math.PI / 180.0) * dxl);

    medialJoint.center.y = (medialNextY >= 2) ? medialNextY : 2;
    lateralJoint.center.y = (lateralNextY >= 2) ? lateralNextY : 2;

    const displacementM = medialJoint.center.y - insoleVertices.getY(medialJoint.centerId);
    const displacementL = lateralJoint.center.y - insoleVertices.getY(lateralJoint.centerId);

    medialJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementM * weight);
      });
    });

    lateralJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementL * weight);
      });
    });
  }

  const checkHighLevelsValuesAfterEditing = (joint: any, foot: number) => {
    if (!joint) return;

    if (originalGeometryRef == null || originalGeometryRef.current === null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');
    switch (joint.name) {
      case 'Thickness': {
        const outsoleOffset = isSandal.current
          ? (surfaceJointsArray.current[foot]['outsoleThickness']?.center.y ?? 0) + 2.55
          : 0;
        const relativeCenterY = joint.center.y - outsoleOffset;
        const limitedY = checkRange(relativeCenterY, joint.min, joint.max, joint.bval, joint.cval);
        joint.center.y = limitedY + (isSandal.current
          ? (surfaceJointsArray.current[foot]['outsoleThickness']?.center.y ?? 0) + 2.55
          : 0);
        const displacement = limitedY - relativeCenterY;
        heelDepthRealY.current[foot] += displacement;
        joint?.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
          });
        });
        setHighLevelForefootPoints(foot, insoleHighLevelParamRef.current[foot].forefootMedialWedge, insoleHighLevelParamRef.current[foot].forefootLateralWedge, joint.center.y);
        break;
      }

      case 'Arch Medial Height': {

        let heelHeight = surfaceJointsArray.current[foot]['heelHeight'];
        let thicknessjoint = surfaceJointsArray.current[foot]['thickness'];
        let thicknessToHeelHeight = thicknessjoint.center.clone().sub(heelHeight.center);

        let archMedialHeight = surfaceJointsArray.current[foot]['archMedialHeight'];
        let archYBase = Math.abs((archMedialHeight.center.z - thicknessjoint.center.z) / thicknessToHeelHeight.z) * (heelHeight.center.y - thicknessjoint.center.y) + thicknessjoint.center.y;

        joint.center.y = checkRange(joint.center.y, joint.min + archYBase, joint.max + archYBase, joint.bval, joint.cval);
        const displacement = joint.center.y - insoleVertices.getY(joint.centerId);

        joint.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
          });
        });
        break;
      }
      case 'Arch Center Height': {
        let heelHeight = surfaceJointsArray.current[foot]['heelHeight'];
        let thicknessjoint = surfaceJointsArray.current[foot]['thickness'];
        let thicknessToHeelHeight = thicknessjoint.center.clone().sub(heelHeight.center);

        let archMedialHeight = surfaceJointsArray.current[foot]['archMedialHeight'];
        let archYBase = Math.abs((archMedialHeight.center.z - thicknessjoint.center.z) / thicknessToHeelHeight.z) * (heelHeight.center.y - thicknessjoint.center.y) + thicknessjoint.center.y;

        joint.center.y = checkRange(joint.center.y, joint.min + archYBase, joint.max + archYBase, joint.bval, joint.cval);
        const displacement = joint.center.y - insoleVertices.getY(joint.centerId);

        joint.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
          });
        });
        break;
      }
      case 'Arch Lateral Height': {
        let heelHeight = surfaceJointsArray.current[foot]['heelHeight'];
        let thicknessjoint = surfaceJointsArray.current[foot]['thickness'];
        let thicknessToHeelHeight = thicknessjoint.center.clone().sub(heelHeight.center);

        let archMedialHeight = surfaceJointsArray.current[foot]['archMedialHeight'];
        let archYBase = Math.abs((archMedialHeight.center.z - thicknessjoint.center.z) / thicknessToHeelHeight.z) * (heelHeight.center.y - thicknessjoint.center.y) + thicknessjoint.center.y;

        joint.center.y = checkRange(joint.center.y, joint.min + archYBase, joint.max + archYBase, joint.bval, joint.cval);
        const displacement = joint.center.y - insoleVertices.getY(joint.centerId);

        joint.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
          });
        });
        break;
      }
      case 'Heel Height': {
        joint.center.y = checkRange(joint.center.y, joint.min + insoleHighLevelParamRef.current[foot].thickness, joint.max + insoleHighLevelParamRef.current[foot].thickness, joint.bval, joint.cval);
        const displacement = joint.center.y - insoleVertices.getY(joint.centerId);
        heelDepthRealY.current[foot] += displacement;
        joint.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
          });
        });
        break;
      }
      case 'Heel Depth': {
        const constVal = insoleHighLevelParamRef.current[foot].thickness + insoleHighLevelParamRef.current[foot].heelHeight;
        const invalidVal = joint.center.y;
        joint.center.y = checkRange(joint.center.y, joint.min + constVal, joint.max + constVal, joint.bval, joint.cval);
        // insoleHighLevelParamRef.current[foot].heelDepth = checkRange(insoleHighLevelParamRef.current[foot].heelDepth, joint.min, joint.max);
        const displacement = joint.center.y - invalidVal;

        joint.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
          });
        });
        break;
      }
      case 'Heel Lateral Wedge': {
        const heelMedialJoint = surfaceJointsArray.current[foot]['heelMedialWedge'];
        const dx = Math.abs(heelMedialJoint.center.x - joint.center.x) / 2;

        if (insoleHighLevelParamRef.current[foot].heelWedgeType != 'Medial') {
          let angle = Math.round(Math.atan((joint.center.y - heelDepthRealY.current[foot]) / dx) * 180.0 / Math.PI);
          let checkAngle = checkRange(angle, joint.min, joint.max);
          const diffAngle = checkAngle - angle;
          if (diffAngle != 0) {
            // const displacement = Math.tan(diffAngle * Math.PI / 180.0) * dx;
            // joint.vertices.forEach((vertexGroup: any) => {
            //   vertexGroup.ids.forEach((vertexId: number) => {
            //     const weight = vertexGroup.weight;
            //     insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
            //   });
            // });
            // if (insoleHighLevelParamRef.current[foot].heelWedgeType == 'Lateral') {
            //   heelMedialJoint.vertices.forEach((vertexGroup: any) => {
            //     vertexGroup.ids.forEach((vertexId: number) => {
            //       const weight = vertexGroup.weight * -1;
            //       insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
            //     });
            //   });
            // }
            if (insoleHighLevelParamRef.current[foot].heelWedgeType == 'Lateral') {
              setHighLevelHeelPoints(foot, 0, checkAngle);
            }
            else {
              setHighLevelHeelPoints(foot, insoleHighLevelParamRef.current[foot].heelMedialWedge, checkAngle);
            }
          }
        }
        break;
      }
      case 'Heel Medial Wedge': {
        const heelLateralJoint = surfaceJointsArray.current[foot]['heelLateralWedge'];
        const dx = Math.abs(heelLateralJoint.center.x - joint.center.x) / 2;

        if (insoleHighLevelParamRef.current[foot].heelWedgeType != 'Lateral') {
          let angle = Math.round(Math.atan((joint.center.y - heelDepthRealY.current[foot]) / dx) * 180.0 / Math.PI);
          let checkAngle = checkRange(angle, joint.min, joint.max);
          const diffAngle = checkAngle - angle;
          if (diffAngle != 0) {
            // const displacement = Math.tan(diffAngle * Math.PI / 180.0) * dx;
            // joint.vertices.forEach((vertexGroup: any) => {
            //   vertexGroup.ids.forEach((vertexId: number) => {
            //     const weight = vertexGroup.weight;
            //     insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
            //   });
            // });
            // if (insoleHighLevelParamRef.current[foot].heelWedgeType == 'Medial') {
            //   heelLateralJoint.vertices.forEach((vertexGroup: any) => {
            //     vertexGroup.ids.forEach((vertexId: number) => {
            //       const weight = vertexGroup.weight * -1;
            //       insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
            //     });
            //   });
            // }
            if (insoleHighLevelParamRef.current[foot].heelWedgeType == 'Medial') {
              setHighLevelHeelPoints(foot, checkAngle, 0);
            }
            else {
              setHighLevelHeelPoints(foot, checkAngle, insoleHighLevelParamRef.current[foot].heelLateralWedge);
            }
          }
        }
        break;
      }
      case 'Forefoot Lateral Wedge': {
        const thicknessJoint = surfaceJointsArray.current[foot]['thickness'];
        const dx = Math.abs(thicknessJoint.center.x - joint.center.x);

        if (insoleHighLevelParamRef.current[foot].forefootWedgeType != 'Medial') {
          let angle = Math.round(Math.atan((joint.center.y - insoleHighLevelParamRef.current[foot].thickness) / dx) * 180.0 / Math.PI);
          let checkAngle = checkRange(angle, joint.min, joint.max);
          const diffAngle = checkAngle - angle;
          if (insoleHighLevelParamRef.current[foot].forefootWedgeType == 'Lateral') {
            setHighLevelForefootPoints(foot, 0, checkAngle, insoleHighLevelParamRef.current[foot].thickness);
          }
          else {
            setHighLevelForefootPoints(foot, insoleHighLevelParamRef.current[foot].forefootMedialWedge, checkAngle, insoleHighLevelParamRef.current[foot].thickness);
          }

        }
        break;
      }
      case 'Forefoot Medial Wedge': {
        const thicknessJoint = surfaceJointsArray.current[foot]['thickness'];
        const dx = Math.abs(thicknessJoint.center.x - joint.center.x);

        if (insoleHighLevelParamRef.current[foot].forefootWedgeType != 'Lateral') {
          let angle = Math.round(Math.atan((joint.center.y - insoleHighLevelParamRef.current[foot].thickness) / dx) * 180.0 / Math.PI);
          let checkAngle = checkRange(angle, joint.min, joint.max);
          const diffAngle = checkAngle - angle;
          if (insoleHighLevelParamRef.current[foot].forefootWedgeType == 'Medial') {
            setHighLevelForefootPoints(foot, checkAngle, 0, insoleHighLevelParamRef.current[foot].thickness);
          }
          else {
            setHighLevelForefootPoints(foot, checkAngle, insoleHighLevelParamRef.current[foot].forefootLateralWedge, insoleHighLevelParamRef.current[foot].thickness);
          }

        }
        break;
      }
      case 'Arch Sagital Position': {
        const insoleBox = GetInsoleBox(outputMeshRef.current[foot]);
        const boxSize = insoleBox?.getSize(new THREE.Vector3());
        if (!insoleBox) return;

        let zRatio = (insoleVertices.getZ(joint.centerId) - insoleBox.min.z) * 100 / boxSize.z;
        const minRatioPercent = meshconfig.current!.joints.surface.archSagitalPosition.min;
        const maxRatioPercent = meshconfig.current!.joints.surface.archSagitalPosition.max;
        let correctionZ = 0
        if (zRatio < minRatioPercent) {
          correctionZ = (minRatioPercent / 100) * boxSize.z + insoleBox.min.z;
        }
        else if (zRatio > maxRatioPercent) {
          correctionZ = (maxRatioPercent / 100) * boxSize.z + insoleBox.min.z;
        }
        if (correctionZ !== 0) {
          correctArchEditor(Math.round(correctionZ), foot, insoleVertices, joint);
        }
        break;
      }
      case 'Band Height': {
        const jointArchCenter = surfaceJointsArray.current[foot]['archCenterHeight'];
        const footLen = insoleHighLevelParamRef.current[foot].length;
        joint.center.y = checkRange(joint.center.y, joint.min * footLen + jointArchCenter.center.y,
          joint.max * footLen + jointArchCenter.center.y, joint.bval, joint.cval);
        const displacement = joint.center.y - insoleVertices.getY(joint.centerId);
        joint?.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            const weight = vertexGroup.weight;
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
          });
        });
        break;
      }
      case 'Outsole Thickness': {
        const invalidY = joint.center.y;
        joint.center.y = checkRange(joint.center.y, joint.min, joint.max, joint.bval, joint.cval);
        const displacement = joint.center.y - invalidY;
        joint.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * vertexGroup.weight);
          });
        });

        const thickness = surfaceJointsArray.current[foot]['thickness'];
        const thicknessValue = insoleHighLevelParamRef.current[foot].thickness;
        const thicknessTargetY = joint.center.y + 2.55 +
          (thicknessValue - thickness.cval) / thickness.bval;
        const thicknessCorrection = thicknessTargetY - insoleVertices.getY(thickness.centerId);
        thickness.vertices.forEach((vertexGroup: any) => {
          vertexGroup.ids.forEach((vertexId: number) => {
            insoleVertices.setY(vertexId,
              insoleVertices.getY(vertexId) + thicknessCorrection * vertexGroup.weight);
          });
        });
        thickness.center.y = thicknessTargetY;

        const heelHeight = surfaceJointsArray.current[foot]['heelHeight'];
        const heelDepth = surfaceJointsArray.current[foot]['heelDepth'];
        const heelDepthValue = insoleHighLevelParamRef.current[foot].heelDepth;
        heelDepthRealY.current[foot] = insoleVertices.getY(heelHeight.centerId) +
          (heelDepthValue - heelDepth.cval) / heelDepth.bval;
        break;
      }
    }
  }

  const correctArchEditor = (correctionZ: number, foot: number, insoleVertices: any, joint: any) => {
    let displacement = correctionZ - insoleVertices.getZ(joint.centerId);
    const zBase = insoleVertices.getZ(meshconfig.current!.archStartIndex);
    const zHeel = insoleVertices.getZ(meshconfig.current!.heelCenterIndex);
    const zFront = insoleVertices.getZ(meshconfig.current!.forefootIndex);
    const zEditor = insoleVertices.getZ(meshconfig.current!.archEditorIndex);

    const ArchLength = Math.abs(zBase - zHeel);
    const ArchLength2 = Math.abs(zEditor - zHeel);
    const ForeFootLength = Math.abs(zBase - zFront);

    const xConst = (foot === 0) ? -archEditorConst.current : archEditorConst.current;
    archLinePointsRef.current[foot][0] = new THREE.Vector3(insoleVertices.getX(joint.centerId) + xConst, 0, correctionZ);

    joint!.center.z += displacement;
    joint.vertices.forEach((vertexGroup: any) => {
      const baseLength = (vertexGroup.weight === 1) ? ArchLength : ForeFootLength;
      const anotherPoint = (vertexGroup.weight === 1) ? zHeel : zFront;

      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = Math.abs(insoleVertices.getZ(vertexId) - anotherPoint) / baseLength;
        const newZ = insoleVertices.getZ(vertexId) + displacement * (ArchLength / ArchLength2) * weight;
        insoleVertices.setZ(vertexId, newZ);

        if (meshconfig.current!.archLineIndices.includes(vertexId)) {
          let index = meshconfig.current!.archLineIndices.indexOf(vertexId);
          let x1 = insoleVertices.getX(vertexId);
          let z1 = insoleVertices.getZ(vertexId);
          archLinePointsRef.current[foot][index + 1] = new THREE.Vector3(x1, 0, z1);
        }
      });
    });

    if (!useDesignStore.getState().categoryChanged)
      useDesignStore.getState().insoleDesign?.insoles[foot].additions.forEach(ad => {
        if (ad.relativeIndexMesh != null) {
          ad.TranslateAdditionFromLowpolyToMainMesh(originalGeometryRef.current![foot], outputMeshRef.current[foot]);
          ad.isUpdated = true;
        }
      });
  }

  const checkRange = (value: number, minVal: number, maxVal: number, bVal: number = 1, cVal: number = 0) => {
    const realVal = value * bVal + cVal;
    if (realVal > maxVal) return (maxVal - cVal) / bVal;
    else if (realVal < minVal) return (minVal - cVal) / bVal;
    else return value;
  }

  // Function to handle mouse click 
  const handleMouseClick = (event: MouseEvent) => {
    // Prevent the context menu from appearing
    event.preventDefault();

    if (!rendererRef.current || !cameraRef.current || !sceneRef.current) {
      console.log('Missing required refs for right click');
      return;
    }

    // Calculate mouse position in normalized device coordinates (-1 to +1)
    const rect = rendererRef.current.domElement.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    // handle left mouse button clicks (button 0)
    if (event.button == 0) {
      setLeftClickedPosition(new THREE.Vector2(x, y));
    }
    // handle right mouse button clicks (button 2)
    else if (event.button == 2) {
      setRightClickedPosition(new THREE.Vector2(x, y));
    }
    return;
  };

  // Function to highlight the selected face
  const highlightSelectedFace = (faceIndex: number, vertexIds: number[], mesh: THREE.Mesh) => {
    if (!sceneRef.current) return;

    // Get the geometry of the selected mesh
    const geometry = mesh.geometry;
    const positionAttribute = geometry.getAttribute('position');

    // Create a new geometry for just this face
    const faceGeometry = new THREE.BufferGeometry();

    // Get the positions of the three vertices
    const positions = new Float32Array(9);
    for (let i = 0; i < 3; i++) {
      const vertexId = vertexIds[i];
      positions[i * 3] = positionAttribute.getX(vertexId);
      positions[i * 3 + 1] = positionAttribute.getY(vertexId);
      positions[i * 3 + 2] = positionAttribute.getZ(vertexId);
    }

    // Set the positions for the face geometry
    faceGeometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));

    // Create indices for the face (0, 1, 2)
    const faceIndices = new Uint32Array([0, 1, 2]);
    faceGeometry.setIndex(new THREE.BufferAttribute(faceIndices, 1));

    // Compute vertex normals for proper lighting
    faceGeometry.computeVertexNormals();

    // Create a material for the highlighted face
    const faceMaterial = new THREE.MeshPhongMaterial({
      color: 0x00ff00, // Green color
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.9 // Increase opacity from 0.8 to 0.9 for better visibility
    });

    // Create a mesh for the highlighted face
    const highlightedFace = new THREE.Mesh(faceGeometry, faceMaterial);

    // Position the highlighted face at the same position as the selected mesh
    highlightedFace.position.copy(mesh.position);
    highlightedFace.rotation.copy(mesh.rotation);
    highlightedFace.scale.copy(mesh.scale);

    // Add the highlighted face to the scene
    sceneRef.current.add(highlightedFace);

    // Store the reference to the highlighted face
    if (!highlightedFaceRef.current) {
      highlightedFaceRef.current = [];
    }
    highlightedFaceRef.current.push(highlightedFace);

    // Force a render to update the scene
    if (rendererRef.current && cameraRef.current) {
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    }
  };

  // Function to remove all highlighted faces
  const removeAllHighlightedFaces = () => {
    if (sceneRef.current && highlightedFaceRef.current) {
      // If highlightedFaceRef is an array, remove all faces
      if (Array.isArray(highlightedFaceRef.current)) {
        highlightedFaceRef.current.forEach(face => {
          if (face) {
            sceneRef.current!.remove(face);

            // Dispose of the geometry and material
            if (face.geometry) {
              face.geometry.dispose();
            }

            if (face.material instanceof THREE.Material) {
              face.material.dispose();
            }
          }
        });

        // Clear the array
        highlightedFaceRef.current = [];
      } else {
        // Handle the case where it's a single face (for backward compatibility)
        const face = highlightedFaceRef.current as unknown as THREE.Mesh;
        sceneRef.current.remove(face);

        // Dispose of the geometry and material
        if (face.geometry) {
          face.geometry.dispose();
        }

        if (face.material instanceof THREE.Material) {
          face.material.dispose();
        }

        highlightedFaceRef.current = [];
      }

      // Force a render to update the scene
      if (rendererRef.current && cameraRef.current) {
        rendererRef.current.render(sceneRef.current, cameraRef.current);
      }
    }
  };

  const addPressureAlignmentElements = (geometry: THREE.BufferGeometry, scene: THREE.Scene | null, foot: number) => {
    if (!scene) return;

    const insoleVertices = geometry.attributes.position.array;

    const pressureAlignmentGroup = new THREE.Group();
    scene.add(pressureAlignmentGroup);

    const surfaceMaterial = new THREE.MeshBasicMaterial({
      color: 0x00aaff, // Light blue color for profile joints
      transparent: true,
      opacity: 0.5,
      depthTest: false
    });
    const highLevelSphereGeometry = new THREE.SphereGeometry(5, 16, 16);
    pressureAlignmentSphereRef.current[foot] = [];

    for (let i = 0; i < meshconfig.current!.pressureAlignmentDefault.length; i++) {
      const index = meshconfig.current!.pressureAlignmentDefault[i];
      const x = insoleVertices[index * 3];
      const y = 0;
      const z = insoleVertices[index * 3 + 2];

      const sphere = new THREE.Mesh(highLevelSphereGeometry, surfaceMaterial.clone());
      sphere.position.set(x, y, z);
      sphere.userData.jointIndex = index;
      sphere.userData.jointType = JointType.PRESSURE_ALIGNMENT;
      sphere.userData.jointName = (i === 0) ? 'translation' : 'rotation';
      sphere.userData.originalPosition = new THREE.Vector3(x, y, z);
      sphere.userData.initialPosition = new THREE.Vector3(x, y, z);
      sphere.userData.foot = foot;
      sphere.renderOrder = 1;

      if (!alignPressureToggle)
        sphere.visible = false;

      pressureAlignmentGroup.add(sphere);
      pressureAlignmentSphereRef.current[foot].push(sphere);
    }

    createPressureLine(foot);
  }

  const makeSphereEasierToTouch = (mesh: THREE.Mesh, multiplier = 2.5) => {
    const tmpSphere = new THREE.Sphere();
    const tmpCenter = new THREE.Vector3();
    const tmpHitPoint = new THREE.Vector3();

    mesh.geometry.computeBoundingSphere();

    mesh.raycast = function (raycaster, intersects) {
      const boundingSphere = mesh.geometry.boundingSphere;
      if (!boundingSphere) return;

      this.updateWorldMatrix(true, false);

      tmpCenter.copy(boundingSphere.center).applyMatrix4(this.matrixWorld);

      const worldScale = new THREE.Vector3();
      this.getWorldScale(worldScale);

      const maxScale = Math.max(worldScale.x, worldScale.y, worldScale.z);
      const radius = boundingSphere.radius * maxScale * multiplier;

      tmpSphere.center.copy(tmpCenter);
      tmpSphere.radius = radius;

      const hitPoint = raycaster.ray.intersectSphere(tmpSphere, tmpHitPoint);
      if (!hitPoint) return;

      const distance = raycaster.ray.origin.distanceTo(hitPoint);

      if (distance < raycaster.near || distance > raycaster.far) return;

      intersects.push({
        distance,
        point: hitPoint.clone(),
        object: this,
      });
    };
  };

  // Function to add joint spheres
  const addJointSpheres = (geometry: THREE.BufferGeometry, scene: THREE.Scene | null, foot: number) => {
    if (!scene) return;

    // Get vertex positions
    const insoleVertices = geometry.attributes.position.array;

    // Create a group to hold all joint spheres
    const jointSpheresGroup = new THREE.Group();
    scene.add(jointSpheresGroup);

    // Create materials for the profile spheres
    const profileMaterial = new THREE.MeshBasicMaterial({
      color: 0xff0000, // Red color
      transparent: true,
      opacity: thirdQuarter.current && !isSandal.current ? 0.5 : 1
    });

    // Create materials for the high level joints spheres
    const surfaceMaterial = new THREE.MeshBasicMaterial({
      color: 0x00aaff, // Light blue color for profile joints
      transparent: true,
      opacity: 0.9,
      depthTest: false
    });

    const archEditorMaterial = new THREE.MeshBasicMaterial({
      color: getColorFromCSSVariable('--accent-color-negative'),
      transparent: true,
      opacity: 0.9,
      depthTest: false
    });

    // Create sphere geometries
    let radius = isMobile() || isTablet() ? 1.5 : 1;
    const profileSphereGeometry = new THREE.SphereGeometry(radius, 16, 16);
    const highLevelSphereGeometry = new THREE.SphereGeometry(2.5, 16, 16);
    const archEditorSphereGeometry = new THREE.SphereGeometry(2.5, 16, 16);

    // Add spheres for profile joints
    profileJointSpheresRef.current[foot] = [];
    profileJointsArray.current[foot].forEach((joint, index) => {
      const centerVertexId = joint.centerId;
      const x = insoleVertices[centerVertexId * 3];
      const y = insoleVertices[centerVertexId * 3 + 1];
      const z = insoleVertices[centerVertexId * 3 + 2];

      joint.center.set(x, y, z);

      // Create a sphere for the profile joint center
      const sphere = new THREE.Mesh(profileSphereGeometry, profileMaterial.clone());
      sphere.position.set(x, 0, z);
      sphere.userData.jointIndex = index;
      sphere.userData.jointType = 'profile';
      sphere.userData.originalPosition = new THREE.Vector3(x, 0, z);
      sphere.userData.foot = foot;
      sphere.renderOrder = 1; // Ensure sphere renders after the main mesh
      makeSphereEasierToTouch(sphere, 3);


      sphere.visible = rightToolboxMode == ViewerTabsMode.Edit && isFootShownInView(foot);

      // Add the sphere to the group
      if (!isSandal.current) {
        jointSpheresGroup.add(sphere);
        profileJointSpheresRef.current[foot].push(sphere);
      }
    });

    createSpline(foot);

    surfaceJointSpheresRef.current[foot] = [];
    archLinePointsRef.current[foot] = [];

    // Add spheres for surface joints
    Object.values(surfaceJointsArray.current[foot]).forEach((joint, index) => {
      if (!joint) return;

      const centerVertexId = joint.centerId;
      let x = insoleVertices[centerVertexId * 3];
      let y = insoleVertices[centerVertexId * 3 + 1];
      const z = insoleVertices[centerVertexId * 3 + 2];

      let highLevelGeo = highLevelSphereGeometry;
      let highMaterial = surfaceMaterial.clone();

      if (joint.name === 'Heel Depth') {
        y = heelDepthRealY.current[foot];
      } else if (joint.name === 'Arch Sagital Position') {
        y = 0;
        const xConst = (foot === 0) ? -archEditorConst.current : archEditorConst.current;
        x += xConst;
        highLevelGeo = archEditorSphereGeometry;
        highMaterial = archEditorMaterial.clone();
        archLinePointsRef.current[foot].push(new THREE.Vector3(x, 0, z));
      }

      joint.center.set(x, y, z);

      // Create a sphere for the surface joint center
      const sphere = new THREE.Mesh(highLevelGeo, highMaterial);
      sphere.position.set(x, y, z);
      sphere.userData.jointIndex = index;
      sphere.userData.jointType = 'surface';
      sphere.userData.jointName = joint.name;
      sphere.userData.originalPosition = new THREE.Vector3(x, y, z);
      sphere.userData.foot = foot;
      sphere.renderOrder = 1; // Ensure sphere renders after the main mesh
      makeSphereEasierToTouch(sphere, 2);

      sphere.visible = rightToolboxMode == ViewerTabsMode.Edit && isFootShownInView(foot);

      // Add the sphere to the group
      jointSpheresGroup.add(sphere);
      surfaceJointSpheresRef.current[foot].push(sphere);
    });

    for (let i = 0; i < meshconfig.current!.archLineIndices.length; i++) {
      let x = insoleVertices[meshconfig.current!.archLineIndices[i] * 3];
      // let y = insoleVertices[meshconfig.current!.archLineIndices[i] * 3 + 1];
      let z = insoleVertices[meshconfig.current!.archLineIndices[i] * 3 + 2];
      archLinePointsRef.current[foot].push(new THREE.Vector3(x, 0, z));
    }
    createArchEditorLine(foot);

    if (insoleHighLevelParamRef.current && insoleHighLevelParamRef.current[foot])
      insoleHighLevelParamRef.current[foot] = new InsoleHighLevelParams;
    else
      insoleHighLevelParamRef.current.push(new InsoleHighLevelParams);

    return jointSpheresGroup;
  };

  // Function to add the spline to the scene
  function createSpline(foot: number) {
    if (useViewerStore.getState().mode != ViewerTabsMode.Edit || !profileJointSpheresRef.current[foot]) {
      if (profileCurveRef.current[foot]) {
        profileCurveRef.current[foot].visible = false;
      }
      return;
    }

    if (isSandal.current) return;

    // Convert the array of arrays to an array of THREE.Vector3 objects
    const threeVectorPoints = profileJointSpheresRef.current[foot].map(p => p.position);

    let curvePoints: THREE.Vector3[] = [...threeVectorPoints, threeVectorPoints[0]];
    curvePoints = lineSubdivide(curvePoints);
    // profileJointSpheresRef.current[foot].forEach((sphere, i) => {
    //   // let a = sphere.clone();
    //   let cl=mapPointToLine(curvePoints, sphere.position);
    //   if (cl) sphere.position.copy(cl);
    //   // sceneRef.current?.add(a);
    // });

    // Create BufferGeometry from the points
    const geometry = new THREE.BufferGeometry().setFromPoints(curvePoints);

    // Create a LineBasicMaterial
    const material = new THREE.LineBasicMaterial({ color: 0x07d2da }); // light blue color, thicker line

    // Create the Line object
    const splineObject = new THREE.Line(geometry, material);

    if (profileCurveRef.current[foot] !== undefined) {
      profileCurveRef.current[foot].geometry = splineObject.geometry;
      profileCurveRef.current[foot].visible = isFootShownInView(foot);

      if (!sceneRef.current?.getObjectById(profileCurveRef.current[foot].id)) {
        sceneRef.current?.add(profileCurveRef.current[foot]);
      }
    } else {
      splineObject.visible = isFootShownInView(foot);
      profileCurveRef.current.push(splineObject);
      sceneRef.current?.add(splineObject);
    }
  }

  function createPressureLine(foot: number) {
    let alignFlag = useViewerStore.getState().alignPressure;
    if (!pressureAlignmentSphereRef.current[foot]) {
      if (pressureAlignmentLine.current[foot]) {
        pressureAlignmentLine.current[foot].visible = false;
      }
      return;
    }

    // Convert the array of arrays to an array of THREE.Vector3 objects
    const threeVectorPoints = pressureAlignmentSphereRef.current[foot].map(p => p.position);

    // Create a CatmullRomCurve3
    // The second argument (true/false) indicates if the curve should be closed
    const line = new THREE.CatmullRomCurve3(threeVectorPoints, false);

    // Get points along the curve for rendering the line
    // The argument (e.g., 50) determines the number of segments
    const linePoints = line.getPoints(2); // More points for a smoother line

    // Create BufferGeometry from the points
    const geometry = new THREE.BufferGeometry().setFromPoints(linePoints);

    // Create a LineBasicMaterial
    const material = new THREE.LineBasicMaterial({
      color: 0x07d2da,
      linewidth: 5,
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: 1.0
    }); // light blue color, thicker line

    // Create the Line object
    const pressureLine = new THREE.Line(geometry, material);
    pressureLine.position.set(0, 0, 0);

    if (pressureAlignmentLine.current[foot] !== undefined) {
      pressureAlignmentLine.current[foot].geometry = pressureLine.geometry;
      pressureAlignmentLine.current[foot].position.set(0, 0, 0);
      pressureAlignmentLine.current[foot].visible = alignFlag;

      if (!sceneRef.current?.getObjectById(pressureAlignmentLine.current[foot].id)) {
        sceneRef.current?.add(pressureAlignmentLine.current[foot]);
      }
    } else {
      pressureAlignmentLine.current.push(pressureLine);
      sceneRef.current?.add(pressureLine);
    }
  }

  /** Show arch/instep guides in Edit, or in View when labels are on. */
  function setArchInstepLineVisibility(foot?: number, insoleVisible = true) {
    const { mode, liveMode } = useViewerStore.getState();
    const allowed = (mode === ViewerTabsMode.Edit || liveMode) && !alignPressureToggle && insoleVisible;
    const feet = foot === undefined ? [0, 1] : [foot];

    feet.forEach((f) => {
      const visible = allowed && isFootShownInView(f);
      if (archEditLine.current[f]) archEditLine.current[f].visible = visible;
      if (instepLine.current[f]) instepLine.current[f].visible = visible;
    });
  }

  function createArchEditorLine(foot: number) {
    // Convert the array of arrays to an array of THREE.Vector3 objects

    // Create a CatmullRomCurve3
    // The second argument (true/false) indicates if the curve should be closed
    if (!archLinePointsRef.current[foot]) return;
    const line = new THREE.CatmullRomCurve3(archLinePointsRef.current[foot], false);

    // Get points along the curve for rendering the line
    // The argument (e.g., 50) determines the number of segments
    const linePoints = line.getPoints(60); // More points for a smoother line

    // Create BufferGeometry from the points
    const geometry = new THREE.BufferGeometry().setFromPoints(linePoints);
    geometry.computeBoundingSphere();
    geometry.computeBoundingBox();

    const material = new THREE.LineBasicMaterial({
      color: getColorFromCSSVariable('--accent-color-negative'),
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: 1.0
    }); // light blue color, thicker line

    // Create the Line object
    const archLine = new THREE.Line(geometry, material);
    archLine.renderOrder = 999;
    archLine.position.set(0, 0, 0);

    if (archEditLine.current[foot] !== undefined) {
      archEditLine.current[foot].geometry = archLine.geometry;
      archEditLine.current[foot].position.set(0, 0, 0);
      archEditLine.current[foot].renderOrder = 999;

      if (!sceneRef.current?.getObjectById(archEditLine.current[foot].id)) {
        sceneRef.current?.add(archEditLine.current[foot]);
      }
    } else {
      archEditLine.current.push(archLine);
      sceneRef.current?.add(archLine);
    }
    setArchInstepLineVisibility(foot);
  }

  function createInStepLine(foot: number, vertives: THREE.TypedArray | undefined, onlyValues: boolean = false): number | void {
    const localDesign = useDesignStore.getState().insoleDesign;
    if (!localDesign) return;
    const insoleVertices = vertives ?? localDesign?.insoles[foot].lowpolyBufferGeometry?.attributes.position.array;
    if (!insoleVertices) return;

    const archEditorMaterial = new THREE.MeshBasicMaterial({
      color: getColorFromCSSVariable('--accent-color-negative'),
      transparent: true,
      opacity: 0.9,
      depthTest: false
    });
    const inStepCurvePoints = meshconfig.current!.inStepAreaIndices
      .map((index) => {
        const x = insoleVertices[index * 3];
        const y = insoleVertices[index * 3 + 1];
        const z = insoleVertices[index * 3 + 2];
        return new THREE.Vector3(x, y, z);
      })
      .filter((point) => Number.isFinite(point.x) && Number.isFinite(point.z) && Number.isFinite(point.y));

    if (inStepCurvePoints.length <= 2) return;
    const curve = new THREE.CatmullRomCurve3(inStepCurvePoints, true);
    const curvePoints = curve.getPoints(30);
    const curveLength = curve.getLength();
    if (onlyValues) return curveLength;
    const curveGeometry = new THREE.BufferGeometry().setFromPoints(curvePoints);
    const inStepCurveLine = new THREE.Line(curveGeometry, archEditorMaterial);
    inStepCurveLine.renderOrder = 998;

    if (instepLine.current[foot]) {
      instepLine.current[foot].geometry = inStepCurveLine.geometry;
      instepLine.current[foot].position.set(0, 0, 0);

      if (!sceneRef.current?.getObjectById(instepLine.current[foot].id)) {
        sceneRef.current?.add(instepLine.current[foot]);
      }
    } else {
      instepLine.current[foot] = inStepCurveLine;
      sceneRef.current?.add(inStepCurveLine);
    }
    setArchInstepLineVisibility(foot);

    // Update band height value
    var bandHeightjoint = surfaceJointsArray.current[foot].bandHeight;
    var archCenterHeight = surfaceJointsArray.current[foot].archCenterHeight;
    var bandHeightValue = Math.round(
      (bandHeightjoint!.center.y - archCenterHeight.center.y) * bandHeightjoint!.bval + bandHeightjoint!.cval);
    insoleHighLevelParamRef.current[foot].bandHeight = bandHeightValue;

    return curveLength;
  }

  /* function addArrowToGroup(group: THREE.Group, start: THREE.Vector3, end: THREE.Vector3, color: string) {
    const material = new THREE.MeshBasicMaterial({ 
      color, 
      depthTest: false, 
    });

    const curve = new THREE.LineCurve3(start, end);
    const tubeGeo = new THREE.TubeGeometry(curve, 1, 0.4, 8, false);
    const tube = new THREE.Mesh(tubeGeo, material);
    group.add(tube);

    const direction = new THREE.Vector3().subVectors(end, start).normalize();
    const coneGeo = new THREE.ConeGeometry(1.2, 3, 8); 
    const cone = new THREE.Mesh(coneGeo, material);
    
    cone.position.copy(end);
    cone.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), direction);
    group.add(cone);
  } */

  function drawBoundingBoxDimensions(foot: number) {
    const mesh = outputMeshRef.current[foot];
    if (!mesh) return;

    if (boundingBoxGroupsRef.current[foot]) {
      sceneRef.current?.remove(boundingBoxGroupsRef.current[foot]);
      boundingBoxGroupsRef.current[foot] = null;
    }

    if (dimensionSpheresRef.current[foot]) {
      sceneRef.current?.remove(dimensionSpheresRef.current[foot]);
      delete dimensionSpheresRef.current[foot];
    }

    const bbox = new THREE.Box3().setFromObject(mesh);
    const y = 0;
    const min = bbox.min;
    const max = bbox.max;

    const p1 = new THREE.Vector3(min.x, y, min.z);
    const p2 = new THREE.Vector3(max.x, y, min.z);
    const p3 = new THREE.Vector3(max.x, y, max.z);
    const p4 = new THREE.Vector3(min.x, y, max.z);

    const segments = [
      [p1, p2], [p2, p3], [p3, p4], [p4, p1]
    ];

    const group = new THREE.Group();
    group.renderOrder = 999;
    group.userData = { foot, type: 'boundingBox' };

    const material = new THREE.MeshBasicMaterial({
      color: getColorFromCSSVariable('--hightlight-surface-markers'),
      depthTest: true,
      transparent: false
    });

    segments.forEach(([a, b]) => {
      if (a.distanceTo(b) > 0.001) {
        const curve = new THREE.LineCurve3(a, b);
        const geometry = new THREE.TubeGeometry(curve, 5, 0.15, 8, false);
        const tube = new THREE.Mesh(geometry, material);
        group.add(tube);
      }
    });

    const sphereGeo = new THREE.SphereGeometry(0.5, 16, 16);
    const sphere = new THREE.Mesh(sphereGeo, material);
    if (foot == 0) sphere.position.copy(p4);
    else sphere.position.copy(p3);

    dimensionSpheresRef.current[foot] = sphere;
    sceneRef.current?.add(group);

    if (!boundingBoxGroupsRef.current[foot]) {
      boundingBoxGroupsRef.current[foot] = null;
    }
    boundingBoxGroupsRef.current[foot] = group;
  }

  const initWedgeTypes = (foot: number) => {
    let thicknessjoint = surfaceJointsArray.current[foot]['thickness'];
    thicknessjoint.value = Math.round(thicknessjoint.center.y * 10) / 10; // round to 1 decimal place

    let heelDepth = surfaceJointsArray.current[foot]['heelDepth'];
    let heelHeight = surfaceJointsArray.current[foot]['heelHeight'];

    heelDepth.value = Math.round(heelDepthRealY.current[foot] - heelHeight.center.y);

    let heelLateralWedge = surfaceJointsArray.current[foot]['heelLateralWedge'];
    heelLateralWedge.value = Math.round(Math.atan((heelLateralWedge.center.y - heelDepthRealY.current[foot]) /
      Math.abs(heelLateralWedge.center.x - heelDepth.center.x)) * 180 / Math.PI);

    let heelMedialWedge = surfaceJointsArray.current[foot]['heelMedialWedge'];
    heelMedialWedge.value = Math.round(Math.atan((heelMedialWedge.center.y - heelDepthRealY.current[foot]) /
      Math.abs(heelMedialWedge.center.x - heelDepth.center.x)) * 180 / Math.PI);

    if (heelLateralWedge.value > 0 && heelMedialWedge.value > 0) insoleHighLevelParamRef.current[foot].heelWedgeType = "Free";
    else if (heelMedialWedge.value > 0) insoleHighLevelParamRef.current[foot].heelWedgeType = "Medial";


    let forefootLateralWedge = surfaceJointsArray.current[foot]['forefootLateralWedge'];
    forefootLateralWedge.value = Math.round(Math.atan((forefootLateralWedge.center.y - thicknessjoint.center.y) /
      Math.abs(forefootLateralWedge.center.x - thicknessjoint.center.x)) * 180 / Math.PI);

    let forefootMedialWedge = surfaceJointsArray.current[foot]['forefootMedialWedge'];
    forefootMedialWedge.value = Math.round(Math.atan((forefootMedialWedge.center.y - thicknessjoint.center.y) /
      Math.abs(forefootMedialWedge.center.x - thicknessjoint.center.x)) * 180 / Math.PI);

    if (forefootLateralWedge.value > 0 && forefootMedialWedge.value <= 0) insoleHighLevelParamRef.current[foot].forefootWedgeType = 'Lateral';
    else if (forefootLateralWedge.value <= 0 && forefootMedialWedge.value > 0) insoleHighLevelParamRef.current[foot].forefootWedgeType = 'Medial';
  }

  const updateInsoleLengthAndWidth = (foot: number, updateTable: boolean = false) => {
    // var bbox = new THREE.Box3().setFromObject(outputMeshRef.current[foot]);
    if (outputMeshRef.current[foot] == null) return;

    const bbox = GetInsoleBox(outputMeshRef.current[foot]);
    var size = bbox.getSize(new THREE.Vector3());
    insoleHighLevelParamRef.current[foot].length = Math.round(size.z);
    insoleHighLevelParamRef.current[foot].width = Math.round(size.x);

    lengthExtraUpdates(foot, updateTable);

    if (!thirdQuarter.current) {
      insoleHighLevelParamRef.current[foot].partialLength = Math.round(size.z);
    }
    else {
      const archCutPosition = archLinePointsRef.current[foot][archLinePointsRef.current[foot].length - 1].z + archCutMargin;
      insoleHighLevelParamRef.current[foot].partialLength = Math.round(archCutPosition - bbox.min.z);
    }

    if (updateTable || thirdQuarter.current) updateSurfaceJointValuesTable();
  }

  const lengthExtraUpdates = (foot: number, update: boolean) => {
    if (!isSandal.current || !update) return;

    const event = new CustomEvent('updateSurfaceParameters', {
      detail: [{ fieldKey: 'Outsole Thickness', foot, value: insoleHighLevelParamRef.current[foot]?.outsoleThickness, single: true },
      { fieldKey: 'Thickness', foot, value: insoleHighLevelParamRef.current[foot]?.thickness, single: true }
      ],
    });
    document.dispatchEvent(event);
  };

  // Add method to handle surface joint changes
  const handleSurfaceJointValues = (foot: number, isHeelDepthMouseChanging: boolean = false) => {
    if (originalGeometryRef.current === null) return;
    if (!useDesignStore.getState().insoleDesign?.insoles[foot].lowpolyBufferGeometry) return;

    updateInsoleLengthAndWidth(foot);

    let outsoleThicknessjoint = surfaceJointsArray.current[foot]['outsoleThickness'];
    let thicknessjoint = surfaceJointsArray.current[foot]['thickness'];
    thicknessjoint.value = Math.round((thicknessjoint.center.y * thicknessjoint.bval + thicknessjoint.cval) * 10) / 10; // round to 1 decimal place
    if (isSandal.current) {
      const refPointY = outsoleThicknessjoint!.center.y;
      thicknessjoint.value = Math.round(((thicknessjoint.center.y - refPointY - 2.55) * thicknessjoint.bval + thicknessjoint.cval) * 10) / 10;
    }
    insoleHighLevelParamRef.current[foot].thickness = thicknessjoint.value;

    if (outsoleThicknessjoint != null && outsoleThicknessjoint != undefined) {
      outsoleThicknessjoint.value = Math.round((outsoleThicknessjoint.center.y * outsoleThicknessjoint.bval + outsoleThicknessjoint.cval));
      insoleHighLevelParamRef.current[foot].outsoleThickness = outsoleThicknessjoint.value;
    }

    let heelHeight = surfaceJointsArray.current[foot]['heelHeight'];
    heelHeight.value = Math.round((heelHeight.center.y - thicknessjoint.center.y) * heelHeight.bval + heelHeight.cval);
    insoleHighLevelParamRef.current[foot].heelHeight = heelHeight.value;

    let heelDepth = surfaceJointsArray.current[foot]['heelDepth'];
    if (isHeelDepthMouseChanging) {
      heelDepth.value = Math.round((heelDepthRealY.current[foot] - heelHeight.center.y) * heelDepth.bval + heelDepth.cval);
      // insoleHighLevelParamRef.current[foot].heelDepth = heelDepth.value - heelHeight.value;
    } else {
      heelDepth.value = Math.round((heelDepth.center.y - heelHeight.center.y) * heelDepth.bval + heelDepth.cval);
      insoleHighLevelParamRef.current[foot].heelDepth = heelDepth.value;
      heelDepthRealY.current[foot] = heelDepth.center.y;
    }

    let heelLateralWedge = surfaceJointsArray.current[foot]['heelLateralWedge'];
    heelLateralWedge.value = Math.round(Math.atan((heelLateralWedge.center.y - heelDepthRealY.current[foot]) /
      Math.abs(heelLateralWedge.center.x - heelDepth.center.x)) * 180 / Math.PI);
    insoleHighLevelParamRef.current[foot].heelLateralWedge = (heelLateralWedge.value >= 0) ? heelLateralWedge.value : insoleHighLevelParamRef.current[foot].heelLateralWedge;
    if (!insoleHighLevelParamRef.current[foot].heelLateralWedge) insoleHighLevelParamRef.current[foot].heelLateralWedge = 0;

    let heelMedialWedge = surfaceJointsArray.current[foot]['heelMedialWedge'];
    heelMedialWedge.value = Math.round(Math.atan((heelMedialWedge.center.y - heelDepthRealY.current[foot]) /
      Math.abs(heelMedialWedge.center.x - heelDepth.center.x)) * 180 / Math.PI);
    insoleHighLevelParamRef.current[foot].heelMedialWedge = (heelMedialWedge.value >= 0) ? heelMedialWedge.value : insoleHighLevelParamRef.current[foot].heelMedialWedge;
    if (!insoleHighLevelParamRef.current[foot].heelMedialWedge) insoleHighLevelParamRef.current[foot].heelMedialWedge = 0;

    let thicknessToHeelHeight = thicknessjoint.center.clone().sub(heelHeight.center);
    let archMedialHeight = surfaceJointsArray.current[foot]['archMedialHeight'];
    let archYBase = Math.abs((archMedialHeight.center.z - thicknessjoint.center.z) / thicknessToHeelHeight.z) * (heelHeight.center.y - thicknessjoint.center.y) + thicknessjoint.center.y;

    archMedialHeight.value = Math.round((archMedialHeight.center.y - archYBase) * archMedialHeight.bval + archMedialHeight.cval);
    insoleHighLevelParamRef.current[foot].archMedialHeight = archMedialHeight.value;

    let archCenterHeight = surfaceJointsArray.current[foot]['archCenterHeight'];
    archCenterHeight.value = Math.round((archCenterHeight.center.y - archYBase) * archCenterHeight.bval + archCenterHeight.cval);
    insoleHighLevelParamRef.current[foot].archCenterHeight = archCenterHeight.value;

    let archLateralHeight = surfaceJointsArray.current[foot]['archLateralHeight'];
    archLateralHeight.value = Math.round((archLateralHeight.center.y - archYBase) * archLateralHeight.bval + archLateralHeight.cval);
    insoleHighLevelParamRef.current[foot].archLateralHeight = archLateralHeight.value;

    let forefootLateralWedge = surfaceJointsArray.current[foot]['forefootLateralWedge'];
    forefootLateralWedge.value = Math.round(Math.atan((forefootLateralWedge.center.y - thicknessjoint.center.y) /
      Math.abs(forefootLateralWedge.center.x - thicknessjoint.center.x)) * 180 / Math.PI);
    insoleHighLevelParamRef.current[foot].forefootLateralWedge = (forefootLateralWedge.value >= 0) ? forefootLateralWedge.value : insoleHighLevelParamRef.current[foot].forefootLateralWedge;

    let forefootMedialWedge = surfaceJointsArray.current[foot]['forefootMedialWedge'];
    forefootMedialWedge.value = Math.round(Math.atan((forefootMedialWedge.center.y - thicknessjoint.center.y) /
      Math.abs(forefootMedialWedge.center.x - thicknessjoint.center.x)) * 180 / Math.PI);
    insoleHighLevelParamRef.current[foot].forefootMedialWedge = (forefootMedialWedge.value >= 0) ? forefootMedialWedge.value : insoleHighLevelParamRef.current[foot].forefootMedialWedge;

    let archEditor = surfaceJointsArray.current[foot]['archSagitalPosition'];
    const insoleBox = GetInsoleBox(outputMeshRef.current[foot]);
    const boxSize = insoleBox?.getSize(new THREE.Vector3());
    archEditor.value = Math.round((archEditor.center.z - insoleBox.min.z) * 100 / boxSize.z);
    insoleHighLevelParamRef.current[foot].archSagitalPosition = archEditor.value;

    let bandHeightjoint = surfaceJointsArray.current[foot]['bandHeight'];
    if (bandHeightjoint != null && bandHeightjoint != undefined) {
      const curcumference = createInStepLine(foot, undefined, true);
      if (curcumference) {
        bandHeightjoint.value = Math.round(((bandHeightjoint.center.y - archCenterHeight.center.y) * bandHeightjoint.bval + bandHeightjoint.cval));
        insoleHighLevelParamRef.current[foot].bandHeight = bandHeightjoint.value;
        insoleHighLevelParamRef.current[foot].instepArea = Math.round(curcumference);
      }
    }

    if (!isSandal.current) {
      if (!useDesignStore.getState().insoleDesign?.insoles[foot].lowpolyBufferGeometry) return;
      let geo = useDesignStore.getState().insoleDesign?.insoles[foot].lowpolyBufferGeometry;
      const insoleVertices = geo.attributes.position.array;

      // let archWallHeight = Math.abs(insoleVertices[ArchWallMedial.topId * 3 + 1]);
      let archWallHeightM1 = insoleVertices[ArchWallMedial.topId * 3 + 1];

      // let archWallHeightL1 = (insoleVertices[ArchWallLateral.topId * 3 + 1]);

      let archWallDisM1 = Math.abs(insoleVertices[ArchWallMedial.topId * 3] - insoleVertices[ArchWallMedial.bottomId * 3]);
      // let archWallDisL1 = Math.abs(insoleVertices[ArchWallLateral.topId * 3] - insoleVertices[ArchWallLateral.bottomId * 3]);

      // console.log(`Arch Medial Angle ${Math.atan(((archWallDisM1 / archWallHeightM1) - Math.tan(ArchWallMedial.minAngle * Math.PI / 180) * 0.1) / 0.9) * 180 / Math.PI}`);
      // console.log(`Arch Lateral Angle ${Math.atan(((archWallDisL1 / archWallHeightL1) - Math.tan(ArchWallLateral.minAngle * Math.PI / 180) * 0.1) / 0.9) * 180 / Math.PI}`);

      if (archWallHeightM1 < 0 && !insoleHighLevelParamRef.current[foot].archFill) insoleHighLevelParamRef.current[foot].archFill = 100;
      // let archFill = Math.round((Math.tan(ArchWallMedial.maxAngle * Math.PI / 180.0) - (archWallDis / archWallHeight)) * 100 / (Math.tan(ArchWallMedial.maxAngle * Math.PI / 180.0)));
      let archFill = Math.round(
        ((Math.tan(ArchWallMedial.maxAngle * Math.PI / 180.0) - Math.tan(ArchWallMedial.minAngle * Math.PI / 180.0))
          - ((archWallDisM1 / archWallHeightM1) - Math.tan(ArchWallMedial.minAngle * Math.PI / 180.0))) * 100 /
        (Math.tan(ArchWallMedial.maxAngle * Math.PI / 180.0) - Math.tan(ArchWallMedial.minAngle * Math.PI / 180.0))
      );
      // if (archFill <= 100 && archFill >= 0) 
      insoleHighLevelParamRef.current[foot].archFill = archFill;

      let heelWallHeight4 = (insoleVertices[HeelMedialToLateral4.topId * 3 + 1]);
      let heelWallDis4 = Math.abs(Math.sqrt(Math.pow(insoleVertices[HeelMedialToLateral4.topId * 3] - insoleVertices[HeelMedialToLateral4.bottomId * 3], 2) + Math.pow(insoleVertices[HeelMedialToLateral4.topId * 3 + 2] - insoleVertices[HeelMedialToLateral4.bottomId * 3 + 2], 2)));

      // console.log(`Heel Angle 4: ${Math.atan(((heelWallDis4 / heelWallHeight4) - Math.tan(HeelMedialToLateral4.minAngle * Math.PI / 180) * 0.5) / 0.5)* 180 / Math.PI}`);

      if (heelWallHeight4 < 0 && !insoleHighLevelParamRef.current[foot].heelFill) insoleHighLevelParamRef.current[foot].heelFill = 100;
      let heelFill = Math.round(
        ((Math.tan(HeelMedialToLateral4.maxAngle * Math.PI / 180.0) - Math.tan(HeelMedialToLateral4.minAngle * Math.PI / 180.0))
          - ((heelWallDis4 / heelWallHeight4) - Math.tan(HeelMedialToLateral4.minAngle * Math.PI / 180.0))) * 100 /
        (Math.tan(HeelMedialToLateral4.maxAngle * Math.PI / 180.0) - Math.tan(HeelMedialToLateral4.minAngle * Math.PI / 180.0))
      );
      // if (heelFill <= 100 && heelFill >= 0) 
      insoleHighLevelParamRef.current[foot].heelFill = heelFill;
    }

    updateSurfaceJointValuesTable();
  };

  const addLabelstoAllSpheres = () => {
    for (let footIndex = 0; footIndex < surfaceJointSpheresRef.current.length; footIndex++) {
      const footSpheres = surfaceJointSpheresRef.current[footIndex];
      if (!footSpheres) continue;

      for (let jointIndex = 0; jointIndex < footSpheres.length; jointIndex++) {
        const sphere = footSpheres[jointIndex];
        if (!sphere || !sphere.userData.jointName) continue;
        createOrUpdateSphereLabel(sphere, sphere.userData.jointName, footIndex);
      }
    }
    //--------------lenght & width ------------------
    Object.entries(dimensionSpheresRef.current).forEach(([footIndex, sphere]) => {
      createOrUpdateDimensionLabel(sphere, ["Length", "Width"], parseInt(footIndex));
    });

    //--------------arch fill ----------------
    createArchFillLine(0);
    if (archGuideSpheresRef.current) createOrUpdateSphereLabel(archGuideSpheresRef.current[0], "Arch Fill", 0);

    createArchFillLine(1);
    if (archGuideSpheresRef.current) createOrUpdateSphereLabel(archGuideSpheresRef.current[1], "Arch Fill", 1);

    //--------------heel fill ----------------
    createHeelFillLine(0);
    if (heelGuideSpheresRef.current) createOrUpdateSphereLabel(heelGuideSpheresRef.current[0], "Heel Fill", 0);

    createHeelFillLine(1);
    if (heelGuideSpheresRef.current) createOrUpdateSphereLabel(heelGuideSpheresRef.current[1], "Heel Fill", 1);
  }

  // Function to update joint spheres after drag
  const updateJointSpheres = (geometry: THREE.BufferGeometry, foot: number) => {
    if (!sceneRef.current) return;
    // Get vertex positions
    const insoleVertices = geometry.attributes.position.array;

    // Update profile joint spheres
    if (!isSandal.current)
      profileJointSpheresRef.current[foot].forEach(joint => {
        const centerVertexId = profileJointsArray.current[foot][joint.userData.jointIndex].centerId;

        const x = insoleVertices[centerVertexId * 3];
        const z = insoleVertices[centerVertexId * 3 + 2];

        joint.position.set(x, 0, z);
        joint.userData.originalPosition = new THREE.Vector3(x, 0, z);
      });

    // Update surface joint spheres
    Object.values(surfaceJointsArray.current[foot]).forEach((joint, index) => {
      if (!joint) return;
      if (joint.name == 'Outsole Thickness' && !isSandal.current) return;

      const centerVertexId = joint.centerId;
      let x = insoleVertices[centerVertexId * 3];
      let y = insoleVertices[centerVertexId * 3 + 1];
      const z = insoleVertices[centerVertexId * 3 + 2];

      if (joint.name === 'Heel Depth') {
        y = heelDepthRealY.current[foot];
      }
      else if (joint.name === 'Arch Sagital Position') {
        y = 0;
        const xConst = (foot === 0) ? -archEditorConst.current : archEditorConst.current;
        x += xConst;
      }

      joint.center.set(x, y, z);

      if (surfaceJointSpheresRef.current[foot]) {
        surfaceJointSpheresRef.current[foot][index].position.set(x, y, z);
        surfaceJointSpheresRef.current[foot][index].userData.originalPosition = new THREE.Vector3(x, y, z);
      }
    });

    // Update advanced joints spheres
    if (!vertexSpheresRef.current || !vertexSpheresRef.current[foot]) return;
    vertexSpheresRef.current[foot].forEach((sphere, index) => {
      const vertexId = sphere.userData.vertexId;

      const x = insoleVertices[vertexId * 3];
      const y = insoleVertices[vertexId * 3 + 1];
      const z = insoleVertices[vertexId * 3 + 2];

      sphere.position.set(x, y, z);
      sphere.userData.originalPosition = new THREE.Vector3(x, y, z);
    });
  };

  function GetAdjustedProfileCurvePoints(newprofile: THREE.BufferGeometry, original: THREE.BufferGeometry, foot: number) {
    const heelJoint = surfaceJointsArray.current[foot]['heelHeight'];

    // 1. Get bounding box for original and new curve
    newprofile.computeBoundingBox();
    const newbox = newprofile.boundingBox ?? new THREE.Box3();

    original.computeBoundingBox();
    const originalBox = original.boundingBox ?? new THREE.Box3();

    // 2. Compute scale in Z
    const scale = (originalBox.max.z - originalBox.min.z) / (newbox.max.z - newbox.min.z);
    let scaleX = scale;

    // 3. Update scaleX if selected profile curve and insole width difference is more than 5mm and changes come from sandal
    if (changesToApply.current &&
      Math.abs((newbox.max.x - newbox.min.x) * scale - insoleHighLevelParamRef.current[foot].width) > 5)
      scaleX = insoleHighLevelParamRef.current[foot].width / (newbox.max.x - newbox.min.x);

    // 4. Scale and translate new curve
    // if (foot == 0) newprofile.scale(-scale, 1, scale);
    // else newprofile.scale(scale, 1, scale);
    newprofile.scale(scaleX, 1, scale);

    const newPositions = newprofile.getAttribute('position');
    const originalPositions = original.getAttribute('position');
    const newArchCenter = new THREE.Vector3(newPositions.getX(heelJoint.centerId), newPositions.getY(heelJoint.centerId), newPositions.getZ(heelJoint.centerId));
    const originalArchCenter = new THREE.Vector3(originalPositions.getX(heelJoint.centerId), originalPositions.getY(heelJoint.centerId), originalPositions.getZ(heelJoint.centerId));

    // newprofile.translate(originalBoxCenter.x - newboxCenter.x, originalBoxCenter.y - newboxCenter.y, originalBoxCenter.z - newboxCenter.z);
    let translateVector = originalArchCenter.clone().sub(newArchCenter);
    newprofile.translate(translateVector.x, 0, translateVector.z);
    // newprofile.translate(originalBox.min.x - newbox.min.x, originalBox.min.y - newbox.min.y, originalBox.min.z - newbox.min.z);

    return newprofile;
  }

  function fitProfileCurve(newprofile: THREE.BufferGeometry, insoleVertices: THREE.BufferAttribute | THREE.InterleavedBufferAttribute, foot: number) {
    const newProfilePositions = newprofile.getAttribute('position');

    profileJointsArray.current[foot].forEach((joint) => {
      joint.center.x = newProfilePositions.getX(joint.centerId);
      joint.center.z = newProfilePositions.getZ(joint.centerId);

      joint.vertices.forEach((vertexGroup: any) => {
        vertexGroup.ids.forEach((vertexId: number) => {

          insoleVertices.setX(vertexId, newProfilePositions.getX(vertexId));
          insoleVertices.setZ(vertexId, newProfilePositions.getZ(vertexId));

        });
      });
    });
  }

  function makeThemeEventListener() {
    return () => {
      updateBackgroundColor();
      updateGizmo(isBackdropOpen);
      if (useViewerStore.getState().grids) enableGrids(true);
      else enableGrids(false);
    };
  }

  const handleAdditiontemplate = async (template: InsoleDesign, inputFoot: number) => {
    const designStore = useDesignStore.getState();
    if (!designStore.insoleDesign?.insoles || !template?.insoles) return;
    const sidesConst = [0, 1];
    const sides = [sidesConst[inputFoot]];
    for (const foot of sides) {
      const currentInsole = designStore.insoleDesign?.insoles[foot];
      const insoleTemplate = template.insoles[foot];
      if (currentInsole == null || insoleTemplate == null) return;

      if (template.name == "PesCavus") {
        if (designStore.insoleDesign?.autoProperties) {
          if (designStore.insoleDesign.autoProperties.metatarSalBarLeft > 0 &&
            designStore.insoleDesign.autoProperties.metatarSalBarRight > 0) {
            return;
          }
        }
        const additionNames = insoleTemplate.additions.map(add => add.name);
        for (const name of additionNames) {
          const addRes = await addNewAddition(api, name, foot);
          if (!addRes) return;
          addRes.automaticAddition = AutomaticAdditions.MetatarsalBarFromPescavus;
          if (designStore.insoleDesign?.autoProperties) {
            designStore.insoleDesign.autoProperties.metatarSalBarRight = 0;
            designStore.insoleDesign.autoProperties.metatarSalBarLeft = 0;
          }
          designStore.pushAdditionToDesign(addRes, foot);
        }
        const event = new CustomEvent('refreshAutomaticComponents');
        document.dispatchEvent(event);
      }
      else {
        const toremove = currentInsole.additions.findIndex(add => add.automaticAddition == AutomaticAdditions.MetatarsalBarFromPescavus);
        if (toremove >= 0 && insoleTemplate.additions.length == 0) {
          useDesignStore.setState({ additionRemoved: [{ 'side': foot, 'index': toremove, 'isAdditionID': false }] });
          if (designStore.insoleDesign?.autoProperties) {
            if (designStore.insoleDesign.autoProperties.metatarSalBarRight != -1)
              designStore.insoleDesign.autoProperties.metatarSalBarRight = -1;
            if (designStore.insoleDesign.autoProperties.metatarSalBarLeft != -1)
              designStore.insoleDesign.autoProperties.metatarSalBarLeft = -1;
          }
        }
        const event = new CustomEvent('refreshAutomaticComponents');
        document.dispatchEvent(event);
      }
    }

  };

  const removeBonesFromScene = () => {
    if (sceneRef == null || sceneRef.current == null) return;
    const toRemovePrefixes = [BONES_ALL_NAME_PREFIX, SHOEMARKERS_INSIDE_NAME_PREFIX, SHOEMARKERS_OUTSIDE_NAME_PREFIX];

    const itemsToRemove = sceneRef.current.children.filter(item =>
      toRemovePrefixes.some(prefix => item.name.startsWith(prefix))
    );

    itemsToRemove.forEach(item => {
      item.traverse(child => { DisposeMesh(child); });
      sceneRef.current?.remove(item);
    });

    DisposeMesh(LiftedMeshRef.current[0]);
    DisposeMesh(LiftedMeshRef.current[1]);
    sceneRef.current.remove(LiftedMeshRef.current[0]);
    sceneRef.current.remove(LiftedMeshRef.current[1]);

    hasBones.current[0] = false;
    hasBones.current[1] = false;

    // shoeInsideMarkerGroup.current = null;
    if (shoeInsideMarkerGroup.current) {
      shoeInsideMarkerGroup.current.pop();
      shoeInsideMarkerGroup?.current.pop();
    }
    if (shoeOutsideMarkerGroup.current) {
      shoeOutsideMarkerGroup.current.pop();
      shoeOutsideMarkerGroup?.current.pop();
    }
  }

  const newWBCTScan = (event: CustomEvent) => {
    let design = useDesignStore.getState().insoleDesign;
    if (design == null) return;
    const hasOldBones = hasBones.current.every(value => value === true);
    if (hasOldBones) removeBonesFromScene();
    ImportWBCTData(false);
    const newLen = useSelectedDesignStore.getState().lengthFromWBCT;
    if (newLen <= 0) return;
    handleUpdateSurfaceParameters(new CustomEvent('updateSurfaceParameters', {
      detail: [
        {
          fieldKey: 'Length',
          foot: 0,
          value: newLen,
        },
        {
          fieldKey: 'Length',
          foot: 1,
          value: newLen,
        },
      ],
    })).then(() => {
      handleUpdateSurfaceParameters(new CustomEvent('updateSurfaceParameters', {
        detail: [
          {
            fieldKey: 'Profile Curve',
            foot: 0,
            value: design?.insoles[0].profileCurveType,
          },
          {
            fieldKey: 'Profile Curve',
            foot: 1,
            value: design?.insoles[1].profileCurveType,
          },
          {
            fieldKey: 'Insole Template',
            foot: 0,
            value: design?.autoProperties?.insoleTemplate,
          },
          {
            fieldKey: 'Insole Template',
            foot: 1,
            value: design?.autoProperties?.insoleTemplate,
          }
        ],
      })).then(() => {
        resetStackWithDesign(design);
        fitCameraToSceneObjects(cameraRef.current!, controlsRef.current!, containerRef.current!, sceneRef, 'load');
        captureInitialCameraView();
      });
    });
  }

  // Listener for updateSurfaceParameters event
  const handleUpdateSurfaceParameters = async (event: CustomEvent) => {
    const raw = event.detail;
    const onComplete: (() => void) | undefined = Array.isArray(raw) ? undefined : raw?.onComplete;
    if (!originalGeometryRef.current) {
      onComplete?.();
      return;
    }

    setIsLoading(true);
    const updates = Array.isArray(raw) ? raw : Array.isArray(raw?.updates) ? raw.updates : [raw];

    try {
      let needAutoPropertiesSave = false;
      let needUpdateLengthWidth = false;
      let saveAdditions = false || changesToApply.current != null;
      let saveCategory = changesToApply.current ? true : false;
      let feetToUpdates = new Set<number>();
      let updatedParams: { foot: number; fieldKey: string; value: any }[] = [];
      await Promise.all(updates.map(async (update: any) => {
        let { fieldKey, foot, value, single } = update;
        updatedParams.push({ foot, fieldKey, value });
        value = (typeof value == 'number' && !measurementExclude.some(w => fieldKey.includes(w))) ? convertUnitToDefault(value, getDefaultLengthUnit()) : value;
        const geometryRef = originalGeometryRef.current!![foot];
        const insoleVertices = geometryRef.getAttribute('position');
        feetToUpdates.add(foot);

        switch (fieldKey) {
          case 'Limb Length Discrepancy': {
            const jointList = surfaceJointsArray.current[foot];
            const joint = jointList['heelHeight'];

            // Update the joint's value
            if (joint) {
              let { enable, amount } = value;
              amount = convertUnitToDefault(amount, getDefaultLengthUnit());
              const sign = enable ? 1 : -1;
              const displacement = (amount - joint.cval) / joint.bval * sign;

              // Update the heel height joint's center position
              joint.center.y += displacement;
              heelDepthRealY.current[foot] += displacement;
              // Update heel fill
              insoleHighLevelParamRef.current[foot].heelFill = enable ? 80 : 50;
              // Update the vertices associated with the joint
              joint.vertices.forEach((vertexGroup: any) => {
                vertexGroup.ids.forEach((vertexId: number) => {
                  const weight = vertexGroup.weight;
                  insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
                });
              });

              insoleHighLevelParamRef.current[foot].heelHeight += amount * sign;
              updateHeelDepthAutoProps();
              needAutoPropertiesSave = true;
            }
            break;
          }
          case 'Insole Template': {
            const template = await getTemplate(api, value);
            if (!template?.insoles?.[foot]) break;
            await handleAdditiontemplate(template, foot);
            let heeldepthy = foot == 0 ? template.autoProperties?.heelDepthRightY : template.autoProperties?.heelDepthLeftY;
            const templateGeometry = template.insoles[foot].lowpolyBufferGeometry;
            if (!templateGeometry) break;
            getAutoDesignValues(foot, templateGeometry, heeldepthy!);

            // heelDepthRealY.current[foot] = insoleHighLevelParamRef.current[foot].thickness +
            //   insoleHighLevelParamRef.current[foot].heelHeight +
            //   insoleHighLevelParamRef.current[foot].heelDepth;

            const jointList = surfaceJointsArray.current[foot];
            var joint = jointList['heelHeight'];
            var jointDepth = jointList['heelDepth'];

            if (joint) {
              joint.value = insoleHighLevelParamRef.current[foot].heelHeight;
              const displacement = (joint.value - joint.cval) / joint.bval + insoleHighLevelParamRef.current[foot].thickness - joint.center.y;
              heelDepthRealY.current[foot] += displacement;
              joint.center.y += displacement;

              joint.vertices.forEach((vertexGroup: any) => {
                vertexGroup.ids.forEach((vertexId: number) => {
                  const weight = vertexGroup.weight;
                  insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);

                  if (jointDepth?.centerId == vertexId) {
                    jointDepth.center.y += displacement;
                  }
                });
              });
            }

            if (jointDepth) {
              jointDepth.value = insoleHighLevelParamRef.current[foot].heelDepth;
              const displacement = (jointDepth.value - jointDepth.cval) / jointDepth.bval + insoleHighLevelParamRef.current[foot].thickness + insoleHighLevelParamRef.current[foot].heelHeight - jointDepth.center.y;
              jointDepth.center.y += displacement;
              heelDepthRealY.current[foot] += displacement;

              jointDepth.vertices.forEach((vertexGroup: any) => {
                vertexGroup.ids.forEach((vertexId: number) => {
                  const weight = vertexGroup.weight;
                  insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
                });
              });
            }

            insoleHighLevelParamRef.current[foot].heelWedgeType = 'Medial';
            getHighLevelHeelPoints(foot);
            getHighLevelArchPoints(foot, labelToProperty('archMedialHeight'), insoleHighLevelParamRef.current[foot].archMedialHeight);
            updateHeelDepthAutoProps();

            needAutoPropertiesSave = true;
            if (foot == 0 && useDesignStore.getState().insoleDesign?.autoProperties) {
              useDesignStore.getState().insoleDesign!.autoProperties!.insoleTemplate = value;
            }

            break;
          }
          case 'Profile Curve': {
            const template = await getTemplate(api, value);
            if (!template || !template.insoles[1].lowpolyBufferGeometry) { setIsLoading(false); return; }
            needAutoPropertiesSave = true;

            const newcurveupdated = GetAdjustedProfileCurvePoints(template.insoles[foot].lowpolyBufferGeometry!, geometryRef, foot);

            let archEditorZ = insoleVertices.getZ(surfaceJoints.current!.archSagitalPosition.centerId);
            const sphere = surfaceJointsArray.current[foot]['archSagitalPosition'];
            correctArchEditor(archEditorZ, foot, newcurveupdated.getAttribute('position'), sphere);

            fitProfileCurve(newcurveupdated, insoleVertices, foot);
            insoleHighLevelParamRef.current[foot].profileCurve = value;
            if (foot == 0) useDesignStore.getState().insoleDesign!.autoProperties!.profileCurveRight = value;
            else useDesignStore.getState().insoleDesign!.autoProperties!.profileCurveLeft = value;
            needUpdateLengthWidth = true;

            break;
          }
          case 'Length': {
            saveAdditions = true;
            var bbox = GetInsoleBox(outputMeshRef.current[foot]);
            var size = bbox.getSize(new THREE.Vector3);
            const scale = value / size.z;
            let scalex = Math.max(Math.min(size.x * scale, 150), 50) / size.x;

            // Scale around the center of the object
            const vertexCount = insoleVertices.count;

            // Compute center          
            geometryRef.computeBoundingBox();
            const center = bbox.getCenter(new THREE.Vector3()) ?? new THREE.Vector3();

            // Move to origin, scale, then move back
            for (let i = 0; i < vertexCount; i++) {
              const x = insoleVertices.getX(i);
              const y = insoleVertices.getY(i);
              const z = insoleVertices.getZ(i);

              const newX = (x - center.x) * scalex + center.x;
              const newY = (y - center.y) * scale + center.y;
              const newZ = (z - center.z) * scale + center.z;

              // For sandals, scale y-direction as normal except insole roof vertices
              if (isSandal.current && !meshconfig.current?.roofJoints.vertices[0].ids.includes(i)) {
                insoleVertices.setY(i, newY);
              }

              insoleVertices.setX(i, newX);
              insoleVertices.setZ(i, newZ);
            }

            // Find the minimum Y value in the insole vertices
            let minY = Infinity;
            for (let i = 0; i < vertexCount; i++) {
              const y = insoleVertices.getY(i);
              if (y < minY) {
                minY = y;
              }
            }
            // Translate all vertices so that the minimum Y becomes 0
            if (minY != 0) {
              for (let i = 0; i < vertexCount; i++) {
                insoleVertices.setY(i, insoleVertices.getY(i) - minY);
              }
              heelDepthRealY.current[foot] -= minY;
            }

            insoleHighLevelParamRef.current[foot].width = Math.round(size.x * scalex);
            insoleHighLevelParamRef.current[foot].length = value;
            if (insoleOldCenter.current[foot] == null) insoleOldCenter.current[foot] = center.clone();
            updateBaseLocation(geometryRef, foot);

            if (!changesToApply.current) {
              const additions = useDesignStore.getState().insoleDesign?.insoles[foot].additions ?? [];
              // Scale additions based on the insole scaling
              additions.forEach((addition) => {
                addition.ScaleWithCenter(scale, scalex, center);
              });

              const xConst = (foot === 0) ? -archEditorConst.current : archEditorConst.current;
              archLinePointsRef.current[foot][0] =
                new THREE.Vector3(
                  insoleVertices.getX(meshconfig.current!.archLineIndices[0]) + xConst,
                  0,
                  insoleVertices.getZ(meshconfig.current!.archLineIndices[0])
                );
              for (let i = 0; i < meshconfig.current!.archLineIndices.length; i++) {
                let x1 = insoleVertices.getX(meshconfig.current!.archLineIndices[i]);
                let z1 = insoleVertices.getZ(meshconfig.current!.archLineIndices[i]);
                archLinePointsRef.current[foot][i + 1] = new THREE.Vector3(x1, 0, z1);
              }
            }

            if (designCategory.current !== DesignCategory.Insole) {
              needUpdateLengthWidth = true;
              // updateBandHeight(insoleVertices, foot);
            }

            if (designCategory.current === DesignCategory.HighHeel) {
              insoleVertices.needsUpdate = true;
              highHeelRef.current.scaleWithLength(foot, scale, geometryRef);
            }

            break;
          }
          case 'Width': {
            if (Math.abs(value - insoleHighLevelParamRef.current[foot].width) < 1)
              break;

            var bbox = GetInsoleBox(outputMeshRef.current[foot]);
            // var size = bbox.getSize(new THREE.Vector3);
            const scalex = value / insoleHighLevelParamRef.current[foot].width;
            // const scalex = value / size.x;
            const vertexCount = insoleVertices.count;

            // Compute center          
            geometryRef.computeBoundingBox();
            const center = bbox.getCenter(new THREE.Vector3()) ?? new THREE.Vector3();
            // const center = geometryRef.boundingBox?.getCenter(new THREE.Vector3()) ?? new THREE.Vector3();

            // Move to origin, scale, then move back
            for (let i = 0; i < vertexCount; i++) {
              const x = insoleVertices.getX(i);
              const newX = (x - center.x) * scalex + center.x;
              insoleVertices.setX(i, newX);
            }

            insoleHighLevelParamRef.current[foot].width = value;
            if (insoleOldCenter.current[foot] == null) insoleOldCenter.current[foot] = center.clone();
            updateBaseLocation(geometryRef, foot);

            if (!changesToApply.current) {
              saveAdditions = true;
              const additions = useDesignStore.getState().insoleDesign?.insoles[foot].additions ?? [];
              // Scale additions based on the insole scaling
              additions.forEach((addition) => {
                addition.ScaleXWithCenter(scalex, center);
              });

              const xConst = (foot === 0) ? -archEditorConst.current : archEditorConst.current;
              archLinePointsRef.current[foot][0] =
                new THREE.Vector3(
                  insoleVertices.getX(meshconfig.current!.archLineIndices[0]) + xConst,
                  0,
                  insoleVertices.getZ(meshconfig.current!.archLineIndices[0]));
              for (let i = 0; i < meshconfig.current!.archLineIndices.length; i++) {
                let x1 = insoleVertices.getX(meshconfig.current!.archLineIndices[i]);
                let z1 = insoleVertices.getZ(meshconfig.current!.archLineIndices[i]);
                archLinePointsRef.current[foot][i + 1] = new THREE.Vector3(x1, 0, z1);
              }
            }
            break;
          }
          case 'Thickness': {
            // Find the corresponding joint based on fieldKey and foot
            const jointList = surfaceJointsArray.current[foot];
            const joint = jointList[labelToProperty(fieldKey)];

            // Update the joint's value
            if (joint) {
              joint.value = value;
              let targetY = (value - joint.cval) / joint.bval;
              if (isSandal.current) {
                const outsoleThicknessCenter = jointList["outsoleThickness"]?.center.y;
                targetY = (value + outsoleThicknessCenter + 2.55 - joint.cval) / joint.bval;
              }
              const displacement = targetY - joint.center.y;
              heelDepthRealY.current[foot] += displacement;
              // Update the joint's center position
              joint.center.y = targetY;

              // Update the vertices associated with the joint
              joint.vertices.forEach((vertexGroup: any) => {
                vertexGroup.ids.forEach((vertexId: number) => {
                  const weight = vertexGroup.weight;
                  insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
                });
              });

              insoleHighLevelParamRef.current[foot].thickness = value;

              getHighLevelForefootPoints(foot);
              updateHeelDepthAutoProps();

              needAutoPropertiesSave = true;
            }
            break;
          }
          case 'Heel Fill': {
            insoleHighLevelParamRef.current[foot].heelFill = value;
            break;
          }
          case 'Arch Fill': {
            insoleHighLevelParamRef.current[foot].archFill = value;
            break;
          }
          case 'Bottom Smoothness': {
            break;
          }
          case 'High Heel Height': {
            if (highHeelRef.current.setHeight(value, foot)) {
              insoleHighLevelParamRef.current[foot].highHeelHeight = value;
            }
            break;
          }
          case 'Heel Height': {
            // Find the corresponding joint based on fieldKey and foot
            const jointList = surfaceJointsArray.current[foot];
            const joint = jointList[labelToProperty(fieldKey)];
            var jointDepth = jointList['heelDepth'];
            var thicknessJoint = jointList['thickness'];

            // Update the joint's value
            if (joint) {
              joint.value = value;
              const displacement = (value - joint.cval) / joint.bval + thicknessJoint.center.y - joint.center.y;
              heelDepthRealY.current[foot] += displacement;
              // Update the joint's center position
              joint.center.y += displacement;

              // Update the vertices associated with the joint
              joint.vertices.forEach((vertexGroup: any) => {
                vertexGroup.ids.forEach((vertexId: number) => {
                  const weight = vertexGroup.weight;
                  insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);

                  if (jointDepth?.centerId == vertexId) {
                    jointDepth.center.y += displacement;
                  }
                });
              });

              insoleHighLevelParamRef.current[foot].heelHeight = value;
              updateHeelDepthAutoProps();
              needAutoPropertiesSave = true;
            }
            break;
          }
          case 'Heel Depth': {
            // Find the corresponding joint based on fieldKey and foot
            const jointList = surfaceJointsArray.current[foot];
            const joint = jointList[labelToProperty(fieldKey)];
            const thicknessJoint = jointList["thickness"];

            // Update the joint's value
            if (joint) {
              joint.value = value;
              const displacement = (value - joint.cval) / joint.bval +
                thicknessJoint.center.y + insoleHighLevelParamRef.current[foot].heelHeight - joint.center.y;
              heelDepthRealY.current[foot] += displacement;
              // Update the joint's center position
              joint.center.y += displacement;

              // Update the vertices associated with the joint
              joint.vertices.forEach((vertexGroup: any) => {
                vertexGroup.ids.forEach((vertexId: number) => {
                  const weight = vertexGroup.weight;
                  insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
                });
              });

              insoleHighLevelParamRef.current[foot].heelDepth = value;
              updateHeelDepthAutoProps();
              needAutoPropertiesSave = true;
            }
            break;
          }
          case 'Heel Wedge Type': {
            insoleHighLevelParamRef.current[foot].heelWedgeType = value;
            getHighLevelHeelPoints(foot);
            break;
          }
          case 'Heel Medial Wedge': {
            insoleHighLevelParamRef.current[foot].heelMedialWedge = value;
            getHighLevelHeelPoints(foot);
            break;
          }
          case 'Heel Lateral Wedge': {
            insoleHighLevelParamRef.current[foot].heelLateralWedge = value;
            getHighLevelHeelPoints(foot);
            break;
          }
          case 'Heel Flatness': {
            break;
          }
          case 'Arch Medial Height': {
            insoleHighLevelParamRef.current[foot].archMedialHeight = value;
            getHighLevelArchPoints(foot, labelToProperty(fieldKey), value);
            break;
          }
          case 'Arch Center Height': {
            insoleHighLevelParamRef.current[foot].archCenterHeight = value;
            getHighLevelArchPoints(foot, labelToProperty(fieldKey), value);
            break;
          }
          case 'Arch Lateral Height': {
            insoleHighLevelParamRef.current[foot].archLateralHeight = value;
            getHighLevelArchPoints(foot, labelToProperty(fieldKey), value);
            break;
          }
          case 'Arch Sagital Position': {
            const jointList = surfaceJointsArray.current[foot];
            const joint = jointList[labelToProperty(fieldKey)];
            const insoleBox = GetInsoleBox(outputMeshRef.current[foot]);
            const boxSize = insoleBox?.getSize(new THREE.Vector3());
            const newZ = (value * boxSize.z / 100) + insoleBox.min.z;
            correctArchEditor(newZ, foot, insoleVertices, joint!);

            saveAdditions = true;
            if (thirdQuarter.current) needUpdateLengthWidth = true;
            insoleHighLevelParamRef.current[foot].archSagitalPosition = value;
            break;
          }
          case 'Forefoot Wedge Type': {
            insoleHighLevelParamRef.current[foot].forefootWedgeType = value;
            getHighLevelForefootPoints(foot);
            break;
          }
          case 'Forefoot Medial Wedge': {
            insoleHighLevelParamRef.current[foot].forefootMedialWedge = value;
            getHighLevelForefootPoints(foot);
            break;
          }
          case 'Forefoot Lateral Wedge': {
            insoleHighLevelParamRef.current[foot].forefootLateralWedge = value;
            getHighLevelForefootPoints(foot);
            break;
          }
          case 'Band Height': {
            insoleHighLevelParamRef.current[foot].bandHeight = value;
            updateBandHeight(insoleVertices, foot)

            break;
          }
          case 'Outsole Thickness': {
            const jointList = surfaceJointsArray.current[foot];
            const joint = jointList[labelToProperty(fieldKey)];

            // Update the joint's value
            if (joint) {
              joint.value = value;
              const targetY = (value - joint.cval) / joint.bval;
              const displacement = targetY - joint.center.y;
              // Update the joint's center position
              joint.center.y = targetY;
              heelDepthRealY.current[foot] += displacement;

              // Update the vertices associated with the joint
              joint.vertices.forEach((vertexGroup: any) => {
                vertexGroup.ids.forEach((vertexId: number) => {
                  const weight = vertexGroup.weight;
                  insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
                });
              });

              insoleHighLevelParamRef.current[foot].outsoleThickness = value;
              updateHeelDepthAutoProps();
              needAutoPropertiesSave = true;
            }
            break;
          }
        }

        updateJointValues(foot, insoleVertices as THREE.BufferAttribute);

        if (!isSandal.current) {
          handleArchFill(foot, insoleHighLevelParamRef.current[foot].archFill);
          handleHeelFill(foot, insoleHighLevelParamRef.current[foot].heelFill);
          handleArchHeelFill(foot, insoleHighLevelParamRef.current[foot].archFill, insoleHighLevelParamRef.current[foot].heelFill);
        }
      }));

      updateSurfaceJointValuesTable();
      setLastUpdatedParams(updatedParams);
      Array.from(feetToUpdates).forEach(foot => {
        const geometryRef = originalGeometryRef.current![foot];
        updateJointSpheres(geometryRef, foot);
        updateOutputMesh(foot);

        if (needUpdateLengthWidth) updateInsoleLengthAndWidth(foot, true);
      });
      scheduleAutosave("New mesh parameters",
        {
          updateInsoleMesh: true,
          updateAutoProperties: needAutoPropertiesSave,
          updateAddition: saveAdditions,
          updateDesignCategory: saveCategory
        });
    } finally {
      setIsLoading(false);
      onComplete?.();
    }
  };

  const hasFootScan = () => {
    const { rightFoot, leftFoot } = useFootMeshStore.getState();
    return !!(rightFoot || leftFoot);
  };

  useEffect(() => {
    const themeEventListener = makeThemeEventListener();

    const newPressureScanListener = async (event: CustomEvent) => {
      pressureImageDataRef.current = [];
      useDesignStore.getState().setPressureAlignment(null);

      setIsLoading(true);
      await event.detail.pressureData.Load();

      const inputFlag_initPressureImage = useViewerStore.getState().coloring == false ? true : false;
      initPressureImage(event.detail.pressureData, inputFlag_initPressureImage, true);
      useViewerStore.setState({ coloring: false });
      // With a 3D foot scan the insoles are already sized to the feet; keep that length.
      if (!hasFootScan()) {
        handleUpdateSurfaceParameters(new CustomEvent('updateSurfaceParameters', {
          detail: [{
            fieldKey: 'Length',
            foot: 0,
            value: event.detail.pressureData.FootLength_Right,
            single: false
          }, {
            fieldKey: 'Length',
            foot: 1,
            value: event.detail.pressureData.FootLength_Left,
            single: true
          }]
        }));
      }

      const design = useDesignStore.getState().insoleDesign;
      if (design !== null) {
        resetStackWithDesign(design);
      }

      useViewerStore.getState().setOldLiveMode(useViewerStore.getState().liveMode);
      useViewerStore.getState().setLiveMode(useViewerStore.getState().alignPressure);
      useViewerStore.getState().toggleAlignPressure();
      setIsLoading(false);
    }

    const newRondomImageListener = async (event: CustomEvent) => {
      let design = useDesignStore.getState().insoleDesign;
      const rondomImages = useDesignStore.getState().RondomImageData;
      if (!design) return;
      if (!rondomImages) return;
      pressureImageDataRef.current = [];
      useDesignStore.getState().setPressureAlignment(null);

      const inputFlag_initPressureImage = useViewerStore.getState().coloring == false ? true : false;
      initRondomPressureImages(rondomImages, inputFlag_initPressureImage);
      useViewerStore.setState({ coloring: false });
      const insoleLength = ((rondomImages[0]?.realHeight! + rondomImages[1]?.realHeight!) / 2) + RONDOM_PRESSURE_INSOLE_LENGTH_GAP;

      // With a 3D foot scan the insoles are already sized to the feet; keep that length.
      if (!hasFootScan()) {
        handleUpdateSurfaceParameters(new CustomEvent('updateSurfaceParameters', {
          detail: [{
            fieldKey: 'Length',
            foot: 0,
            value: Math.round(insoleLength),
            single: false
          }, {
            fieldKey: 'Length',
            foot: 1,
            value: Math.round(insoleLength),
            single: true
          }]
        }));
      }

      if (design !== null) {
        resetStackWithDesign(design);
      }
      useViewerStore.setState({ alignPressure: true });

      setIsLoading(false);
    }

    const setLoadingEnable = () => setIsLoading(true);
    const setLoadingDisable = () => setIsLoading(false);

    const setCategoryState = async (event: CustomEvent) => {
      const category = event.detail.state;
      // Carry the pressure alignment over as offsets; the stored absolute points belong to the old mesh.
      // Clearing the store also keeps updateObjectsLocation from shifting and saving the old points.
      pressureAlignmentTransferRef.current = capturePressureAlignmentOffsets();
      useDesignStore.getState().setPressureAlignment(null);
      useDesignStore.getState().setCategory(category);
      let design = useDesignStore.getState().insoleDesign;

      if (!design) return;
      setIsLoading(true);

      let templateName = category != DesignCategory.Insole ? category : design.autoProperties!.insoleTemplate;
      const template = await getTemplate(api, templateName);

      if (template && template.insoles[0].lowpolyBufferGeometry && template.insoles[1].lowpolyBufferGeometry) {
        var rightInsoleBox = GetInsoleBox(outputMeshRef.current[0]);
        var rightcenter = rightInsoleBox.getCenter(new THREE.Vector3);
        var leftInsoleBox = GetInsoleBox(outputMeshRef.current[1]);
        var leftcenter = leftInsoleBox.getCenter(new THREE.Vector3);
        insoleOldCenter.current = [rightcenter, leftcenter];

        design.insoles[0].lowpolyBufferGeometry = template.insoles[0].lowpolyBufferGeometry?.clone();
        design.insoles[1].lowpolyBufferGeometry = template.insoles[1].lowpolyBufferGeometry?.clone();
        if (template.autoProperties?.heelDepthRightY) {
          heelDepthRealY.current[0] = template.autoProperties?.heelDepthRightY;
        }
        if (template.autoProperties?.heelDepthLeftY) {
          heelDepthRealY.current[1] = template.autoProperties?.heelDepthLeftY;
        }
        updateHeelDepthAutoProps();
        if (useViewerStore.getState().advanceMode) useViewerStore.getState().toggleAdvance();
      }

      changesToApply.current = insoleHighLevelParamRef.current.map(p => p.clone());
      useViewerStore.getState().setPreviousViewerMode(useViewerStore.getState().mode);
      useDesignStore.setState({ designLoaded: true });
      setIsLoading(false);
    }

    document.addEventListener('themeChange', themeEventListener);
    document.addEventListener('updateSurfaceParameters', handleUpdateSurfaceParameters as unknown as EventListener);
    document.addEventListener('newPressureScan', newPressureScanListener as unknown as EventListener);
    document.addEventListener('newRondomImages', newRondomImageListener as unknown as EventListener);
    document.addEventListener('setLoadingEnable', setLoadingEnable as unknown as EventListener);
    document.addEventListener('setLoadingDisable', setLoadingDisable as unknown as EventListener);
    document.addEventListener('newWBCTScan', newWBCTScan as unknown as EventListener);
    document.addEventListener('updateCategoryState', setCategoryState as unknown as EventListener);
    return () => {
      document.removeEventListener('updateSurfaceParameters', handleUpdateSurfaceParameters as unknown as EventListener);
      document.removeEventListener('themeChange', themeEventListener);
      document.removeEventListener('newPressureScan', newPressureScanListener as unknown as EventListener);
      document.removeEventListener('newRondomImages', newRondomImageListener as unknown as EventListener);
      document.removeEventListener('setLoadingDisable', setLoadingDisable as unknown as EventListener);
      document.removeEventListener('setLoadingEnable', setLoadingEnable as unknown as EventListener);
      document.removeEventListener('newWBCTScan', newWBCTScan as unknown as EventListener);
      document.removeEventListener('updateSandalState', setCategoryState as unknown as EventListener);
    };
  }, []);

  useEffect(() => {
    const onVoiceCamera = (event: Event) => {
      const view = (event as CustomEvent<{ view?: string }>).detail?.view;
      if (!view || !cameraRef.current || !controlsRef.current || !containerRef.current) return;
      setNamedCameraView(view);
    };

    const onVoiceZoom = (event: Event) => {
      const detail = (event as CustomEvent<{ action?: string; amount?: number }>).detail;
      if (!detail?.action) return;
      applyVoiceZoom(detail.action, detail.amount);
    };

    const onVoicePan = (event: Event) => {
      const detail = (event as CustomEvent<{ action?: string; amount?: number }>).detail;
      if (!detail?.action) return;
      applyVoicePan(detail.action, detail.amount);
    };

    const onVoiceGetState = (event: Event) => {
      const resolve = (event as CustomEvent<{ resolve?: (state: unknown) => void }>).detail?.resolve;
      if (!resolve) return;
      const snapshot = (params?: InsoleHighLevelParams | null) =>
        params
          ? {
            heelHeight: params.heelHeight,
            heelDepth: params.heelDepth,
            thickness: params.thickness,
            archMedialHeight: params.archMedialHeight,
            archLateralHeight: params.archLateralHeight,
            archCenterHeight: params.archCenterHeight,
            heelLateralWedge: params.heelLateralWedge,
            heelMedialWedge: params.heelMedialWedge,
            forefootLateralWedge: params.forefootLateralWedge,
            forefootMedialWedge: params.forefootMedialWedge,
            length: params.length,
            width: params.width,
            heelFill: params.heelFill,
            archFill: params.archFill,
            archSagitalPosition: params.archSagitalPosition,
            // Model-specific, so only reported where the app actually shows
            // them. Left out elsewhere rather than sent as zero, so the
            // assistant can say they belong to another model instead of
            // reading out a value that means nothing.
            ...(isSandal.current
              ? {
                outsoleThickness: params.outsoleThickness,
                bandHeight: params.bandHeight,
                // Computed, not settable: the length of the instep curve.
                instepArea: params.instepArea,
              }
              : {}),
            ...(!isSandal.current && thirdQuarter.current
              ? { partialLength: params.partialLength }
              : {}),
          }
          : null;
      const limits: Record<string, { min: number; max: number }> = {};
      const limitFields = [
        "Heel Height", "Heel Depth", "Thickness", "Arch Medial Height", "Arch Lateral Height", "Arch Center Height",
        "Heel Lateral Wedge", "Heel Medial Wedge", "Forefoot Lateral Wedge", "Forefoot Medial Wedge",
        "Length", "Width", "Heel Fill", "Arch Fill", "Arch Sagital Position",
        // getValueFromFieldKey returns null for these outside the sandal, so
        // the guard below leaves them out of the limits with no special case.
        "Outsole Thickness", "Band Height",
      ];
      limitFields.forEach((fieldKey) => {
        const data = getValueFromFieldKey(0, fieldKey);
        if (data && data.min != null && data.max != null) {
          limits[fieldKey] = { min: data.min, max: data.max };
        }
      });
      resolve({
        left: snapshot(insoleHighLevelParamRef.current?.[1]),
        right: snapshot(insoleHighLevelParamRef.current?.[0]),
        limits,
        // The 3/4 tick in Automatic Design, and what it governs. Reported as
        // model state rather than per foot, which is how the panel holds it.
        model: isSandal.current ? "Sandal" : (useDesignStore.getState().insoleDesign?.category ?? "Insole"),
        ...(isSandal.current ? {} : { thirdQuarter: thirdQuarter.current === true }),
      });
    };

    const onVoiceGetParamRange = (event: Event) => {
      const detail = (event as CustomEvent<{
        fieldKey?: string;
        foot?: number;
        resolve?: (range: { min: number; max: number } | null) => void;
      }>).detail;
      const resolve = detail?.resolve;
      if (!resolve) return;
      const fieldKey = detail?.fieldKey;
      const foot = detail?.foot ?? 0;
      if (!fieldKey) {
        resolve(null);
        return;
      }
      const data = getValueFromFieldKey(foot, fieldKey);
      if (!data || data.min == null || data.max == null || !Number.isFinite(data.min) || !Number.isFinite(data.max)) {
        resolve(null);
        return;
      }
      resolve({ min: Number(data.min), max: Number(data.max) });
    };

    const onVoiceClearParamLabels = () => {
      // Kept for compatibility; param changes no longer open CSS2D labels.
    };

    /**
     * Report the exact camera durations for a run of parameter steps without
     * moving. Each step is measured from where the previous one lands, so a
     * multi-step tour is planned as one chain before the voice tool returns.
     */
    const onVoicePlanParamCamera = (event: Event) => {
      const detail = (event as CustomEvent<{
        steps?: { fieldKey: string; foot: number; camera?: { single: string; fill?: number } }[];
        resolve?: (plan: { steps: { focusMs: number }[]; returnMs: number } | null) => void;
      }>).detail;
      const resolve = detail?.resolve;
      if (!resolve) return;

      const steps = detail?.steps ?? [];
      const camera = cameraRef.current;
      const controls = controlsRef.current;
      const container = containerRef.current;
      if (!steps.length || !camera || !controls || !container || !sceneRef.current) {
        resolve(null);
        return;
      }

      sceneRef.current.updateMatrixWorld(true);
      // A tour already in flight leaves from wherever it stands; a new tour
      // leaves from the live view and must come back to it.
      const home = voiceFocusSnapshotRef.current ?? snapshotCameraView();
      if (!home) {
        resolve(null);
        return;
      }

      let fromPos = camera.position.clone();
      let fromTarget = controls.target.clone();
      const planned: { focusMs: number }[] = [];

      for (const step of steps) {
        const points = getParamFocusPoints(step.fieldKey, [step.foot]);
        if (!points.length) {
          planned.push({ focusMs: 1700 });
          continue;
        }
        const focusBox = new THREE.Box3().setFromPoints(points);
        focusBox.expandByScalar(12);
        const center = focusBox.getCenter(new THREE.Vector3());
        const dir = getSphereViewDirection(center, [step.foot], step.camera?.single ?? "heel");
        const fit = fitCameraToSphereBox(camera, container, focusBox, step.camera?.fill ?? 0.6);
        const endPos = center.clone().add(dir.multiplyScalar(fit.distance));

        planned.push({
          focusMs: Math.round(calculateCameraMoveDuration(fromPos, endPos, fromTarget, center) * 1000),
        });
        fromPos = endPos;
        fromTarget = center;
      }

      resolve({
        steps: planned,
        returnMs: Math.round(calculateCameraMoveDuration(fromPos, home.position, fromTarget, home.target) * 1000),
      });
    };

    /**
     * Frame an addition and open its label, for the narration step that explains
     * what a pad's height and hardness are.
     *
     * Built on the same pieces as the parameter focus above — snapshot, move,
     * open the label, hold, put the camera back — rather than pointing a named
     * view at the foot and hoping the pad is in shot.
     */
    const runAdditionFocus = async (job: {
      foot: number;
      index: number;
      fill: number;
      viewHint: string;
      holdMs: number;
      openLabel: boolean;
      keepCamera: boolean;
      onArrived?: () => void;
      done?: () => void;
    }) => {
      if (additionFocusBusyRef.current) {
        job.done?.();
        return;
      }
      additionFocusBusyRef.current = true;
      try {
        // Addition labels, like parameter labels, exist only in live mode.
        await ensureLiveModeForParamLabels();
        const key = `${job.foot}_${job.index}`;
        const deadline = Date.now() + 1500;
        while (Date.now() < deadline && !additionLabelsRef.current.has(key)) {
          await waitMs(60);
        }
        if (!additionLabelsRef.current.has(key)) return;

        // Only the first trip records where home was, so a second trip to the
        // same pad does not adopt the close-up as the place to return to.
        if (!additionFocusHomeRef.current) additionFocusHomeRef.current = snapshotCameraView();
        closeVoiceParamLabel();
        await focusCameraOnAdditionLabel(job.foot, job.index, job.fill, job.viewHint);
        if (job.openLabel) await openVoiceAdditionLabel(job.foot, job.index);
        // Whatever the caller wants demonstrated happens here, while the camera
        // is still on the pad. Timing it from the caller's side raced the hold
        // and the move ended up happening after the camera had gone home.
        job.onArrived?.();
        await waitMs(job.holdMs);
        if (!job.keepCamera) await releaseAdditionFocus();
      } finally {
        additionFocusBusyRef.current = false;
        job.done?.();
      }
    };

    /** End the circle now, wherever it has got to. */
    const onVoiceOrbitStop = () => {
      orbitTokenRef.current += 1;
    };

    /**
     * Claim or release the camera for the narration.
     *
     * Held across a model change, where the viewer would otherwise re-frame
     * itself the moment the rebuild lands and throw the picture to a new angle.
     */
    const onVoiceCameraHold = (event: Event) => {
      const detail = (event as CustomEvent<{ hold?: boolean }>).detail;
      voiceCameraHeldRef.current = detail?.hold !== false;
    };

    const onVoiceOrbit = (event: Event) => {
      const detail = (event as CustomEvent<{
        degrees?: number;
        durationMs?: number;
        fill?: number;
        enterMs?: number;
        reframe?: boolean;
        tiltDegrees?: number;
        onStart?: () => void;
        settleMs?: number;
        done?: () => void;
      }>).detail;
      void (async () => {
        // Claimed before anything changes, so the viewer's own reaction to that
        // change does not move the camera first.
        voiceCameraBusyRef.current = true;
        // Anything the caller wants changed for this shot — hiding a foot, say —
        // happens here, so the change and the camera move begin together. Doing
        // it before the request left a visible pause between the two.
        detail?.onStart?.();
        // Long enough for that change to reach the scene graph, since the circle
        // measures what is visible the moment it starts, and no longer than a
        // couple of frames so the two still read as one movement.
        await waitMs(Math.max(0, detail?.settleMs ?? 120));
        await orbitCameraAroundScene(
          detail?.degrees ?? 360,
          Math.max(0.5, (detail?.durationMs ?? 6000) / 1000),
          detail?.fill ?? 0.5,
          Math.max(0.3, (detail?.enterMs ?? 1200) / 1000),
          detail?.reframe !== false,
          detail?.tiltDegrees ?? 0
        );
        voiceCameraBusyRef.current = false;
        detail?.done?.();
      })();
    };

    /** Close the pad's label and take the camera back where it came from. */
    const releaseAdditionFocus = async (keepCamera = false): Promise<void> => {
      closeVoiceParamLabel();
      const home = additionFocusHomeRef.current;
      additionFocusHomeRef.current = null;
      // With keepCamera the caller has its own move to make, and restoring here
      // first would send the picture to one position and then to another.
      if (home && !keepCamera) await restoreCameraView(home);
    };

    const onVoiceReleaseFocus = (event: Event) => {
      const detail = (event as CustomEvent<{ keepCamera?: boolean; done?: () => void }>).detail;
      void releaseAdditionFocus(detail?.keepCamera === true).then(() => detail?.done?.());
    };

    const onVoiceAdditionFocus = (event: Event) => {
      const detail = (event as CustomEvent<{
        foot?: number;
        index?: number;
        fill?: number;
        viewHint?: string;
        holdMs?: number;
        openLabel?: boolean;
        keepCamera?: boolean;
        onArrived?: () => void;
        done?: () => void;
      }>).detail;
      void runAdditionFocus({
        foot: detail?.foot ?? 0,
        index: detail?.index ?? 0,
        fill: detail?.fill ?? 0.45,
        viewHint: detail?.viewHint || "top",
        holdMs: Math.max(400, detail?.holdMs ?? 3500),
        openLabel: detail?.openLabel !== false,
        keepCamera: detail?.keepCamera === true,
        onArrived: detail?.onArrived,
        done: detail?.done,
      });
    };

    const onVoiceParamFocus = (event: Event) => {
      const detail = (event as CustomEvent<{
        fieldKey?: string;
        feet?: number[];
        updates?: { fieldKey: string; foot: number; value: number; single?: boolean }[];
        camera?: { single: string; both?: string; fill?: number; zoom?: number };
        line?: string;
        silent?: boolean;
        expectFollowUp?: boolean;
        focusMs?: number;
        returnMs?: number;
        speechMs?: number;
        startsTurn?: boolean;
        done?: () => void;
      }>).detail;

      voiceFocusQueueRef.current.push({
        fieldKey: detail?.fieldKey || "Heel Height",
        feet: detail?.feet?.length ? detail.feet : [0],
        updates: detail?.updates || [],
        camera: detail?.camera || { single: "heel", fill: 0.6 },
        line: detail?.line || "",
        silent: Boolean(detail?.silent),
        expectFollowUp: Boolean(detail?.expectFollowUp),
        focusMs: Math.max(300, detail?.focusMs ?? 1700),
        returnMs: Math.max(300, detail?.returnMs ?? 1700),
        speechMs: Math.max(0, detail?.speechMs ?? 0),
        startsTurn: detail?.startsTurn === true,
        done: detail?.done,
      });
      void processVoiceFocusQueue();
    };

    const applyStepUpdates = (
      updates: { fieldKey: string; foot: number; value: number; single?: boolean }[]
    ): Promise<void> => {
      if (!updates.length) return Promise.resolve();
      return new Promise<void>((resolve) => {
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve();
        };
        const timer = window.setTimeout(finish, 8000);
        document.dispatchEvent(
          new CustomEvent("updateSurfaceParameters", { detail: { updates, onComplete: finish } })
        );
        document.dispatchEvent(new CustomEvent("updateClippingBounds"));
      });
    };

    const processVoiceFocusQueue = async () => {
      if (voiceFocusProcessingRef.current) return;
      voiceFocusProcessingRef.current = true;

      await ensureLiveModeForParamLabels();

      if (!voiceFocusSnapshotRef.current) {
        voiceFocusSnapshotRef.current = snapshotCameraView();
      }

      let stepIndex = 0;
      let lastReturnMs = 0;
      let lastStepEndedAt = 0;
      // First audible word of the turn the current steps belong to, and how much
      // of that turn has been spoken by the end of the steps already run.
      let turnStartedAt = 0;
      let spokenThroughMs = 0;

      const runJob = async (job: (typeof voiceFocusQueueRef.current)[number]) => {
        const foot = job.feet[0] ?? 0;
        const fieldKey = job.fieldKey;
        // On the last step the closing sentence also covers the ride home, so
        // that much of the line is spoken after this step ends.
        const returnAllowanceMs = job.expectFollowUp ? 0 : job.returnMs;

        // Every move starts on an audible TTS frame, so speech and camera share
        // one start time regardless of network latency.
        if (job.silent) {
          // Nothing is spoken, so the viewer owns the gap itself.
          if (stepIndex > 0) await waitMs(VOICE_PARAM_GAP_MS - (Date.now() - lastStepEndedAt));
        } else if (job.startsTurn) {
          if (stepIndex === 0) {
            await waitUntilAgentSpeaking(VOICE_SPEAK_START_TIMEOUT_MS);
          } else {
            // A later tool call in the same request answers in a turn of its own,
            // so sit out the tail of the last sentence and leave on the new word.
            await waitUntilAgentQuiet();
            await waitUntilAgentAudible(VOICE_STEP_SPEAK_START_TIMEOUT_MS);
          }
          turnStartedAt = Date.now();
          spokenThroughMs = 0;
        }
        // Otherwise this step's sentence follows the previous one inside the same
        // utterance, so the camera moves on without waiting for anything.

        const startedAt = Date.now();
        spokenThroughMs += job.speechMs;
        // Time the step against the turn's first word rather than its own start:
        // a slow move or rebuild would otherwise push every later step further
        // behind the words, since the utterance runs on regardless.
        const endsSpeechAt = turnStartedAt + spokenThroughMs - returnAllowanceMs;
        // A move cannot be cut short, and a silent step has no sentence to follow,
        // so it falls back to the fixed hold.
        const floorAt =
          startedAt + job.focusMs + VOICE_PARAM_APPLY_MS + (job.speechMs > 0 ? 0 : VOICE_PARAM_HOLD_MS);
        const endAt = job.speechMs > 0 ? Math.max(endsSpeechAt, floorAt) : floorAt;
        const plannedMs = endAt - startedAt + returnAllowanceMs;

        emitParamStepStart({ fieldKey, foot, stepIndex, startedAt, plannedMs, line: job.line });

        // The previous parameter's label closes as this move begins, so it stays
        // open for the whole silence before it.
        closeVoiceParamLabel();
        await focusCameraOnParam(fieldKey, [foot], job.camera, job.focusMs / 1000);

        // The label opens only here: the camera has stopped and the new value is
        // in, so it is fitted to the view it will actually sit in, and it does
        // not flash open then collapse when the value rebuilds it.
        const outgoingLabel = paramLabel(paramLabelKey(fieldKey, foot));
        await applyStepUpdates(job.updates.filter((u) => u.foot === foot));
        await openVoiceParamLabel(fieldKey, foot, outgoingLabel);

        // Pad to the planned step length rather than sleeping a fixed dwell on
        // top of it. Whatever ran long eats into the dwell instead of pushing
        // the step past the sentence written for it. The next step closes this
        // label as soon as we return, so never leave it open for less than the
        // hold: the first parameter's camera+apply often consume the whole
        // sentence, which used to skip the label entirely.
        await waitMs(Math.max(endAt, Date.now() + VOICE_PARAM_HOLD_MS) - Date.now());

        emitParamStepEnd({
          fieldKey,
          foot,
          stepIndex,
          startedAt,
          endedAt: Date.now(),
          plannedMs,
          line: job.line,
        });
        job.done?.();
        lastReturnMs = job.returnMs;
        lastStepEndedAt = Date.now();
        stepIndex += 1;
      };

      while (voiceFocusQueueRef.current.length > 0) {
        const job = voiceFocusQueueRef.current.shift()!;
        await runJob(job);

        // Wait for the next step: announced follow-ups get the long window,
        // everything else only a short grace before the camera goes home.
        const hasNext =
          voiceFocusQueueRef.current.length > 0 ||
          (await waitForQueueItems(
            () => voiceFocusQueueRef.current.length === 0,
            job.expectFollowUp ? VOICE_FOLLOWUP_WAIT_MS : VOICE_TAIL_WAIT_MS
          ));
        if (!hasNext) break;
      }

      // The last label closes as the camera leaves for home.
      closeVoiceParamLabel();

      const snapshot = voiceFocusSnapshotRef.current;
      voiceFocusSnapshotRef.current = null;
      if (snapshot) {
        await restoreCameraView(snapshot, lastReturnMs > 0 ? lastReturnMs / 1000 : undefined);
      }

      voiceFocusProcessingRef.current = false;
      if (voiceFocusQueueRef.current.length > 0) {
        void processVoiceFocusQueue();
      }
    };

    document.addEventListener('voice:camera', onVoiceCamera);
    document.addEventListener('voice:zoom', onVoiceZoom);
    document.addEventListener('voice:pan', onVoicePan);
    document.addEventListener('voice:getInsoleState', onVoiceGetState);
    document.addEventListener('voice:getParamRange', onVoiceGetParamRange);
    document.addEventListener('voice:clearParamLabels', onVoiceClearParamLabels);
    document.addEventListener('voice:focusParam', onVoiceParamFocus as EventListener);
    document.addEventListener('voice:focusAddition', onVoiceAdditionFocus as EventListener);
    document.addEventListener('voice:orbit', onVoiceOrbit as EventListener);
    document.addEventListener('voice:orbitStop', onVoiceOrbitStop as EventListener);
    document.addEventListener('voice:cameraHold', onVoiceCameraHold as EventListener);
    document.addEventListener('voice:releaseFocus', onVoiceReleaseFocus as EventListener);
    document.addEventListener('voice:planParamCamera', onVoicePlanParamCamera as EventListener);
    return () => {
      document.removeEventListener('voice:camera', onVoiceCamera);
      document.removeEventListener('voice:zoom', onVoiceZoom);
      document.removeEventListener('voice:pan', onVoicePan);
      document.removeEventListener('voice:getInsoleState', onVoiceGetState);
      document.removeEventListener('voice:getParamRange', onVoiceGetParamRange);
      document.removeEventListener('voice:clearParamLabels', onVoiceClearParamLabels);
      document.removeEventListener('voice:focusParam', onVoiceParamFocus as EventListener);
      document.removeEventListener('voice:focusAddition', onVoiceAdditionFocus as EventListener);
      document.removeEventListener('voice:orbit', onVoiceOrbit as EventListener);
      document.removeEventListener('voice:orbitStop', onVoiceOrbitStop as EventListener);
      document.removeEventListener('voice:cameraHold', onVoiceCameraHold as EventListener);
      document.removeEventListener('voice:releaseFocus', onVoiceReleaseFocus as EventListener);
      document.removeEventListener('voice:planParamCamera', onVoicePlanParamCamera as EventListener);
    };
  }, []);

  const initRondomPressureImages = async (rondomImagesSrc: (PressureImage | undefined)[], loadPressureAlignment: boolean) => {
    textureOffsetsRef.current = [];
    const defaultOffsets1: TextureOffsets = { rotationAngle: 0, uOffset: 0, vOffset: 0 };
    const defaultOffsets2: TextureOffsets = { rotationAngle: 0, uOffset: 0, vOffset: 0 };

    // let rightImageData = await srcToImageData(rondomImagesSrc[0]);
    // let leftImageData = await srcToImageData(rondomImagesSrc[1]);

    // const rightPressureImage: PressureImage = {
    //   image: rightImageData,
    //   realHeight: rightImageData.height / 4,
    //   realWidth: rightImageData.width / 4
    // };

    // const leftPressureImage: PressureImage = {
    //   image: leftImageData,
    //   realHeight: leftImageData.height / 4,
    //   realWidth: leftImageData.width / 4
    // };

    pressureImageDataRef.current.push(rondomImagesSrc[0]);
    pressureImageDataRef.current.push(rondomImagesSrc[1]);
    textureOffsetsRef.current.push(defaultOffsets1);
    textureOffsetsRef.current.push(defaultOffsets2);

    resetTextureAlignmentPoints();
    if (loadPressureAlignment) {
      loadStoredPressureAlignment();
    }

    if (pressureImageDataRef.current[0]) {
      updateInsoleTexture(0, pressureImageDataRef.current[0], outputMeshRef.current[0]);
      updateInsoleTexture(0, pressureImageDataRef.current[0], LiftedMeshRef.current[0]);
    }
    if (pressureImageDataRef.current[1]) {
      updateInsoleTexture(1, pressureImageDataRef.current[1], outputMeshRef.current[1]);
      updateInsoleTexture(1, pressureImageDataRef.current[1], LiftedMeshRef.current[1]);
    }
  }

  const getAutoDesignValues = (foot: number, template: THREE.BufferGeometry, heelDepthY: number) => {
    const insoleVertices = template.attributes.position.array;
    var surfaceJoints = meshConfigs['Insole'].joints.surface;

    let thicknessjoint = surfaceJoints.thickness;
    let thicknessjointCenter = new THREE.Vector3(insoleVertices[thicknessjoint.centerId * 3], insoleVertices[thicknessjoint.centerId * 3 + 1], insoleVertices[thicknessjoint.centerId * 3 + 2]);

    let heelHeight = surfaceJoints.heelHeight;
    let heelHeightCenter = new THREE.Vector3(insoleVertices[heelHeight.centerId * 3], insoleVertices[heelHeight.centerId * 3 + 1], insoleVertices[heelHeight.centerId * 3 + 2]);
    let heelHeightValue = Math.round((heelHeightCenter.y - thicknessjointCenter.y) * heelHeight.bval + heelHeight.cval);
    insoleHighLevelParamRef.current[foot].heelHeight = heelHeightValue;

    let heelDepth = surfaceJoints.heelDepth;
    let heelDepthCenter = new THREE.Vector3(insoleVertices[heelDepth.centerId * 3], insoleVertices[heelDepth.centerId * 3 + 1], insoleVertices[heelDepth.centerId * 3 + 2]);
    let heelDepthValue = Math.round((heelDepthY - heelHeightCenter.y) * heelDepth.bval + heelDepth.cval);
    insoleHighLevelParamRef.current[foot].heelDepth = heelDepthValue;

    let heelMedialWedgeId = surfaceJoints.heelMedialWedge.centerId;
    let heelMedialWedgeCenter = new THREE.Vector3(insoleVertices[heelMedialWedgeId * 3], insoleVertices[heelMedialWedgeId * 3 + 1], insoleVertices[heelMedialWedgeId * 3 + 2]);
    let heelMedialWedgeValue = Math.round(Math.atan((heelMedialWedgeCenter.y - heelDepthY) /
      Math.abs(heelMedialWedgeCenter.x - heelDepthCenter.x)) * 180 / Math.PI);
    insoleHighLevelParamRef.current[foot].heelMedialWedge = heelMedialWedgeValue;

    let thicknessToHeelHeight = thicknessjointCenter.clone().sub(heelHeightCenter);

    let archMedialHeightId = surfaceJoints.archMedialHeight.centerId;
    let archMedialHeightCenter = new THREE.Vector3(insoleVertices[archMedialHeightId * 3], insoleVertices[archMedialHeightId * 3 + 1], insoleVertices[archMedialHeightId * 3 + 2]);
    let archYBase = Math.abs((archMedialHeightCenter.z - thicknessjointCenter.z) / thicknessToHeelHeight.z)
      * (heelHeightCenter.y - thicknessjointCenter.y) + thicknessjointCenter.y;

    let archMedialHeightValue = Math.round((archMedialHeightCenter.y - archYBase) * surfaceJoints.archMedialHeight.bval + surfaceJoints.archMedialHeight.cval);
    insoleHighLevelParamRef.current[foot].archMedialHeight = archMedialHeightValue;

    let archWallHeightM1 = (insoleVertices[ArchWallMedial.topId * 3 + 1]);
    let archWallDisM1 = Math.abs(insoleVertices[ArchWallMedial.topId * 3] - insoleVertices[ArchWallMedial.bottomId * 3]);

    let archFill = Math.round(
      ((Math.tan(ArchWallMedial.maxAngle * Math.PI / 180.0) - Math.tan(ArchWallMedial.minAngle * Math.PI / 180.0))
        - ((archWallDisM1 / archWallHeightM1) - Math.tan(ArchWallMedial.minAngle * Math.PI / 180.0))) * 100 /
      (Math.tan(ArchWallMedial.maxAngle * Math.PI / 180.0) - Math.tan(ArchWallMedial.minAngle * Math.PI / 180.0))
    );
    insoleHighLevelParamRef.current[foot].archFill = archFill;

    let heelWallHeight4 = (insoleVertices[HeelMedialToLateral4.topId * 3 + 1]);
    let heelWallDis4 = Math.abs(Math.sqrt(Math.pow(insoleVertices[HeelMedialToLateral4.topId * 3] - insoleVertices[HeelMedialToLateral4.bottomId * 3], 2) + Math.pow(insoleVertices[HeelMedialToLateral4.topId * 3 + 2] - insoleVertices[HeelMedialToLateral4.bottomId * 3 + 2], 2)));

    let heelFill = Math.round(
      ((Math.tan(HeelMedialToLateral4.maxAngle * Math.PI / 180.0) - Math.tan(HeelMedialToLateral4.minAngle * Math.PI / 180.0))
        - ((heelWallDis4 / heelWallHeight4) - Math.tan(HeelMedialToLateral4.minAngle * Math.PI / 180.0))) * 100 /
      (Math.tan(HeelMedialToLateral4.maxAngle * Math.PI / 180.0) - Math.tan(HeelMedialToLateral4.minAngle * Math.PI / 180.0))
    );
    insoleHighLevelParamRef.current[foot].heelFill = heelFill;
  };

  const getHighLevelForefootPoints = (foot: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current === null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');
    const jointList = surfaceJointsArray.current[foot];
    const lateralJoint = jointList['forefootLateralWedge'];
    const medialJoint = jointList['forefootMedialWedge'];
    const thicknessJoint = jointList['thickness'];
    if (!thicknessJoint || !medialJoint || !lateralJoint) return;
    const dxm = Math.abs(thicknessJoint.center.x - medialJoint.center.x);
    const dxl = Math.abs(lateralJoint.center.x - thicknessJoint.center.x);
    const thicknessY = (thicknessJoint.center.y - thicknessJoint.cval) / thicknessJoint.bval;

    const medialNextY = (insoleHighLevelParamRef.current[foot].forefootWedgeType != 'Lateral') ?
      thicknessY + (Math.tan(insoleHighLevelParamRef.current[foot].forefootMedialWedge * Math.PI / 180.0) * dxm) :
      thicknessY - (Math.tan(insoleHighLevelParamRef.current[foot].forefootLateralWedge * Math.PI / 180.0) * dxm);

    const lateralNextY = (insoleHighLevelParamRef.current[foot].forefootWedgeType != 'Medial') ?
      thicknessY + (Math.tan(insoleHighLevelParamRef.current[foot].forefootLateralWedge * Math.PI / 180.0) * dxl) :
      thicknessY - (Math.tan(insoleHighLevelParamRef.current[foot].forefootMedialWedge * Math.PI / 180.0) * dxl);

    medialJoint.center.y = (medialNextY >= 2) ? medialNextY : 2;
    lateralJoint.center.y = (lateralNextY >= 2) ? lateralNextY : 2;

    const displacementM = medialJoint.center.y - insoleVertices.getY(medialJoint.centerId);
    const displacementL = lateralJoint.center.y - insoleVertices.getY(lateralJoint.centerId);

    medialJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementM * weight);
      });
    });

    lateralJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementL * weight);
      });
    });
  }

  const getHighLevelHeelPoints = (foot: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current === null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');
    const jointList = surfaceJointsArray.current[foot];
    const lateralJoint = jointList['heelLateralWedge'];
    const medialJoint = jointList['heelMedialWedge'];
    const centerJoint = jointList['heelDepth'];

    const dx = Math.abs(lateralJoint.center.x - medialJoint.center.x);

    const medialNextYChange = (insoleHighLevelParamRef.current[foot].heelWedgeType != 'Lateral') ?
      (Math.tan(insoleHighLevelParamRef.current[foot].heelMedialWedge * Math.PI / 180.0) * dx / 2) :
      (Math.tan(insoleHighLevelParamRef.current[foot].heelLateralWedge * Math.PI / 180.0) * dx / 2) * -1;

    const lateralNextYChange = (insoleHighLevelParamRef.current[foot].heelWedgeType != 'Medial') ?
      (Math.tan(insoleHighLevelParamRef.current[foot].heelLateralWedge * Math.PI / 180.0) * dx / 2) :
      (Math.tan(insoleHighLevelParamRef.current[foot].heelMedialWedge * Math.PI / 180.0) * dx / 2) * -1;

    medialJoint.center.y = centerJoint.center.y + medialNextYChange;
    lateralJoint.center.y = centerJoint.center.y + lateralNextYChange;

    const displacementM = medialJoint.center.y - insoleVertices.getY(medialJoint.centerId);
    const displacementL = lateralJoint.center.y - insoleVertices.getY(lateralJoint.centerId);

    lateralJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementL * weight);
      });
    });
    medialJoint?.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacementM * weight);
      });
    });
  };

  const getHighLevelArchPoints = (foot: number, jointName: keyof MeshJoints["surface"], value: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current === null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');

    const archJoint = surfaceJointsArray.current[foot][jointName];
    if (!archJoint) return;

    let heelHeight = surfaceJointsArray.current[foot]['heelHeight'];
    let thicknessjoint = surfaceJointsArray.current[foot]['thickness'];
    let thicknessToHeelHeight = thicknessjoint.center.clone().sub(heelHeight.center);

    let archMedialHeight = surfaceJointsArray.current[foot]['archMedialHeight'];
    let archYBase = Math.abs((archMedialHeight.center.z - thicknessjoint.center.z) / thicknessToHeelHeight.z) * (heelHeight.center.y - thicknessjoint.center.y) + thicknessjoint.center.y;

    archJoint.center.y = (value - archJoint.cval) / archJoint.bval + archYBase;
    const displacement = archJoint.center.y - insoleVertices.getY(archJoint.centerId);

    archJoint.vertices.forEach((vertexGroup: any) => {
      vertexGroup.ids.forEach((vertexId: number) => {
        const weight = vertexGroup.weight;
        insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
      });
    });
  }

  const handleArchFill = (foot: number, value: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current == null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');
    // insoleHighLevelParamRef.current[foot].archFill = value;

    archWallJoints.forEach((wallJoints) => {
      let minAngle = wallJoints.minAngle * Math.PI / 180.0;
      let maxAngle = wallJoints.maxAngle * Math.PI / 180.0;
      let archRatio = Math.tan(minAngle) + ((Math.tan(maxAngle) - Math.tan(minAngle)) * (1 - (value / 100)));

      let tVector = new THREE.Vector3(insoleVertices.getX(wallJoints.topId), 0, insoleVertices.getZ(wallJoints.topId));
      let bVector = new THREE.Vector3(insoleVertices.getX(wallJoints.bottomId), 0, insoleVertices.getZ(wallJoints.bottomId));
      let initDistance = bVector.clone().sub(tVector);
      let cVector = new THREE.Vector3(insoleVertices.getX(wallJoints.centerId), 0, insoleVertices.getZ(wallJoints.centerId));
      let bInitDistance = cVector.clone().sub(bVector);

      if ((foot == 0 && wallJoints.side === 'Lateral') || (foot == 1 && wallJoints.side === 'Medial')) archRatio *= -1;
      // let medialNewXPos = insoleVertices.getX(wallJoints.topId) - (medialRatio * Math.abs(insoleVertices.getY(wallJoints.topId)));
      let newXPos = insoleVertices.getX(wallJoints.topId) - (archRatio * (insoleVertices.getY(wallJoints.topId)));
      let displacement = newXPos - insoleVertices.getX(wallJoints.bottomId);

      wallJoints.wallVerticesIds.forEach((vertexId) => {
        // let ratio = (insoleVertices.getY(wallJoints.topId) - insoleVertices.getY(vertexId)) / insoleVertices.getY(wallJoints.topId);
        let vVector = new THREE.Vector3(insoleVertices.getX(vertexId), 0, insoleVertices.getZ(vertexId));
        if (wallJoints.topId !== vertexId) {
          let topToVertex = vVector.clone().sub(tVector);
          let ratio = topToVertex.length() / initDistance.length();
          insoleVertices.setX(vertexId, insoleVertices.getX(vertexId) + displacement * ratio);
        }
      });

      wallJoints.relatedVerticesIds.forEach((vertexId) => {
        let vertexVector = new THREE.Vector3(insoleVertices.getX(vertexId), 0, insoleVertices.getZ(vertexId));
        let vertexToCenter = cVector.clone().sub(vertexVector);
        let bottomWeight = vertexToCenter.length() / bInitDistance.length();
        insoleVertices.setX(vertexId, insoleVertices.getX(vertexId) + displacement * bottomWeight);
      });
    });

  }

  const handleHeelFill = (foot: number, value: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current == null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');

    heelWallJoints.forEach((wallJoints) => {
      // let angleRatio = Math.tan((wallJoints.minAngle + (wallJoints.maxAngle - wallJoints.minAngle)) * Math.PI / 180.0) * (1 - (value / 100));
      let minAngle = wallJoints.minAngle * Math.PI / 180.0;
      let maxAngle = wallJoints.maxAngle * Math.PI / 180.0;
      let angleRatio = Math.tan(minAngle) + ((Math.tan(maxAngle) - Math.tan(minAngle)) * (1 - (value / 100)));

      let tVector = new THREE.Vector3(insoleVertices.getX(wallJoints.topId), 0, insoleVertices.getZ(wallJoints.topId));
      let bVector = new THREE.Vector3(insoleVertices.getX(wallJoints.bottomId), 0, insoleVertices.getZ(wallJoints.bottomId));
      let initDistance = bVector.clone().sub(tVector);
      let cVector = new THREE.Vector3(insoleVertices.getX(wallJoints.centerId), 0, insoleVertices.getZ(wallJoints.centerId));
      let bInitDistance = cVector.clone().sub(bVector);



      // let height = Math.abs(insoleVertices.getY(wallJoints.topId));
      let height = (insoleVertices.getY(wallJoints.topId));
      let initDis = initDistance.length();
      // let initVal = Math.round(((wallJoints.maxAngle - wallJoints.minAngle) - ((Math.atan(initDis / height) * 180 / Math.PI) - wallJoints.minAngle)) * 100 / (wallJoints.maxAngle - wallJoints.minAngle));
      // let angleRatioPre = Math.tan((wallJoints.minAngle + (wallJoints.maxAngle - wallJoints.minAngle) * (1 - (initVal / 100))) * Math.PI / 180.0);
      let initVal = Math.round(((Math.tan(maxAngle) - Math.tan(minAngle)) - ((initDis / height) - Math.tan(minAngle))) * 100 / (Math.tan(maxAngle) - Math.tan(minAngle)));
      let angleRatioPre = Math.tan(minAngle) + ((Math.tan(maxAngle) - Math.tan(minAngle)) * (1 - (initVal / 100)));
      // let angleRatioPre = (initDis / height);

      // console.log(`The vertex Dis ${initDis} Height ${height}`);

      let displaceVector = cVector.clone().sub(tVector).normalize();

      let placeAfter = (angleRatio * insoleVertices.getY(wallJoints.topId));
      let placeBefore = (angleRatioPre * insoleVertices.getY(wallJoints.topId));
      let displacement = (placeAfter - placeBefore);

      wallJoints.wallVerticesIds.forEach((vertexId) => {
        // let ratio = (insoleVertices.getY(wallJoints.topId) - insoleVertices.getY(vertexId)) / insoleVertices.getY(wallJoints.topId);
        // console.log(`Displacement: ${displacement}, Wall Ratio: ${ratio}, normalVectorX: ${displaceVector.x}, normalVectorZ: ${displaceVector.z}, topHeight${insoleVertices.getY(wallJoints.topId)}, vertextHeight ${insoleVertices.getY(vertexId)}`);
        let vVector = new THREE.Vector3(insoleVertices.getX(vertexId), 0, insoleVertices.getZ(vertexId));
        if (vertexId != wallJoints.topId) {
          let topToVertex = vVector.clone().sub(tVector);
          let ratio = topToVertex.length() / initDis;
          insoleVertices.setX(vertexId, insoleVertices.getX(vertexId) + displaceVector.x * displacement * ratio);
          insoleVertices.setZ(vertexId, insoleVertices.getZ(vertexId) + displaceVector.z * displacement * ratio);
        }
      });

      wallJoints.relatedVerticesIds.forEach((vertexId) => {
        let vertexVector = new THREE.Vector3(insoleVertices.getX(vertexId), 0, insoleVertices.getZ(vertexId));
        let vertexToCenter = cVector.clone().sub(vertexVector);
        let bottomWeight = vertexToCenter.length() / bInitDistance.length();
        insoleVertices.setX(vertexId, insoleVertices.getX(vertexId) + displaceVector.x * displacement * bottomWeight);
        insoleVertices.setZ(vertexId, insoleVertices.getZ(vertexId) + displaceVector.z * displacement * bottomWeight);
      });


    });

    // insoleHighLevelParamRef.current[foot].heelFill = value;
  }

  const handleArchHeelFill = (foot: number, archValue: number, heelValue: number) => {
    if (originalGeometryRef == null || originalGeometryRef.current == null) return;
    const insoleVertices = originalGeometryRef.current[foot].getAttribute('position');

    archHeelWallJoints.forEach((wallJoints) => {
      // let angleRatio = Math.tan((wallJoints.minAngle + (wallJoints.maxAngle - wallJoints.minAngle)) * Math.PI / 180.0) * (1 - (value / 100));
      let minAngle = wallJoints.minAngle * Math.PI / 180.0;
      let maxAngle = wallJoints.maxAngle * Math.PI / 180.0;
      let value = wallJoints.heelWeight * heelValue + wallJoints.archWeight * archValue;
      let angleRatio = Math.tan(minAngle) + ((Math.tan(maxAngle) - Math.tan(minAngle)) * (1 - (value / 100)));

      let tVector = new THREE.Vector3(insoleVertices.getX(wallJoints.topId), 0, insoleVertices.getZ(wallJoints.topId));
      let bVector = new THREE.Vector3(insoleVertices.getX(wallJoints.bottomId), 0, insoleVertices.getZ(wallJoints.bottomId));
      let initDistance = bVector.clone().sub(tVector);
      let cVector = new THREE.Vector3(insoleVertices.getX(wallJoints.centerId), 0, insoleVertices.getZ(wallJoints.centerId));
      let bInitDistance = cVector.clone().sub(bVector);


      if ((foot == 0 && wallJoints.side === 'Lateral') || (foot == 1 && wallJoints.side === 'Medial')) angleRatio *= -1;
      // let newXPos = insoleVertices.getX(wallJoints.topId) - (angleRatio * Math.abs(insoleVertices.getY(wallJoints.topId)));
      let newXPos = insoleVertices.getX(wallJoints.topId) - (angleRatio * (insoleVertices.getY(wallJoints.topId)));
      let displacement = newXPos - insoleVertices.getX(wallJoints.bottomId);

      wallJoints.wallVerticesIds.forEach((vertexId) => {
        // let ratio = (insoleVertices.getY(wallJoints.topId) - insoleVertices.getY(vertexId)) / insoleVertices.getY(wallJoints.topId);
        let vVector = new THREE.Vector3(insoleVertices.getX(vertexId), 0, insoleVertices.getZ(vertexId));
        if (vertexId != wallJoints.topId) {
          let topToVertex = vVector.clone().sub(tVector);
          let ratio = topToVertex.length() / initDistance.length();
          insoleVertices.setX(vertexId, insoleVertices.getX(vertexId) + displacement * ratio);
        }
      });
      wallJoints.relatedVerticesIds.forEach((vertexId) => {
        let vertexVector = new THREE.Vector3(insoleVertices.getX(vertexId), 0, insoleVertices.getZ(vertexId));
        let vertexToCenter = cVector.clone().sub(vertexVector);
        let bottomWeight = vertexToCenter.length() / bInitDistance.length();
        insoleVertices.setX(vertexId, insoleVertices.getX(vertexId) + displacement * bottomWeight);
      });


    });

  }

  // Initialize the scene
  useEffect(() => {
    if (!containerRef.current || isInitializedRef.current) return;

    // Scene setup
    const scene = new THREE.Scene();
    // Set initial background color 
    scene.background = new THREE.Color(0xf1f0f0); // Light gray background   
    sceneRef.current = scene;

    // Camera setup
    const aspect = containerRef.current.clientWidth / containerRef.current.clientHeight;
    // Perspective camera
    const perspectiveCamera = new THREE.PerspectiveCamera(
      60,
      aspect,
      0.1,
      2000
    );
    perspectiveCamera.position.z = 5;
    perspectiveCameraRef.current = perspectiveCamera;

    // Orthographic camera
    const d = 10;
    const orthoCamera = new THREE.OrthographicCamera(
      -d * aspect, d * aspect, // left, right
      d, -d,                   // top, bottom
      0.1, 2000                // near, far
    );
    orthoCamera.position.z = 5;
    orthoCamera.updateProjectionMatrix();
    orthographicCameraRef.current = orthoCamera;

    // Set initial camera
    cameraRef.current = useViewerStore.getState().perspectiveCamera ? perspectiveCameraRef.current : orthographicCameraRef.current;

    // Renderer setup with error handling
    let renderer: THREE.WebGLRenderer | null = null;
    try {
      // Try to create WebGL2 renderer first
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        powerPreference: 'high-performance',
        failIfMajorPerformanceCaveat: false,
        precision: 'mediump',
        stencil: false,
        depth: true,
        alpha: false
      });

      // Check if the renderer was created successfully
      if (!renderer || !renderer.getContext()) {
        throw new Error('WebGL context creation failed');
      }
    } catch (error) {
      console.error('Error creating WebGL renderer:', error);

      // Try to create a fallback renderer with WebGL1
      try {
        console.log('Attempting to create fallback WebGL1 renderer');
        renderer = new THREE.WebGLRenderer({
          antialias: true,
          powerPreference: 'high-performance',
          failIfMajorPerformanceCaveat: false,
          precision: 'mediump',
          stencil: false,
          depth: true,
          alpha: false,
          context: undefined // Let it try to create a WebGL1 context
        });

        if (!renderer || !renderer.getContext()) {
          throw new Error('Fallback WebGL context creation failed');
        }

        console.log('Fallback WebGL1 renderer created successfully');
      } catch (fallbackError) {
        console.error('Error creating fallback WebGL renderer:', fallbackError);

        // Create a dummy renderer to prevent errors
        renderer = {
          domElement: document.createElement('canvas'),
          render: () => { },
          setSize: () => { },
          setClearColor: () => { },
          dispose: () => { },
          getContext: () => null,
          getContextAttributes: () => ({}),
          getPixelRatio: () => 1,
          setPixelRatio: () => { },
          getSize: () => ({ width: 0, height: 0 }),
          setAnimationLoop: () => { },
          clear: () => { },
          state: { reset: () => { } },
          info: { reset: () => { } },
          shadowMap: { enabled: false, type: 0 },
          outputColorSpace: THREE.SRGBColorSpace,
          toneMapping: THREE.NoToneMapping,
          toneMappingExposure: 1
        } as unknown as THREE.WebGLRenderer;

        console.log('Created dummy renderer to prevent errors');
      }
    }

    // Set up the renderer
    if (renderer) {
      renderer.setSize(containerRef.current.clientWidth, containerRef.current.clientHeight);
      renderer.outputColorSpace = THREE.SRGBColorSpace;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      renderer.sortObjects = true;

      // Set pixel ratio for better quality
      renderer.setPixelRatio(window.devicePixelRatio);

      containerRef.current.appendChild(renderer.domElement);
      rendererRef.current = renderer;
    }

    labelRenderer.setSize(window.innerWidth, window.innerHeight);
    labelRenderer.domElement.style.position = 'absolute';
    labelRenderer.domElement.style.top = '0px';
    labelRenderer.domElement.style.left = '0px';
    labelRenderer.domElement.style.pointerEvents = 'none';
    labelRenderer.domElement.style.overflow = 'hidden';
    labelRenderer.domElement.style.width = '100%';
    labelRenderer.domElement.style.height = '100%';
    labelRenderer.domElement.style.transform = 'translateZ(0)';
    if (containerRef.current) {
      containerRef.current.appendChild(labelRenderer.domElement);
    }

    standRenderer.setSize(window.innerWidth, window.innerHeight);
    standRenderer.domElement.style.position = 'absolute';
    standRenderer.domElement.style.top = '0px';
    standRenderer.domElement.style.left = '0px';
    standRenderer.domElement.style.pointerEvents = 'none';
    standRenderer.domElement.style.overflow = 'hidden';
    standRenderer.domElement.style.width = '100%';
    standRenderer.domElement.style.height = '100%';
    standRenderer.domElement.style.transform = 'translateZ(0)';
    standRenderer.domElement.style.zIndex = '20';

    if (containerRef.current) {
      containerRef.current.appendChild(standRenderer.domElement);
    }


    const gizmo = new ViewportGizmo(
      (useViewerStore.getState().perspectiveCamera ? perspectiveCameraRef.current : orthographicCameraRef.current)!,
      renderer,
      getGizmoConfig(true),
    );
    gizmoRef.current = gizmo;
    // Controls setup - only if we have a valid renderer
    if (renderer && renderer.getContext()) {
      const controls = new OrbitControls(cameraRef.current!, renderer.domElement);
      controls.enableDamping = true;
      controls.dampingFactor = 0.05;
      controls.mouseButtons = {
        //MIDDLE: THREE.MOUSE.ROTATE,
        LEFT: THREE.MOUSE.ROTATE,
        RIGHT: THREE.MOUSE.PAN
      }
      controlsRef.current = controls;
      controlsRef.current.target.set(0, -10, 0);
      gizmoRef.current.attachControls(controlsRef.current);
    }

    scene.add(new THREE.AxesHelper(15));

    // Set up lights
    const maxX = 300;
    const maxY = 300;
    const backLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    backLight.position.set(0, maxY, -200);
    const bbackLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    bbackLight.position.set(0, -maxY, -200);
    const leftLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    leftLight.position.set(maxX, maxY, 0);
    const bleftLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    bleftLight.position.set(maxX, -maxY, 0);
    const rightLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    rightLight.position.set(-maxX, maxY, 0);
    const brightLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    brightLight.position.set(-maxX, -maxY, 0);
    const frontLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    frontLight.position.set(0, maxY, 200);
    const bfrontLight = new THREE.PointLight(0xffffff, 30, 0, 0.7);
    bfrontLight.position.set(0, -maxY, 200);

    scene.add(backLight);
    scene.add(leftLight);
    scene.add(rightLight);
    scene.add(frontLight);
    scene.add(bbackLight);
    scene.add(bleftLight);
    scene.add(brightLight);
    scene.add(bfrontLight);

    function createVertexMarkerForMesh(mesh: THREE.Mesh): THREE.Mesh {
      if (vertexMarkers.has(mesh)) {
        return vertexMarkers.get(mesh)!;
      }

      const geo = new THREE.SphereGeometry(1);
      const mat = new THREE.MeshBasicMaterial({ color: 0xffffff });
      const marker = new THREE.Mesh(geo, mat);
      marker.visible = false;
      marker.renderOrder = 999;
      scene.add(marker);

      vertexMarkers.set(mesh, marker);
      return marker;
    }

    function getClosestVertex(intersection: THREE.Intersection): { vertIndex: number; worldPos: THREE.Vector3; dist: number } | null {
      const mesh = intersection.object as THREE.Mesh;
      const geo = mesh.geometry as THREE.BufferGeometry;

      const pos = geo.attributes.position;
      const index = geo.index;
      if (!pos || !index) return null;

      const faceIndex = intersection.faceIndex!;
      const ia = index.getX(faceIndex * 3);
      const ib = index.getX(faceIndex * 3 + 1);
      const ic = index.getX(faceIndex * 3 + 2);
      const verts = [ia, ib, ic];
      const p = intersection.point;
      const temp = new THREE.Vector3();

      let best = { vertIndex: -1, worldPos: new THREE.Vector3(), dist: Infinity };

      verts.forEach((vi) => {
        temp.fromBufferAttribute(pos, vi);
        mesh.localToWorld(temp);
        const d = temp.distanceTo(p);
        if (d < best.dist) {
          best = {
            vertIndex: vi,
            worldPos: temp.clone(),
            dist: d
          };
        }
      });

      return best;
    }

    function updateVertexPicking(targetMesh: THREE.Mesh): THREE.Vector3 | null {
      if (
        !cameraRef.current ||
        !targetMesh ||
        !isDesktop() ||
        !useViewerStore.getState().showMarkerPosition
      ) return null;


      const vertexMarker = createVertexMarkerForMesh(targetMesh);


      let raycaster = new THREE.Raycaster();
      raycaster.layers.set(0);
      raycaster.params.Mesh = { threshold: 0.001 };
      cameraRef.current.updateMatrixWorld(true);
      raycaster.setFromCamera(realtimeMousePos, cameraRef.current);
      const intersects = raycaster.intersectObject(targetMesh, false);


      if (intersects && intersects.length === 0) {
        vertexMarker.visible = false;
        return null;
      }

      vertexMarker.visible = true;
      const hit = intersects[0];
      const result = getClosestVertex(hit);
      if (!result) return null;


      vertexMarker.position.copy(result.worldPos);
      return result.worldPos;
    }


    // Mark as initialized
    isInitializedRef.current = true;

    // Animation loop - only if we have a valid renderer
    const animate = () => {
      if (rendererRef.current && sceneRef.current && cameraRef.current) {
        requestAnimationFrame(animate);

        const viewerState = useViewerStore.getState();
        const viewingGcode = viewerState.gcodeVisible;
        const setMarkerPosition = viewerState.setMarkerPosition;

        // Vertex picking is useless while G-code view hides the insole meshes
        if (viewerState.gcodeStatus.result === "idle" && !viewingGcode && viewerState.showMarkerPosition) {
          let foundPosition: THREE.Vector3 | null = null;

          for (let i = 0; i < outputMeshRef.current.length; i++) {
            const mesh = outputMeshRef.current[i];
            if (!mesh || !mesh.visible) continue;
            const position = updateVertexPicking(mesh);
            if (position) foundPosition = position;
          }

          if (foundPosition) {
            const newPosition = {
              x: foundPosition.x.toFixed(2),
              y: foundPosition.y.toFixed(2),
              z: foundPosition.z.toFixed(2)
            };

            if (JSON.stringify(lastFoundPosition) !== JSON.stringify(newPosition)) {
              lastFoundPosition = newPosition;
              setMarkerPosition(newPosition);
            }
          } else if (lastFoundPosition !== null) {
            lastFoundPosition = null;
            setMarkerPosition(null);
          }
        }

        if (controlsRef.current) {
          controlsRef.current.update();
        }

        if (atomiControlsRef.current && atomiControlsRef.current.update) {
          atomiControlsRef.current.update();
        }

        // Wheel zoom and ViewportGizmo change the camera-to-target distance
        // without recalculating its clipping planes. Refresh the depth range
        // immediately before drawing so close Top/Bottom views cannot cross a
        // stale near plane and disappear.
        if (controlsRef.current) {
          ensureCameraDepthRange(
            cameraRef.current,
            cameraRef.current.position.distanceTo(controlsRef.current.target)
          );
        }

        rendererRef.current.render(sceneRef.current, cameraRef.current);

        // CSS overlays are hidden / unused during G-code preview — skip their full-scene passes
        if (!viewingGcode) {
          labelRenderer.render(sceneRef.current, cameraRef.current);
          standRenderer.render(sceneRef.current, cameraRef.current);
        }

        if (gizmoRef.current) gizmoRef.current.render();
      }
    };

    // Only start animation if we have a valid renderer
    if (rendererRef.current && (rendererRef.current as any).getContext?.()) {
      animate();
    } else {
      console.warn('Animation loop not started due to invalid renderer');
    }

    // Handle window resize
    const handleResize = () => {
      updateRendererSize();
      controlsRef.current?.update();
      gizmoRef.current?.update();
    };
    window.onresize = handleResize;

    // Create a ResizeObserver with throttling
    let resizeTimeoutId: number | null = null;
    const resizeObserver = new ResizeObserver(() => {
      // Cancel any pending resize
      if (resizeTimeoutId !== null) {
        window.clearTimeout(resizeTimeoutId);
      }

      // Throttle resize operations to run at most once every 100ms
      resizeTimeoutId = window.setTimeout(() => {
        window.requestAnimationFrame(() => {
          try {
            if (containerRef.current) {
              updateRendererSize();
            }
          } catch (error) {
            console.error('Error in ResizeObserver callback:', error);
          }
          resizeTimeoutId = null;
        });
      }, 100);
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    // Add click event listener for selection
    if (containerRef.current) {
      containerRef.current.addEventListener('contextmenu', (e) => e.preventDefault());
      containerRef.current.addEventListener('mousedown', handleMouseClick);
      containerRef.current?.addEventListener("mousemove", (event) => {
        realtimeMousePos.x = (event.clientX / window.innerWidth) * 2 - 1;
        realtimeMousePos.y = -(event.clientY / window.innerHeight) * 2 + 1;
      });
      // containerRef.current.addEventListener('click', handleLeftClick);
    }

    // Add click event listener for selection
    if (containerRef.current) {
      containerRef.current.addEventListener('contextmenu', (e) => e.preventDefault());
      containerRef.current.addEventListener('mousedown', handleMouseClick);
      // containerRef.current.addEventListener('click', handleLeftClick);
    }



    // Cleanup
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      vertexMarkers.forEach((marker) => {
        scene.remove(marker);
      });
      vertexMarkers.clear();

      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();

      // Remove event listeners
      if (containerRef.current) {
        containerRef.current.removeEventListener('contextmenu', (e) => e.preventDefault());
        containerRef.current.removeEventListener('mousedown', handleMouseClick);
        // containerRef.current.removeEventListener('click', handleLeftClick);
      }

      // Remove vertex spheres
      if (vertexSpheresGroupRef.current && sceneRef.current) {
        vertexSpheresGroupRef.current.forEach(group => {
          sceneRef.current?.remove(group);
          group.traverse((object) => {
            if (object instanceof THREE.Mesh) {
              if (object.material instanceof THREE.Material) {
                object.material.dispose();
              }
            }
          });
        });
      }

      if (profileJointSpheresRef.current && sceneRef.current)
        profileJointSpheresRef.current.forEach(group => {
          group.forEach(sphere => {
            sceneRef.current?.remove(sphere);
            sphere.traverse((object) => {
              if (object instanceof THREE.Mesh) {
                if (object.material instanceof THREE.Material) {
                  object.material.dispose();
                }
              }
            });
          });
        });

      if (surfaceJointSpheresRef.current && sceneRef.current)
        surfaceJointSpheresRef.current.forEach(group => {
          group.forEach(sphere => {
            sceneRef.current?.remove(sphere);
            sphere.traverse((object) => {
              if (object instanceof THREE.Mesh) {
                if (object.material instanceof THREE.Material) {
                  object.material.dispose();
                }
              }
            });
          });
        });

      // Remove all highlighted faces
      removeAllHighlightedFaces();

      if (rendererRef.current) {
        containerRef.current?.removeChild(rendererRef.current.domElement);
        rendererRef.current.dispose();
      }

      isInitializedRef.current = false;
      sceneRef.current?.remove(backLight);
      sceneRef.current?.remove(leftLight);
      sceneRef.current?.remove(rightLight);
      sceneRef.current?.remove(frontLight);
      sceneRef.current?.remove(bbackLight);
      sceneRef.current?.remove(bleftLight);
      sceneRef.current?.remove(brightLight);
      sceneRef.current?.remove(bfrontLight);

      // Clean up drag controls
      if (jointControlsRef.current) {
        jointControlsRef.current.forEach(control => control[0].dispose());
        jointControlsRef.current = [];
      }
      if (sectionControlsRef.current) {
        sectionControlsRef.current.forEach(control => control[0].dispose());
        sectionControlsRef.current = [];
      }
      // Clean up output mesh
      if (outputMeshRef.current) {
        if (outputMeshRef.current[0] && outputMeshRef.current[0].geometry) {
          outputMeshRef.current[0].geometry.dispose();
        }
        if (outputMeshRef.current[0] && outputMeshRef.current[0].material instanceof THREE.Material) {
          outputMeshRef.current[0].material.dispose();
        }

        if (outputMeshRef.current[1] && outputMeshRef.current[1].geometry) {
          outputMeshRef.current[1].geometry.dispose();
        }
        if (outputMeshRef.current[1] && outputMeshRef.current[1].material instanceof THREE.Material) {
          outputMeshRef.current[1].material.dispose();
        }
      }

      resetMeshRefs();

    };
  }, []);

  // Cleanup function
  const cleanupFunction = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    useViewerStore.getState().setMode(ViewerTabsMode.View);
    if (vertexMarkers && vertexMarkers.size > 0) {
      vertexMarkers.forEach((marker: THREE.Mesh) => {
        if (sceneRef.current && marker.parent) {
          sceneRef.current.remove(marker);
        }
        if (marker.geometry) {
          marker.geometry.dispose();
        } if (marker.material) {
          if (Array.isArray(marker.material)) {
            marker.material.forEach(mat => mat.dispose());
          } else {
            marker.material.dispose();
          }
        }
      });
      vertexMarkers.clear();
    }

    removeBonesFromScene();

    // Clean up drag controls
    if (jointControlsRef.current) {
      jointControlsRef.current.forEach(control => control[0].dispose());
      jointControlsRef.current = [];
    }
    if (sectionControlsRef.current) {
      sectionControlsRef.current.forEach(control => control[0].dispose());
      sectionControlsRef.current = [];
    }

    // Clean up scene
    if (sceneRef.current) {
      // Remove all objects from scene
      for (let i = 0; i < sceneRef.current.children.length; i++) {
        const object = sceneRef.current.children[i];

        // Dispose of geometries and materials
        if (object instanceof THREE.Mesh || object instanceof THREE.Line) {
          i--;
          sceneRef.current.remove(object);
          if (object.geometry) {
            object.geometry.dispose();
          }
          if (object.material) {
            if (Array.isArray(object.material)) {
              object.material.forEach(material => material.dispose());
            } else {
              object.material.dispose();
            }
          }
        }

        if (object instanceof THREE.Group) {
          i--;
          sceneRef.current.remove(object);

          object.traverse((obj) => {
            if (obj instanceof THREE.Mesh) {
              if (obj.geometry) {
                obj.geometry.dispose();
              }
              if (obj.material instanceof THREE.Material) {
                obj.material.dispose();
              }
            }
          });
        }
      }
    }
    // Clean up lifted insole
    if (LiftedMeshRef.current) {
      if (outputMeshRef.current[0] && outputMeshRef.current[0].geometry) {
        outputMeshRef.current[0].geometry.dispose();
      }
      if (outputMeshRef.current[0] && outputMeshRef.current[0].material instanceof THREE.Material) {
        outputMeshRef.current[0].material.dispose();
      }

      if (outputMeshRef.current[1] && outputMeshRef.current[1].geometry) {
        outputMeshRef.current[1].geometry.dispose();
      }
      if (outputMeshRef.current[1] && outputMeshRef.current[1].material instanceof THREE.Material) {
        outputMeshRef.current[1].material.dispose();
      }
    }

    resetMeshRefs();
    removeAllLabels();
  }

  useEffect(() => {
    return () => {
      if (cameraFrameTimeoutRef.current !== null) {
        window.clearTimeout(cameraFrameTimeoutRef.current);
        cameraFrameTimeoutRef.current = null;
      }
      //console.log('useeeeeeeeee effect cleanup');
      cleanupFunction();

      if (sceneRef.current) {
        // Remove all objects from scene
        while (sceneRef.current.children.length > 0) {
          const object = sceneRef.current.children[0];
          sceneRef.current.remove(object);
        }
      }
      // Clean up renderer
      if (rendererRef.current) {
        rendererRef.current.dispose();
        rendererRef.current = null;
      }

      // Reset refs
      isInitializedRef.current = false;
      sceneRef.current = null;
      cameraRef.current = null;
      controlsRef.current = null;
    };
  }, []);

  // A different design is a different scene, so a framing remembered for the
  // old one would drop the new model in the wrong place. The next switch into
  // each mode fits from scratch again.
  useEffect(() => {
    cameraModeStateRef.current = {};
  }, [insoleDesign]);

  useEffect(() => {
    if (insoleDesign === null || insoleDesign === undefined) return;
    const fitScene = !skipNextCameraFitRef.current;
    skipNextCameraFitRef.current = false;
    switchCamera(perspectiveCameraEnabled, fitScene);
  }, [perspectiveCameraEnabled]);

  const switchCamera = (perspective: boolean, fitScene = true) => {
    if (!cameraRef.current || !perspectiveCameraRef.current || !orthographicCameraRef.current || !controlsRef.current) return;

    const newCamera = perspective ? perspectiveCameraRef.current : orthographicCameraRef.current;
    if (cameraRef.current === newCamera) return;

    const cameraState = {
      position: cameraRef.current.position,
      target: controlsRef.current.target,
      up: cameraRef.current.up,
    };

    // Remember where the camera being left was looking from, before anything
    // moves, so coming back to this mode can land on it again.
    const leaving = cameraRef.current === orthographicCameraRef.current ? 'orthographic' : 'perspective';
    cameraModeStateRef.current[leaving] = {
      position: cameraState.position.clone(),
      target: cameraState.target.clone(),
      up: cameraState.up.clone(),
      zoom: (cameraRef.current as any).zoom ?? 1,
    };

    newCamera.position.copy(cameraState.position);
    newCamera.up.copy(cameraState.up);
    controlsRef.current.target.copy(cameraState.target);
    newCamera.lookAt(cameraState.target);

    // Returning to a mode this scene has already been in: put it back exactly,
    // rather than copying across from the other camera and then re-fitting.
    const remembered = cameraModeStateRef.current[perspective ? 'perspective' : 'orthographic'];
    if (remembered) {
      newCamera.position.copy(remembered.position);
      newCamera.up.copy(remembered.up);
      controlsRef.current.target.copy(remembered.target);
      (newCamera as any).zoom = remembered.zoom;
      newCamera.lookAt(remembered.target);
    }

    newCamera.updateProjectionMatrix();

    cameraRef.current = newCamera;
    updateAllControlsForNewCamera(newCamera);
    newCamera.updateMatrixWorld(true);

    if (gizmoRef.current) {
      gizmoRef.current.camera = newCamera;
      gizmoRef.current.update();
    }
    updateRendererSize();

    // A remembered framing is the answer on its own; fitting over it is what
    // used to walk the model away on a there-and-back toggle.
    if (!fitScene || remembered) return;

    requestAnimationFrame(() => {
      if (cameraRef.current === newCamera) {
        fitCameraToSceneObjects(newCamera, controlsRef.current!, containerRef.current!, sceneRef, 'toggle');
      }
    });
  };

  const framePressureAlignmentView = () => {
    const camera = cameraRef.current;
    const ortho = orthographicCameraRef.current;
    const controls = controlsRef.current;
    const container = containerRef.current;
    if (!camera || !ortho || !controls || !container || !sceneRef.current) return;

    const box = calculateBoundingBoxOfAllMeshes(sceneRef.current);
    if (box.isEmpty()) return;

    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());
    const maxDim = Math.max(size.x, size.y, size.z);
    const position = center.clone().add(new THREE.Vector3(0, maxDim * 1.1, maxDim * 0.02));
    const up = new THREE.Vector3(0, 1, 0);

    // Top-down: fit X (left-right) and Z (heel-toe) to the current viewport aspect.
    const aspect = container.clientWidth / Math.max(container.clientHeight, 1);
    const padding = 1.4;
    let width = size.x * padding;
    let height = size.z * padding;
    if (width / height > aspect) height = width / aspect;
    else width = height * aspect;

    const applyPose = (cam: THREE.Camera) => {
      cam.up.copy(up);
      cam.position.copy(position);
      cam.lookAt(center);
    };
    applyPose(camera);
    applyPose(ortho);

    ortho.left = -width / 2;
    ortho.right = width / 2;
    ortho.top = height / 2;
    ortho.bottom = -height / 2;
    ortho.zoom = 1;
    ortho.near = maxDim / 10;
    ortho.far = Math.max(maxDim * 100, 1000);
    ortho.updateProjectionMatrix();

    controls.target.copy(center);
    controls.update();
  };

  const updateAllControlsForNewCamera = (newCamera: THREE.Camera) => {
    if (!rendererRef.current) return;
    //Orbit Control
    if (controlsRef.current) {
      controlsRef.current.object = newCamera;
      controlsRef.current.update();
    }
    //Joint Drag Controls
    jointControlsRef.current.forEach(([dragControl, _]) => {
      try {
        if (dragControl.removeEventListener) {
          dragControl.removeEventListener('dragstart', onDragStart);
          dragControl.removeEventListener('drag', onDrag);
          dragControl.removeEventListener('dragend', onDragEnd);
        }
      } catch (e) {
        console.log('Error removing event listeners from drag control:', e);
      }
      dragControl.dispose();
    });
    jointControlsRef.current = [];
    let jointObjects: THREE.Object3D[] = [
      ...profileJointSpheresRef.current.flat(),
      ...surfaceJointSpheresRef.current.flat(),
      ...highHeelRef.current.getDragSpheres().filter(Boolean),
    ];
    jointObjects.forEach(obj => { obj.updateMatrixWorld(true); });
    const jointDragControl = new DragControls(jointObjects, newCamera, rendererRef.current!.domElement);
    jointDragControl.addEventListener('dragstart', onDragStart);
    jointDragControl.addEventListener('drag', onDrag);
    jointDragControl.addEventListener('dragend', onDragEnd);
    jointControlsRef.current.push([jointDragControl, 'joint']);
    jointControlsRef.current.forEach(control => { control[0].disconnect(); });

    //Section Drag Controls
    sectionControlsRef.current.forEach(([dragControl, _]) => {
      try {
        if (dragControl.removeEventListener) {
          dragControl.removeEventListener('dragstart', onDragStart);
          dragControl.removeEventListener('drag', onDrag);
          dragControl.removeEventListener('dragend', onDragEnd);
        }
      } catch (e) {
        console.log('Error removing event listeners from drag control:', e);
      }
      dragControl.dispose();
    });
    sectionControlsRef.current = [];
    let sectionObjects: THREE.Object3D[] = vertexSpheresRef.current.flat();
    const sectionDragControl = new DragControls(sectionObjects, newCamera, rendererRef.current!.domElement);
    sectionDragControl.addEventListener('dragstart', onDragStart);
    sectionDragControl.addEventListener('drag', onDrag);
    sectionDragControl.addEventListener('dragend', onDragEnd);
    sectionControlsRef.current.push([sectionDragControl, 'section']);
    sectionControlsRef.current.forEach(control => { control[0].disconnect(); });

    //Pressure Alignment Drag Control
    pressureControlsRef.current.forEach(([dragControl, _]) => {
      try {
        if (dragControl.removeEventListener) {
          dragControl.removeEventListener('dragstart', onDragStart);
          dragControl.removeEventListener('drag', onDragPressureAlignment);
          dragControl.removeEventListener('dragend', onDragEndPressureAlignment);
        }
      } catch (e) {
        console.log('Error removing event listeners from pressure drag control:', e);
      }
      dragControl.dispose();
    });
    pressureControlsRef.current = [];
    let pressureObjects: THREE.Object3D[] = pressureAlignmentSphereRef.current.flat();
    const pressureDragControl = new DragControls(pressureObjects, newCamera, rendererRef.current!.domElement);
    pressureDragControl.addEventListener('dragstart', onDragStart);
    pressureDragControl.addEventListener('drag', onDragPressureAlignment);
    pressureDragControl.addEventListener('dragend', onDragEndPressureAlignment);
    pressureControlsRef.current.push([pressureDragControl, 'pressureAlignment']);
    pressureControlsRef.current.forEach(control => { control[0].disconnect(); });

    //Engraving Drag Controls
    engravingControlsRef.current.forEach(([dragControl, _]) => {
      try {
        if (dragControl.removeEventListener) {
          dragControl.removeEventListener('dragstart', onDragStart);
          dragControl.removeEventListener('drag', engravingOnDrag);
          dragControl.removeEventListener('dragend', engravingOnDragEnd);
        }
      } catch (e) {
        console.log('Error removing event listeners from engraving drag control:', e);
      }
      dragControl.dispose();
    });
    engravingControlsRef.current = [];
    if (!sceneRef.current) return;
    const allMeshes = sceneRef.current.getObjectsByProperty('name', 'engraving');
    let engravingObjects = allMeshes.filter(mesh => mesh.position.x < 0);
    const engravingDragControl = new DragControls(engravingObjects, newCamera, rendererRef.current!.domElement);
    engravingDragControl.addEventListener('dragstart', onDragStart);
    engravingDragControl.addEventListener('drag', engravingOnDrag);
    engravingDragControl.addEventListener('dragend', engravingOnDragEnd);
    engravingControlsRef.current.push([engravingDragControl, 'engraving']);
    engravingControlsRef.current.forEach(control => { control[0].disconnect(); });

    if (atomiControlsRef.current) {
      atomiControlsRef.current.camera = newCamera;
    }

    if (raycasterRef.current) {
      raycasterRef.current.camera = newCamera;
    }
    handleDragControlConnections(rightToolboxMode);
  };

  useEffect(() => {
    const handleResize = () => {
      const container = containerRef.current;
      if (!container) return;

      const width = container.clientWidth;
      const height = container.clientHeight;

      rendererRef.current?.setSize(width, height);
      labelRenderer?.setSize(width, height);
      standRenderer?.setSize(width, height);

      if (cameraRef.current instanceof THREE.PerspectiveCamera) {
        cameraRef.current.aspect = width / height;
        cameraRef.current.updateProjectionMatrix();
      }

      scheduleVisibleDesignFrame();
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // --- GIZMO CLICK: FIT ONCE AFTER THE SELECTED VIEW HAS SETTLED ---
  useEffect(() => {
    if (!gizmoRef.current) return;
    const gizmo = gizmoRef.current;
    const handleGizmoEnd = () => {
      requestAnimationFrame(() => frameVisibleDesignObjects(true));
    };
    gizmo.addEventListener && gizmo.addEventListener('end', handleGizmoEnd);
    return () => {
      gizmo.removeEventListener && gizmo.removeEventListener('end', handleGizmoEnd);
    };
  }, [gizmoRef, cameraRef, controlsRef, sceneRef]);

  const findTextureOffsets = (foot: number) => {
    const image = pressureImageDataRef.current?.[foot];
    if (!outputMeshRef.current?.[foot]) return;
    if (!image) return;
    const presssureData = useDesignStore.getState().insoleDesign?.pressureData;
    if (!presssureData) return;
    const heelCenter = presssureData.HeelCenter?.[foot];
    const metCenter = presssureData.MetCenter?.[foot];
    if (!heelCenter || !metCenter) return;
    const mesh = outputMeshRef.current?.[foot];
    const spheres = pressureAlignmentSphereRef.current?.[foot];
    if (!mesh?.geometry || !spheres?.[0]?.userData?.initialPosition) return;

    let heelVector = new THREE.Vector3(image.realWidth - heelCenter.x, 0, (image.realHeight - heelCenter.y));
    let metVector = new THREE.Vector3((image.realWidth - metCenter.x), 0, (image.realHeight - metCenter.y));
    // console.log(`${foot === 0 ? 'Right' : 'Left'} Heel Center: x = ${heelVector.x} y = ${heelVector.z}`);
    // console.log(`${foot === 0 ? 'Right' : 'Left'} Translate Point ${pressureAlignmentSphereRef.current[foot][0].userData.initialPosition.x} ${pressureAlignmentSphereRef.current[foot][0].userData.initialPosition.z}`);

    // console.log(`${foot === 0 ? 'Right' : 'Left'} Met Center: x = ${metVector.x} y = ${metVector.z}`);
    // console.log(`${foot===0?'Right':'Left'} Rotation Point ${pressureAlignmentSphereRef.current[foot][1].position.x} ${pressureAlignmentSphereRef.current[foot][1].position.z}`);

    const geo = mesh.geometry;
    geo.computeBoundingBox();
    const center = new THREE.Vector3();
    if (geo.boundingBox)
      geo.boundingBox.getCenter(center);

    let z = center.z - spheres[0].userData.initialPosition.z;
    let x = center.x - spheres[0].userData.initialPosition.x;
    let xConsTranslation = presssureData.ExamType === 'dynamic'
      ? ((heelCenter.x - image.realWidth / 2) * 1 - 10 + x)
      : ((heelCenter.x - image.realWidth / 2) * 1 - 10 + x);
    let zConsTranslation = presssureData.ExamType === 'dynamic'
      ? ((-heelCenter.y + image.realHeight / 2) * 1 + z + 2)
      : ((-heelCenter.y + image.realHeight / 2) * 1 + z + 2);

    let pressureVector = metVector.clone().sub(heelVector);

    return { xPressureOffset: xConsTranslation, zPressureOffset: zConsTranslation, pressureVector: pressureVector };
  }

  const findInitialRotaionTranslationTexture = () => {
    const applyFoot = (foot: number) => {
      const pressure = findTextureOffsets(foot);
      const spheres = pressureAlignmentSphereRef.current?.[foot];
      const image = pressureImageDataRef.current?.[foot];
      const offsets = textureOffsetsRef.current?.[foot];
      if (!pressure?.pressureVector || !spheres?.[0] || !spheres?.[1] || !image || !offsets) return;

      offsets.uOffset = (((spheres[0].userData.initialPosition.x + pressure.xPressureOffset) - spheres[0].position.x)) / image.realWidth;
      offsets.vOffset = (((spheres[0].userData.initialPosition.z + pressure.zPressureOffset) - spheres[0].position.z)) / image.realHeight;
      const meshVector = spheres[1].position.clone().sub(spheres[0].position);
      const pAngle = Math.atan2(pressure.pressureVector.x, pressure.pressureVector.z) * -1;
      const mAngle = Math.atan2(meshVector.x, meshVector.z);
      offsets.rotationAngle = (mAngle - pAngle);
    };

    applyFoot(0);
    applyFoot(1);
  }

  const initPressureImage = async (pData: PressureData, loadPressureAlignment = true, isnew: boolean = false) => {
    if (colorPalleteRef.current.length == 0)
      colorPalleteRef.current = await GenerateColormap();
    textureOffsetsRef.current = [];

    if (!pData) return;
    // Remount after a pressure design can call this before meshes exist.
    if (!outputMeshRef.current?.[0] || !outputMeshRef.current?.[1]) return;
    const defaultOffsets1: TextureOffsets = { rotationAngle: 0, uOffset: 0, vOffset: 0 };
    const defaultOffsets2: TextureOffsets = { rotationAngle: 0, uOffset: 0, vOffset: 0 };

    const rightImageData = CreateImageData(colorPalleteRef.current, pData.CalibMaxFrame_Right, pData.ROI_Right, (pData.ExamType != 'static'), true, pData.CalibFrames_Right);
    const leftImageData = CreateImageData(colorPalleteRef.current, pData.CalibMaxFrame_Left, pData.ROI_Left, (pData.ExamType != 'static'), false, pData.CalibFrames_Left);

    const rightPressureImage: PressureImage = {
      image: rightImageData,
      realHeight: pData.PressureSensorHeight * rightImageData.height / 5.0,
      realWidth: pData.PressureSensorWidth * rightImageData.width / 5.0
    };

    pressureImageDataRef.current.push(rightPressureImage);
    textureOffsetsRef.current.push(defaultOffsets1);

    const leftPressureImage: PressureImage = {
      image: leftImageData,
      realHeight: pData.PressureSensorHeight * leftImageData.height / 5.0,
      realWidth: pData.PressureSensorWidth * leftImageData.width / 5.0
    };

    pressureImageDataRef.current.push(leftPressureImage);
    textureOffsetsRef.current.push(defaultOffsets2);

    if (isnew)
      resetTextureAlignmentPoints();
    if (loadPressureAlignment) {
      loadStoredPressureAlignment();
    }
    findInitialRotaionTranslationTexture();

    if (pressureImageDataRef.current[0]) {
      updateInsoleTexture(0, pressureImageDataRef.current[0], outputMeshRef.current[0]);
      updateInsoleTexture(0, pressureImageDataRef.current[0], LiftedMeshRef.current[0]);
    }
    if (pressureImageDataRef.current[1]) {
      updateInsoleTexture(1, pressureImageDataRef.current[1], outputMeshRef.current[1]);
      updateInsoleTexture(1, pressureImageDataRef.current[1], LiftedMeshRef.current[1]);
    }
  }

  const GetRenderPoint = (point: any, roi: Rect, renderRect: Rect) => {
    const scaleX = renderRect.width / roi.width;
    const scaleY = renderRect.height / roi.height;

    let x = (point.x - roi.x) * scaleX + roi.x;
    let y = (point.y - roi.y) * scaleY + roi.y;


    if (x > renderRect.x + renderRect.width) {
      x = renderRect.x + renderRect.width;
    } else if (x < 0) {
      x = renderRect.x;
    }

    if (y > renderRect.y + renderRect.height) {
      y = renderRect.y + renderRect.height;
    } else if (y < renderRect.y) {
      y = renderRect.y;
    }

    return new cv.Point(x - 11, y - 5);
  }

  const GetZoomRectangle = (roi: Rect, displayWidth: number, displayHeight: number): Rect => {


    const targetWidthRatio = 1;
    const targetHeightRatio = 1;

    const scaleX = (displayWidth * targetWidthRatio) / roi.width;
    const scaleY = (displayHeight * targetHeightRatio) / roi.height;

    const scale = Math.min(scaleX, scaleY);

    const newWidth = Math.round(scale * roi.width);
    const newHeight = Math.round(scale * roi.height);

    const locx = Math.round((displayWidth - newWidth) / 2.0);
    const locy = Math.round((displayHeight - newHeight) / 2.0);

    return new Rect(locx, locy, newWidth, newHeight);
    // return new Rect(-22, locy, newWidth, newHeight);
  }

  const CreateImageData = (colorMap: [number, number, number][], maxFrame: Mat, ROI2: Rect, isDynamic: boolean, isRight: boolean, frames: Mat[]): ImageData => {
    const ROI = (isDynamic) ? fp.autoCropROI(maxFrame) : ((isRight) ? fp.autoCropROIRight(maxFrame) : fp.autoCropROILeft(maxFrame));
    // const ROI = ((isRight) ? fp.autoCropROIRight(maxFrame) : fp.autoCropROILeft(maxFrame));
    const copPoints = fp.GetCOPArray(frames, ROI);
    const mat = maxFrame.clone().roi(ROI2);
    const maxVal = fp.getMaxValue(mat);
    let convertMat = new Mat();
    mat.convertTo(convertMat, CV_8U, 255 / maxVal);
    let resizeMat = new Mat();
    const dsize = new Size(convertMat.cols * 5, convertMat.rows * 5);
    resize(convertMat, resizeMat, dsize, INTER_LINEAR);
    let blurMat = new Mat();
    GaussianBlur(resizeMat, blurMat, new Size(5, 5), 1.4);

    // const colorizeMat = applyColorMap2(colorMap, convertMat);
    const colorizeMat = applyColorMap2(colorMap, blurMat);

    // COP line
    // if (isDynamic) {
    //   let zoomRect = GetZoomRectangle(ROI, colorizeMat.cols, colorizeMat.rows);
    //   let renderPoints = copPoints.map((point) => GetRenderPoint(point, ROI, zoomRect)).filter((p): p is Point => !!p);
    //   for (let i = 0; i < renderPoints.length - 1; i++) {
    //     let p1 = new Point(renderPoints[i].x, renderPoints[i].y);
    //     let p2 = new Point(renderPoints[i + 1].x, renderPoints[i + 1].y);
    //     line(
    //       colorizeMat,
    //       p1,
    //       p2,
    //       [21, 14, 169, 255], //[b,g,r,alpha]
    //       2,
    //       LINE_AA
    //     );
    //   }
    // }

    // const center = new cv.Point(heelCenter.x * 5, heelCenter.y * 5);
    // const radius = 2; // pixels
    // const color = new cv.Scalar(0, 0, 0, 255);
    // const thickness = -1; // Filled circle. Use 2 for a border.
    // cv.circle(colorizeMat, center, radius, color, thickness, cv.LINE_8);

    // circle(
    //   colorizeMat,
    //   heelCenter,
    //   3,
    //   [231, 109, 245, 255],
    //   2,
    //   LINE_AA
    // );
    // circle(
    //   colorizeMat,
    //   metCenter,
    //   3,
    //   [231, 109, 245, 255],
    //   2,
    //   LINE_AA
    // );
    return reverseImageData(convertMatToImageData(colorizeMat));
    // return reverseImageData(convertMatToImageData(colorizeMat));
  }

  const ReadPalleteImage = (palletPath: string, callback: (im: Mat) => void): void => {
    const img = new Image();
    img.src = palletPath;
    img.crossOrigin = 'Anonymous';

    img.onload = () => {
      const canvasComp = document.createElement('canvas');
      canvasComp.width = img.width;
      canvasComp.height = img.height;

      const ctx = canvasComp.getContext("2d");
      if (!ctx) return;

      ctx.drawImage(img, 0, 0);
      const srcMat: Mat = imread(canvasComp);

      ctx.clearRect(0, 0, canvasComp.width, canvasComp.height);
      callback(srcMat);
    }
  }

  const GenerateColormap = (): Promise<[number, number, number][]> => {
    return new Promise((resolve) => {
      ReadPalleteImage(config.palletePrintImagePath, (im) => {
        const customLUT: [number, number, number][] = [];
        for (let i = 0; i < 256; i++) {
          let color = im.ucharPtr(0, 255 - i);
          let b = color[2];
          let g = color[1];
          let r = color[0];
          customLUT.push([b, g, r]);
        }
        im.delete();
        resolve(customLUT);
      });
    });
  };

  const updateAutomaticDesignParameters = () => {
    const iDesign = useDesignStore.getState().insoleDesign;
    if (iDesign == null) return;

    const event = new CustomEvent('automaticDesignParametersUpdate', {
      detail: iDesign.autoProperties,
    });

    insoleHighLevelParamRef.current[0].profileCurve = iDesign.autoProperties!.profileCurveRight;
    insoleHighLevelParamRef.current[1].profileCurve = iDesign.autoProperties!.profileCurveLeft;

    document.dispatchEvent(event);
  }

  const initAutoDesignAdditions = () => {
    const design = useDesignStore.getState().insoleDesign;
    if (design == null) return;

    if (design.autoProperties?.cutoutMet1Right != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet1Right);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet1;
    }
    if (design.autoProperties?.cutoutMet2Right != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet2Right);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet2;
    }
    if (design.autoProperties?.cutoutMet3Right != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet3Right);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet3;
    }
    if (design.autoProperties?.cutoutMet4Right != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet4Right);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet4;
    }
    if (design.autoProperties?.cutoutMet5Right != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet5Right);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet5;
    }

    if (design.autoProperties?.metatarSalBarRight != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.metatarSalBarRight);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.MetatarsalBar;
    }
    if (design.autoProperties?.metatarSalPadRight != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.metatarSalPadRight);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.MetatarsalPad;
    }
    if (design.autoProperties?.dancersPadRight != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.dancersPadRight);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.DancerPad;
    }
    if (design.autoProperties?.mortonsExtensionRight != -1) {
      let selectedAddition = design.insoles[0].additions.find((addition) => addition.designAdditionId === design.autoProperties!.mortonsExtensionRight);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.MortonExtention;
    }

    if (design.autoProperties?.cutoutMet1Left != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet1Left);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet1;
    }
    if (design.autoProperties?.cutoutMet2Left != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet2Left);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet2;
    }
    if (design.autoProperties?.cutoutMet3Left != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet3Left);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet3;
    }
    if (design.autoProperties?.cutoutMet4Left != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet4Left);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet4;
    }
    if (design.autoProperties?.cutoutMet5Left != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.cutoutMet5Left);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.CutoutMet5;
    }

    if (design.autoProperties?.metatarSalBarLeft != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.metatarSalBarLeft);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.MetatarsalBar;
    }
    if (design.autoProperties?.metatarSalPadLeft != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.metatarSalPadLeft);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.MetatarsalPad;
    }
    if (design.autoProperties?.dancersPadLeft != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.dancersPadLeft);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.DancerPad;
    }
    if (design.autoProperties?.mortonsExtensionLeft != -1) {
      let selectedAddition = design.insoles[1].additions.find((addition) => addition.designAdditionId === design.autoProperties!.mortonsExtensionLeft);
      if (selectedAddition) selectedAddition.automaticAddition = AutomaticAdditions.MortonExtention;
    }
  }

  const initHeelDepthRealY = () => {
    const design = useDesignStore.getState().insoleDesign;
    if (design == null || !design.autoProperties) return;
    heelDepthRealY.current = [design.autoProperties.heelDepthRightY, design.autoProperties.heelDepthLeftY];
  }

  const updateHeelDepthAutoProps = () => {
    const design = useDesignStore.getState().insoleDesign;
    if (design == null || !design.autoProperties) return;

    design.autoProperties!.heelDepthRightY = Math.round(heelDepthRealY.current[0] * 1000) / 1000;
    design.autoProperties!.heelDepthLeftY = Math.round(heelDepthRealY.current[1] * 1000) / 1000;

    //scheduleAutosave("Update Heel Depth", { updateAutoProperties: true });
  }

  const updateSurfaceJointValuesTable = () => {
    const event = new CustomEvent('surfaceJointUpdate', {
      detail: insoleHighLevelParamRef.current.map(params => {
        const copy = { ...params };

        for (const [key, value] of Object.entries(copy)) {
          if (typeof value == 'number' && !measurementExclude.some(w => key.includes(w))) {
            (copy as any)[key] = convertMmToViewerUnit(value);
          }
        }
        return copy;
      })
    });
    document.dispatchEvent(event);
  };

  updateSurfaceJointValuesTable();

  // --- Fit grid helpers to bounding box ---
  const createGridHelpers = () => {
    const insole = useDesignStore.getState().insoleDesign;
    if (insole === null || insole === undefined) return;
    removeExistingGridHelpers(sceneRef.current!);

    const box = calculateBoundingBoxOfAllMeshes(sceneRef.current!);
    if (box.isEmpty()) return;

    const sizeVec = box.getSize(new THREE.Vector3()).addScalar(1.2);

    const step = useViewerStore.getState().measurementSystem === MeasurementSystem.imperial ? convertUnitToDefault(1, getDefaultLengthUnit()) : 10;
    const center = box.getCenter(new THREE.Vector3());

    const gridHelperX = new CustomGridHelper(sizeVec.x, sizeVec.z, step);
    (gridHelperX.material as THREE.Material).depthWrite = false;
    (gridHelperX.material as THREE.Material).transparent = true;
    gridHelperX.renderOrder = -1;
    gridHelperX.position.set(center.x, 0, center.z);
    gridHelperX.GridNumbers("X").forEach((label) => {
      sceneRef.current!.add(label);
    });
    gridHelperX.GridNumbers("Z").forEach((label) => {
      sceneRef.current!.add(label);
    });

    const gridHelperXY = new CustomGridHelper(sizeVec.x, sizeVec.y, step);
    gridHelperXY.position.set(center.x, 0, center.z);
    gridHelperXY.position.z -= gridHelperX.width / 2;
    gridHelperXY.position.y += gridHelperXY.width / 2;
    gridHelperXY.rotation.x = Math.PI / 2;
    (gridHelperXY.material as THREE.Material).depthWrite = false;
    (gridHelperXY.material as THREE.Material).transparent = true;
    gridHelperXY.renderOrder = -1;
    gridHelperXY.GridNumbers("Y").forEach((label) => {
      sceneRef.current!.add(label);
    });

    const gridHelperYZ = new CustomGridHelper(sizeVec.y, sizeVec.z, step);
    gridHelperYZ.position.set(center.x, 0, center.z);
    gridHelperYZ.position.x += gridHelperX.length / 2;
    gridHelperYZ.position.y += gridHelperYZ.length / 2;
    gridHelperYZ.rotation.z = Math.PI / 2;
    (gridHelperYZ.material as THREE.Material).depthWrite = false;
    (gridHelperYZ.material as THREE.Material).transparent = true;
    gridHelperYZ.renderOrder = -1;

    sceneRef.current!.add(gridHelperX);
    sceneRef.current!.add(gridHelperXY);
    sceneRef.current!.add(gridHelperYZ);
  }

  useEffect(() => {
    if (insoleDesign === null) return;

    RenderManualEdit();
    pressureAlignmentSphereRef.current.forEach((profileGroup, foot) => {
      profileGroup.forEach(jnt => {
        jnt.visible = alignPressureToggle && isFootShownInView(foot);
      })
    });
    pressureAlignmentLine.current.forEach((line, foot) => {
      line.visible = alignPressureToggle && isFootShownInView(foot);
    });

    const controls = controlsRef.current;

    if (!controls || !cameraRef.current) return;

    if (alignPressureToggle) {
      changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, false);
      if (insoleDesign && selectedAdditionIndexRef.current >= 0) {
        const selectedAddition = insoleDesign.insoles[selectedFootIndexRef.current]?.additions[selectedAdditionIndexRef.current];
        if (selectedAddition?.jointGeometry) {
          if (additionGizmoPivotRef.current && sceneRef.current) {
            additionGizmoPivotRef.current.remove(selectedAddition.jointGeometry);
            sceneRef.current.remove(additionGizmoPivotRef.current);
          }
          if (sceneRef.current && sceneRef.current.children.includes(selectedAddition.jointGeometry)) {
            sceneRef.current.remove(selectedAddition.jointGeometry);
          }
        }
      }
      selectedAdditionIndexRef.current = -1;
      currentMode.current = AdditionTransformControlMode.No;
      useViewerStore.setState({
        selectedAdditionFromViewer: { foot: -1, additionIndex: -1 }
      });

      // Fit top-down first for the current aspect, then switch to ortho without re-fitting.
      framePressureAlignmentView();
      skipNextCameraFitRef.current = true;
      useViewerStore.getState().setPerspectiveCamera(false);
    }
    else {
      cameraRef.current.up.set(0, 1, 0);
      if (cameraRef.current instanceof THREE.OrthographicCamera) {
        const target = controls.target.clone();
        const distance = Math.max(cameraRef.current.position.distanceTo(target), 1);
        cameraRef.current.position.copy(target).add(new THREE.Vector3(0, distance, distance * 0.1));
        cameraRef.current.lookAt(target);
        controls.update();
      }

      useViewerStore.getState().setPerspectiveCamera(true);
    }

    savePressureAlignment();
  }, [alignPressureToggle])

  useEffect(() => {
    enableGrids(useViewerStore.getState().grids);
  }, [useViewerStore((state) => state.grids)]);

  useEffect(() => {
    if (insoleDesign === null || insoleDesign === undefined) return;
    toggleAdvanceMode();
  }, [advanceMode])

  useEffect(() => {
    if (insoleDesign === null || insoleDesign === undefined) return;
    if (finalize) {
      const gcodes = useDesignStore.getState().gCodes;
      if (gcodes.length > 0)
        gcodes.forEach((gcodeObject, index) => {
          sceneRef.current?.add(gcodeObject);
          if (outputMeshRef.current[index])
            outputMeshRef.current[index].visible = false;
        });
      useViewerStore.setState({
        gcodeVisible: true,
        additionsViewMeshVisible: false,
        insolesVisible: false,
        liftedInsoleMeshVisible: false,
        bonesMeshVisible: false,
        shoeDataMeshVisible: false,
        highHeelMeshVisible: false
      });

      useViewerStore.setState({ mode: ViewerTabsMode.View });
    }
    else {
      sceneRef.current?.remove(...sceneRef.current.children.filter(child => child.name.startsWith('gcode')));
      useViewerStore.setState({
        gcodeVisible: false,
        additionsViewMeshVisible: true,
        insolesVisible: true,
        liftedInsoleMeshVisible: true,
        bonesMeshVisible: true,
        shoeDataMeshVisible: true,
        highHeelMeshVisible: true
      });
    }
    if (useViewerStore.getState().grids) enableGrids(true);
    else enableGrids(false);
  }, [finalize]);

  const RenderManualEdit = () => {
    profileJointSpheresRef.current.forEach((profileGroup, foot) => {
      profileGroup.forEach(jnt => {
        jnt.visible = (rightToolboxMode == ViewerTabsMode.Edit && !alignPressureToggle && isFootShownInView(foot));
      });
    });

    surfaceJointSpheresRef.current.forEach((surfaceGroup, foot) => {
      surfaceGroup.forEach(jnt => {
        jnt.visible = (rightToolboxMode == ViewerTabsMode.Edit && !alignPressureToggle && isFootShownInView(foot));
      });
    });

    setArchInstepLineVisibility();

    const defaultAdditionOpacity = (DEFAULT_ADDITON_MESH_MATERIAL.opacity ?? 1);
    setAdditionsOpacity(defaultAdditionOpacity);
    handleDragControlConnections(rightToolboxMode);
    createSpline(0);
    createArchEditorLine(0);
    createSpline(1);
    createArchEditorLine(1);
    highHeelRef.current.setDragHandlesVisible(
      highHeelVisibility &&
      rightToolboxMode == ViewerTabsMode.Edit &&
      !alignPressureToggle,
      feetView
    );
  }

  const toggleAdvanceMode = () => {
    vertexSpheresRef.current?.forEach((sphereGroup, foot) => {
      sphereGroup.forEach(sphere => {
        sphere.visible = advanceMode && (rightToolboxMode == ViewerTabsMode.Edit) && isFootShownInView(foot);
      });
    });
    handleDragControlConnections(rightToolboxMode);
  }

  const resetMeshRefs = () => {
    currentMode.current = AdditionTransformControlMode.No;
    originalGeometryRef.current = [];
    outputMeshRef.current = [];
    profileJointSpheresRef.current = [];
    surfaceJointSpheresRef.current = [];
    highHeelRef.current.reset();

    if (additionGizmoPivotRef.current) {
      additionGizmoPivotRef.current.children
        .filter((c: any) => c?.userData?.jointType === 'addition')
        .forEach(c => additionGizmoPivotRef.current?.remove(c));

      sceneRef.current?.remove(additionGizmoPivotRef.current);
      additionGizmoPivotRef.current = null;
    }

    if (atomiControlsRef.current) {
      atomiControlsRef.current.parent?.remove(atomiControlsRef.current);
      atomiControlsRef.current.dispose?.();
      atomiControlsRef.current = null;
    }

    gizmoStartForwardRef.current = null;
    gizmoStartRotationYRef.current = 0;
    gizmoStartScaleXRef.current = 1;
    gizmoStartScaleYRef.current = 1;
    gizmoStartScaleZRef.current = 1;
  };

  const ImportWBCTData = (updateLiftedMesh: boolean = true) => {
    const shift = UpdateBonesPosition();
    if (shift == null || shift.length == 0) return;
    if ((!hasBones.current[0] || !hasBones.current[1])) return;

    InitialShiftBones.current = shift;
    AddClonedInsole();
    addShoeMarkersToScene();
    if (updateLiftedMesh) {
      UpdateLiftedMesh(0);
      UpdateLiftedMesh(1);
    }
    if (useViewerStore.getState().grids) enableGrids(true);
    else enableGrids(false);
  }

  const saveOldCenters = () => {
    // Save the old centers for undo action
    if (useDesignStore.getState().undoLoaded) {
      for (let index = 0; index < outputMeshRef.current.length; index++) {
        var ibox = GetInsoleBox(outputMeshRef.current[index]);
        insoleOldCenter.current[index] = ibox.getCenter(new THREE.Vector3).clone();
      }
    }
  }

  const syncHighHeelHandlesIntoJointControls = () => {
    const jointDragControl = jointControlsRef.current[0]?.[0];
    if (!jointDragControl) return;

    const heelSpheres = highHeelRef.current.getDragSpheres().filter(Boolean) as THREE.Object3D[];
    heelSpheres.forEach(sphere => sphere.updateMatrixWorld(true));

    jointDragControl.objects = jointDragControl.objects.filter(
      (obj) => obj.userData?.jointType !== HIGH_HEEL_JOINT_TYPE
    );
    jointDragControl.objects.push(...heelSpheres);
  };

  const updatesForHighHeelDesign = async () => {
    AddClonedInsole();

    const highHeel = await highHeelRef.current.build();
    if (!highHeel) return;

    highHeelRef.current.setMeshesVisible(highHeelVisibility, feetView);
    highHeel.meshes.forEach(mesh => sceneRef.current?.add(mesh));
    highHeel.dragSpheres.forEach(sphere => {
      sceneRef.current?.add(sphere);
    });
    highHeelRef.current.setDragHandlesVisible(
      highHeelVisibility &&
      rightToolboxMode === ViewerTabsMode.Edit &&
      !alignPressureToggle,
      feetView
    );

    syncHighHeelHandlesIntoJointControls();
    handleDragControlConnections(rightToolboxMode);

    insoleHighLevelParamRef.current.forEach(params => {
      params.highHeelHeight = highHeel.initialHeight;
    });
    updateSurfaceJointValuesTable();
    highHeel.curveGroups.forEach((_, foot) => UpdateLiftedMesh(foot));
  };

  useEffect(() => {
    if (!designLoaded || !insoleDesign) return;
    try {
      saveOldCenters();
      cleanupFunction();
      renderAfterDesignLoaded();
    } catch (error) {
      toast.error("Cannot load this design. Please select another one using the “Database” button.");
      useLoadingComponentStore.getState().setVisibile(false);
    }
    useDesignStore.setState({ designLoaded: false });
    useViewerStore.setState({ animatePressure: false });
  }, [designLoaded]);

  const renderAfterDesignLoaded = async () => {
    if (insoleDesign == null) return;
    const insolesCount = useDesignStore.getState().insoleDesign?.insoles.length;
    if (!insolesCount) return;
    pressureImageDataRef.current = [];

    isSandal.current = insoleDesign.isSandal ? true : false;
    archEditorConst.current = insoleDesign.isSandal ? 50 : 20;
    useDesignStore.setState({ thirdQuarter: insoleDesign.autoProperties?.thirdQuarter });

    initHeelDepthRealY();
    initAutoDesignAdditions();

    if (alignPressureToggle)
      useViewerStore.setState({ alignPressure: false });

    for (let i = 0; i < insolesCount; i++) {
      let geo: THREE.BufferGeometry | null | undefined = useDesignStore.getState().insoleDesign?.insoles[i].lowpolyBufferGeometry;

      if (geo === null || geo === undefined) { continue; }
      let { loadedMesh, outputMesh } = initMeshes(geo, i) as { loadedMesh: any, outputMesh: any };

      originalGeometryRef.current?.push(geo);
      outputMeshRef.current?.push(outputMesh);

      // sceneRef.current?.add(loadedMesh!);
      sceneRef.current?.add(outputMeshRef.current?.[i]!);

      // Add vertex spheres      
      addJointSpheres(geo, sceneRef.current, i);
      addRoofVertexSpheres(geo, sceneRef.current, i);
      addPressureAlignmentElements(geo, sceneRef.current, i);
    }

    RenderManualEdit();
    InitAdditionTransformControl();
    updateOutputMesh();
    initWedgeTypes(0);
    initWedgeTypes(1);
    handleSurfaceJointValues(0);
    handleSurfaceJointValues(1);
    resetLeftToolbox();

    await applyDesignUpdates();
    updateAutomaticDesignParameters();

    const hasBonesLocal = insoleDesign.insoles[0].bonesGroup != null && insoleDesign.insoles[0].bonesGroup.children.length > 0;
    if (!hasBonesLocal && insoleDesign.category == DesignCategory.HighHeel) {
      await updatesForHighHeelDesign();
    }

    const alignmentOffsets = pressureAlignmentTransferRef.current;
    pressureAlignmentTransferRef.current = null;
    if (alignmentOffsets && useDesignStore.getState().categoryChanged) {
      await applyPressureAlignmentOffsets(alignmentOffsets);
    }

    if (!useViewerStore.getState().coloring) {
      const pData = useDesignStore.getState().insoleDesign?.pressureData;
      if (pData) {
        await initPressureImage(pData);
      }
      if (useSelectedDesignStore.getState().hasRondomImage) {
        initRondomPressureImages(useDesignStore.getState().RondomImageData, true)
      }
    }

    if (useViewerStore.getState().liveMode) {
      drawBoundingBoxDimensions(0);
      drawBoundingBoxDimensions(1);
      addLabelstoAllAdditions();
      addLabelstoAllSpheres();
      createOrUpdateNewAdditionLabel(0);
      createOrUpdateNewAdditionLabel(1);
      const toolboxSpread = isMobile() || isTablet() ? 40 : 20;
      createOrUpdateToolboxIcon(ReplyIcon, new THREE.Vector3(-toolboxSpread, 5, 0), undoLastAutosave, true);
      createOrUpdateToolboxIcon(UTurnLeft, new THREE.Vector3(0, 5, 0), mirrorToRight);
      createOrUpdateToolboxIcon(UTurnRight, new THREE.Vector3(toolboxSpread, 5, 0), mirrorToLeft);
    }



    ImportWBCTData();

    if (useDesignStore.getState().categoryChanged) {
      resetStackWithDesign(insoleDesign);
    }

    if (cameraRef.current) updateAllControlsForNewCamera(cameraRef.current);

    if (useSelectedDesignStore.getState().templateReplaced || useDesignStore.getState().undoLoaded || useDesignStore.getState().mirrorLoaded || useDesignStore.getState().categoryChanged) {
      useViewerStore.getState().setMode(useViewerStore.getState().previousViewerMode);
      // Not while the narration owns the camera. Switching between the insole
      // and the sandal rebuilds the model, and this re-frames with no animation
      // at all — the jump seen on every model change mid-explanation. The
      // narration keeps its own angle across the switch instead.
      if (
        !useDesignStore.getState().undoLoaded &&
        !useDesignStore.getState().mirrorLoaded &&
        !voiceCameraBusyRef.current &&
        !voiceCameraHeldRef.current
      ) fitCameraToSceneObjects(cameraRef.current!, controlsRef.current!, containerRef.current!, sceneRef, 'toggle');

      if (useSelectedDesignStore.getState().templateReplaced) useSelectedDesignStore.setState({ templateReplaced: false });
      if (useDesignStore.getState().undoLoaded) { useDesignStore.setState({ undoLoaded: false }); }
      if (useDesignStore.getState().mirrorLoaded) useDesignStore.setState({ mirrorLoaded: false });
      if (useDesignStore.getState().categoryChanged) useDesignStore.setState({ categoryChanged: false });
      setColorandTransparency();

    }
    else {
      fitCameraToSceneObjects(cameraRef.current!, controlsRef.current!, containerRef.current!, sceneRef, 'load');
      captureInitialCameraView();
      SetDefaultMeshColorBasedOnGroup();
      useViewerStore.getState().setLiveMode(useViewerStore.getState().voiceSessionActive);
    }

    if (useDesignStore.getState().insoleDesign?.designType == DesignType.Template)
      applyTemplate(useDesignStore.getState().insoleDesign!,
        useDesignStore.getState().previousDesign!);
  }

  const SetDefaultMeshColorBasedOnGroup = () => {
    const savedHardness = useDesignStore.getState().gcodeSetting?.at(0)?.foreFootHardness;
    if (user?.group?.IsRondom) {
      const a = RONDOM_getColorByHardness(savedHardness);
      useViewerStore.getState().setTopInsoleDeafultColor(a.getHexString());
      useViewerStore.getState().setBottomInsoleDeafultColor(a.getHexString());
    }
    else {
      useViewerStore.getState().setTopInsoleDeafultColor(DEFAULT_TOP_MESH_COLOR.getHexString());
      useViewerStore.getState().setBottomInsoleDeafultColor(DEFAULT_BOTTOM_MESH_COLOR.getHexString());
      useViewerStore.getState().setLiftedInsoleDefaultColor(DEFAULT_LIFTEDMESH_COLOR.getHexString());
      useViewerStore.getState().setShoeDataDefaultColor(DEFAULT_FOOTSHOE_COLOR.getHexString());
    }

    if (insoleDesign?.designType != 'Template') {
      useViewerStore.getState().setPressureTrancparency(255);
      useViewerStore.getState().setLiftedInsoleTransparency(255);
      useViewerStore.getState().setBonesTransparency(255);
      useViewerStore.getState().setShoeDataTransparency(128);
      // The narration design opens as a bare shell and reveals the scan data as
      // it talks about it, so the loader leaves those switched off here rather
      // than having them switched on and hidden again a moment later — which is
      // what made the skeleton flash up between login and the first sentence.
      const bareShell = isExhibitionNarrationDesign(useSelectedDesignStore.getState().designId);
      useViewerStore.setState({
        bonesMeshVisible: !bareShell,
        shoeDataMeshVisible: !bareShell,
        liftedInsoleMeshVisible: !bareShell,
      });
      if (bareShell) {
        // The loader frames on a box that counts the shoe and the skeleton even
        // when they are not drawn, because Box3.setFromObject walks invisible
        // children too. On a design that opens with those hidden that left the
        // insoles small in the middle of a mostly empty screen, so the framing is
        // redone on what is actually visible — after a beat, since the toggles
        // above have to reach the meshes first.
        window.setTimeout(() => void frameVisibleMeshes(0.72, 0.1), 400);
      }
    }
  }

  const resetLeftToolbox = () => {
    if (useSelectedDesignStore.getState().templateReplaced || useDesignStore.getState().undoLoaded || useDesignStore.getState().mirrorLoaded || useDesignStore.getState().categoryChanged) {
      if (useViewerStore.getState().grids) enableGrids(true);
      else enableGrids(false);
    }
    else {
      useViewerStore.setState({
        grids: false,
        wireframe: 'insole',
        perspectiveCamera: true,
        clipping: false,
        bandHeightClipping: false,
        coloring: false,
        feetView: 'both',
        liveMode: true,
        linkMode: true,
      });
      enableGrids(false);
      if (!insoleDesign?.pressureData && useDesignStore.getState().RondomImageData.some(img => img == undefined)) useViewerStore.setState({ coloring: true });
    }
  }

  const initMeshes = (geometry: THREE.BufferGeometry, foot: number) => {
    if (geometry === null) { return; }

    // Initialize the 'selected' attribute for the original geometry
    const vertexCount = geometry.attributes.position.count;
    createSelectedVerticesAttribute(geometry, vertexCount);
    updateBaseLocation(geometry, foot);

    // Create the loaded mesh with the existing material
    const standardMaterail = {
      color: 0x156289,
      emissive: 0x072534,
      side: THREE.DoubleSide,
      flatShading: false,
      metalness: 0.8,  // Reduced from 0.8
      roughness: 0.1,  // Increased from 0.1
      opacity: 1.0,
      transparent: false,
    }
    const loadedMesh = new THREE.Mesh(geometry, new THREE.MeshStandardMaterial(standardMaterail));

    // Enable shadows for the mesh
    loadedMesh.castShadow = true;
    loadedMesh.receiveShadow = true;

    // Create the output mesh with the original geometry (no subdivision)
    let outputMesh = new THREE.Mesh(geometry.clone(), DEFAULT_MESH_MATERIAL);

    // Enable shadows for the output mesh
    outputMesh.castShadow = true;
    outputMesh.receiveShadow = true;
    outputMesh.userData.foot = foot;

    return { loadedMesh, outputMesh };
  };

  const updateBaseLocation = (geometry: THREE.BufferGeometry, foot: number) => {
    geometry.computeBoundingBox();
    var oldCenter = geometry.boundingBox!.getCenter(new THREE.Vector3()).clone();

    if (geometry.boundingBox!.min.x * geometry.boundingBox!.max.x < 0) {
      var displacement = 0;
      if (foot == 0) displacement += -geometry.boundingBox!.max.x;
      else displacement += -geometry.boundingBox!.min.x;

      geometry.translate(displacement, 0, 0);
    }

    var toOriginDistance = Math.min(Math.abs(geometry.boundingBox!.min.x), Math.abs(geometry.boundingBox!.max.x));

    if (toOriginDistance > originDistance || toOriginDistance < originDistance) {
      var centerDisplacement = Math.pow(-1, foot) * (toOriginDistance - originDistance);
      geometry.translate(centerDisplacement, 0, 0);

      if (centerDisplacement != 0 && insoleOldCenter.current[foot] == null) {
        insoleOldCenter.current[foot] = oldCenter;

        const design = useDesignStore.getState().insoleDesign;
        if (design?.designType != DesignType.Template && canEditDesign(user, design?.createdBy?.id)) {
          scheduleAutosave("Mesh location update",
            {
              updateInsoleMesh: true,
              updateAddition: true
            });
        }
      }
    }
  }

  const updateObjectsLocation = (geometry: THREE.Mesh, foot: number): THREE.Vector3 | null => {
    if (insoleOldCenter.current[foot] == null) return null;

    var insoleBox = GetInsoleBox(geometry);
    var newCenter = insoleBox.getCenter(new THREE.Vector3);
    var dif = new THREE.Vector3().subVectors(newCenter, insoleOldCenter.current[foot]);
    dif.y = 0;

    if (dif.x != 0) {
      if (useDesignStore.getState().pressureAlignment) {
        if (pressureAlignmentSphereRef.current.length > foot) {

          const translationMesh: THREE.Mesh = Object.assign({},
            pressureAlignmentSphereRef.current[foot].filter(
              sphere => sphere.userData.jointName === 'translation')[0]
          );

          translationMesh.position.add(dif);
          textureAlignment(translationMesh, foot);

          storePressureAlignment(foot);
          if (pressureAlignmentSphereRef.current.length == 2)
            savePressureAlignment();
        }
      }

      if (engraving && foot == 0)
        fitEngravingWithInsole(dif);
    }

    insoleOldCenter.current[foot] = null;
    return !useDesignStore.getState().undoLoaded ? dif : null;
  }

  const fitEngravingWithInsole = (trans: THREE.Vector3) => {
    var mainBox = new THREE.Box3().setFromObject(outputMeshRef.current[0]);
    var engraving = useDesignStore.getState().engraving;

    if (engraving.UIDMesh) {
      engraving.UIDMesh[0].position.add(trans);
      var uidBox = new THREE.Box3().setFromObject(engraving.UIDMesh[0]);
      if (!isBoxInside(uidBox, mainBox))
        fitInside(engraving.UIDMesh[0], outputMeshRef.current[0]);
      engraving.updateUID();
    }

    if (engraving.textMesh) {
      engraving.textMesh[0].position.add(trans);
      var textBox = new THREE.Box3().setFromObject(engraving.textMesh[0]);
      if (!isBoxInside(textBox, mainBox))
        fitInside(engraving.textMesh[0], outputMeshRef.current[0]);
      engraving.updateText();
    }

    if (engraving.CEMesh) {
      engraving.CEMesh[0].position.add(trans);
      var ceBox = new THREE.Box3().setFromObject(engraving.CEMesh[0]);
      if (!isBoxInside(ceBox, mainBox))
        fitInside(engraving.CEMesh[0], outputMeshRef.current[0]);
      engraving.updateCE();
    }
  }

  {/* Insole color and transparency update based on viewerStore*/ }
  const setColorandTransparency = () => {
    if (useViewerStore.getState().coloring) {
      const transparency = useViewerStore.getState().pressureTransparency;
      const topHexColor = useViewerStore.getState().topInsoleDefaultColor;
      const bottomHexColor = useViewerStore.getState().bottomInsoleDefaultColor;
      const topNewColor = new THREE.Color(`#${topHexColor}`);
      const bottomNewColor = new THREE.Color(`#${bottomHexColor}`);

      const alpha = transparency / 255;

      if (!outputMeshRef.current) return;

      outputMeshRef.current.forEach((mesh) => {
        if (!mesh || !mesh.geometry || !mesh.geometry.attributes.position) return;
        const material = mesh.material as THREE.MeshStandardMaterial;
        material.dispose();

        setColorBufferBySelection(mesh.geometry, bottomNewColor, topNewColor);

        const newMaterial = DEFAULT_MESH_MATERIAL.clone();
        newMaterial.opacity = alpha;
        newMaterial.needsUpdate = true;
        newMaterial.visible = !thirdQuarter.current || isSandal.current;
        mesh.material = newMaterial;
        mesh.castShadow = true;
        mesh.receiveShadow = true;

        mesh.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            const material = child.material as THREE.Material;
            material.dispose();

            setColorBufferBySelection(child.geometry, bottomNewColor, topNewColor);

            child.material = newMaterial.clone();
            child.material.visible = true;
            child.castShadow = true;
            child.receiveShadow = true;
          }
        });
      });

      LiftedMeshRef.current.forEach((mesh) => {
        if (!mesh || !mesh.geometry || !mesh.geometry.attributes.position) return;
        const material = mesh.material as THREE.MeshStandardMaterial;
        material.dispose();
        mesh.material = DEFAULT_MESH_MATERIAL.clone();
        mesh.material.vertexColors = false;
        mesh.material.visible = useViewerStore.getState().liftedInsoleMeshVisible;
        const currentViewerState = useViewerStore.getState();
        const liftedMeshColorObject = new THREE.Color(
          `#${currentViewerState.liftedInsoleDefaultColor}`
        );
        (mesh.material as THREE.MeshStandardMaterial).color = liftedMeshColorObject;
        if (currentViewerState.liftedInsoleTransparency < 255) {
          mesh.material.transparent = true;
        }
        const liftedMeshOpacity = currentViewerState.liftedInsoleTransparency / 255;
        mesh.material.opacity = liftedMeshOpacity;
        mesh.material.needsUpdate = true;
        mesh.castShadow = true;
        mesh.receiveShadow = true;
      });
    }

    insoleDesign?.insoles.forEach((insole: Insole) => {
      if (insole.footShoeMesh && insole.footShoeMesh.material instanceof THREE.MeshStandardMaterial) {
        const shoeMeshColorObject = new THREE.Color(`#${shoeDataMeshColor}`);
        insole.footShoeMesh.material.color = shoeMeshColorObject;
        const shoeMeshOpacity = shoeDataMeshTransparency / 255;
        if (shoeMeshOpacity < 1) {
          insole.footShoeMesh.material.transparent = true;
        }
        insole.footShoeMesh.material.opacity = shoeMeshOpacity;
      }
    });

    const shoeMeshOpacity = shoeDataMeshTransparency / 255;
    const sides = [0, 1];

    sides.forEach(side => {
      if (shoeInsideMarkerGroup.current[side]) {
        shoeInsideMarkerGroup.current[side].children.forEach(child => {
          if (child instanceof THREE.Mesh && child.name &&
            (child.name.startsWith('InsideLines_') || child.name.startsWith('OutsideLines_'))) {
            const material = child.material as THREE.MeshStandardMaterial;
            if (material) {
              material.transparent = shoeMeshOpacity < 1;
              material.opacity = shoeMeshOpacity;
              material.needsUpdate = true;
            }
          }
        });
      }

      if (shoeOutsideMarkerGroup.current[side]) {
        shoeOutsideMarkerGroup.current[side].children.forEach(child => {
          if (child instanceof THREE.Mesh && child.name &&
            (child.name.startsWith('InsideLines_') || child.name.startsWith('OutsideLines_'))) {
            const material = child.material as THREE.MeshStandardMaterial;
            if (material) {
              material.transparent = shoeMeshOpacity < 1;
              material.opacity = shoeMeshOpacity;
              material.needsUpdate = true;
            }
          }
        });
      }
    });

    const bonesOpacity = bonesTransparency / 255;
    insoleDesign?.insoles.forEach((insole: Insole) => {
      if (insole.bonesGroup) {
        insole.bonesGroup.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            const material = child.material as THREE.MeshStandardMaterial;
            if (material) {
              material.transparent = bonesOpacity < 1;
              material.opacity = bonesOpacity;
              material.needsUpdate = true;
            }
          } else if (child instanceof THREE.Group) {
            child.children.forEach(grandChild => {
              if (grandChild instanceof THREE.Mesh) {
                const material = grandChild.material as THREE.MeshStandardMaterial;
                if (material) {
                  material.transparent = bonesOpacity < 1;
                  material.opacity = bonesOpacity;
                  material.needsUpdate = true;
                }
              }
            });
          }
        });
      }
      if (insole.bonesFPIMarkers) {
        insole.bonesFPIMarkers.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            const material = child.material as THREE.MeshStandardMaterial;
            if (material) {
              material.transparent = bonesOpacity < 1;
              material.opacity = bonesOpacity;
              material.needsUpdate = true;
            }
          }
        });
      }
    });
  };

  function addShaderToMaterial(index: number) {
    if (!archEditLine.current[index]) return;

    const mainMat = outputMeshRef.current[index].material as THREE.Material;
    if (mainMat) mainMat.visible = true;

    const additions = useDesignStore.getState().insoleDesign?.insoles[index].additions;

    if (!thirdQuarter.current || isSandal.current) {
      outputMeshRef.current[index].children.forEach(child => {
        if (child instanceof THREE.Mesh) {
          child.removeFromParent();
          child.geometry.dispose();
        }
      });

      additions?.forEach(addition => {
        var additionMaterial = addition.viewMesh.material as THREE.Material;
        additionMaterial.onBeforeCompile = function () { };
      });
    }
    else {
      const lineGeometry = archEditLine.current[index].geometry;
      const positionAttribute = lineGeometry.attributes.position;

      // Extract X and Z coordinates from the line vertices
      var linePoints2D = [];
      for (let i = 0; i < positionAttribute.count; i++) {
        // Assuming the line is in local space or transformed correctly
        linePoints2D.push(new THREE.Vector2(
          positionAttribute.getX(i),
          positionAttribute.getZ(i) + archCutMargin
        ));
      }

      if (linePoints2D.length > 0) {
        linePoints2D.push(new THREE.Vector2(
          linePoints2D[linePoints2D.length - 1].x + (Math.pow(-1, index) * archCutMargin * 2),
          linePoints2D[linePoints2D.length - 1].y));
      }

      const customUniforms = {
        uLinePoints: { value: linePoints2D },
        uPointCount: { value: linePoints2D.length }
      };

      const shaderMaterial = (shader: any) => {
        // Inject uniforms into the shader scope
        shader.uniforms.uLinePoints = customUniforms.uLinePoints;
        shader.uniforms.uPointCount = customUniforms.uPointCount;

        // Inject world position into the vertex shader so we can evaluate it in the fragment shader
        shader.vertexShader = shader.vertexShader.replace(
          '#include <begin_vertex>',
          `
            #include <begin_vertex>
            vLocalPosition = position; // local model-space position
            //vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
            `
        );

        // Add the varying declaration at the top of vertex and fragment shaders
        shader.vertexShader = 'varying vec3 vLocalPosition;\n' + shader.vertexShader;
        shader.fragmentShader = `
            uniform vec2 uLinePoints[${linePoints2D.length}]; // Adjust size based on max line points expected
            uniform int uPointCount;
            varying vec3 vLocalPosition;
            ` + shader.fragmentShader;

        // Inject discard logic in the fragment shader
        // (Example: Discard pixels if they are past a certain threshold or side of your curved mesh)
        shader.fragmentShader = shader.fragmentShader.replace(
          '#include <color_fragment>',
          `
            #include <color_fragment>
    
            // Find the corresponding Z threshold on the line for this pixel's X coordinate
            float targetZ = -9999.0;
            bool foundX = false;

            // Simple lookup / interpolation along the line points
            for (int i = 0; i < ${linePoints2D.length}; i++) {
              if (i >= uPointCount - 1) break;

              vec2 p1 = uLinePoints[i];
              vec2 p2 = uLinePoints[i+1];

              // Check if current fragment's X falls between this segment's X bounds
              if (vLocalPosition.x >= min(p1.x, p2.x) && vLocalPosition.x <= max(p1.x, p2.x)) {
                // Interpolate Z on the line for this X position
                float t = (vLocalPosition.x - p1.x) / (p2.x - p1.x + 0.0001);
                targetZ = mix(p1.y, p2.y, t); // p.y stores our Z coordinate here
                foundX = true;
                break;
              }
            }

            // If we found a valid point on the line, check if fragment is "after" it in Z
            if (foundX && vLocalPosition.z > targetZ) {
              discard;
            }
          `
        );
      };

      additions?.forEach(addition => {
        var additionMaterial = addition.viewMesh.material as THREE.Material;
        additionMaterial.onBeforeCompile = shaderMaterial;
      });

      createCutCrossSection(linePoints2D, index);
    }
  }

  function createCutCrossSection(linePoints2D: THREE.Vector2[], foot: number) {
    [...outputMeshRef.current[foot].children].forEach(child => {
      outputMeshRef.current[foot].remove(child);
      DisposeMesh(child);
    });

    outputMeshRef.current[foot].geometry.computeVertexNormals();
    var maxY = (outputMeshRef.current[foot].geometry.boundingBox?.max.z ?? 0) + 5;

    const cutterVertices = [
      new THREE.Vector2(linePoints2D[0].x, maxY),
      ...linePoints2D,
      new THREE.Vector2(linePoints2D[linePoints2D.length - 1].x, maxY)
    ];

    const extrudeSettings = {
      steps: 1,
      depth: 50,           // How thick/deep the cutter 3D volume will be
      bevelEnabled: true
    };

    const cutterShape = new THREE.Shape(cutterVertices);
    cutterShape.closePath();
    let cutterGeometry = new THREE.ExtrudeGeometry(cutterShape, extrudeSettings);
    cutterGeometry.translate(0, 0, -25);    // center cutter position 
    cutterGeometry.rotateX(Math.PI / 2);
    cutterGeometry.setAttribute(
      'selected',
      new THREE.BufferAttribute(new Float32Array(cutterGeometry.attributes.position.count), 1)
    );

    var capMat = (outputMeshRef.current[foot].material as THREE.Material).clone() as THREE.MeshStandardMaterial;
    const cutterCSG = new Brush(cutterGeometry);
    const insoleCSG = new Brush(prepareGeometry(outputMeshRef.current[foot].geometry));

    const csgEvaluator = new Evaluator();
    csgEvaluator.attributes = ['position', 'normal', 'selected'];
    const resultCSG = csgEvaluator.evaluate(insoleCSG, cutterCSG, SUBTRACTION);

    // Fix: Ensure the geometry has an index. If not, generate one.
    if (!resultCSG.geometry.getIndex()) {
      const posAttr = resultCSG.geometry.getAttribute('position');
      const vertexCount = posAttr.count;

      // Assume triangles (three vertices per face)
      const indexArray = [];
      for (let i = 0; i < vertexCount; i++) {
        indexArray.push(i);
      }
      resultCSG.geometry.setIndex(indexArray);
    }

    resultCSG.material = capMat;
    setColorBufferBySelection(resultCSG.geometry, DEFAULT_BOTTOM_MESH_COLOR, DEFAULT_TOP_MESH_COLOR);
    resultCSG.name = 'cap';
    outputMeshRef.current[foot].add(resultCSG);

    // Hide parent geometry only — Object3D.visible=false also hides children.
    const mainMat = outputMeshRef.current[foot].material as THREE.Material;
    if (mainMat) mainMat.visible = false;
    resultCSG.visible = true;
  }

  function propertyToLabel(property: string): string {
    return property
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, c => c.toUpperCase());
  }

  function labelToProperty(property: string): keyof MeshJoints["surface"] {
    return property
      .replace(/\s+/g, "")
      .replace(/^./, c => c.toLowerCase()) as keyof MeshJoints["surface"];
  }

  useEffect(() => {
    setColorandTransparency();
  }, [
    topInsoleDefaultColor,
    bottomInsoleDefaultColor,
    useViewerStore((state) => state.pressureTransparency),
    liftedMeshColor,
    liftedMeshTransparency,
    shoeDataMeshColor,
    shoeDataMeshTransparency,
    bonesTransparency
  ]);

  useEffect(() => {
    updateGizmo(isBackdropOpen)
  }, [isBackdropOpen]);

  useEffect(() => {
    // useViewerStore.setState({ alignPressure: false });
    setColoring(useViewerStore.getState().coloring);
  }, [useViewerStore((state) => state.coloring)]);

  const setColoring = (coloring: boolean = false) => {
    if (!insoleDesign || !insoleDesign.insoles) return;
    if (coloring) {
      setColorandTransparency();
      // alignPressureToggle = false;
      useViewerStore.setState({ alignPressure: false });
    } else {
      if (!outputMeshRef.current?.[0] || !outputMeshRef.current?.[1]) return;
      const pData = useDesignStore.getState().insoleDesign?.pressureData;
      const rondom = useDesignStore.getState().RondomImageData;
      if (pData) initPressureImage(pData);
      if (!rondom.some(img => img == undefined)) initRondomPressureImages(rondom, true);
    }
  };

  const enableGrids = (visible: boolean = true) => {
    const localInsoleDesign = useDesignStore.getState().insoleDesign;
    if (!sceneRef?.current || !localInsoleDesign) return;

    let gridHelpers = sceneRef.current.children.filter(
      (obj) => obj instanceof CustomGridHelper || obj instanceof Text
    );

    if (visible) createGridHelpers();

    gridHelpers.forEach((helper) => {
      helper.visible = visible;
    });
  };

  const getThemeBackgroundColor = () => {
    const root = document.body;
    const styles = getComputedStyle(root);

    return styles.getPropertyValue('--viewer-bg').trim();
  };

  const updateBackgroundColor = () => {
    if (sceneRef.current && cameraRef.current && rendererRef.current) {
      const color = getThemeBackgroundColor();
      //console.log('Updating background color to theme color:', color);
      const threeColor = new THREE.Color(color);

      sceneRef.current.background = threeColor;
      rendererRef.current.setClearColor(threeColor);

      // Force a render to apply changes
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    }
  };

  const updateGizmo = (hide: boolean = false) => {
    if (gizmoRef.current) {
      gizmoRef.current.set(getGizmoConfig(hide));
      gizmoRef.current.camera = cameraRef.current! as THREE.PerspectiveCamera | THREE.OrthographicCamera;
      if (controlsRef.current) {
        gizmoRef.current?.attachControls(controlsRef.current);
      }
      gizmoRef.current?.update();
    }
  }

  // --- CLIPPING PLANES LOGIC ---
  useEffect(() => {
    let planeX: THREE.Plane | null = null;
    let planeZ: THREE.Plane | null = null;

    const updateLabelsWithClipping = () => {
      const planes = [planeX, planeZ].filter((p): p is THREE.Plane => !!p);
      const currentInsoleState = useViewerStore.getState().insolesVisible;
      const currentAdditionState = useViewerStore.getState().additionsViewMeshVisible;
      const currentFeetViewState = useViewerStore.getState().feetView;
      const currentLiveModeState = useViewerStore.getState().liveMode;

      const shouldShowFoot = (footStr: string): boolean => {
        if (currentFeetViewState === 'right') return footStr === '0';
        if (currentFeetViewState === 'left') return footStr === '1';
        return true;
      };

      const calculateVisibility = (position: THREE.Vector3, defaultState: boolean): boolean => {
        if (planes.length === 0) return defaultState;

        for (const plane of planes) {
          if (plane.distanceToPoint(position) < 0) {
            return false;
          }
        }
        return defaultState;
      };

      // ====== 1. Sphere Labels ======
      const excludedJoints = ["Heel Fill", "Arch Fill"];

      sphereLabelsRef.current.forEach((label, key) => {
        const [footStr, jointName] = key.split('_');

        if (!shouldShowFoot(footStr)) {
          label.visible = false;
          return;
        }

        const footIndex = parseInt(footStr);
        let sphere: THREE.Object3D | undefined;

        if (!excludedJoints.includes(jointName)) {
          sphere = surfaceJointSpheresRef.current[footIndex]?.find(
            (s) => s.userData?.jointName === jointName
          );
        } else {
          sphere = archGuideSpheresRef.current[footIndex];
        }

        if (sphere && planes.length > 0) {
          const worldPos = sphere.getWorldPosition(new THREE.Vector3());
          label.visible = calculateVisibility(worldPos, currentInsoleState);
        } else {
          label.visible = currentInsoleState;
        }
      });

      // ====== 2. Addition Labels ======
      updateAdditionsRef();

      additionLabelsRef.current.forEach((label, key) => {
        const [footStr, indexStr] = key.split('_');

        if (!shouldShowFoot(footStr)) {
          label.visible = false;
          return;
        }

        const footType = footStr === "0" ? 'right' : 'left';
        const index = parseInt(indexStr);

        const additionsForFoot = additionsRef.current.filter(
          (a) => a.foot === footType
        );
        const addition = additionsForFoot[index];

        if (addition?.viewMesh && planes.length > 0) {
          addition.viewMesh.updateMatrixWorld(true);
          const worldPos = addition.additionCenter;
          label.visible = calculateVisibility(worldPos, currentAdditionState);
        } else {
          label.visible = currentAdditionState;
        }
      });

      // ====== 3. Dimension Labels ======
      dimensionLabelsRef.current.forEach((label, key) => {
        const [footStr] = key.split('_');

        if (!shouldShowFoot(footStr)) {
          label.visible = false;
          const hiddenLine = dimensionLinesRef.current.get(`line_${key}`);
          if (hiddenLine) hiddenLine.visible = false;
          return;
        }

        const footIndex = parseInt(footStr);
        const sphere = dimensionSpheresRef.current[footIndex];
        const lineKey = `line_${key}`;
        const line = dimensionLinesRef.current.get(lineKey);

        if (sphere && planes.length > 0) {
          const worldPos = sphere.getWorldPosition(new THREE.Vector3());
          const visible = calculateVisibility(worldPos, currentInsoleState);

          label.visible = visible;
          if (line) line.visible = visible;
        } else {
          label.visible = currentInsoleState;
          if (line) line.visible = currentInsoleState;
        }
      });

      // ====== 4. Toolbox Panels ======
      toolboxPanelRef.current.forEach((panel) => {
        if (!panel) return;

        if (planes.length > 0) {
          const worldPos = panel.getWorldPosition(new THREE.Vector3());
          panel.visible = calculateVisibility(worldPos, currentLiveModeState && currentInsoleState);
        } else {
          panel.visible = currentLiveModeState && currentInsoleState;
        }
      });

      // ====== 5. New Addition Labels ======
      newAdditionLabelsRef.current.forEach((label, key) => {
        const [_, footStr] = key.split('_');

        if (!shouldShowFoot(footStr)) {
          label.visible = false;
          return;
        }

        if (planes.length > 0) {
          const worldPos = label.getWorldPosition(new THREE.Vector3());
          label.visible = calculateVisibility(worldPos, currentInsoleState);
        } else {
          label.visible = currentInsoleState;
        }
      });
    };

    const handleClippingPlanesChange = (event: CustomEvent) => {
      // Support both new Clipper and legacy event shapes
      if (event.detail && event.detail.planes && event.detail.planes.length === 1 && event.detail.axis) {
        if (event.detail.axis === 'x') {
          planeX = event.detail.planes[0];
        } else if (event.detail.axis === 'z') {
          planeZ = event.detail.planes[0];
        }
      }
      // Compose planes array for renderer
      const planes: THREE.Plane[] = [planeX, planeZ, bandClipPlaneRef.current].filter((p): p is THREE.Plane => !!p);
      if (rendererRef.current) {
        rendererRef.current.clippingPlanes = planes;
        rendererRef.current.localClippingEnabled = planes.length > 0;
      }

      if (useViewerStore.getState().liveMode) {
        updateLabelsWithClipping();
      }
    };
    document.addEventListener('clippingPlanesChange', handleClippingPlanesChange as EventListener);

    // Listen for deactivation (when user hides the clippers)
    const handleDeactivateClipping = () => {
      //const visibilityState = findVisibilityState();
      planeX = null;
      planeZ = null;

      const planes: THREE.Plane[] = [bandClipPlaneRef.current].filter((p): p is THREE.Plane => !!p);
      if (rendererRef.current) {
        rendererRef.current.clippingPlanes = planes;
        rendererRef.current.localClippingEnabled = planes.length > 0;
      }
      if (useViewerStore.getState().liveMode) {
        const currentInsoleState = useViewerStore.getState().insolesVisible;
        const currentAdditionState = useViewerStore.getState().additionsViewMeshVisible;
        const showRight = isFootShownInView(0);
        const showLeft = isFootShownInView(1);

        setLabelsVisibility('right', showRight && currentInsoleState, showRight && currentAdditionState);
        setLabelsVisibility('left', showLeft && currentInsoleState, showLeft && currentAdditionState);
      }
    };

    document.addEventListener('deactivateClipping', handleDeactivateClipping);

    // Respond to Clipper's request for mesh bounds
    const handleRequestClippingBounds = (event: any) => {
      if (sceneRef.current) {
        const box = new THREE.Box3();
        let found = false;
        sceneRef.current.traverse(obj => {
          if (obj instanceof THREE.Mesh && obj.visible) {
            const meshBox = new THREE.Box3().setFromObject(obj);
            if (!meshBox.isEmpty()) {
              box.union(meshBox);
              found = true;
            }
          }
        });
        if (found) {
          event.detail.callback({
            minX: box.min.x * 1.1,
            maxX: box.max.x * 1.1,
            minZ: box.min.z * 1.1,
            maxZ: box.max.z * 1.1
          });
        }
      }
    };
    document.addEventListener('requestClippingBounds', handleRequestClippingBounds);

    return () => {
      document.removeEventListener('clippingPlanesChange', handleClippingPlanesChange as EventListener);
      document.removeEventListener('deactivateClipping', handleDeactivateClipping);
      document.removeEventListener('requestClippingBounds', handleRequestClippingBounds);
    };
  }, []);

  function getGizmoConfig(hide: boolean = false) {
    const type: 'cube' | 'sphere' = "cube";
    if (hide) {
      return { size: 0, type };
    }

    const size = isTablet() || isMobile() ? 90 : 90;
    const gizmoColors = getGizmoColors();
    const placement: "bottom-left" | "top-left" | "top-center" = window.innerWidth < 1250 ? 'top-left' : 'bottom-left';
    let offset = {};
    if (window.innerWidth <= 430) {
      offset = { top: 12 + 64, left: 12 };
    } else if (window.innerWidth <= 1250) {
      offset = { top: 12 + 64, left: 24 };
    } else {
      offset = { left: 22, bottom: (size + 40) * -1 }
    }
    return {
      placement,
      offset: offset,
      size: size,
      container: window.innerWidth < 1250 ? containerRef?.current : toolbarRef?.current || undefined, // Set location of ViewPortGizmo based on a parent container 
      type,
      lineWidth: 1,
      ...gizmoColors,
    }
  }

  const previousEngravingCameraStateRef = useRef<{
    position: THREE.Vector3;
    target: THREE.Vector3;
  } | null>(null);
  const lastToolboxModeRef = useRef(rightToolboxMode);

  function setCameraViewWithAnimation(
    camera: THREE.Camera,
    controls: OrbitControls,
    container: HTMLDivElement,
    sceneRef: any,
    mode: 'engraving' | 'default' = 'default',
    duration = 2
  ) {
    if (!camera || !controls || !container || !sceneRef.current) return;

    const startPos = camera.position.clone();
    const startTarget = controls.target.clone();

    let endPos: THREE.Vector3;
    let endTarget: THREE.Vector3;

    if (mode === 'engraving') {
      if (!previousEngravingCameraStateRef.current) {
        previousEngravingCameraStateRef.current = {
          position: startPos.clone(),
          target: startTarget.clone(),
        };
      }

      const box = new THREE.Box3();
      let found = false;
      sceneRef.current.traverse((obj: THREE.Object3D) => {
        if (obj instanceof THREE.Mesh && obj.visible && obj.geometry) {
          box.expandByObject(obj);
          found = true;
        }
      });
      if (!found) return;

      const center = box.getCenter(new THREE.Vector3());
      const size = box.getSize(new THREE.Vector3());
      const maxDim = Math.max(size.x, size.y, size.z);

      endTarget = center.clone();
      endTarget.z += maxDim * 0.05;
      endPos = center.clone().add(new THREE.Vector3(0, -maxDim * 1.1, maxDim * 0.1));

    } else {
      if (!previousEngravingCameraStateRef.current) return;

      endPos = previousEngravingCameraStateRef.current.position.clone();
      endTarget = previousEngravingCameraStateRef.current.target.clone();
      previousEngravingCameraStateRef.current = null;
    }

    const clock = new THREE.Clock();
    let elapsed = 0;

    function animate() {
      elapsed += clock.getDelta();
      const t = Math.min(elapsed / duration, 1);
      const easedT = easeInOutCubic(t);
      camera.position.lerpVectors(startPos, endPos, easedT);
      controls.target.lerpVectors(startTarget, endTarget, easedT);

      camera.lookAt(controls.target);
      controls.update();

      if ((gizmoRef.current as any)?.cameraUpdate) {
        (gizmoRef.current as any).cameraUpdate();
      }

      if (t < 1) requestAnimationFrame(animate);
      // Nothing on arrival. The 'default' leg has just finished animating back
      // to the exact position and target saved on the way into engraving, and
      // re-fitting the scene here threw that away and framed the whole scene
      // instead — which left the insoles sitting much further off than where
      // the user had them.
    }
    animate();
  }

  function captureInitialCameraView() {
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    if (!camera || !controls) return;
    const saved: {
      position: THREE.Vector3;
      target: THREE.Vector3;
      up: THREE.Vector3;
      distance: number;
      ortho?: { left: number; right: number; top: number; bottom: number };
    } = {
      position: camera.position.clone(),
      target: controls.target.clone(),
      up: camera.up.clone(),
      distance: Math.max(camera.position.distanceTo(controls.target), 1),
    };
    const orthoCam = camera instanceof THREE.OrthographicCamera
      ? camera
      : orthographicCameraRef.current;
    if (orthoCam) {
      saved.ortho = {
        left: orthoCam.left,
        right: orthoCam.right,
        top: orthoCam.top,
        bottom: orthoCam.bottom,
      };
    }
    initialCameraViewRef.current = saved;
  }

  function applyOrthoFramed(camera: THREE.Camera, ortho: { left: number; right: number; top: number; bottom: number }) {
    if (!(camera instanceof THREE.OrthographicCamera)) return;
    camera.left = ortho.left;
    camera.right = ortho.right;
    camera.top = ortho.top;
    camera.bottom = ortho.bottom;
    camera.zoom = ORTHO_FIXED_ZOOM;
    camera.updateProjectionMatrix();
  }

  function restoreInitialCameraView(duration = 0.8) {
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    const saved = initialCameraViewRef.current;
    if (!camera || !controls) return;

    if (!saved) {
      if (containerRef.current && sceneRef.current) {
        fitCameraToSceneObjects(camera, controls, containerRef.current, sceneRef, 'load');
        captureInitialCameraView();
      }
      if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
      return;
    }

    camera.up.copy(saved.up);
    const startPos = camera.position.clone();
    const startTarget = controls.target.clone();
    const endPos = saved.position.clone();
    const endTarget = saved.target.clone();
    const startOrtho = camera instanceof THREE.OrthographicCamera
      ? { left: camera.left, right: camera.right, top: camera.top, bottom: camera.bottom }
      : null;
    const endOrtho = saved.ortho;
    const prevDamping = controls.enableDamping;
    controls.enableDamping = false;
    const clock = new THREE.Clock();
    let elapsed = 0;

    function finishHome() {
      camera.position.copy(endPos);
      controls.target.copy(endTarget);
      camera.up.copy(saved.up);
      camera.lookAt(controls.target);
      if (endOrtho) {
        applyOrthoFramed(camera, endOrtho);
        if (orthographicCameraRef.current && orthographicCameraRef.current !== camera) {
          applyOrthoFramed(orthographicCameraRef.current, endOrtho);
        }
      }
      controls.enableDamping = prevDamping;
      controls.update();
      if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
    }

    if (duration <= 0) {
      finishHome();
      return;
    }

    function animateHome() {
      elapsed += clock.getDelta();
      const t = Math.min(elapsed / duration, 1);
      const easedT = easeInOutCubic(t);
      camera.position.lerpVectors(startPos, endPos, easedT);
      controls.target.lerpVectors(startTarget, endTarget, easedT);
      camera.lookAt(controls.target);
      if (camera instanceof THREE.OrthographicCamera && startOrtho && endOrtho) {
        camera.left = startOrtho.left + (endOrtho.left - startOrtho.left) * easedT;
        camera.right = startOrtho.right + (endOrtho.right - startOrtho.right) * easedT;
        camera.top = startOrtho.top + (endOrtho.top - startOrtho.top) * easedT;
        camera.bottom = startOrtho.bottom + (endOrtho.bottom - startOrtho.bottom) * easedT;
        camera.zoom = ORTHO_FIXED_ZOOM;
        camera.updateProjectionMatrix();
      }
      controls.update();
      if ((gizmoRef.current as any)?.cameraUpdate) {
        (gizmoRef.current as any).cameraUpdate();
      }
      if (t < 1) requestAnimationFrame(animateHome);
      else finishHome();
    }
    animateHome();
  }

  type CameraViewSnapshot = {
    position: THREE.Vector3;
    target: THREE.Vector3;
    up: THREE.Vector3;
    distance: number;
    ortho?: { left: number; right: number; top: number; bottom: number; zoom?: number };
  };

  function snapshotCameraView(): CameraViewSnapshot | null {
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    if (!camera || !controls) return null;
    const saved: CameraViewSnapshot = {
      position: camera.position.clone(),
      target: controls.target.clone(),
      up: camera.up.clone(),
      distance: Math.max(camera.position.distanceTo(controls.target), 1),
    };
    if (camera instanceof THREE.OrthographicCamera) {
      saved.ortho = {
        left: camera.left,
        right: camera.right,
        top: camera.top,
        bottom: camera.bottom,
        zoom: camera.zoom,
      };
    }
    return saved;
  }

  function restoreCameraView(saved: CameraViewSnapshot, durationOverride?: number): Promise<void> {
    return new Promise((resolve) => {
      const camera = cameraRef.current;
      const controls = controlsRef.current;
      if (!camera || !controls) {
        resolve();
        return;
      }

      const startPos = camera.position.clone();
      const startTarget = controls.target.clone();
      const startUp = camera.up.clone();
      const startOrtho = camera instanceof THREE.OrthographicCamera
        ? { left: camera.left, right: camera.right, top: camera.top, bottom: camera.bottom, zoom: camera.zoom }
        : null;
      const endPos = saved.position.clone();
      const endTarget = saved.target.clone();
      const endUp = saved.up.clone();
      const endOrtho = saved.ortho
        ? {
          left: saved.ortho.left,
          right: saved.ortho.right,
          top: saved.ortho.top,
          bottom: saved.ortho.bottom,
          zoom: saved.ortho.zoom ?? ORTHO_FIXED_ZOOM,
        }
        : null;
      const duration = durationOverride ?? calculateCameraMoveDuration(startPos, endPos, startTarget, endTarget);

      animateCameraTransition(
        camera,
        controls,
        startPos,
        startTarget,
        startUp,
        startOrtho,
        endPos,
        endTarget,
        endUp,
        endOrtho,
        duration,
        resolve,
      );
    });
  }

  function getViewerDisplaySize(el?: HTMLElement | null) {
    const node = el || containerRef.current || rendererRef.current?.domElement;
    const rect = node?.getBoundingClientRect();
    const widthPx = Math.max(rect?.width || 0, node?.clientWidth || 0, 1);
    const heightPx = Math.max(rect?.height || 0, node?.clientHeight || 0, 1);
    return { widthPx, heightPx, aspect: widthPx / heightPx };
  }

  function getVoiceDisplayView() {
    const camera = cameraRef.current!;
    const controls = controlsRef.current!;
    const { widthPx, heightPx, aspect } = getViewerDisplaySize();
    const dist = Math.max(camera.position.distanceTo(controls.target), 1);

    if (camera instanceof THREE.PerspectiveCamera) {
      camera.aspect = aspect;
      camera.updateProjectionMatrix();
    } else if (camera instanceof THREE.OrthographicCamera) {
      const spanY = Math.max(camera.top - camera.bottom, 1);
      const spanX = spanY * aspect;
      const cx = (camera.left + camera.right) / 2;
      const cy = (camera.top + camera.bottom) / 2;
      camera.left = cx - spanX / 2;
      camera.right = cx + spanX / 2;
      camera.top = cy + spanY / 2;
      camera.bottom = cy - spanY / 2;
      camera.updateProjectionMatrix();
    }

    let viewHeight = dist * 0.5;
    if (camera instanceof THREE.OrthographicCamera) {
      viewHeight = Math.max(camera.top - camera.bottom, 1);
    } else if ("fov" in camera) {
      viewHeight = 2 * dist * Math.tan(((camera as THREE.PerspectiveCamera).fov * Math.PI) / 360);
    }
    return {
      widthPx,
      heightPx,
      viewWidth: viewHeight * aspect,
      viewHeight,
      dist,
    };
  }

  function applyVoiceZoom(action: string, amount?: number) {
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    if (!camera || !controls) return;

    const { widthPx, heightPx } = getVoiceDisplayView();
    const percent = Number.isFinite(amount) && (amount as number) > 0
      ? Math.min(80, amount as number)
      : 25;
    const phone = Math.min(widthPx, heightPx) < 768;
    const displayScale = phone
      ? Math.max(0.5, Math.min(widthPx, heightPx) / 768)
      : 1;
    const step = 1 + (percent / 100) * displayScale;
    const maxFactor = 4;

    if (action === "reset") {
      const saved = initialCameraViewRef.current;
      if (!saved) {
        restoreInitialCameraView(0.5);
        return;
      }
      const dir = camera.position.clone().sub(controls.target);
      if (dir.lengthSq() < 1e-8) dir.set(0, 0, 1);
      dir.normalize().multiplyScalar(saved.distance);
      camera.position.copy(controls.target).add(dir);
      if (saved.ortho) {
        applyOrthoFramed(camera, saved.ortho);
        if (orthographicCameraRef.current && orthographicCameraRef.current !== camera) {
          applyOrthoFramed(orthographicCameraRef.current, saved.ortho);
        }
      }
      camera.lookAt(controls.target);
      controls.update();
      if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
      return;
    }

    const closer = action === "in";
    const saved = initialCameraViewRef.current;

    if (camera instanceof THREE.OrthographicCamera) {
      const homeSpan = saved?.ortho
        ? Math.max(saved.ortho.top - saved.ortho.bottom, 1)
        : Math.max(camera.top - camera.bottom, 1);
      const currentSpan = Math.max(camera.top - camera.bottom, 1);
      const minSpan = homeSpan / maxFactor;
      const maxSpan = homeSpan * maxFactor;
      let nextSpan = closer ? currentSpan / step : currentSpan * step;
      nextSpan = Math.min(maxSpan, Math.max(minSpan, nextSpan));
      const apply = nextSpan / currentSpan;
      camera.left *= apply;
      camera.right *= apply;
      camera.top *= apply;
      camera.bottom *= apply;
      camera.updateProjectionMatrix();
    } else {
      const homeDistance = saved?.distance || Math.max(camera.position.distanceTo(controls.target), 1);
      const dir = camera.position.clone().sub(controls.target);
      const current = Math.max(dir.length(), 1);
      const minDistance = homeDistance / maxFactor;
      const maxDistance = homeDistance * maxFactor;
      let next = closer ? current / step : current * step;
      next = Math.min(maxDistance, Math.max(minDistance, next));
      dir.normalize().multiplyScalar(next);
      camera.position.copy(controls.target).add(dir);
      camera.lookAt(controls.target);
    }

    controls.update();
    if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
  }

  function applyVoicePan(action: string, amount?: number) {
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    if (!camera || !controls) return;

    const { viewWidth, viewHeight, dist } = getVoiceDisplayView();
    const percent = Number.isFinite(amount) && (amount as number) > 0
      ? Math.min(80, amount as number)
      : 25;

    if (action === "reset") {
      const saved = initialCameraViewRef.current;
      if (!saved) {
        restoreInitialCameraView(0.5);
        return;
      }
      const look = camera.position.clone().sub(controls.target);
      const dist = Math.max(look.length(), 1);
      if (look.lengthSq() < 1e-8) look.set(0, 0, 1);
      look.normalize().multiplyScalar(dist);
      controls.target.copy(saved.target);
      camera.position.copy(saved.target).add(look);
      camera.lookAt(controls.target);
      controls.update();
      if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
      return;
    }

    const look = controls.target.clone().sub(camera.position);
    if (look.lengthSq() < 1e-8) look.set(0, 0, -1);
    look.normalize();
    const right = new THREE.Vector3().crossVectors(look, camera.up);
    if (right.lengthSq() < 1e-8) right.set(1, 0, 0);
    right.normalize();
    const up = new THREE.Vector3().crossVectors(right, look).normalize();

    const horizontal = viewWidth * (percent / 100);
    const vertical = viewHeight * (percent / 100);
    const offset = new THREE.Vector3();
    if (action === "left") offset.copy(right).multiplyScalar(-horizontal);
    else if (action === "right") offset.copy(right).multiplyScalar(horizontal);
    else if (action === "up") offset.copy(up).multiplyScalar(vertical);
    else if (action === "down") offset.copy(up).multiplyScalar(-vertical);
    else return;

    const saved = initialCameraViewRef.current;
    if (saved) {
      const nextTarget = controls.target.clone().add(offset);
      const maxPan = Math.max(saved.distance, dist) * 2;
      const fromHome = nextTarget.clone().sub(saved.target);
      if (fromHome.length() > maxPan) {
        fromHome.setLength(maxPan);
        nextTarget.copy(saved.target).add(fromHome);
        offset.copy(nextTarget).sub(controls.target);
      }
    }

    camera.position.add(offset);
    controls.target.add(offset);
    camera.lookAt(controls.target);
    controls.update();
    if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
  }

  function setNamedCameraView(view: string, duration = 0.8, onComplete?: () => void) {
    const camera = cameraRef.current;
    const controls = controlsRef.current;
    const container = containerRef.current;
    if (!camera || !controls || !container || !sceneRef.current) {
      onComplete?.();
      return;
    }

    camera.up.set(0, 1, 0);

    if (view === 'reset') {
      restoreInitialCameraView(duration);
      window.setTimeout(() => onComplete?.(), duration * 1000 + 40);
      return;
    }

    const offset = getNamedViewOffset(view, 1);
    if (!offset || offset.lengthSq() < 1e-8) {
      onComplete?.();
      return;
    }

    const insoleMeshes = (outputMeshRef.current || []).filter((mesh): mesh is THREE.Mesh => !!mesh);
    const box = new THREE.Box3();
    insoleMeshes.forEach((mesh) => box.expandByObject(mesh));
    if (box.isEmpty()) {
      box.copy(calculateBoundingBoxOfAllMeshes(sceneRef.current));
    }
    if (box.isEmpty()) {
      onComplete?.();
      return;
    }
    const center = box.getCenter(new THREE.Vector3());

    const cam = camera;
    const orbit = controls;
    const startPos = cam.position.clone();
    const startTarget = orbit.target.clone();
    const startUp = cam.up.clone();
    const startOrtho = cam instanceof THREE.OrthographicCamera
      ? { left: cam.left, right: cam.right, top: cam.top, bottom: cam.bottom, zoom: cam.zoom }
      : null;

    cam.up.set(0, 1, 0);
    orbit.target.copy(center);
    cam.position.copy(center).add(offset.normalize().multiplyScalar(100));
    cam.lookAt(center);
    orbit.update();
    fitCameraToSceneObjects(cam, orbit, container, sceneRef, 'toggle');
    if (cam instanceof THREE.OrthographicCamera) {
      cam.zoom = ORTHO_FIXED_ZOOM;
      cam.updateProjectionMatrix();
    }

    const endPos = cam.position.clone();
    const endTarget = orbit.target.clone();
    const endUp = cam.up.clone();
    const endOrtho = cam instanceof THREE.OrthographicCamera
      ? { left: cam.left, right: cam.right, top: cam.top, bottom: cam.bottom, zoom: cam.zoom }
      : null;

    cam.position.copy(startPos);
    orbit.target.copy(startTarget);
    cam.up.copy(startUp);
    if (startOrtho && cam instanceof THREE.OrthographicCamera) {
      cam.left = startOrtho.left;
      cam.right = startOrtho.right;
      cam.top = startOrtho.top;
      cam.bottom = startOrtho.bottom;
      cam.zoom = startOrtho.zoom;
      cam.updateProjectionMatrix();
    }
    cam.lookAt(orbit.target);

    animateCameraTransition(cam, orbit, startPos, startTarget, startUp, startOrtho, endPos, endTarget, endUp, endOrtho, duration, onComplete);
  }

  /**
   * Bounding box of the meshes actually being drawn.
   *
   * Written rather than reusing calculateBoundingBoxOfAllMeshes, which tests
   * obj.visible and then calls Box3.setFromObject on that object — and
   * setFromObject walks every descendant whether or not it is visible. With one
   * foot hidden the box therefore still spanned both, so its centre sat between
   * them and the visible foot ended up off to one side. Only leaf meshes are
   * measured here, and an invisible ancestor disqualifies its whole branch.
   */
  function visibleMeshesBox(): THREE.Box3 {
    const box = new THREE.Box3();
    const scene = sceneRef.current;
    if (!scene) return box;
    scene.updateMatrixWorld(true);
    scene.traverse((obj) => {
      if (!(obj instanceof THREE.Mesh) || !obj.geometry) return;
      // Helpers and annotations are not the subject, and the grid in particular
      // is far larger than the feet.
      if (obj instanceof CustomGridHelper || obj instanceof Text) return;
      for (let node: THREE.Object3D | null = obj; node; node = node.parent) {
        if (!node.visible) return;
      }
      const meshBox = new THREE.Box3().setFromObject(obj);
      if (!meshBox.isEmpty()) box.union(meshBox);
    });
    return box;
  }

  /**
   * Move the camera to frame the meshes on screen, as an animated move.
   *
   * fitCameraToSceneObjects does the same arithmetic but writes the result
   * straight onto the camera, so the view jumps. That is fine when a toggle has
   * already changed the picture, and wrong in the middle of a narration, where
   * every change of subject should be a move the eye can follow.
   */
  function frameVisibleMeshes(
    fill = 0.6,
    durationSec = 1.2,
    avoidOverhead = false,
    view?: string,
  ): Promise<void> {
    const cam = cameraRef.current;
    const orbit = controlsRef.current;
    const container = containerRef.current;
    if (!cam || !orbit || !container) return Promise.resolve();

    const box = visibleMeshesBox();
    if (box.isEmpty()) return Promise.resolve();

    const centre = box.getCenter(new THREE.Vector3());
    const dir = cam.position.clone().sub(orbit.target);
    if (dir.lengthSq() < 1e-8) dir.set(0, 0, 1);
    dir.normalize();
    // A named direction, framed on the visible meshes in one move. Asking for the
    // named view and then re-framing was two moves, and the named view's own
    // framing counts the shoe and the skeleton whether or not they are drawn,
    // which is what left the camera so far back.
    if (view === "reset") {
      // The angle the design opened at, but framed on what is visible now. The
      // reset view restores the camera wholesale, including a distance measured
      // when other meshes were in the scene; taking only its direction gives the
      // familiar view without the framing that came with it.
      const saved = initialCameraViewRef.current;
      const savedDir = saved ? saved.position.clone().sub(saved.target) : null;
      if (savedDir && savedDir.lengthSq() > 1e-8) dir.copy(savedDir.normalize());
    } else if (view) {
      const named = getNamedViewOffset(view, 1)?.normalize();
      if (named) dir.copy(named);
    }
    // A circle turns about the vertical axis, so from near enough straight
    // overhead it would spin on the spot and show nothing. The pressure step
    // leaves the camera looking down, so dropping to a three-quarter view is
    // what makes the turn read at all — and it happens inside this move rather
    // than as a jump before it.
    if (avoidOverhead && Math.abs(dir.y) > 0.82) dir.set(0, 0.32, 1).normalize();

    const fit = fitCameraToSphereBox(cam, container, box.clone().expandByScalar(8), fill);
    ensureCameraDepthRange(cam, fit.distance);
    const startOrtho = cam instanceof THREE.OrthographicCamera
      ? { left: cam.left, right: cam.right, top: cam.top, bottom: cam.bottom, zoom: cam.zoom }
      : null;

    // Swung round the subject rather than lerped in a straight line.
    //
    // A straight line would be enough on its own, but the up vector is not: from
    // directly overhead it is very nearly parallel to the view direction, and
    // interpolating it towards vertical passes through the degenerate case where
    // lookAt has no defined answer — which is the jump coming out of the
    // pressure view. Interpolating the angles instead keeps up vertical the
    // whole way and gives one smooth arc from wherever the camera is to the
    // point that frames the insole.
    const startTarget = orbit.target.clone();
    const startSph = new THREE.Spherical().setFromVector3(cam.position.clone().sub(startTarget));
    const endSph = new THREE.Spherical().setFromVector3(dir.clone().multiplyScalar(fit.distance));
    // Off the poles, where the arc has no azimuth to speak of.
    const POLE_EPS = 0.05;
    startSph.phi = THREE.MathUtils.clamp(startSph.phi, POLE_EPS, Math.PI - POLE_EPS);
    endSph.phi = THREE.MathUtils.clamp(endSph.phi, POLE_EPS, Math.PI - POLE_EPS);
    // The short way round, so it never takes the long way for the sake of sign.
    let deltaTheta = endSph.theta - startSph.theta;
    while (deltaTheta > Math.PI) deltaTheta -= Math.PI * 2;
    while (deltaTheta < -Math.PI) deltaTheta += Math.PI * 2;

    return new Promise((settle) => {
      const token = ++cameraTransitionTokenRef.current;
      const clock = new THREE.Clock();
      let elapsed = 0;
      const offset = new THREE.Vector3();
      const sph = new THREE.Spherical();

      const step = () => {
        // Superseded by a newer move, which now owns the camera. Settle anyway,
        // so a narration step waiting on this one is not left hanging.
        if (cameraTransitionTokenRef.current !== token) {
          settle();
          return;
        }
        elapsed += clock.getDelta();
        const t = Math.min(elapsed / Math.max(durationSec, 0.1), 1);
        const eased = easeInOutCubic(t);

        sph.set(
          startSph.radius + (endSph.radius - startSph.radius) * eased,
          startSph.phi + (endSph.phi - startSph.phi) * eased,
          startSph.theta + deltaTheta * eased,
        );
        const target = startTarget.clone().lerp(centre, eased);
        cam.position.copy(target).add(offset.setFromSpherical(sph));
        cam.up.set(0, 1, 0);
        orbit.target.copy(target);
        cam.lookAt(target);

        if (startOrtho && fit.ortho && cam instanceof THREE.OrthographicCamera) {
          cam.left = startOrtho.left + (fit.ortho.left - startOrtho.left) * eased;
          cam.right = startOrtho.right + (fit.ortho.right - startOrtho.right) * eased;
          cam.top = startOrtho.top + (fit.ortho.top - startOrtho.top) * eased;
          cam.bottom = startOrtho.bottom + (fit.ortho.bottom - startOrtho.bottom) * eased;
          cam.zoom = startOrtho.zoom + (fit.ortho.zoom - startOrtho.zoom) * eased;
          cam.updateProjectionMatrix();
        }

        orbit.update();
        if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
        if (t < 1) requestAnimationFrame(step);
        else settle();
      };
      requestAnimationFrame(step);
    });
  }

  /**
   * Swing the camera once around whatever it is currently looking at.
   *
   * A still frame of a skeleton sitting on an insole is hard to read: it is not
   * obvious which bone is in front of which. Circling the subject gives that
   * depth back without the visitor touching anything, and because the orbit
   * keeps the controls' target fixed, the subject stays dead centre for the
   * whole move — which a pair of named views cannot promise.
   */
  function orbitCameraAroundScene(
    degrees = 360,
    durationSec = 6,
    fill = 0.5,
    enterSec = 1.2,
    reframe = true,
    tiltDegrees = 0,
  ): Promise<void> {
    // Each turn carries its own token, so a stop only ends the turn that was
    // running when it was asked for.
    const token = ++orbitTokenRef.current;
    return new Promise((resolve) => {
      const cam = cameraRef.current;
      const orbit = controlsRef.current;
      if (!cam || !orbit) {
        resolve();
        return;
      }

      // Re-centred on what is on screen before circling. Orbiting about the
      // controls' existing target swung the camera around a point that was not
      // the subject, which is what threw the single foot out to one side.
      // Read after the re-centring above has landed, so the circle is struck
      // about the subject rather than about wherever the camera was aimed.
      const runCircle = () => {
        const centre = orbit.target.clone();
        // Spherical rather than a rotated offset, so the turn can also change
        // how steeply the camera looks down without a second, visible move.
        const startSph = new THREE.Spherical().setFromVector3(
          cam.position.clone().sub(centre)
        );
        const total = THREE.MathUtils.degToRad(degrees);
        // Positive drops the camera towards the horizon. Spread across the whole
        // turn and eased with it, so it reads as one movement rather than as a
        // tilt happening on top of a circle.
        const tilt = THREE.MathUtils.degToRad(tiltDegrees);
        const POLE_EPS = 0.05;
        const clock = new THREE.Clock();
        const offset = new THREE.Vector3();
        const sph = new THREE.Spherical();
        let elapsed = 0;

        const step = () => {
          elapsed += clock.getDelta();
          const t = Math.min(elapsed / Math.max(durationSec, 0.1), 1);
          // Eased so it does not start and stop with a jerk. A full turn ends
          // where it began, so the camera needs no restoring afterwards.
          const eased = easeInOutCubic(t);
          sph.set(
            startSph.radius,
            THREE.MathUtils.clamp(startSph.phi + tilt * eased, POLE_EPS, Math.PI - POLE_EPS),
            startSph.theta + total * eased,
          );
          cam.position.copy(centre).add(offset.setFromSpherical(sph));
          cam.up.set(0, 1, 0);
          orbit.target.copy(centre);
          cam.lookAt(centre);
          orbit.update();
          if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
          // Stopped from outside, or superseded by a newer turn: the caller has
          // moved on and the camera belongs to whatever comes next.
          if (token !== orbitTokenRef.current) {
            resolve();
            return;
          }
          if (t < 1) requestAnimationFrame(step);
          else resolve();
        };
        requestAnimationFrame(step);
      };

      // With reframe off the camera simply starts turning from where it is.
      // The entry move exists for a shot that arrives from somewhere unsuitable
      // — the overhead pressure view, where a turn about the vertical would show
      // nothing — but when the caller has already placed the camera, re-framing
      // reads as the view dropping out of the sky before the turn begins.
      void (reframe ? frameVisibleMeshes(fill, enterSec, true) : Promise.resolve()).then(runCircle);
    });
  }

  function animateCameraTransition(
    cam: THREE.Camera,
    orbit: OrbitControls,
    startPos: THREE.Vector3,
    startTarget: THREE.Vector3,
    startUp: THREE.Vector3,
    startOrtho: { left: number; right: number; top: number; bottom: number; zoom: number } | null,
    endPos: THREE.Vector3,
    endTarget: THREE.Vector3,
    endUp: THREE.Vector3,
    endOrtho: { left: number; right: number; top: number; bottom: number; zoom: number } | null,
    duration: number,
    onComplete?: () => void,
  ) {
    const token = ++cameraTransitionTokenRef.current;
    const clock = new THREE.Clock();
    let elapsed = 0;

    function finishNamedView() {
      cam.position.copy(endPos);
      orbit.target.copy(endTarget);
      cam.up.copy(endUp);
      cam.lookAt(orbit.target);
      if (endOrtho && cam instanceof THREE.OrthographicCamera) {
        applyOrthoFramed(cam, endOrtho);
        cam.zoom = endOrtho.zoom;
        cam.updateProjectionMatrix();
        if (orthographicCameraRef.current && orthographicCameraRef.current !== cam) {
          applyOrthoFramed(orthographicCameraRef.current, endOrtho);
          orthographicCameraRef.current.zoom = endOrtho.zoom;
          orthographicCameraRef.current.updateProjectionMatrix();
        }
      }
      orbit.update();
      if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
      onComplete?.();
    }

    function animateNamedView() {
      // Superseded: leave the camera to the newer move and do not snap it onto
      // this move's end pose. Whoever queued this one is still told it is over,
      // so a sequence waiting on it does not stall behind a move that will
      // never land.
      if (cameraTransitionTokenRef.current !== token) {
        onComplete?.();
        return;
      }
      elapsed += clock.getDelta();
      const t = Math.min(elapsed / duration, 1);
      const easedT = easeInOutCubic(t);
      cam.position.lerpVectors(startPos, endPos, easedT);
      orbit.target.lerpVectors(startTarget, endTarget, easedT);
      cam.up.copy(startUp).lerp(endUp, easedT).normalize();
      cam.lookAt(orbit.target);
      if (startOrtho && endOrtho && cam instanceof THREE.OrthographicCamera) {
        cam.left = startOrtho.left + (endOrtho.left - startOrtho.left) * easedT;
        cam.right = startOrtho.right + (endOrtho.right - startOrtho.right) * easedT;
        cam.top = startOrtho.top + (endOrtho.top - startOrtho.top) * easedT;
        cam.bottom = startOrtho.bottom + (endOrtho.bottom - startOrtho.bottom) * easedT;
        cam.zoom = startOrtho.zoom + (endOrtho.zoom - startOrtho.zoom) * easedT;
        cam.updateProjectionMatrix();
      }
      orbit.update();
      if ((gizmoRef.current as any)?.cameraUpdate) (gizmoRef.current as any).cameraUpdate();
      if (t < 1) requestAnimationFrame(animateNamedView);
      else finishNamedView();
    }
    animateNamedView();
  }

  function getParamFocusPoints(fieldKey: string, feet: number[]): THREE.Vector3[] {
    const points: THREE.Vector3[] = [];
    feet.forEach((foot) => {
      if (fieldKey === "Length" || fieldKey === "Width") {
        const dim = dimensionSpheresRef.current[foot];
        if (dim) {
          dim.updateMatrixWorld(true);
          points.push(dim.getWorldPosition(new THREE.Vector3()));
        }
        return;
      }
      if (fieldKey === "Arch Fill") {
        if (!archGuideSpheresRef.current?.[foot]) createArchFillLine(foot);
        const sphere = archGuideSpheresRef.current?.[foot];
        if (sphere) {
          sphere.updateMatrixWorld(true);
          points.push(sphere.getWorldPosition(new THREE.Vector3()));
        } else {
          const mesh = outputMeshRef.current?.[foot];
          if (mesh) points.push(new THREE.Box3().setFromObject(mesh).getCenter(new THREE.Vector3()));
        }
        return;
      }
      if (fieldKey === "Heel Fill") {
        if (!heelGuideSpheresRef.current?.[foot]) createHeelFillLine(foot);
        const sphere = heelGuideSpheresRef.current?.[foot];
        if (sphere) {
          sphere.updateMatrixWorld(true);
          points.push(sphere.getWorldPosition(new THREE.Vector3()));
        } else {
          const mesh = outputMeshRef.current?.[foot];
          if (mesh) points.push(new THREE.Box3().setFromObject(mesh).getCenter(new THREE.Vector3()));
        }
        return;
      }
      const match = (surfaceJointSpheresRef.current[foot] || []).find(
        (sphere) => sphere?.userData?.jointName === fieldKey
      );
      if (match) {
        match.updateMatrixWorld(true);
        points.push(match.getWorldPosition(new THREE.Vector3()));
      }
    });
    return points;
  }

  function getSphereViewDirection(
    target: THREE.Vector3,
    feet: number[],
    viewHint: string,
  ): THREE.Vector3 {
    if (viewHint === "top") {
      return new THREE.Vector3(0, 1, 0.12).normalize();
    }

    const named =
      viewHint === "toes" ? "toes" :
        viewHint === "medial" ? "medial" :
          viewHint === "lateral" ? "lateral" :
            "heel";
    const anat = getNamedViewOffset(named, 1)?.normalize() ?? new THREE.Vector3(0, 0.3, 1).normalize();

    const foot = feet[0] ?? 0;
    const mesh = outputMeshRef.current?.[foot];
    const sceneBox = sceneRef.current ? calculateBoundingBoxOfAllMeshes(sceneRef.current) : new THREE.Box3();
    const sceneCenter = sceneBox.isEmpty() ? target.clone() : sceneBox.getCenter(new THREE.Vector3());
    const footCenter = mesh
      ? new THREE.Box3().setFromObject(mesh).getCenter(new THREE.Vector3())
      : target.clone();

    // Prefer looking from the outside of this foot toward the sphere.
    const outward = footCenter.clone().sub(sceneCenter);
    outward.y = 0;
    if (outward.lengthSq() < 1e-8) outward.set(foot === 0 ? 1 : -1, 0, 0);
    outward.normalize();

    // Bias toward the sphere from the foot center (where the marker sits on the insole).
    const markerBias = target.clone().sub(footCenter);
    markerBias.y = 0;
    if (markerBias.lengthSq() > 1e-8) markerBias.normalize();
    else markerBias.copy(outward);

    const dir = new THREE.Vector3()
      .addScaledVector(outward, 0.55)
      .addScaledVector(anat, 0.7)
      .addScaledVector(markerBias, 0.35);
    dir.y = Math.max(0.32, Math.abs(dir.y) * 0.5 + 0.32);
    if (dir.lengthSq() < 1e-8) return anat;
    return dir.normalize();
  }

  /** Keep close camera moves in front of the near clipping plane. */
  function ensureCameraDepthRange(camera: THREE.Camera, distance: number): void {
    const span = Math.max(distance, 0.001);
    let near: number;
    let far: number;

    if (camera instanceof THREE.PerspectiveCamera) {
      // Depth precision at the target falls off with distance² / near, so a
      // near plane capped at 0.1 left the far portrait framing on phones too
      // coarse to separate the stacked insole layers, and they z-fought. Scaling
      // near with the distance keeps that precision the same at every zoom
      // while staying well in front of anything around the target.
      near = Math.max(0.01, span * 0.02);
      far = Math.max(span * 20, 2000);
    } else if (camera instanceof THREE.OrthographicCamera) {
      far = Math.max(span * 20, 2000);
      near = -far;
    } else {
      return;
    }

    if (Math.abs(camera.near - near) < 1e-6 && Math.abs(camera.far - far) < 1e-6) return;

    camera.near = near;
    camera.far = far;
    camera.updateProjectionMatrix();
  }

  function fitCameraToSphereBox(
    camera: THREE.Camera,
    container: HTMLDivElement,
    box: THREE.Box3,
    fill: number,
  ): { distance: number; ortho: { left: number; right: number; top: number; bottom: number; zoom: number } | null } {
    const size = box.getSize(new THREE.Vector3());
    const aspect = Math.max(container.clientWidth, 1) / Math.max(container.clientHeight, 1);
    const fillSafe = Math.min(0.85, Math.max(0.4, fill));
    // World extents the spheres occupy; keep a minimum so a single sphere still frames clearly.
    const fitW = Math.max(size.x, size.z * 0.85, 22);
    const fitH = Math.max(size.y, size.z * 0.55, 18);

    if (camera instanceof THREE.PerspectiveCamera) {
      const vFov = THREE.MathUtils.degToRad(camera.fov);
      const hFov = 2 * Math.atan(Math.tan(vFov / 2) * aspect);
      const distV = (fitH * 0.5) / Math.tan(vFov / 2);
      const distH = (fitW * 0.5) / Math.tan(hFov / 2);
      const radius = Math.max(fitW, fitH) * 0.5;
      const lim = Math.min(vFov, hFov);
      const distSphere = radius / Math.sin(lim / 2);
      return {
        distance: Math.max(distV, distH, distSphere) / fillSafe,
        ortho: null,
      };
    }

    // The frustum has to have the canvas's own aspect ratio. It used to take the
    // wider of the two half extents and keep the height from fitH alone, so on a
    // portrait phone the box it described was not the shape of the viewport: the
    // picture came out distorted and the insole could fall outside the frustum
    // altogether, which is why both it and the parameter label vanished there.
    let halfH = (fitH * 0.5) / fillSafe;
    let halfW = (fitW * 0.5) / fillSafe;
    if (halfW / halfH > aspect) halfH = halfW / aspect;
    else halfW = halfH * aspect;
    return {
      distance: Math.max(fitW, fitH) * 2.2,
      ortho: {
        left: -halfW,
        right: halfW,
        top: halfH,
        bottom: -halfH,
        // The zoom every other path pins the orthographic camera to. Returning 1
        // meant a move animated towards 1 and was then snapped back to this on
        // arrival.
        zoom: ORTHO_FIXED_ZOOM,
      },
    };
  }

  function calculateCameraMoveDuration(
    startPos: THREE.Vector3,
    endPos: THREE.Vector3,
    startTarget: THREE.Vector3,
    endTarget: THREE.Vector3,
  ): number {
    const travel = startPos.distanceTo(endPos) + startTarget.distanceTo(endTarget) * 0.45;
    const seconds = travel / VOICE_CAMERA_SPEED_UNITS_PER_SEC;
    return Math.min(VOICE_CAMERA_MAX_MS / 1000, Math.max(VOICE_CAMERA_MIN_MS / 1000, seconds));
  }

  function focusCameraOnParam(
    fieldKey: string,
    feet: number[],
    cameraPreset: { single: string; both?: string; fill?: number; zoom?: number },
    durationOverride?: number,
  ): Promise<number> {
    return new Promise((resolve) => {
      const camera = cameraRef.current;
      const controls = controlsRef.current;
      const container = containerRef.current;
      if (!camera || !controls || !container || !sceneRef.current) {
        resolve(0);
        return;
      }

      sceneRef.current.updateMatrixWorld(true);
      const points = getParamFocusPoints(fieldKey, feet);
      const viewHint = cameraPreset.single;
      const fill = cameraPreset.fill
        ?? (typeof cameraPreset.zoom === "number" ? Math.min(0.8, Math.max(0.4, 1 - cameraPreset.zoom * 0.35)) : 0.6);

      const cam = camera;
      const orbit = controls;
      const startPos = cam.position.clone();
      const startTarget = orbit.target.clone();
      const startUp = cam.up.clone();
      const startOrtho = cam instanceof THREE.OrthographicCamera
        ? { left: cam.left, right: cam.right, top: cam.top, bottom: cam.bottom, zoom: cam.zoom }
        : null;

      if (!points.length) {
        const fallbackDuration = durationOverride ?? 1.2;
        setNamedCameraView(viewHint === "toes" ? "toes" : viewHint === "top" ? "top" : "heel", fallbackDuration, () => {
          resolve(fallbackDuration);
        });
        return;
      }

      // Frame only the parameter spheres (plus a small pad), not the whole foot mesh.
      const focusBox = new THREE.Box3().setFromPoints(points);
      const pad = 12;
      focusBox.expandByScalar(pad);
      const center = focusBox.getCenter(new THREE.Vector3());
      const dir = getSphereViewDirection(center, feet, viewHint);
      const fit = fitCameraToSphereBox(camera, container, focusBox, fill);
      ensureCameraDepthRange(camera, fit.distance);

      const endTarget = center.clone();
      const endPos = center.clone().add(dir.multiplyScalar(fit.distance));
      const endUp = new THREE.Vector3(0, 1, 0);
      const endOrtho = fit.ortho;
      const duration = durationOverride ?? calculateCameraMoveDuration(startPos, endPos, startTarget, endTarget);

      animateCameraTransition(cam, orbit, startPos, startTarget, startUp, startOrtho, endPos, endTarget, endUp, endOrtho, duration, () => {
        resolve(duration);
      });
    });
  }

  function getNamedViewOffset(view: string, distance: number): THREE.Vector3 | null {
    if (view === 'top') return new THREE.Vector3(0, distance, distance * 0.02);
    if (view === 'bottom') return new THREE.Vector3(0, -distance, distance * 0.02);

    const offsetFromTo = (from: THREE.Vector3, to: THREE.Vector3) => {
      const dir = from.clone().sub(to);
      dir.y = 0;
      if (dir.lengthSq() < 1e-8) return null;
      dir.normalize();
      return dir.multiplyScalar(distance).add(new THREE.Vector3(0, distance * 0.28, 0));
    };

    const footIndex = outputMeshRef.current[0] ? 0 : outputMeshRef.current[1] ? 1 : -1;
    const cfg = meshconfig.current;
    const mesh = footIndex >= 0 ? outputMeshRef.current[footIndex] : null;
    const geometry = (footIndex >= 0
      ? (originalGeometryRef.current?.[footIndex] || mesh?.geometry)
      : null) as THREE.BufferGeometry | undefined;

    if (mesh && geometry && cfg) {
      mesh.updateMatrixWorld(true);
      const worldVertex = (index: number) => {
        const point = new THREE.Vector3().fromBufferAttribute(geometry.getAttribute('position'), index);
        return point.applyMatrix4(mesh.matrixWorld);
      };

      if (view === 'heel' || view === 'toes') {
        const heel = worldVertex(cfg.heelCenterIndex);
        const toes = worldVertex(cfg.forefootIndex);
        return view === 'heel' ? offsetFromTo(heel, toes) : offsetFromTo(toes, heel);
      }

      const joints = surfaceJointsArray.current[footIndex];
      const medialCenter = joints?.heelMedialWedge?.center;
      const lateralCenter = joints?.heelLateralWedge?.center;
      if (medialCenter && lateralCenter) {
        const medial = medialCenter.clone().applyMatrix4(mesh.matrixWorld);
        const lateral = lateralCenter.clone().applyMatrix4(mesh.matrixWorld);
        if (view === 'medial') return offsetFromTo(medial, lateral);
        if (view === 'lateral') return offsetFromTo(lateral, medial);
      }
    }

    const fallback: Record<string, THREE.Vector3> = {
      heel: new THREE.Vector3(0, distance * 0.28, distance),
      toes: new THREE.Vector3(0, distance * 0.28, -distance),
      medial: new THREE.Vector3(distance, distance * 0.22, 0),
      lateral: new THREE.Vector3(-distance, distance * 0.22, 0),
    };
    return fallback[view] ?? null;
  }

  function easeInOutCubic(t: number): number {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function getGizmoColors() {
    const root = document.body;
    const styles = getComputedStyle(root);

    const faceColor = styles.getPropertyValue('--canvas-bg').trim();
    const faceBackColor = styles.getPropertyValue('--canvas-shadow').trim();
    const faceBorderColor = styles.getPropertyValue('--toolbar-border').trim();
    const edgeColor = styles.getPropertyValue('--canvas-edge').trim();
    const cornerColor = styles.getPropertyValue('--canvas-edge').trim();
    const labelColor = styles.getPropertyValue('--canvas-text-color').trim();
    const hoverColor = styles.getPropertyValue('--button-hover').trim();

    const faceConfig = {
      color: faceColor,
      labelColor: labelColor,
      hover: {
        color: hoverColor,
        labelColor: labelColor,
      },
    };
    const edgeConfig = {
      color: edgeColor,
      opacity: 1,
      hover: {
        color: hoverColor,
      },
    };
    const cornerConfig = {
      ...faceConfig,
      color: cornerColor,
      hover: {
        color: hoverColor,
      },
    };

    return {
      background: {
        enabled: true,
        color: faceBackColor,
        opacity: 1,
        hover: {
          color: faceBackColor,
          opacity: 1,
        },
      },
      corners: cornerConfig,
      edges: edgeConfig,
      right: faceConfig,
      top: faceConfig,
      front: faceConfig,
      left: faceConfig,
      bottom: faceConfig,
      back: faceConfig,
    };
  }

  useEffect(() => {
    if (insoleDesign == null) return;
    updateBoneMarkersVisibility()
    updateShoeDataMeshVisibility()
  }, [bonesVisibility, shoeDataVisibility])

  const updateBoneMarkersVisibility = () => {
    insoleDesign?.insoles.forEach((insole: Insole) => {
      if (insole.bonesGroup) {
        insole.bonesGroup.visible = bonesVisibility;
      }
    });
  }

  const updateShoeDataMeshVisibility = () => {
    [0, 1].forEach((side) => {
      const shoeMesh = insoleDesign?.insoles[side]?.footShoeMesh;
      if (shoeMesh) shoeMesh.visible = shoeDataVisibility;
      // The outside group was left out here, so the outer outline stayed on
      // screen after the shoe had been switched off. Both groups are also
      // updated independently of the mesh now: they were behind a condition that
      // required the mesh as well, and one missing meant neither was touched.
      const inside = shoeInsideMarkerGroup.current[side];
      if (inside) inside.visible = shoeDataVisibility;
      const outside = shoeOutsideMarkerGroup.current[side];
      if (outside) outside.visible = shoeDataVisibility;
    });
  }

  const resetAllSpheresToDefaultColor = (): void => {
    surfaceJointSpheresRef.current.forEach((footSpheres) => {
      footSpheres?.forEach((sphere) => {
        if (sphere && sphere.material && sphere.userData?.type === 'surfaceJoint') {
          (sphere.material as THREE.MeshStandardMaterial).color = getColorFromCSSVariable('--default-surface-markers');
        }
      });
    });
  };

  useEffect(() => {
    if (!lastUpdatedParams.length) return;

    const focusedParams = lastUpdatedParams.map((p) => ({ ...p }));
    const dimensionsChanged = focusedParams.some(({ fieldKey }) => fieldKey === 'Length' || fieldKey === 'Width');

    resetAllSpheresToDefaultColor();

    focusedParams.forEach(({ foot, fieldKey, value }) => {

      if (!fieldKey) return;

      if (fieldKey === "Length" || fieldKey === "Width" || fieldKey === "Profile Curve" || fieldKey === "Insole Template") {
        drawBoundingBoxDimensions(foot);

        let targetSphere = dimensionSpheresRef.current[foot]
          ? (dimensionSpheresRef.current[foot]?.clone() as THREE.Mesh)
          : null;

        if (targetSphere) {
          if (targetSphere.material) {
            (targetSphere.material as THREE.MeshStandardMaterial)
              .color = getColorFromCSSVariable('--hightlight-surface-markers');
          }

          createOrUpdateDimensionLabel(targetSphere, ["Length", "Width"], foot);
          const toolboxSpread = isMobile() || isTablet() ? 40 : 20;
          createOrUpdateToolboxIcon(ReplyIcon, new THREE.Vector3(-toolboxSpread, 5, 0), undoLastAutosave, true);
          createOrUpdateToolboxIcon(UTurnLeft, new THREE.Vector3(0, 5, 0), mirrorToRight);
          createOrUpdateToolboxIcon(UTurnRight, new THREE.Vector3(toolboxSpread, 5, 0), mirrorToLeft);
        }
      }

      const spheres = [...(surfaceJointSpheresRef.current[foot] || [])];

      createArchFillLine(foot);
      if (archGuideSpheresRef.current) {
        let targetSphere = archGuideSpheresRef.current[foot]?.clone() ?? null;
        if (targetSphere) {
          targetSphere.userData = {
            ...targetSphere.userData,
            jointType: 'surface',
            jointName: 'Arch Fill',
          };
          spheres.push(targetSphere);
        }
      }

      createHeelFillLine(foot);
      if (heelGuideSpheresRef.current) {
        let targetSphere = heelGuideSpheresRef.current[foot]?.clone() ?? null;
        if (targetSphere) {
          targetSphere.userData = {
            ...targetSphere.userData,
            jointType: 'surface',
            jointName: 'Heel Fill',
          };
          spheres.push(targetSphere);
        }
      }

      spheres.forEach((sphere) => {
        if (sphere?.userData?.jointType === 'surface') {
          createOrUpdateSphereLabel(sphere, sphere.userData.jointName, foot);
        }
      });
    });

    createOrUpdateNewAdditionLabel(0);
    createOrUpdateNewAdditionLabel(1);
    addLabelstoAllAdditions(false);

    setLastUpdatedParams([]);
    setAllLabelsVisibility(liveMode);
    if (dimensionsChanged) scheduleVisibleDesignFrame();

  }, [lastUpdatedParams]);

  const clampLabelToViewport = (element: HTMLElement, padding: number = 10): void => {
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let translateX = 0;
    let translateY = 0;

    if (rect.right > viewportWidth - padding) {
      translateX = viewportWidth - padding - rect.right;
    } else if (rect.left < padding) {
      translateX = padding - rect.left;
    }

    if (rect.bottom > viewportHeight - padding) {
      translateY = viewportHeight - padding - rect.bottom;
    } else if (rect.top < padding) {
      translateY = padding - rect.top;
    }

    const currentTransform = element.style.transform || 'translate(0px, 0px)';
    const match = currentTransform.match(/translate\(([^,]+),\s*([^)]+)\)/);

    if (match) {
      const baseX = parseFloat(match[1]) || 0;
      const baseY = parseFloat(match[2]) || 0;
      element.style.transform = `translate(${baseX + translateX}px, ${baseY + translateY}px)`;
    } else {
      element.style.transform = `translate(${translateX}px, ${translateY}px)`;
    }
  };

  /**
   * Show only the active label and its own connector, hiding every other label
   * plus its connector and guide line. Split out of activateLabel because label
   * objects and their lines are rebuilt on every parameter change, and each
   * rebuild starts them visible; the active label then has to be re-asserted.
   */
  const applyLabelExclusivity = (
    activeKey: string,
    labelType: 'dimension' | 'sphere' | 'addition' | 'newAddition'
  ): void => {
    const toolboxMap = new Map<string, CSS2DObject>();
    toolboxPanelRef.current.forEach((obj, index) => {
      if (obj) {
        toolboxMap.set(`toolbox_${index}`, obj);
      }
    });

    const full_key = `guideLine_${activeKey}`
    guideLines.current.forEach((line, key) => {
      if (key === full_key) {
        line.visible = true;
      } else {
        line.visible = false;
      }
    });

    const labelMaps = {
      dimension: { labels: dimensionLabelsRef.current, lines: dimensionLinesRef.current },
      sphere: { labels: sphereLabelsRef.current, lines: sphereLinesRef.current },
      addition: { labels: additionLabelsRef.current, lines: additionLinesRef.current },
      newAddition: { labels: newAdditionLabelsRef.current, lines: null },
      toolbox: { labels: toolboxMap, lines: null },
    };

    Object.entries(labelMaps).forEach(([type, { labels, lines }]) => {
      labels?.forEach((labelObj, labelKey) => {
        const element = labelObj.element as HTMLDivElement;
        const line = lines?.get(`line_${labelKey}`);

        if (labelKey === activeKey) {
          element.style.zIndex = '10000';
          element.style.pointerEvents = 'auto';
          element.style.opacity = '1';
          if (line && labelType != 'addition') line.visible = true;
          else if (line) line.visible = false;
        } else {
          element.style.opacity = '0';
          element.style.pointerEvents = 'none';
          if (line) line.visible = false;
        }
      });
    });
  };

  /** Re-assert exclusivity after anything that resets label or line visibility. */
  const refreshActiveLabelExclusivity = (): void => {
    const activeKey = activeLabelKeyRef.current;
    if (!activeKey) return;
    applyLabelExclusivity(activeKey, activeLabelTypeRef.current ?? 'sphere');
  };

  const activateLabel = (activeKey: string, targetInnerDiv: HTMLElement, labelType: 'dimension' | 'sphere' | 'addition' | 'newAddition'): void => {
    activeLabelInnerDivRef.current = targetInnerDiv;
    activeLabelKeyRef.current = activeKey;
    activeLabelTypeRef.current = labelType;

    applyLabelExclusivity(activeKey, labelType);

    if (labelType !== 'newAddition') {
      requestAnimationFrame(() => {
        clampLabelToViewport(targetInnerDiv);
        requestAnimationFrame(() => {
          clampLabelToViewport(targetInnerDiv);
        });
      });
    }

    if (labelType === 'addition') {
      const [foot, index] = [
        parseInt(activeKey.split('_')[0], 10),
        parseInt(activeKey.split('_')[1], 10),
      ];

      useViewerStore.setState({
        selectedAdditionFromViewer: { foot: foot, additionIndex: index }
      });

      if (selectedAdditionIndexRef.current != -1)
        changeAdditionColor(selectedAdditionIndexRef.current, selectedFootIndexRef.current, false);

      selectedAdditionIndexRef.current = index;
      selectedFootIndexRef.current = foot;

      changeAdditionColor(index, foot, true);
      SetMode(AdditionTransformControlMode.EnableTransformControl);
    }

  };

  const deactivateLabel = (): void => {
    activeLabelKeyRef.current = null;
    activeLabelTypeRef.current = null;

    const toolboxMap = new Map<string, CSS2DObject>();
    toolboxPanelRef.current.forEach((obj, index) => {
      if (obj) {
        toolboxMap.set(`toolbox_${index}`, obj);
      }
    });

    const liveMode = useViewerStore.getState().liveMode;
    guideLines.current.forEach((line, key) => {
      const foot = footIndexFromViewKey(key);
      line.visible = liveMode && (foot === null || isFootShownInView(foot));
    });

    const labelMaps = {
      dimension: { labels: dimensionLabelsRef.current, lines: dimensionLinesRef.current },
      sphere: { labels: sphereLabelsRef.current, lines: sphereLinesRef.current },
      addition: { labels: additionLabelsRef.current, lines: additionLinesRef.current },
      newAddition: { labels: newAdditionLabelsRef.current, lines: null },
      toolbox: { labels: toolboxMap, lines: null }
    };

    Object.entries(labelMaps).forEach(([type, { labels, lines }]) => {
      labels.forEach((labelObj, labelKey) => {
        const element = labelObj.element as HTMLDivElement;
        const line = lines?.get(`line_${labelKey}`);
        const foot = type === 'toolbox' ? null : footIndexFromViewKey(labelKey);
        const show = liveMode && (foot === null || isFootShownInView(foot));

        labelObj.visible = show;
        if (element) {
          element.style.display = "";
          element.style.opacity = show ? "1" : "0";
          element.style.pointerEvents = show ? "auto" : "none";
          element.style.zIndex = "1";
        }
        if (line) line.visible = show;
      });
    });

    if (activeLabelInnerDivRef.current) {
      activeLabelInnerDivRef.current.style.transform = 'translate(0px, 0px)';
      activeLabelInnerDivRef.current = null;
    }

    SetMode(AdditionTransformControlMode.DisableTransformControl);
    toggleDeactivation();
  };

  /** Label key for a voice parameter. Length and Width share one dimension label. */
  const paramLabelKey = (fieldKey: string, foot: number): string =>
    fieldKey === 'Length' || fieldKey === 'Width'
      ? `${foot}_Length_Width`
      : `${foot}_${fieldKey}`;

  // Additions are included deliberately: their keys are `foot_index`, which
  // cannot collide with a parameter's `foot_fieldKey`, and it lets the open and
  // close helpers below drive an addition label through exactly the same path as
  // a parameter label.
  const paramLabel = (key: string): CSS2DObject | null =>
    sphereLabelsRef.current.get(key) ??
    dimensionLabelsRef.current.get(key) ??
    additionLabelsRef.current.get(key) ??
    null;

  /** Label key for an addition, matching createOrUpdateAdditionLabel. */
  const additionLabelKey = (foot: number, index: number): string => `${foot}_${index}`;

  const paramLabelElement = (key: string): HTMLElement | null => {
    if (!useViewerStore.getState().liveMode) return null;
    return ((paramLabel(key)?.element as HTMLElement | undefined) ?? null);
  };

  /**
   * Parameter labels exist only in live mode, and the tour opens the label of
   * every parameter it visits, so it turns live mode on and leaves it on. Waits
   * for the labels the mode change builds, otherwise the first click finds none.
   */
  const ensureLiveModeForParamLabels = async (): Promise<void> => {
    const store = useViewerStore.getState();
    if (store.liveMode) return;
    store.setOldLiveMode(store.liveMode);
    store.setLiveMode(true);
    const deadline = Date.now() + 2000;
    while (Date.now() < deadline && sphereLabelsRef.current.size === 0) {
      await waitMs(60);
    }
  };

  /** Present only while the spinner is collapsed, so it doubles as a state check. */
  const paramLabelOpener = (key: string): HTMLElement | null =>
    (paramLabelElement(key)?.querySelector('[data-voice-open]') as HTMLElement | null) ?? null;

  /**
   * Expand the label of the parameter the voice tour just changed. The real
   * spinner is clicked so the label goes through the same activateLabel path as
   * a user click, which is what hides the other labels and their lines, and
   * what fits it to the viewport — hence only ever called on a still camera.
   *
   * Applying a value replaces the label object, so this waits for the
   * replacement: clicking the outgoing one would be undone by the rebuild. It
   * is also the first chance to open a label for a parameter that was zero
   * before the change and therefore had none to click.
   */
  const openVoiceParamLabel = async (
    fieldKey: string,
    foot: number,
    replacing: CSS2DObject | null,
    timeoutMs = 2000
  ): Promise<void> => {
    if (!useViewerStore.getState().liveMode) return;
    const key = paramLabelKey(fieldKey, foot);
    const deadline = Date.now() + timeoutMs;
    // Applying a value replaces the CSS2D object immediately, but the spinner
    // inside it is a React root and the open button is not in the DOM until
    // that commit. Clicking before then is a no-op, which is why the first
    // parameter of a tour never showed a label.
    while (Date.now() < deadline) {
      const replaced = paramLabel(key) !== replacing;
      const opener = replaced || replacing == null ? paramLabelOpener(key) : null;
      if (opener) {
        voiceLabelKeyRef.current = key;
        opener.click();
        return;
      }
      await waitMs(40);
    }
    const opener = paramLabelOpener(key);
    if (!opener) return;
    voiceLabelKeyRef.current = key;
    opener.click();
  };

  /**
   * Expand an addition's label, so the visitor sees the height and hardness
   * controls on the pad being talked about.
   *
   * The collapsed spinner is clicked rather than the label being activated
   * directly, for the same reason the parameter labels are: that is the path a
   * user's click takes, and it is what hides the other labels and fits this one
   * to the viewport. Waits for the spinner, because the label is a React root
   * that may not have committed yet.
   */
  const openVoiceAdditionLabel = async (
    foot: number,
    index: number,
    timeoutMs = 2000
  ): Promise<void> => {
    if (!useViewerStore.getState().liveMode) return;
    const key = additionLabelKey(foot, index);
    const deadline = Date.now() + timeoutMs;
    while (Date.now() < deadline) {
      const opener = paramLabelOpener(key);
      if (opener) {
        voiceLabelKeyRef.current = key;
        opener.click();
        return;
      }
      await waitMs(40);
    }
  };

  /**
   * Bring the camera onto an addition, located from its label.
   *
   * The label is the addition's own anchor — it is placed at the pad's centre —
   * so it gives the 3D position without having to find the pad geometry. Framed
   * looser than a parameter sphere: an addition is a broad pad and the point is
   * to see it sitting on the insole, not to fill the screen with it.
   */
  function focusCameraOnAdditionLabel(
    foot: number,
    index: number,
    fill = 0.45,
    viewHint = "top",
    durationOverride?: number,
  ): Promise<number> {
    return new Promise((resolve) => {
      const camera = cameraRef.current;
      const controls = controlsRef.current;
      const container = containerRef.current;
      if (!camera || !controls || !container || !sceneRef.current) {
        resolve(0);
        return;
      }

      sceneRef.current.updateMatrixWorld(true);
      const label = additionLabelsRef.current.get(additionLabelKey(foot, index));
      if (!label) {
        resolve(0);
        return;
      }

      const center = label.position.clone();
      const focusBox = new THREE.Box3().setFromCenterAndSize(
        center,
        new THREE.Vector3(70, 45, 70)
      );
      const dir = getSphereViewDirection(center, [foot], viewHint);
      const fit = fitCameraToSphereBox(camera, container, focusBox, fill);
      ensureCameraDepthRange(camera, fit.distance);

      const startPos = camera.position.clone();
      const startTarget = controls.target.clone();
      const startUp = camera.up.clone();
      const startOrtho = camera instanceof THREE.OrthographicCamera
        ? { left: camera.left, right: camera.right, top: camera.top, bottom: camera.bottom, zoom: camera.zoom }
        : null;
      const endTarget = center.clone();
      const endPos = center.clone().add(dir.multiplyScalar(fit.distance));
      const duration = durationOverride
        ?? calculateCameraMoveDuration(startPos, endPos, startTarget, endTarget);

      animateCameraTransition(
        camera, controls, startPos, startTarget, startUp, startOrtho,
        endPos, endTarget, new THREE.Vector3(0, 1, 0), fit.ortho, duration,
        () => resolve(duration)
      );
    });
  }

  /** Collapse via Cancel, which restores every other label and line. */
  const closeVoiceParamLabel = (): void => {
    const key = voiceLabelKeyRef.current;
    voiceLabelKeyRef.current = null;
    if (!key) return;
    const closer = paramLabelElement(key)?.querySelector('[data-voice-close]') as HTMLElement | null;
    if (closer) closer.click();
    else if (activeLabelKeyRef.current === key) deactivateLabel();
  };

  const createOrUpdateSphereLabel = (sphere: THREE.Mesh, jointName: string, foot: number): void => {
    const data = getValueFromFieldKey(foot, jointName);
    // No parameters for this foot yet, so there is no value to put on a label.
    // getValueFromFieldKey returns null while the design is still loading, and
    // reading through it threw during load as soon as anything asked for labels
    // before the design was ready. The labels are rebuilt once the parameters
    // arrive, so skipping here loses nothing.
    if (!data) return;
    const key = `${foot}_${jointName}`;
    const existingLabel = sphereLabelsRef.current.get(key);
    const existingLineKey = `line_${key}`;
    const existingLine = sphereLinesRef.current?.get(existingLineKey);

    if (data.value === 0) {
      if (existingLabel) {
        existingLabel.removeFromParent();
        const oldRoot = (existingLabel as any)._root;
        if (oldRoot) setTimeout(() => oldRoot.unmount(), 0);
        sphereLabelsRef.current.delete(key);
      }

      if (existingLine) {
        sceneRef.current?.remove(existingLine);
        sphereLinesRef.current?.delete(existingLineKey);
      }
    }

    if (data?.value == null || data.value === 0) return;

    const excludedJoints = ["Heel Fill", "Arch Fill", 'Arch Sagital Position'];
    if (jointName.includes('Fill') && isSandal.current) return;
    // if (excludedJoints.includes(jointName) && isSandal.current) return;

    let offset = 0;
    let newJointName = "";
    let step = 1;
    let themecolor = 'var(--toolbar-button-border)';

    if (excludedJoints.includes(jointName)) {
      newJointName = `${jointName} %`;
      themecolor = 'var(--accent-label-color)';
    } else {
      newJointName = jointName;
      offset = 10;
    }

    if (jointName === "Thickness") {
      step = thicknessPropertyStep.current;
    }
    else {
      if (!measurementExclude.some(w => newJointName.includes(w)))
        step = propertyStep.current;
      else
        step = 1;
    }

    const div = document.createElement('div');
    div.style.background = 'transparent';
    div.style.pointerEvents = 'auto';
    div.style.position = 'relative';
    div.style.zIndex = '1';

    const innerDiv = document.createElement('div');
    innerDiv.style.position = 'relative';
    innerDiv.style.willChange = 'transform';

    div.appendChild(innerDiv);

    const root = createRoot(innerDiv);
    root.render(
      <SurfaceJointSpinner
        value={data?.value}
        jointName={newJointName}
        min={data?.min}
        max={data?.max}
        color={themecolor}
        step={step}
        onOpen={() => activateLabel(key, innerDiv, 'sphere')}
        onClose={() => deactivateLabel()}
        onChange={(newValue: number) => {
          const event = new CustomEvent('updateSurfaceParameters', {
            detail: {
              fieldKey: jointName,
              foot,
              value: newValue,
              single: true,
            },
          });
          document.dispatchEvent(event);
        }}
      />
    );

    if (jointName === "Band Height") {
      root.render(
        <SurfaceJointDualSpinner
          value1={data?.value}
          jointName={newJointName}
          value2={insoleHighLevelParamRef.current[foot].instepArea}
          label1={newJointName}
          label2="Instep Area"
          displayedValue='value2'
          min={data?.min * insoleHighLevelParamRef.current[foot].length}
          max={data?.max * insoleHighLevelParamRef.current[foot].length}
          color={themecolor}
          step={step}
          onOpen={() => activateLabel(key, innerDiv, 'sphere')}
          onClose={() => deactivateLabel()}
          onChange={(newValue: number) => {
            const event = new CustomEvent('updateSurfaceParameters', {
              detail: {
                fieldKey: jointName,
                foot,
                value: newValue,
                single: true,
              },
            });
            document.dispatchEvent(event);
          }}
        />
      );
    }

    const label = new CSS2DObject(div);
    (label as any)._root = root;
    label.position.copy(sphere.position);
    label.center.set(0.5, 1);
    label.position.y += offset;

    if (existingLabel) {
      existingLabel.removeFromParent();
      const oldRoot = (existingLabel as any)._root;
      if (oldRoot) setTimeout(() => oldRoot.unmount(), 0);
      sphereLabelsRef.current.delete(key);
    }

    const showLabel = useViewerStore.getState().liveMode && isFootShownInView(foot);
    label.visible = showLabel;
    if ((label as any).element) {
      (label as any).element.style.display = "";
      (label as any).element.style.opacity = showLabel ? "1" : "0";
      (label as any).element.style.pointerEvents = showLabel ? "auto" : "none";
    }
    sceneRef.current?.add(label);
    sphereLabelsRef.current.set(key, label);

    if (!excludedJoints.includes(jointName)) {
      const points = [
        new THREE.Vector3(sphere.position.x, sphere.position.y, sphere.position.z),
        new THREE.Vector3(label.position.x, label.position.y, label.position.z)
      ];

      const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);
      const lineMaterial = new THREE.LineBasicMaterial({
        color: getColorFromCSSVariable('--hightlight-surface-markers')
      });
      const line = new THREE.Line(lineGeometry, lineMaterial);
      line.visible = showLabel;

      if (existingLine) {
        sceneRef.current?.remove(existingLine);
        sphereLinesRef.current?.delete(existingLineKey);
      }

      sceneRef.current?.add(line);
      sphereLinesRef.current.set(existingLineKey, line);
    }
  };

  const createArchFillLine = (foot: number) => {
    if (!originalGeometryRef.current || !sceneRef.current) return;
    if (isSandal.current) return;
    //clear previous line and sphere
    if (archGuideSpheresRef.current[foot]) {
      sceneRef.current?.remove(archGuideSpheresRef.current[foot]);
      delete archGuideSpheresRef.current[foot];
    }
    const LabelName = "Arch Fill";
    const key = `${foot}_${LabelName}`;
    const existingGuideLineKey = `guideLine_${key}`;

    const existing = guideLines.current.get(existingGuideLineKey);

    if (existing) {
      existing.traverse((child) => {
        if (
          child instanceof THREE.Mesh ||
          child instanceof THREE.Line
        ) {
          child.geometry.dispose();

          const materials = Array.isArray(child.material)
            ? child.material
            : [child.material];

          materials.forEach((m) => m.dispose());
        }
      });

      sceneRef.current?.remove(existing);
      guideLines.current.delete(existingGuideLineKey);
    }
    //create new line and sphere
    const geometry = originalGeometryRef.current[foot];
    const insoleVertices = geometry.attributes.position.array;
    let xArchOffset = 0;
    let xSphereOffset = 0;
    let yShpereOffset = 1;

    if (foot === 0) {
      xArchOffset = 2;
      xSphereOffset = 5;
    } else {
      xArchOffset = -2;
      xSphereOffset = -5;
    }
    const points = meshconfig.current!.archFillIndeices.map((index) => {
      return new THREE.Vector3(
        insoleVertices[index * 3] - xArchOffset,
        insoleVertices[index * 3 + 1],
        insoleVertices[index * 3 + 2]
      );
    });
    const spherePosition = new THREE.Vector3(points[0].x - xSphereOffset, points[0].y + yShpereOffset, points[0].z);
    const color = getColorFromCSSVariable('--accent-color-negative');
    const sphereGeo = new THREE.SphereGeometry(0.5, 16, 16);
    const sphereMaterial = new THREE.MeshBasicMaterial({ color });
    const markerSphere = new THREE.Mesh(sphereGeo, sphereMaterial);
    markerSphere.position.copy(spherePosition);
    points.unshift(spherePosition);
    const archCurve = new THREE.CatmullRomCurve3(points, false, 'centripetal');
    const curvePoints = archCurve.getPoints(50);
    const lineGeometry = new THREE.BufferGeometry().setFromPoints(curvePoints);
    const lineMaterial = new THREE.LineBasicMaterial({ color: color });
    const archLine = new THREE.Line(lineGeometry, lineMaterial);
    archGuideSpheresRef.current[foot] = markerSphere;
    guideLines.current.set(existingGuideLineKey, archLine);
    sceneRef.current.add(archLine);
  };

  const createHeelFillLine = (foot: number) => {
    if (!originalGeometryRef.current || !sceneRef.current) return;
    if (isSandal.current) return;
    //clear previous line and sphere
    if (heelGuideSpheresRef.current[foot]) {
      sceneRef.current?.remove(heelGuideSpheresRef.current[foot]);
      delete heelGuideSpheresRef.current[foot];
    }
    const LabelName = "Heel Fill";
    const key = `${foot}_${LabelName}`;
    const existingGuideLineKey = `guideLine_${key}`;

    const existing = guideLines.current.get(existingGuideLineKey);

    if (existing) {
      existing.traverse((child) => {
        if (
          child instanceof THREE.Mesh ||
          child instanceof THREE.Line
        ) {
          child.geometry.dispose();

          const materials = Array.isArray(child.material)
            ? child.material
            : [child.material];

          materials.forEach((m) => m.dispose());
        }
      });

      sceneRef.current?.remove(existing);
      guideLines.current.delete(existingGuideLineKey);
    }
    //create new line and sphere
    const geometry = originalGeometryRef.current[foot];
    const insoleVertices = geometry.attributes.position.array;
    const zHeelOffset = 2;
    const ySphereOffset = 1;
    const zSphereOffset = 5;

    const points = meshconfig.current!.heelFillIndices.map((index) => {
      return new THREE.Vector3(
        insoleVertices[index * 3],
        insoleVertices[index * 3 + 1],
        insoleVertices[index * 3 + 2] - zHeelOffset
      );
    });
    const spherePosition = new THREE.Vector3(points[0].x, points[0].y + ySphereOffset, points[0].z - zSphereOffset);
    const color = getColorFromCSSVariable('--accent-color-negative');;
    const sphereGeo = new THREE.SphereGeometry(0.5, 16, 16);
    const sphereMaterial = new THREE.MeshBasicMaterial({ color });
    const markerSphere = new THREE.Mesh(sphereGeo, sphereMaterial);
    markerSphere.position.copy(spherePosition);
    points.unshift(spherePosition);
    const archCurve = new THREE.CatmullRomCurve3(points, false, 'centripetal');
    const curvePoints = archCurve.getPoints(50);
    const lineGeometry = new THREE.BufferGeometry().setFromPoints(curvePoints);
    const lineMaterial = new THREE.LineBasicMaterial({ color: color });
    const heelLine = new THREE.Line(lineGeometry, lineMaterial);
    heelGuideSpheresRef.current[foot] = markerSphere;
    guideLines.current.set(existingGuideLineKey, heelLine);
    sceneRef.current.add(heelLine);
  };

  const createOrUpdateDimensionLabel = (sphere: THREE.Mesh, labelNames: string[], foot: number): void => {
    const key = `${foot}_${labelNames[0]}_${labelNames[1]}`;
    const existingLabel = dimensionLabelsRef.current.get(key);
    const existingLineKey = `line_${key}`;
    const existingLine = dimensionLinesRef.current?.get(existingLineKey);
    const data1 = getValueFromFieldKey(foot, labelNames[0]);
    const data2 = getValueFromFieldKey(foot, labelNames[1]);
    // Same reason as the sphere labels: the lookup is null until this foot's
    // parameters have loaded, and every value below reads straight through it.
    if (!data1 || !data2) return;

    const div = document.createElement('div');
    div.style.background = 'transparent';
    div.style.pointerEvents = 'auto';
    div.style.position = 'relative';
    div.style.zIndex = '1';

    const innerDiv = document.createElement('div');
    innerDiv.style.position = 'relative';
    innerDiv.style.willChange = 'transform';

    div.appendChild(innerDiv);

    const root = createRoot(innerDiv);
    root.render(
      <DimensionSpinner
        value1={data1.value}
        value2={data2.value}
        label1={labelNames[0]}
        label2={labelNames[1]}
        min1={data1.min}
        max1={data1.max}
        step1={propertyStep.current}
        min2={data2.min}
        max2={data2.max}
        step2={propertyStep.current}
        onOpen={() => activateLabel(key, innerDiv, 'dimension')}
        onClose={() => deactivateLabel()}
        onChange1={(newValue: number) => {
          const event = new CustomEvent('updateSurfaceParameters', {
            detail: {
              fieldKey: labelNames[0],
              foot,
              value: newValue,
              single: true,
            },
          });
          document.dispatchEvent(event);
        }}
        onChange2={(newValue: number) => {
          const event = new CustomEvent('updateSurfaceParameters', {
            detail: {
              fieldKey: labelNames[1],
              foot,
              value: newValue,
              single: true,
            },
          });
          document.dispatchEvent(event);
        }}
      />
    );

    const label = new CSS2DObject(div);
    (label as any)._root = root;
    label.position.copy(sphere?.position);
    label.center.set(0.5, 1);

    if (existingLabel) {
      existingLabel.removeFromParent();
      const oldRoot = (existingLabel as any)._root;
      if (oldRoot) setTimeout(() => oldRoot.unmount(), 0);
      dimensionLabelsRef.current.delete(key);
    }

    sceneRef.current?.add(label);
    dimensionLabelsRef.current.set(key, label);

    const points = [
      new THREE.Vector3(sphere.position.x, sphere.position.y, sphere.position.z),
      new THREE.Vector3(label.position.x, label.position.y, label.position.z)
    ];

    const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);
    const lineMaterial = new THREE.LineBasicMaterial({
      color: getColorFromCSSVariable('--hightlight-surface-markers')
    });
    const line = new THREE.Line(lineGeometry, lineMaterial);

    if (existingLine) {
      sceneRef.current?.remove(existingLine);
      dimensionLinesRef.current?.delete(existingLineKey);
    }

    sceneRef.current?.add(line);
    dimensionLinesRef.current.set(existingLineKey, line);
  };

  const updateLabelYOffset = (key: string, isEditing: boolean) => {
    const EDIT_OFFSET_Y = 20;
    const label = additionLabelsRef.current.get(key);
    if (!label) return;

    if (isEditing) {
      label.position.y += EDIT_OFFSET_Y;
    } else {
      label.position.y -= EDIT_OFFSET_Y;
    }
  };

  const createOrUpdateAdditionLabel = (addition: Addition, foot: number, index: number, mode: 'create' | 'update' = 'update') => {
    if (mode === 'create') {
      additionLabelsRef.current.forEach((lbl) => {
        lbl.removeFromParent();
        const r = (lbl as any)._root;
        if (r) setTimeout(() => r.unmount(), 0);
      });
      additionLabelsRef.current.clear();

      additionLinesRef.current.forEach((ln) => {
        sceneRef.current?.remove(ln);
      });
      additionLinesRef.current.clear();
    }

    const key = `${foot}_${index}`;
    const existingLabel = additionLabelsRef.current.get(key);
    const existingLineKey = `line_${key}`;
    const existingLine = additionLinesRef.current.get(existingLineKey);

    const div = document.createElement('div');
    div.style.background = 'transparent';
    div.style.pointerEvents = 'auto';
    div.style.position = 'relative';
    div.style.zIndex = '1';

    const innerDiv = document.createElement('div');
    innerDiv.style.position = 'relative';
    innerDiv.style.willChange = 'transform';

    div.appendChild(innerDiv);

    const root = createRoot(innerDiv);
    root.render(
      <AdditionSpinner
        name={addition.name ?? 'Addition'}
        height={convertMmToViewerUnit(addition.height.value)}
        hardness={addition.hardness}
        min={convertMmToViewerUnit(addition.height.min ?? 0)}
        max={convertMmToViewerUnit(addition.height.max ?? 10)}
        step={propertyStep.current}
        color='var(--accent-label-color)'
        onOpen={() => {
          activateLabel(key, innerDiv, 'addition');
          updateLabelYOffset(key, true);
        }}
        onClose={() => {
          updateLabelYOffset(key, false);
          deactivateLabel();
        }}
        onHeightChange={(value) => {
          useViewerStore.setState({ selectedAdditionFromViewer: { foot, additionIndex: index } });
          setAdditionHeightUpdated({ side: foot, index, value: convertUnitToDefault(Number(value), getDefaultLengthUnit()) });
        }}
        onHardnessChange={(value: Hardness) => {
          useViewerStore.setState({ selectedAdditionFromViewer: { foot, additionIndex: index } });
          setAdditionHardnessUpdated({ side: foot, index, value });
        }}
        onDelete={() => {
          setTimeout(() => {
            useViewerStore.setState({ selectedAdditionFromViewer: { foot, additionIndex: index } });
            useDesignStore.setState({ additionRemoved: [{ side: foot, index, isAdditionID: false }] });
          }, 0);
        }}
      />
    );

    const label = new CSS2DObject(div);
    addition.getCenter();
    label.position.copy(addition.additionCenter);
    label.center.set(0.5, 1);
    label.position.y += 5;
    (label as any)._root = root;

    if (existingLabel) {
      existingLabel.removeFromParent();
      const oldRoot = (existingLabel as any)._root;
      if (oldRoot) setTimeout(() => oldRoot.unmount(), 0);
      additionLabelsRef.current.delete(key);
    }

    // The pads' own visibility counts too. A label is built when its mesh
    // finishes, which can be after the toggle that hid the additions has already
    // run — so a label that only asked about liveMode and the feet view came up
    // visible over hidden pads, leaving a gear floating on an empty insole.
    const viewer = useViewerStore.getState();
    const showAdditionLabel =
      viewer.liveMode && viewer.additionsViewMeshVisible && isFootShownInView(foot);
    label.visible = showAdditionLabel;
    if ((label as any).element) {
      (label as any).element.style.display = "";
      (label as any).element.style.opacity = showAdditionLabel ? "1" : "0";
      (label as any).element.style.pointerEvents = showAdditionLabel ? "auto" : "none";
    }
    sceneRef.current?.add(label);
    additionLabelsRef.current.set(key, label);

    const points = [
      new THREE.Vector3(addition.additionCenter.x, addition.additionCenter.y, addition.additionCenter.z),
      new THREE.Vector3(label.position.x, label.position.y, label.position.z),
    ];

    const line = new THREE.Line(
      new THREE.BufferGeometry().setFromPoints(points),
      new THREE.LineBasicMaterial({ color: getColorFromCSSVariable('--accent-color-negative') })
    );
    line.visible = showAdditionLabel;

    if (existingLine) {
      sceneRef.current?.remove(existingLine);
      additionLinesRef.current.delete(existingLineKey);
    }

    sceneRef.current?.add(line);
    additionLinesRef.current.set(existingLineKey, line);
  };

  const createOrUpdateNewAdditionLabel = (foot: number) => {
    const key = `newAddition_${foot}`;

    const existingLabel = newAdditionLabelsRef.current.get(key);
    if (existingLabel) {
      existingLabel.removeFromParent();
      const oldRoot = (existingLabel as any)._root;
      if (oldRoot) setTimeout(() => oldRoot.unmount(), 0);
      newAdditionLabelsRef.current.delete(key);
    }

    const div = document.createElement('div');
    div.style.background = 'transparent';
    div.style.pointerEvents = 'auto';
    div.style.position = 'relative';
    div.style.zIndex = '1';

    const innerDiv = document.createElement('div');
    innerDiv.style.position = 'relative';
    innerDiv.style.willChange = 'transform';

    div.appendChild(innerDiv);

    const root = createRoot(innerDiv);
    root.render(
      <ImageGallerySpinner
        name="Add New Additions"
        api={api}
        foot={foot}
        onOpen={() => {
          activateLabel(key, innerDiv, 'newAddition');
        }}
        onClose={() => deactivateLabel()}
      />
    );

    const label = new CSS2DObject(div);

    if (isSandal.current) {
      if (!originalGeometryRef.current || !sceneRef.current) return;
      const geometry = originalGeometryRef.current[foot];
      if (geometry == null) return;
      const insoleVertices = geometry.attributes.position.array;
      const x = insoleVertices[meshconfig.current!.forefootIndex * 3];
      const y = insoleVertices[meshconfig.current!.forefootIndex * 3 + 1];
      const z = insoleVertices[meshconfig.current!.forefootIndex * 3 + 2];

      const sphere = new THREE.Mesh();
      sphere.position.set(x, y, z);
      sphere.userData.originalPosition = new THREE.Vector3(x, y, z);
      sphere.userData.foot = foot;
      sphere.renderOrder = 1;
      label.position.copy(sphere.position);
    }
    else {
      const spheresForFoot = profileJointSpheresRef.current[foot];
      if (spheresForFoot && spheresForFoot.length > 0) {
        const targetSphere = spheresForFoot.find(sphere => sphere?.userData?.jointIndex === 0);
        if (targetSphere) {
          label.position.copy(targetSphere.position);
        }
      }
      else {
        return;
      }

      const data = getValueFromFieldKey(foot, "Thickness");
      label.position.y += data?.value;
      label.center.set(0.5, 0.5);
    }

    (label as any)._root = root;
    const showNewAddition = useViewerStore.getState().liveMode && isFootShownInView(foot);
    label.visible = showNewAddition;
    if ((label as any).element) {
      (label as any).element.style.display = "";
      (label as any).element.style.opacity = showNewAddition ? "1" : "0";
      (label as any).element.style.pointerEvents = showNewAddition ? "auto" : "none";
    }

    sceneRef.current?.add(label);
    newAdditionLabelsRef.current.set(key, label);

    const handleClamp = (e: CustomEvent) => {
      console.log('Clamp event received for new addition');
      if (e.detail?.foot === foot) {
        console.log('Clamping innerDiv for foot:', foot);
        clampLabelToViewport(innerDiv, 50);

        requestAnimationFrame(() => {
          clampLabelToViewport(innerDiv, 50);
        });
      }
    };

    document.addEventListener('clampNewAddition', handleClamp as EventListener);

    (label as any)._clampListener = handleClamp;
  };

  const createOrUpdateToolboxIcon = (Icon: any, position: THREE.Vector3, callback: () => void, update: boolean = false) => {
    if (update && toolboxPanelRef.current) {
      toolboxPanelRef.current.forEach((obj) => {
        sceneRef.current?.remove(obj);

        setTimeout(() => {
          const reactRoot = (obj as any)._root;
          if (reactRoot && typeof reactRoot.unmount === 'function') {
            reactRoot.unmount();
          }

          obj?.element?.remove?.();
        }, 0);
      });

      toolboxPanelRef.current = [];
    }
    const rightMesh = outputMeshRef.current[0];
    const leftMesh = outputMeshRef.current[1];
    let newPosition = new THREE.Vector3;
    if (!rightMesh || !leftMesh) {
      newPosition = position.clone();
    }

    const rightbbox = new THREE.Box3().setFromObject(rightMesh);
    const rightMax = rightbbox.max;

    const leftbbox = new THREE.Box3().setFromObject(leftMesh);
    const leftMax = leftbbox.max;

    const frontBox = Math.max(rightMax.z, leftMax.z);
    newPosition = new THREE.Vector3(position.x, position.y, frontBox + 10);

    const container = document.createElement('div');
    container.style.background = 'transparent';
    container.style.pointerEvents = 'auto';

    const root = createRoot(container);

    root.render(
      <ToolboxButton
        icon={Icon}
        onClick={callback}
      />
    );

    const toolboxObject = new CSS2DObject(container);

    toolboxObject.position.copy(newPosition);
    toolboxObject.rotation.set(0, 0, 0);
    toolboxObject.scale.set(0.25, 0.25, 0.25);

    (toolboxObject as any)._root = root;

    sceneRef.current?.add(toolboxObject);
    toolboxPanelRef.current?.push(toolboxObject);
  };

  const removeAllLabels = (): void => {
    // Sphere labels
    resetAllSpheresToDefaultColor();
    sphereLabelsRef.current.forEach((label) => {
      setTimeout(() => {
        const root = (label as any)._root;
        if (root) root.unmount();
        label.removeFromParent();
      }, 0);
    });

    sphereLabelsRef.current.clear();
    sphereLinesRef.current.forEach((line) => {
      sceneRef.current?.remove(line);
    });
    sphereLinesRef.current.clear();

    // Addition labels
    additionLabelsRef.current.forEach((label) => {
      setTimeout(() => {
        const root = (label as any)._root;
        if (root) root.unmount();

        label.removeFromParent();
      }, 0);
    });
    additionLabelsRef.current.clear();

    additionLinesRef.current.forEach((line) => {
      sceneRef.current?.remove(line);
    });
    additionLinesRef.current.clear();
  };

  const removeAllAdditionLabels = () => {
    additionLabelsRef.current.forEach((label) => {
      const root = (label as any)._root;
      if (root) root.unmount();

      label.removeFromParent();
    });
    additionLabelsRef.current.clear();

    additionLinesRef.current.forEach((line) => {
      sceneRef.current?.remove(line);
    });
    additionLinesRef.current.clear();
  }

  const removeAllSphereLabels = () => {
    resetAllSpheresToDefaultColor();
    sphereLabelsRef.current.forEach((label) => {
      const root = (label as any)._root;
      if (root) root.unmount();

      label.removeFromParent();
    });
    sphereLabelsRef.current.clear();

    sphereLinesRef.current.forEach((line) => {
      sceneRef.current?.remove(line);
    });
    sphereLinesRef.current.clear();
  }

  const removeAdditionLabel = (foot: number, index: number) => {
    const key = `${foot}_${index}`;
    // label
    const label = additionLabelsRef.current.get(key);
    if (label) {
      sceneRef.current?.remove(label);
      label.element?.remove();
      additionLabelsRef.current.delete(key);
    }

    // line
    const line = additionLinesRef.current.get(`line_${key}`);
    if (line) {
      sceneRef.current?.remove(line);

      if (line.geometry) line.geometry.dispose();

      if (Array.isArray(line.material)) {
        line.material.forEach((m) => m.dispose());
      } else if (line.material) {
        line.material.dispose();
      }

      additionLinesRef.current.delete(key);
    }
  };

  const footIndexFromViewKey = (key: string): number | null => {
    const match = key.match(/(?:^|_)(\d+)(?:_|$)/);
    if (!match) return null;
    const foot = Number(match[1]);
    return Number.isFinite(foot) ? foot : null;
  };

  const isLabelShownForFeetView = (key: string, isVisible: boolean): boolean => {
    if (!isVisible) return false;
    const foot = footIndexFromViewKey(key);
    return foot === null || isFootShownInView(foot);
  };

  const applyCss2dVisibility = (obj: THREE.Object3D, visible: boolean) => {
    obj.visible = visible;
    const element = (obj as any).element as HTMLElement | undefined;
    if (!element) return;
    element.style.display = "";
    element.style.opacity = visible ? "1" : "0";
    element.style.pointerEvents = visible ? "auto" : "none";
  };

  const setAllLabelsVisibility = (isVisible: boolean): void => {
    // Sphere labels
    sphereLabelsRef.current.forEach((label, key) => {
      applyCss2dVisibility(label, isLabelShownForFeetView(key, isVisible));
    });

    sphereLinesRef.current.forEach((line, key) => {
      line.visible = isLabelShownForFeetView(key, isVisible);
    });

    // Addition labels
    additionLabelsRef.current.forEach((label, key) => {
      applyCss2dVisibility(label, isLabelShownForFeetView(key, isVisible));
    });

    additionLinesRef.current.forEach((line, key) => {
      line.visible = isLabelShownForFeetView(key, isVisible);
    });

    // Arch guide spheres
    Object.entries(archGuideSpheresRef.current).forEach(([foot, sphere]) => {
      if (sphere) sphere.visible = isVisible && isFootShownInView(Number(foot));
    });

    // Heel guide spheres
    Object.entries(heelGuideSpheresRef.current).forEach(([foot, sphere]) => {
      if (sphere) sphere.visible = isVisible && isFootShownInView(Number(foot));
    });

    // Guide lines
    guideLines.current.forEach((line, key) => {
      line.visible = isLabelShownForFeetView(key, isVisible);
    });

    // Dimension labels
    dimensionLabelsRef.current.forEach((label, key) => {
      applyCss2dVisibility(label, isLabelShownForFeetView(key, isVisible));
    });

    // Dimension lines
    dimensionLinesRef.current.forEach((line, key) => {
      line.visible = isLabelShownForFeetView(key, isVisible);
    });

    // Bounding box groups
    Object.entries(boundingBoxGroupsRef.current).forEach(([foot, group]) => {
      if (group) group.visible = isVisible && isFootShownInView(Number(foot));
    });

    // Dimension spheres
    Object.entries(dimensionSpheresRef.current).forEach(([foot, sphere]) => {
      if (sphere) sphere.visible = isVisible && isFootShownInView(Number(foot));
    });

    // New Addition Label
    newAdditionLabelsRef.current.forEach((label, key) => {
      applyCss2dVisibility(label, isLabelShownForFeetView(key, isVisible));
    });

    toolboxPanelRef.current.forEach((toolbox) => {
      if (toolbox) toolbox.visible = isVisible;
    });

    setArchInstepLineVisibility();

    // A blanket reset would un-hide the labels and connector lines that the
    // expanded label is meant to keep hidden.
    if (isVisible) refreshActiveLabelExclusivity();
  };

  useEffect(() => {
    if (!liveMode) {
      deactivateLabel();
    }
    if (liveMode && sphereLabelsRef.current && sphereLabelsRef.current.size == 0) {
      drawBoundingBoxDimensions(0);
      drawBoundingBoxDimensions(1);
      addLabelstoAllSpheres();
      addLabelstoAllAdditions();
    }
    setAllLabelsVisibility(liveMode);
  }, [liveMode]);

  useEffect(() => {
    updateFeetViewState();
  }, [feetView,
    wireframe,
    advanceMode,
    rightToolboxMode,
    surfaceUpdated,
    additionsVisibility,
    insolesVisibility,
    gcodesVisibility,
    shoeDataVisibility,
    bonesVisibility,
    liftedInsoleVisibility,
    updateFromPanel,
    updateFromViewer,
    insoleDesign?.name,
    designLoaded,
    newAddition,
    additionRemoved,
    additionHeightUpdated,
    additionHardnessUpdated,
    coloringState,
    liftedInsoleVisibility,
    liveMode,
    clipping,
    deactivationFlag,
    highHeelVisibility,
    lastUpdatedParams]);

  useEffect(() => {
    // Left alone while the narration owns the camera; it is already moving to a
    // framing of its own and does not want to be snapped out from under it.
    if (voiceCameraBusyRef.current || voiceCameraHeldRef.current) return;
    const animationFrame = requestAnimationFrame(() => frameVisibleDesignObjects());
    return () => cancelAnimationFrame(animationFrame);
  }, [feetView]);

  // Imported 3D foot meshes, aligned onto the insoles (index 0 = right, 1 = left).
  const removeFootMeshes = () => {
    removeFootAlignmentPoints();
    footMeshesRef.current.forEach((mesh, side) => {
      if (!mesh) return;
      sceneRef.current?.remove(mesh);
      (mesh.material as THREE.Material).dispose();
      if (mesh.userData.mirrored) mesh.geometry.dispose();
      footMeshesRef.current[side] = null;
    });
  };

  // Saves the feet applied in the foot mesh panel, aligned onto the insoles (both feet, mirrored one included).
  const saveFootMeshesIfRequested = (alignedFeet: (AlignedFoot | null)[]) => {
    const { saveRequest } = useFootMeshStore.getState();
    if (saveRequest === handledFootSaveRequestRef.current) return;
    handledFootSaveRequestRef.current = saveRequest;
    const designId = useSelectedDesignStore.getState().designId;
    if (designId < 0) return;

    if (alignedFeet.every(foot => !foot)) {
      // Both feet removed in the panel; nothing to report if the design had no scans.
      deleteFootScans(api, designId);
      return;
    }
    const [right, left] = alignedFeet;
    if (!right || !left) {
      toast.error('Could not align the foot meshes to the insoles, so they were not saved.');
      return;
    }
    saveFootScans(api, designId, right, left)
      .then(saved => saved ? toast.success('Foot meshes saved.') : toast.error('Failed to save the foot meshes.'))
      .catch(err => {
        console.error(err);
        toast.error(err instanceof Error ? err.message : 'Failed to save the foot meshes.');
      });
  };

  const updateFootMeshes = () => {
    removeFootMeshes();
    const { rightFoot, leftFoot, adjustments } = useFootMeshStore.getState();
    if (!rightFoot && !leftFoot) {
      saveFootMeshesIfRequested([null, null]);
      return;
    }
    if (!sceneRef.current || !originalGeometryRef.current || !meshconfig.current) return;

    // Like PT-SCAN3D, a missing foot is replaced by mirroring the other one.
    const feet = [rightFoot ?? mirrorFoot(leftFoot!), leftFoot ?? mirrorFoot(rightFoot!)];
    const view = useViewerStore.getState().feetView;
    const alignedFeet: (AlignedFoot | null)[] = [null, null];
    feet.forEach((foot, side) => {
      const lowpolyGeometry = originalGeometryRef.current?.[side];
      const insoleGeometry = outputMeshRef.current[side]?.geometry;
      if (!lowpolyGeometry || !insoleGeometry) return;
      // Saved feet keep their saved placement; the manual adjustment is applied on top.
      const baseMatrix = foot.placed ? new THREE.Matrix4() : alignFootToInsole(foot, lowpolyGeometry, insoleGeometry, meshconfig.current!);
      if (!baseMatrix) return;
      const placedMatrix = adjustments[side] ? baseMatrix.clone().multiply(adjustments[side]!) : baseMatrix;
      // Height always comes from the insole: foot min Y on the insole top surface at the heel center.
      const alignMatrix = seatFootOnInsole(foot, placedMatrix, lowpolyGeometry, insoleGeometry, meshconfig.current!);
      alignedFeet[side] = { foot, alignMatrix };

      const mesh = new THREE.Mesh(
        foot.geometry,
        new THREE.MeshStandardMaterial({ color: 0xf0e68c, roughness: 0.7, transparent: true, opacity: 1, side: THREE.DoubleSide, depthWrite: false })
      );
      mesh.name = `foot-mesh-${side}`;
      mesh.userData.mirrored = !(side === 0 ? rightFoot : leftFoot);
      mesh.userData.baseMatrix = baseMatrix;
      mesh.matrixAutoUpdate = false;
      mesh.matrix.copy(alignMatrix);
      // Hidden while aligning the pressure, shown again when the mode is left.
      const { footMeshVisible, alignPressure } = useViewerStore.getState();
      mesh.visible = footMeshVisible && !alignPressure && (view === 'both' || (view === 'right') === (side === 0));
      mesh.renderOrder = 1000;
      sceneRef.current!.add(mesh);
      footMeshesRef.current[side] = mesh;
    });
    saveFootMeshesIfRequested(alignedFeet);
    if (useViewerStore.getState().alignFoot) addFootAlignmentPoints();
  };

  // Align 3D foot mode, like pressure alignment: per foot, a translation point (insole heel center) and a
  // rotation point (insole met center), at the pressure alignment default vertices. Dragging the translation point moves the foot,
  // dragging the rotation point turns it around the translation point. Right click applies.
  const FOOT_ALIGN_POINT_RADIUS = 5;

  const addFootAlignmentPoints = () => {
    removeFootAlignmentPoints();
    if (!sceneRef.current || !cameraRef.current || !rendererRef.current) return;

    const spheres: THREE.Mesh[] = [];
    footMeshesRef.current.forEach((mesh, side) => {
      const insoleGeometry = originalGeometryRef.current?.[side];
      if (!mesh || !mesh.visible || !insoleGeometry || !meshconfig.current) return;
      const insolePositions = insoleGeometry.getAttribute('position');
      const [heelCenter, metCenter] = meshconfig.current.pressureAlignmentDefault
        .map(index => new THREE.Vector3().fromBufferAttribute(insolePositions, index));
      metCenter.y = heelCenter.y;

      const material = new THREE.MeshBasicMaterial({ color: 0x00aaff, transparent: true, opacity: 0.5, depthTest: false });
      const [translation, rotation] = [heelCenter, metCenter].map((position, i) => {
        const sphere = new THREE.Mesh(new THREE.SphereGeometry(FOOT_ALIGN_POINT_RADIUS, 16, 16), material.clone());
        sphere.position.copy(position);
        sphere.renderOrder = 1001;
        sphere.userData = { foot: side, jointName: i === 0 ? 'translation' : 'rotation', lastPosition: position.clone() };
        makeSphereEasierToTouch(sphere);
        sceneRef.current!.add(sphere);
        spheres.push(sphere);
        return sphere;
      });
      material.dispose();

      const line = new THREE.Line(
        new THREE.BufferGeometry().setFromPoints([translation.position, rotation.position]),
        new THREE.LineBasicMaterial({ color: 0x00aaff, depthTest: false })
      );
      line.renderOrder = 1001;
      sceneRef.current!.add(line);
      footAlignmentRef.current.lines[side] = line;
    });
    if (spheres.length === 0) return;

    const dragControls = new DragControls(spheres, cameraRef.current, rendererRef.current.domElement);
    dragControls.addEventListener('dragstart', () => { if (controlsRef.current) controlsRef.current.enabled = false; });
    dragControls.addEventListener('drag', (event) => onDragFootAlignmentPoint(event.object as THREE.Mesh));
    dragControls.addEventListener('dragend', () => { if (controlsRef.current) controlsRef.current.enabled = true; });
    footAlignmentRef.current.spheres = spheres;
    footAlignmentRef.current.dragControls = dragControls;
  };

  const onDragFootAlignmentPoint = (sphere: THREE.Mesh) => {
    const side: number = sphere.userData.foot;
    const mesh = footMeshesRef.current[side];
    const pair = footAlignmentRef.current.spheres.filter(s => s.userData.foot === side);
    const translation = pair.find(s => s.userData.jointName === 'translation');
    const rotation = pair.find(s => s.userData.jointName === 'rotation');
    if (!mesh || !translation || !rotation) return;

    // Points stay on their horizontal plane.
    const last: THREE.Vector3 = sphere.userData.lastPosition;
    sphere.position.y = last.y;

    let step: THREE.Matrix4;
    if (sphere === translation) {
      const delta = sphere.position.clone().sub(last);
      step = new THREE.Matrix4().makeTranslation(delta.x, 0, delta.z);
      rotation.position.add(delta);
      rotation.userData.lastPosition.copy(rotation.position);
    } else {
      const center = translation.position;
      const from = last.clone().sub(center);
      const to = sphere.position.clone().sub(center);
      const angle = Math.atan2(from.z * to.x - from.x * to.z, from.x * to.x + from.z * to.z);
      step = new THREE.Matrix4().makeTranslation(center.x, 0, center.z)
        .multiply(new THREE.Matrix4().makeRotationY(angle))
        .multiply(new THREE.Matrix4().makeTranslation(-center.x, 0, -center.z));
    }
    sphere.userData.lastPosition.copy(sphere.position);

    mesh.matrix.premultiply(step);
    mesh.matrixWorldNeedsUpdate = true;
    footAlignmentRef.current.lines[side]?.geometry.setFromPoints([translation.position, rotation.position]);
  };

  const removeFootAlignmentPoints = () => {
    const { spheres, lines, dragControls } = footAlignmentRef.current;
    dragControls?.dispose();
    [...spheres, ...lines].forEach(object => {
      if (!object) return;
      sceneRef.current?.remove(object);
      object.geometry.dispose();
      (object.material as THREE.Material).dispose();
    });
    footAlignmentRef.current = { spheres: [], lines: [], dragControls: null };
    if (controlsRef.current) controlsRef.current.enabled = true;
  };

  // Stores each foot's manual transform relative to its automatic placement, saves, and leaves the mode.
  const applyFootTransforms = () => {
    const adjustments = footMeshesRef.current.map(mesh => {
      if (!mesh) return null;
      return (mesh.userData.baseMatrix as THREE.Matrix4).clone().invert().multiply(mesh.matrix);
    });
    removeFootAlignmentPoints();
    useViewerStore.getState().setAlignFoot(false);
    useFootMeshStore.getState().applyAdjustments(adjustments);
  };

  useEffect(() => {
    if (!alignFoot) {
      // Leaving without applying drops unapplied changes.
      updateFootMeshes();
      return;
    }
    if (!footMeshesRef.current.some(mesh => mesh?.visible)) {
      toast.error('Import a 3D foot first.');
      useViewerStore.getState().setAlignFoot(false);
      return;
    }
    addFootAlignmentPoints();
  }, [alignFoot]);

  useEffect(() => {
    // Load the foot scans saved with the design when another design opens.
    const designId = useSelectedDesignStore.getState().designId;
    if (designLoaded && designId !== footScansDesignIdRef.current) {
      footScansDesignIdRef.current = designId;
      useFootMeshStore.setState({ rightFoot: null, leftFoot: null, adjustments: [null, null] });
      // 3D foot scans are only available to the dev group.
      if (designId >= 0 && canUseDevelopmentExports(user)) {
        loadFootScans(api, designId)
          .then(({ right, left }) => {
            if (useSelectedDesignStore.getState().designId !== designId || (!right && !left)) return;
            useFootMeshStore.setState({ rightFoot: right, leftFoot: left });
          })
          .catch(err => console.error('load foot scans', err));
      }
    }

    updateFootMeshes();
    return useFootMeshStore.subscribe(updateFootMeshes);
  }, [designLoaded, surfaceUpdated, feetView, footMeshVisible, alignPressureToggle]);

  useEffect(() => removeFootMeshes, []);

  // When new feet are applied, resize the insoles to the feet (same flow as a new WBCT scan).
  const resizeInsolesToFeet = async () => {
    const design = useDesignStore.getState().insoleDesign;
    const { rightFoot, leftFoot } = useFootMeshStore.getState();
    if (!design || (!rightFoot && !leftFoot)) return;

    // Saved feet (placed) already sit on insoles sized for them, and their geometry is in insole
    // coordinates where Y is the foot height, not its length: only newly imported feet resize.
    const lengths = [rightFoot ?? leftFoot!, leftFoot ?? rightFoot!]
      .map((foot, side) => ({ fieldKey: 'Length', foot: side, value: foot.placed ? null : convertMmToViewerUnit(getInsoleLengthForFoot(foot)) }))
      .filter(length => length.value !== null);
    if (lengths.length === 0) return;
    await handleUpdateSurfaceParameters(new CustomEvent('updateSurfaceParameters', { detail: lengths }));
    await handleUpdateSurfaceParameters(new CustomEvent('updateSurfaceParameters', {
      detail: [0, 1].flatMap(foot => [
        { fieldKey: 'Profile Curve', foot, value: design.insoles[foot].profileCurveType },
        { fieldKey: 'Insole Template', foot, value: design.autoProperties?.insoleTemplate },
      ]),
    }));
    updateFootMeshes();
    resetStackWithDesign(design);
  };

  useEffect(() => {
    return useFootMeshStore.subscribe((state, prev) => {
      if (state.rightFoot !== prev.rightFoot || state.leftFoot !== prev.leftFoot) void resizeInsolesToFeet();
    });
  }, [designLoaded]);

  const updateFeetViewState = () => {
    highHeelRef.current.setMeshesVisible(highHeelVisibility, feetView);
    highHeelRef.current.setDragHandlesVisible(
      highHeelVisibility &&
      rightToolboxMode == ViewerTabsMode.Edit &&
      !alignPressureToggle,
      feetView
    );

    if (outputMeshRef.current == null || sceneRef.current == null || outputMeshRef.current.length == 0) return;
    if (insoleDesign?.insoles && outputMeshRef.current) {
      const rightGCode = sceneRef.current.children.find(c => c.name === "gcode-0") || null;
      const leftGCode = sceneRef.current.children.find(c => c.name === "gcode-1") || null;

      const rightVisibility = useViewerStore.getState().feetView !== 'left';
      const leftVisibility = useViewerStore.getState().feetView !== 'right';

      if (currentMode.current != AdditionTransformControlMode.AdditionWithTransformControl) {
        setLabelsVisibility('right', insolesVisibility && rightVisibility, additionsVisibility && rightVisibility);
        setLabelsVisibility('left', insolesVisibility && leftVisibility, additionsVisibility && leftVisibility);
        setPanelVisibility(true);
      }

      if (rightGCode || leftGCode) {
        setPanelVisibility(insolesVisibility);

        // GCodes
        if (rightGCode) rightGCode.visible = gcodesVisibility && rightVisibility;
        if (leftGCode) leftGCode.visible = gcodesVisibility && leftVisibility;

        //Wireframe
        applyDisplayMode();
        if (useViewerStore.getState().wireframe === "both") {
          const rightInsole = insoleDesign.insoles[0];
          const rightWire = sceneRef.current.getObjectByName(`${rightInsole.mainMesh.name}_wire_0`);
          if (rightWire) rightWire.visible = insolesVisibility && rightVisibility;

          rightInsole.mainMesh.children.forEach(child => {
            const rightWire = sceneRef.current!.getObjectByName(`${child.name}_wire_0`);
            if (rightWire && !rightWire.name.includes('cutter')) rightWire.visible = insolesVisibility && rightVisibility;
          });

          rightInsole.additions.forEach((add, addIndex) => {
            const addWire = sceneRef.current?.getObjectByName(`${add.viewMesh.name}_wire_0_${addIndex}`);
            if (addWire) addWire.visible = additionsVisibility && rightVisibility;
          });

          const rightLifted = rightInsole.liftedMesh;
          if (rightLifted != null) {
            const rightLiftedWire = sceneRef.current.getObjectByName(`${rightLifted.name}_lifted_wire_0`);
            if (rightLiftedWire) rightLiftedWire.visible = liftedInsoleVisibility && rightVisibility;
          }

          const rightBones = rightInsole.bonesGroup;
          if (rightBones != null) {
            const rightBonesWire = sceneRef.current.getObjectByName(`${rightBones.name}_bones_wire_0`);
            if (rightBonesWire) rightBonesWire.visible = bonesVisibility && rightVisibility;
          }

          /* const rightBonesMarkers = rightInsole.bonesMarkers;
          if(rightBonesMarkers != null){
            const rightBonesMarkersWire = sceneRef.current.getObjectByName(`${rightBonesMarkers.name}_wire_0`);
            if (rightBonesMarkersWire) rightBonesMarkersWire.visible = bonesVisibility;
          } */

          const rightShoe = rightInsole.footShoeMesh;
          if (rightShoe != null) {
            const rightShoeWire = sceneRef.current.getObjectByName(`${rightShoe.name}_shoe_wire_0`);
            if (rightShoeWire) rightShoeWire.visible = shoeDataVisibility && rightVisibility;
          }

          const leftInsole = insoleDesign.insoles[1];
          const leftWire = sceneRef.current.getObjectByName(`${leftInsole.mainMesh.name}_wire_1`);
          if (leftWire) leftWire.visible = insolesVisibility && leftVisibility;

          leftInsole.mainMesh.children.forEach(child => {
            const leftWire = sceneRef.current!.getObjectByName(`${child.name}_wire_1`);
            if (leftWire && !leftWire.name.includes('cutter')) leftWire.visible = insolesVisibility && leftVisibility;
          });

          leftInsole.additions.forEach((add, addIndex) => {
            const addWire = sceneRef.current?.getObjectByName(`${add.viewMesh.name}_wire_1_${addIndex}`);
            if (addWire) addWire.visible = additionsVisibility && leftVisibility;
          });

          const leftLifted = leftInsole.liftedMesh;
          if (leftLifted != null) {
            const leftLiftedWire = sceneRef.current.getObjectByName(`${leftLifted.name}_lifted_wire_1`);
            if (leftLiftedWire) leftLiftedWire.visible = liftedInsoleVisibility && leftVisibility;
          }

          const leftBones = leftInsole.bonesGroup;
          if (leftBones != null) {
            const leftBonesWire = sceneRef.current.getObjectByName(`${leftBones.name}_bones_wire_1`);
            if (leftBonesWire) leftBonesWire.visible = bonesVisibility && leftVisibility;
          }

          /* const leftBonesMarkers = leftInsole.bonesMarkers;
          if(leftBonesMarkers != null){
            const leftBonesMarkersWire = sceneRef.current.getObjectByName(`${leftBonesMarkers.name}_wire_1`);
            if (leftBonesMarkersWire) leftBonesMarkersWire.visible = false;
          } */

          const leftShoe = leftInsole.footShoeMesh;
          if (leftShoe != null) {
            const leftShoeWire = sceneRef.current.getObjectByName(`${leftShoe.name}_shoe_wire_1`);
            if (leftShoeWire) leftShoeWire.visible = shoeDataVisibility && leftVisibility;
          }
        }

        //Additions
        insoleDesign.insoles[0].additions?.forEach((addition) => {
          if (addition.viewMesh) {
            addition.viewMesh.visible = additionsVisibility && rightVisibility;
          }
        });
        insoleDesign.insoles[1].additions?.forEach((addition) => {
          if (addition.viewMesh) {
            addition.viewMesh.visible = additionsVisibility && leftVisibility;
          }
        });

        //Insoles
        outputMeshRef.current[0].visible = insolesVisibility && rightVisibility;
        outputMeshRef.current[1].visible = insolesVisibility && leftVisibility;

        //Lifted Mesh
        if (LiftedMeshRef.current.length > 0) {
          LiftedMeshRef.current[0].visible = liftedInsoleVisibility && rightVisibility;
          LiftedMeshRef.current[1].visible = liftedInsoleVisibility && leftVisibility;
        }

        // Bone FPI Marker Group
        if (insoleDesign.insoles[0].bonesFPIMarkers) {
          insoleDesign.insoles[0].bonesFPIMarkers.visible = bonesVisibility && rightVisibility;
        }
        if (insoleDesign.insoles[1].bonesFPIMarkers) {
          insoleDesign.insoles[1].bonesFPIMarkers.visible = bonesVisibility && leftVisibility;
        }

        // Bones
        if (insoleDesign.insoles[0].bonesGroup != null) insoleDesign.insoles[0].bonesGroup.visible = bonesVisibility && rightVisibility;
        if (insoleDesign.insoles[1].bonesGroup != null) insoleDesign.insoles[1].bonesGroup.visible = bonesVisibility && leftVisibility;

        // Shoe Mesh
        if (insoleDesign.insoles[0].footShoeMesh != null) insoleDesign.insoles[0].footShoeMesh.visible = shoeDataVisibility && rightVisibility;
        if (insoleDesign.insoles[1].footShoeMesh != null) insoleDesign.insoles[1].footShoeMesh.visible = shoeDataVisibility && leftVisibility;

        // shoe Lines
        if (shoeInsideMarkerGroup.current.length > 0) {
          shoeInsideMarkerGroup.current[0].children.forEach(child => {
            if (child.name.startsWith('InsideLines_')) {
              child.visible = shoeDataVisibility && rightVisibility;
            }
          })

          shoeInsideMarkerGroup.current[1].children.forEach(child => {
            if (child.name.startsWith('InsideLines_')) {
              child.visible = shoeDataVisibility && leftVisibility;
            }
          })
        }

        if (shoeOutsideMarkerGroup.current.length > 0) {
          shoeOutsideMarkerGroup.current[0].children.forEach(child => {
            if (child.name.startsWith('OutsideLines_')) {
              child.visible = shoeDataVisibility && rightVisibility;
            }
          })

          shoeOutsideMarkerGroup.current[1].children.forEach(child => {
            if (child.name.startsWith('OutsideLines_')) {
              child.visible = shoeDataVisibility && leftVisibility;
            }
          })
        }
      }
      else {
        //Wireframe
        applyDisplayMode();
        if (useViewerStore.getState().wireframe === "both") {
          const rightInsole = insoleDesign.insoles[0];
          const rightWire = sceneRef.current.getObjectByName(`${rightInsole.mainMesh.name}_wire_0`);
          if (rightWire) rightWire.visible = insolesVisibility && rightVisibility;

          rightInsole.mainMesh.children.forEach(child => {
            const rightWire = sceneRef.current!.getObjectByName(`${child.name}_wire_0`);
            if (rightWire) rightWire.visible = insolesVisibility && rightVisibility;
          });

          rightInsole.additions.forEach((add, addIndex) => {
            const addWire = sceneRef.current?.getObjectByName(`${add.viewMesh.name}_wire_0_${addIndex}`);
            if (addWire) addWire.visible = additionsVisibility && rightVisibility;
          });

          const rightLifted = rightInsole.liftedMesh;
          if (rightLifted != null) {
            const rightLiftedWire = sceneRef.current.getObjectByName(`${rightLifted.name}_lifted_wire_0`);
            if (rightLiftedWire) rightLiftedWire.visible = liftedInsoleVisibility && rightVisibility;
          }

          const rightBones = rightInsole.bonesGroup;
          if (rightBones != null) {
            const rightBonesWire = sceneRef.current.getObjectByName(`${rightBones.name}_bones_wire_0`);
            if (rightBonesWire) rightBonesWire.visible = bonesVisibility && rightVisibility;
          }

          /*  const rightBonesMarkers = rightInsole.bonesMarkers;
           if(rightBonesMarkers != null){
             const rightBonesMarkersWire = sceneRef.current.getObjectByName(`${rightBonesMarkers.name}_wire_0`);
             if (rightBonesMarkersWire) rightBonesMarkersWire.visible = bonesVisibility && rightVisibility;
           } */

          const rightShoe = rightInsole.footShoeMesh;
          if (rightShoe != null) {
            const rightShoeWire = sceneRef.current.getObjectByName(`${rightShoe.name}_shoe_wire_0`);
            if (rightShoeWire) rightShoeWire.visible = shoeDataVisibility && rightVisibility;
          }

          const leftInsole = insoleDesign.insoles[1];
          const leftWire = sceneRef.current.getObjectByName(`${leftInsole.mainMesh.name}_wire_1`);
          if (leftWire) leftWire.visible = insolesVisibility && leftVisibility;

          leftInsole.mainMesh.children.forEach(child => {
            const leftWire = sceneRef.current!.getObjectByName(`${child.name}_wire_1`);
            if (leftWire) leftWire.visible = insolesVisibility && leftVisibility;
          });

          leftInsole.additions.forEach((add, addIndex) => {
            const addWire = sceneRef.current?.getObjectByName(`${add.viewMesh.name}_wire_1_${addIndex}`);
            if (addWire) addWire.visible = additionsVisibility && leftVisibility;
          });

          const leftLifted = leftInsole.liftedMesh;
          if (leftLifted != null) {
            const leftLiftedWire = sceneRef.current.getObjectByName(`${leftLifted.name}_lifted_wire_1`);
            if (leftLiftedWire) leftLiftedWire.visible = liftedInsoleVisibility && leftVisibility;
          }

          const leftBones = leftInsole.bonesGroup;
          if (leftBones != null) {
            const leftBonesWire = sceneRef.current.getObjectByName(`${leftBones.name}_bones_wire_1`);
            if (leftBonesWire) leftBonesWire.visible = bonesVisibility && leftVisibility;
          }

          /* const leftBonesMarkers = leftInsole.bonesMarkers;
          if(leftBonesMarkers != null){
            const leftBonesMarkersWire = sceneRef.current.getObjectByName(`${leftBonesMarkers.name}_wire_1`);
            if (leftBonesMarkersWire) leftBonesMarkersWire.visible = false;
          } */

          const leftShoe = leftInsole.footShoeMesh;
          if (leftShoe != null) {
            const leftShoeWire = sceneRef.current.getObjectByName(`${leftShoe.name}_shoe_wire_1`);
            if (leftShoeWire) leftShoeWire.visible = shoeDataVisibility && leftVisibility;
          }
        }

        //Additions
        insoleDesign.insoles[0].additions?.forEach((addition) => {
          if (addition.viewMesh) {
            addition.viewMesh.visible = additionsVisibility && rightVisibility;
          }
        });
        insoleDesign.insoles[1].additions?.forEach((addition) => {
          if (addition.viewMesh) {
            addition.viewMesh.visible = additionsVisibility && leftVisibility;
          }
        });

        //Insoles
        outputMeshRef.current[0].visible = insolesVisibility && rightVisibility;
        outputMeshRef.current[1].visible = insolesVisibility && leftVisibility;

        //Lifted Meshes
        if (LiftedMeshRef.current.length > 0) {
          LiftedMeshRef.current[0].visible = liftedInsoleVisibility && rightVisibility;
          LiftedMeshRef.current[1].visible = liftedInsoleVisibility && leftVisibility;
        }

        // Bone FPI Marker Group
        if (insoleDesign.insoles[0].bonesFPIMarkers) {
          insoleDesign.insoles[0].bonesFPIMarkers.visible = bonesVisibility && rightVisibility;
        }
        if (insoleDesign.insoles[1].bonesFPIMarkers) {
          insoleDesign.insoles[1].bonesFPIMarkers.visible = bonesVisibility && leftVisibility;
        }

        // Bones
        if (insoleDesign.insoles[0].bonesGroup != null) insoleDesign.insoles[0].bonesGroup.visible = bonesVisibility && rightVisibility;
        if (insoleDesign.insoles[1].bonesGroup != null) insoleDesign.insoles[1].bonesGroup.visible = bonesVisibility && leftVisibility;

        // Shoe Mesh
        if (insoleDesign.insoles[0].footShoeMesh != null) insoleDesign.insoles[0].footShoeMesh.visible = shoeDataVisibility && rightVisibility;
        if (insoleDesign.insoles[1].footShoeMesh != null) insoleDesign.insoles[1].footShoeMesh.visible = shoeDataVisibility && leftVisibility;

        // shoe Lines
        if (shoeInsideMarkerGroup.current.length > 0) {
          shoeInsideMarkerGroup.current[0].children.forEach(child => {
            if (child.name.startsWith('InsideLines_')) {
              child.visible = shoeDataVisibility && rightVisibility;
            }
          })

          shoeInsideMarkerGroup.current[1].children.forEach(child => {
            if (child.name.startsWith('InsideLines_')) {
              child.visible = shoeDataVisibility && leftVisibility;
            }
          })
        }

        if (shoeOutsideMarkerGroup.current.length > 0) {
          shoeOutsideMarkerGroup.current[0].children.forEach(child => {
            if (child.name.startsWith('OutsideLines_')) {
              child.visible = shoeDataVisibility && rightVisibility;
            }
          })

          shoeOutsideMarkerGroup.current[1].children.forEach(child => {
            if (child.name.startsWith('OutsideLines_')) {
              child.visible = shoeDataVisibility && leftVisibility;
            }
          })
        }
      }
    }
    applyFeetViewOverlays();
  }

  const applyDisplayMode = () => {
    if (!insoleDesign || !sceneRef.current) return;

    const mode = useViewerStore.getState().wireframe;
    const parent = sceneRef.current;
    const shifts = InitialShiftBones.current;

    [...parent.children]
      .filter(c => c.name.includes("_wire_"))
      .forEach(c => parent.remove(c));

    insoleDesign.insoles.forEach((insole, insoleIndex) => {
      const mainMesh = insole.mainMesh;
      const additions = insole.additions.filter(a => a.status != AdditionNewStatus.removed);
      const boneGroup = insole.bonesGroup;
      const liftedMesh = insole.liftedMesh;
      const footShoe = insole.footShoeMesh;
      const currentShift = shifts[insoleIndex]

      if (mode === "insole") {
        (mainMesh.material as THREE.MeshStandardMaterial).wireframe = false;

        mainMesh.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            (child.material as THREE.MeshStandardMaterial).wireframe = false;
          }
        });

        additions.forEach(add => {
          if (!add?.viewMesh) return;
          (add.viewMesh.material as THREE.MeshStandardMaterial).wireframe = false;
        });

        if (liftedMesh?.material) {
          (liftedMesh.material as THREE.MeshStandardMaterial).wireframe = false;
        }
        if (footShoe?.material) {
          (footShoe.material as THREE.MeshStandardMaterial).wireframe = false;
        }
        if (boneGroup) {
          boneGroup.traverse((child) => {
            if (child instanceof THREE.Mesh) {
              (child.material as THREE.MeshStandardMaterial).wireframe = false;
            }
          });
        }
        return;
      }

      if (mode === "wireframe") {
        (mainMesh.material as THREE.MeshStandardMaterial).wireframe = true;

        mainMesh.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            (child.material as THREE.MeshStandardMaterial).wireframe = true;
          }
        });

        additions.forEach(add => {
          if (!add?.viewMesh) return;
          (add.viewMesh.material as THREE.MeshStandardMaterial).wireframe = true;
        });

        if (liftedMesh?.material) {
          (liftedMesh.material as THREE.MeshStandardMaterial).wireframe = true;
        }
        if (footShoe?.material) {
          (footShoe.material as THREE.MeshStandardMaterial).wireframe = true;
        }
        if (boneGroup) {
          boneGroup.traverse((child) => {
            if (child instanceof THREE.Mesh) {
              (child.material as THREE.MeshStandardMaterial).wireframe = true;
            }
          });
        }
        return;
      }

      if (mode === "both") {
        (mainMesh.material as THREE.MeshStandardMaterial).wireframe = false;

        mainMesh.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            (child.material as THREE.MeshStandardMaterial).wireframe = false;
          }
        });

        additions.forEach(add => {
          if (!add?.viewMesh) return;
          (add.viewMesh.material as THREE.MeshStandardMaterial).wireframe = false;
        });

        if (liftedMesh?.material) {
          (liftedMesh.material as THREE.MeshStandardMaterial).wireframe = false;
        }
        if (footShoe?.material) {
          (footShoe.material as THREE.MeshStandardMaterial).wireframe = false;
        }
        if (boneGroup) {
          boneGroup.traverse((child) => {
            if (child instanceof THREE.Mesh) {
              (child.material as THREE.MeshStandardMaterial).wireframe = false;
            }
          });
        }

        const wireMat = new THREE.MeshBasicMaterial({
          color: 0x000000,
          wireframe: true,
          transparent: true,
          opacity: 0.4
        });

        const wireMesh = new THREE.Mesh(thirdQuarter.current && !isSandal.current ? (mainMesh.children[0] as THREE.Mesh).geometry.clone() : mainMesh.geometry, wireMat);
        wireMesh.name = `${mainMesh.name}_wire_${insoleIndex}`;
        wireMesh.renderOrder = 999;
        parent.add(wireMesh);

        additions.forEach((add, addIndex) => {
          if (!add) return;
          if (!add.viewMesh) return;

          const addWireMat = new THREE.MeshBasicMaterial({
            color: 0x000000,
            wireframe: true,
            transparent: true,
            opacity: 0.4
          });
          addWireMat.onBeforeCompile = (add.viewMesh.material as THREE.Material).onBeforeCompile;

          const addWireMesh = add.viewMesh.clone();
          addWireMesh.material = addWireMat;
          addWireMesh.name = `${add.viewMesh.name}_wire_${insoleIndex}_${addIndex}`;
          addWireMesh.renderOrder = 999;
          parent.add(addWireMesh);
        });

        if (boneGroup) {
          const boneWireGroup = boneGroup.clone();
          boneWireGroup.traverse((child) => {
            if (child instanceof THREE.Mesh) {
              child.material = new THREE.MeshBasicMaterial({
                color: 0x000000,
                wireframe: true,
                transparent: true,
                opacity: 0.4
              });
            }
          });
          boneWireGroup.name = `${boneGroup.name}_bones_wire_${insoleIndex}`;
          boneWireGroup.renderOrder = 999;

          if (currentShift) {
            boneWireGroup.position.copy(currentShift);
          }

          parent.add(boneWireGroup);
        }

        if (liftedMesh) {
          const liftedWireMesh = liftedMesh.clone();
          liftedWireMesh.material = new THREE.MeshBasicMaterial({
            color: 0x000000,
            wireframe: true,
            transparent: true,
            opacity: 0.4
          });
          liftedWireMesh.name = `${liftedMesh.name}_lifted_wire_${insoleIndex}`;
          liftedWireMesh.renderOrder = 999;
          parent.add(liftedWireMesh);
        }

        if (footShoe) {
          const footShoeWireMesh = footShoe.clone();
          footShoeWireMesh.material = new THREE.MeshBasicMaterial({
            color: 0x000000,
            wireframe: true,
            transparent: true,
            opacity: 0.4
          });
          footShoeWireMesh.name = `${footShoe.name}_shoe_wire_${insoleIndex}`;
          footShoeWireMesh.renderOrder = 999;

          if (currentShift) {
            footShoeWireMesh.position.copy(currentShift);
          }

          parent.add(footShoeWireMesh);
        }
      }
    });
  };

  const applyFeetViewOverlays = () => {
    const mode = useViewerStore.getState().mode;
    const inEdit = mode === ViewerTabsMode.Edit && !alignPressureToggle;
    const showRight = isFootShownInView(0);
    const showLeft = isFootShownInView(1);

    setJointSpheresVisibility(0, inEdit && showRight && insolesVisibility);
    setJointSpheresVisibility(1, inEdit && showLeft && insolesVisibility);

    if (mode === ViewerTabsMode.Engraving) {
      setEngravingVisibility('right', showRight && !finalize);
      setEngravingVisibility('left', showLeft && !finalize);
    }

    setLabelsVisibility('right', showRight && insolesVisibility, showRight && additionsVisibility);
    setLabelsVisibility('left', showLeft && insolesVisibility, showLeft && additionsVisibility);
    if (activeLabelKeyRef.current) {
      const activeFoot = footIndexFromViewKey(activeLabelKeyRef.current);
      if (activeFoot === null || isFootShownInView(activeFoot)) {
        refreshActiveLabelExclusivity();
      }
    }

    [0, 1].forEach((foot) => {
      const showPressure = alignPressureToggle && isFootShownInView(foot);
      pressureAlignmentSphereRef.current[foot]?.forEach((sphere) => {
        sphere.visible = showPressure;
      });
      if (pressureAlignmentLine.current[foot]) {
        pressureAlignmentLine.current[foot].visible = showPressure;
      }
    });
  };

  const setJointSpheresVisibility = (foot: number, visible: boolean, gcodeMode: boolean = false) => {
    const inEdit = useViewerStore.getState().mode === ViewerTabsMode.Edit;
    const show = visible && inEdit && isFootShownInView(foot);
    //profile curve 
    if (profileCurveRef.current[foot])
      profileCurveRef.current[foot].visible = show;
    // Profile joints
    if (profileJointSpheresRef.current[foot]) {
      profileJointSpheresRef.current[foot].forEach(s => (s.visible = show));
    }
    // Surface joints
    if (surfaceJointSpheresRef.current[foot]) {
      surfaceJointSpheresRef.current[foot].forEach(s => (s.visible = show));
    }

    setArchInstepLineVisibility(foot);

    // Vertex spheres (advanced)
    if (vertexSpheresRef.current[foot] && useViewerStore.getState().advanceMode) {
      vertexSpheresRef.current[foot].forEach(s => (s.visible = show));
    }
  };

  const setEngravingVisibility = (side: 'left' | 'right', visible: boolean) => {
    if (!sceneRef.current) return;
    const engravings = sceneRef.current.getObjectsByProperty('name', 'engraving');
    if (engravings.length === 0) {
      requestAnimationFrame(() => setEngravingVisibility(side, visible));
      return;
    }
    engravings.forEach(obj => {
      if (side === 'left' && obj.position.x > 0) {
        obj.visible = visible;
      }
      else if (side === 'right' && obj.position.x < 0) {
        obj.visible = visible;
      }
    });
    if (rendererRef.current && cameraRef.current) {
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    }
  };

  const setLabelsVisibility = (
    side: 'left' | 'right',
    insoleVisible: boolean,
    additionVisible: boolean
  ) => {
    const foot = side === 'right' ? 0 : 1;
    const prefix = `${foot}_`;
    const live = useViewerStore.getState().liveMode;
    const showInsole = insoleVisible && isFootShownInView(foot);
    const showAddition = additionVisible && isFootShownInView(foot);
    const showInsoleLabels = live && showInsole;
    const showAdditionLabels = live && showAddition;

    const setMapVisibility = (map: Map<string, THREE.Object3D>, keyFilter: (k: string) => boolean, visible: boolean) => {
      map.forEach((obj, key) => {
        if (!keyFilter(key)) return;
        applyCss2dVisibility(obj, visible);
      });
    };

    // insole-related
    setMapVisibility(sphereLabelsRef.current, k => k.startsWith(prefix), showInsoleLabels);
    setMapVisibility(sphereLinesRef.current, k => k.startsWith(`line_${prefix}`), showInsoleLabels);
    setMapVisibility(dimensionLabelsRef.current, k => k.startsWith(prefix), showInsoleLabels);
    setMapVisibility(dimensionLinesRef.current, k => k.startsWith(`line_${prefix}`), showInsoleLabels);
    setMapVisibility(newAdditionLabelsRef.current, k => k === `newAddition_${foot}`, showInsoleLabels);
    setMapVisibility(guideLines.current, k => k.includes(`_${foot}_`), showInsoleLabels);

    if (archGuideSpheresRef.current[foot]) archGuideSpheresRef.current[foot].visible = showInsoleLabels;
    if (heelGuideSpheresRef.current[foot]) heelGuideSpheresRef.current[foot].visible = showInsoleLabels;
    if (boundingBoxGroupsRef.current[foot]) boundingBoxGroupsRef.current[foot].visible = showInsoleLabels;
    if (dimensionSpheresRef.current[foot]) dimensionSpheresRef.current[foot].visible = showInsoleLabels;
    setArchInstepLineVisibility(foot, showInsole);

    // addition-related
    setMapVisibility(additionLabelsRef.current, k => k.startsWith(prefix), showAdditionLabels);
    setMapVisibility(additionLinesRef.current, k => k.startsWith(`line_${prefix}`), showAdditionLabels);
  };

  const setPanelVisibility = (visible: boolean) => {
    if (!liveMode) return;
    toolboxPanelRef.current.forEach((toolbox) => {
      if (toolbox) toolbox.visible = visible;
    });
  };

  const applyDesignUpdates = async () => {
    if (!changesToApply.current || changesToApply.current.length == 0) return;

    const detailsToUpdate: {
      fieldKey: string;
      foot: number;
      value: unknown;
    }[] = [];

    changesToApply.current.forEach((footChanges: Record<string, any>, foot) => {
      for (const key of Object.keys(footChanges) as (keyof InsoleHighLevelParams)[]) {
        if (['heelFill', 'archFill'].includes(key)) {
          if (footChanges[key]) insoleHighLevelParamRef.current[foot][key] = footChanges[key];
          continue;
        }

        if (key.toLocaleLowerCase() == 'profilecurve') {
          if (designCategory.current != DesignCategory.Insole) {
            insoleHighLevelParamRef.current[foot][key] = footChanges[key];
          }
          else {
            detailsToUpdate.push({
              fieldKey: propertyToLabel(key),
              foot: foot,
              value: footChanges[key]
            })
          }
          continue;
        }

        if (key.toLocaleLowerCase().includes('outsolethickness')) {
          continue;
        }

        if (key.toLocaleLowerCase().includes('bandheight')) {
          continue;
        }

        if (key.toLocaleLowerCase().includes('wedge')) {
          if (footChanges[key] !== insoleHighLevelParamRef.current[foot][key]) {
            const fieldName = propertyToLabel(key);

            if (fieldName.includes('Forefoot')) {
              insoleHighLevelParamRef.current[foot].forefootLateralWedge = footChanges.forefootLateralWedge;
              insoleHighLevelParamRef.current[foot].forefootMedialWedge = footChanges.forefootMedialWedge;
            }
            else if (fieldName.includes('Heel')) {
              insoleHighLevelParamRef.current[foot].heelLateralWedge = footChanges.heelLateralWedge;
              insoleHighLevelParamRef.current[foot].heelMedialWedge = footChanges.heelMedialWedge;
            }

            detailsToUpdate.push({
              fieldKey: fieldName,
              foot: foot,
              value: footChanges[key]
            });
          }
          continue;
        }

        if (footChanges[key] !== insoleHighLevelParamRef.current[foot][key]) {
          detailsToUpdate.push({
            fieldKey: propertyToLabel(key),
            foot: foot,
            value: convertMmToViewerUnit(Number(footChanges[key]))
          });
        }
      }

      useDesignStore.getState().insoleDesign?.insoles[foot].additions.forEach(addition => {
        addition.relativeIndexMesh = addition.getRelativeIndexMesh(designCategory.current);
      });
    });

    insoleOldCenter.current = [null, null];

    await handleUpdateSurfaceParameters(new CustomEvent('updateSurfaceParameters', { detail: detailsToUpdate }));
    if (useViewerStore.getState().previousViewerMode === ViewerTabsMode.Engraving) setUpdateFromViewer(true);

    changesToApply.current = null;
  }

  useEffect(() => {
    if (useViewerStore.getState().grids) enableGrids(true);
    else enableGrids(false);

    if (useViewerStore.getState().measurementSystem == MeasurementSystem.imperial) {
      thicknessPropertyStep.current = 0.02;
      propertyStep.current = 0.05;
    }
    else {
      thicknessPropertyStep.current = 0.5;
      propertyStep.current = 1;
    }

    if (insoleDesign !== null && liveMode) {
      addLabelstoAllSpheres();
      addLabelstoAllAdditions();
    }
  }, [useViewerStore.getState().measurementSystem]);

  const updateBandHeight = (insoleVertices: any, foot: number) => {
    const jointList = surfaceJointsArray.current[foot];
    const joint = jointList.bandHeight;

    var value = checkRange(insoleHighLevelParamRef.current[foot].bandHeight,
      joint!.min * insoleHighLevelParamRef.current[foot].length,
      joint!.max * insoleHighLevelParamRef.current[foot].length,
      joint?.bval, joint?.cval);
    insoleHighLevelParamRef.current[foot].bandHeight = value;

    joint!.center.y = insoleVertices.getY(joint?.centerId);
    var jointArchCenter = jointList.archCenterHeight;

    if (joint && jointArchCenter) {
      joint.value = value;
      const displacement = (value - joint.cval) / joint.bval - (joint.center.y - jointArchCenter.center.y);
      joint.center.y = value;

      joint.vertices.forEach((vertexGroup: any) => {
        vertexGroup.ids.forEach((vertexId: number) => {
          const weight = vertexGroup.weight;
          insoleVertices.setY(vertexId, insoleVertices.getY(vertexId) + displacement * weight);
        });
      });
    }
  }

  const updateJointValues = (foot: number, insoleVertices: THREE.BufferAttribute) => {
    Object.values(surfaceJointsArray.current[foot]).forEach(joint => {
      if (!joint) return;

      const centerVertexId = joint.centerId;
      const x = insoleVertices.getX(centerVertexId);
      let y = insoleVertices.getY(centerVertexId);
      const z = insoleVertices.getZ(centerVertexId);

      if (joint.name === 'Heel Depth')
        y = heelDepthRealY.current[foot];

      joint.center.set(x, y, z);
    });
  }

  useEffect(() => {
    thirdQuarter.current = thirdQuarterValue;
    // setColorandTransparency();
    updateOutputMesh();
    updateInsoleLengthAndWidth(0);
    updateInsoleLengthAndWidth(1);
    if (thirdQuarterValue !== useDesignStore.getState().insoleDesign?.autoProperties!.thirdQuarter) {
      const design = useDesignStore.getState().insoleDesign;
      if (design == null) return;
      design.autoProperties!.thirdQuarter = thirdQuarterValue;
      scheduleAutosave("Autoparams Updated", { updateAutoProperties: true });
    }
  }, [thirdQuarterValue]);

  useEffect(() => {
    const renderer = rendererRef.current;
    if (!renderer) return;

    const withoutBandPlane = renderer.clippingPlanes.filter(
      (plane) => Math.abs(plane.normal.y) < 0.5
    );

    if (!isSandal.current || !bandHeightClipping) {
      bandClipPlaneRef.current = null;
      renderer.clippingPlanes = withoutBandPlane;
      renderer.localClippingEnabled = withoutBandPlane.length > 0;
      return;
    }

    const feetView = useViewerStore.getState().feetView;
    const feet = feetView === 'left' ? [1] : feetView === 'right' ? [0] : [0, 1];
    let cutY: number | null = null;

    for (const foot of feet) {
      const joint = surfaceJointsArray.current[foot]?.bandHeight;
      const bandHeight = insoleHighLevelParamRef.current[foot]?.bandHeight;
      if (!joint || typeof bandHeight !== 'number' || !Number.isFinite(bandHeight)) continue;

      const nextCutY = joint.center.y - bandHeight / 2;
      cutY = cutY == null ? nextCutY : Math.min(cutY, nextCutY);
    }

    if (cutY == null) {
      bandClipPlaneRef.current = null;
      renderer.clippingPlanes = withoutBandPlane;
      renderer.localClippingEnabled = withoutBandPlane.length > 0;
      return;
    }

    // Keep y <= cutY (lower part of the sandal)
    bandClipPlaneRef.current = new THREE.Plane(new THREE.Vector3(0, -1, 0), cutY);
    renderer.clippingPlanes = [...withoutBandPlane, bandClipPlaneRef.current];
    renderer.localClippingEnabled = true;
  }, [bandHeightClipping, surfaceUpdated, designLoaded, feetView]);

  const isFootShownInView = (foot: number): boolean => {
    const view = useViewerStore.getState().feetView;
    if (view === 'right') return foot === 0;
    if (view === 'left') return foot === 1;
    return true;
  };

  return (
    <>
      <div className="viewer-container" ref={containerRef}>
        <progress className="viewer-progress" value={gcodeStatus.percent} max={100} />
        {isLoading && (
          <div
            className="loading-indicator"
            style={{ backgroundColor: "rgba(255, 255, 255, 0)" }}
          >
            <svg className="loading-spinner" width="48" height="48" viewBox="0 0 48 48">
              <circle
                className="spinner-bg"
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke="#eee"
                strokeWidth="4"
              />
              <circle
                className="spinner-fg"
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke="#07d2da"
                strokeWidth="4"
                strokeDasharray="100"
                strokeDashoffset="60"
                strokeLinecap="round"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 24 24"
                  to="360 24 24"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </div>
        )}
      </div>
    </>
  );


};

export default Viewer3D;
